/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, Type, typeCast, markType, delegateCombine, delegateRemove, PropertyChangedEventArgs, String_$type, Number_$type, enumGetBox, Boolean_$type, EnumUtil, Delegate_$type, typeGetValue, runOn, INotifyPropertyChanged_$type, EventArgs, IList$1_$type, NotSupportedException, Point_$type, fromEnum, fromEn, getInstanceType, Date_$type } from "igniteui-react-core";
import { IDataSource_$type } from "igniteui-react-core";
import { Brush } from "igniteui-react-core";
import { ICellActionManager_$type } from "./ICellActionManager";
import { RowPath } from "./RowPath";
import { DataSourceSchemaPropertyType_$type } from "igniteui-react-core";
import { GridCellPosition } from "./GridCellPosition";
import { EditModeType_$type } from "./EditModeType";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { GridViewportChangedEventArgs } from "./GridViewportChangedEventArgs";
import { DateTimeFormats_$type } from "./DateTimeFormats";
import { dateMinValue, dateNow } from "igniteui-react-core";
import { ModelStates_$type } from "./ModelStates";
import { CellPath } from "./CellPath";
import { Rect } from "igniteui-react-core";
import { ModelTypes_$type } from "./ModelTypes";
import { CellContentHorizontalAlignment_$type } from "./CellContentHorizontalAlignment";
import { CellContentVerticalAlignment_$type } from "./CellContentVerticalAlignment";
import { FontInfo } from "igniteui-react-core";
import { TextCellLineBreakMode_$type } from "./TextCellLineBreakMode";
import { ColumnSortDirection_$type } from "./ColumnSortDirection";
import { PinnedPositions_$type } from "./PinnedPositions";
import { Dictionary$2 } from "igniteui-react-core";
import { GridStyleRepository } from "./GridStyleRepository";
import { BrushUtil } from "igniteui-react-core";
import { CellModelExport } from "./CellModelExport";
import { AppearanceHelper } from "igniteui-react-core";
import { FontUtil } from "igniteui-react-core";
import { DataSourceRowType_$type } from "igniteui-react-core";
import { truncate, isNaN_, intDivide, tryParseNumber } from "igniteui-react-core";
import { GroupSummaryDisplayMode_$type } from "./GroupSummaryDisplayMode";
import { BindingFormatter } from "igniteui-react-core";
import { DateTimeCellModelExport } from "./DateTimeCellModelExport";
import { EditorType_$type } from "./EditorType";
import { EditorCellModelExport } from "./EditorCellModelExport";
import { SummaryCellModelExport } from "./SummaryCellModelExport";
import { ImageStretchOptions_$type } from "./ImageStretchOptions";
import { ImageResourceType_$type } from "./ImageResourceType";
import { ImageCellModelExport } from "./ImageCellModelExport";
import { NumericCellModelExport } from "./NumericCellModelExport";
import { RowSeparatorModelExport } from "./RowSeparatorModelExport";
import { GroupData } from "./GroupData";
import { SummaryData } from "./SummaryData";
import { SectionHeaderCellModelExport } from "./SectionHeaderCellModelExport";
import { TemplateCellModelExport } from "./TemplateCellModelExport";
import { TextCellModelExport } from "./TextCellModelExport";
import { SortIndicatorStyle_$type } from "./SortIndicatorStyle";
import { ColumnOptionsIconAlignment_$type } from "./ColumnOptionsIconAlignment";
import { ColumnOptionsIconBehavior_$type } from "./ColumnOptionsIconBehavior";
import { TextHeaderCellModelExport } from "./TextHeaderCellModelExport";
import { IDataSourceUpdateNotifier_$type } from "igniteui-react-core";
import { HashSet$1 } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { createGuid, stringStartsWith, stringEmpty, stringIsNullOrWhiteSpace } from "igniteui-react-core";
import { FastIterationDictionary$2 } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { ColumnResizingMode_$type } from "./ColumnResizingMode";
import { ColumnMovingMode_$type } from "./ColumnMovingMode";
import { ColumnWidth } from "./ColumnWidth";
import { HeaderClickAction_$type } from "./HeaderClickAction";
import { EditModeClickAction_$type } from "./EditModeClickAction";
import { ColumnShowingAnimationMode_$type } from "./ColumnShowingAnimationMode";
import { ColumnPropertyUpdatingAnimationMode_$type } from "./ColumnPropertyUpdatingAnimationMode";
import { CellDataLoadedAnimationMode_$type } from "./CellDataLoadedAnimationMode";
import { RowSelectionAnimationMode_$type } from "./RowSelectionAnimationMode";
import { RowHoverAnimationMode_$type } from "./RowHoverAnimationMode";
import { CellSelectionAnimationMode_$type } from "./CellSelectionAnimationMode";
import { GridColumnAnimationSettings } from "./GridColumnAnimationSettings";
import { GridAnimationSettings } from "./GridAnimationSettings";
import { ColumnResizingAnimationMode_$type } from "./ColumnResizingAnimationMode";
import { ColumnMovingAnimationMode_$type } from "./ColumnMovingAnimationMode";
import { ColumnHidingAnimationMode_$type } from "./ColumnHidingAnimationMode";
import { ColumnExchangingAnimationMode_$type } from "./ColumnExchangingAnimationMode";
import { GridSelectionMode_$type } from "./GridSelectionMode";
import { GridActivationMode_$type } from "./GridActivationMode";
import { GridSelectionBehavior_$type } from "./GridSelectionBehavior";
import { GridSelectedItemsCollection } from "./GridSelectedItemsCollection";
import { GridSelectedKeysCollection } from "./GridSelectedKeysCollection";
import { GridSelectedCellRangesCollection } from "./GridSelectedCellRangesCollection";
import { CornerRadius } from "igniteui-react-core";
import { ColumnSortDescriptionCollection } from "./ColumnSortDescriptionCollection";
import { ColumnGroupDescriptionCollection } from "./ColumnGroupDescriptionCollection";
import { FilterExpressionCollection } from "igniteui-react-core";
import { ColumnSummaryDescriptionCollection } from "./ColumnSummaryDescriptionCollection";
import { DataSourceSummaryScope_$type } from "igniteui-react-core";
import { DataSourceSectionHeaderDisplayMode_$type } from "igniteui-react-core";
import { IEditableDataSource_$type } from "igniteui-react-core";
import { EnterKeyBehaviors_$type } from "./EnterKeyBehaviors";
import { EnterKeyBehaviorAfterEdit_$type } from "./EnterKeyBehaviorAfterEdit";
import { GridFilterExpressionsEventArgs } from "./GridFilterExpressionsEventArgs";
import { CellRange } from "./CellRange";
import { PrimaryKeyValue } from "./PrimaryKeyValue";
import { DeviceUtils } from "igniteui-react-core";
import { DefaultPlatformPixelConverter } from "./DefaultPlatformPixelConverter";
import { ObservableCollection$1 } from "igniteui-react-core";
import { ColumnSortDescription } from "./ColumnSortDescription";
import { GridGroupDescriptionsChangedEventArgs } from "./GridGroupDescriptionsChangedEventArgs";
import { GridSortDescriptionsChangedEventArgs } from "./GridSortDescriptionsChangedEventArgs";
import { GridSelectedItemsChangedEventArgs } from "./GridSelectedItemsChangedEventArgs";
import { GridSelectedKeysChangedEventArgs } from "./GridSelectedKeysChangedEventArgs";
import { GridSelectedCellRangesChangedEventArgs } from "./GridSelectedCellRangesChangedEventArgs";
import { GridDataCommittedEventArgs } from "./GridDataCommittedEventArgs";
import { GridDataCommittingEventArgs } from "./GridDataCommittingEventArgs";
import { DefinitionPropertyUpdatedEventArgs } from "./DefinitionPropertyUpdatedEventArgs";
import { CellPropertyAnimationType_$type } from "./CellPropertyAnimationType";
import { GridSizeChangedEventArgs } from "./GridSizeChangedEventArgs";
import { ColumnStates_$type } from "./ColumnStates";
import { InvalidOperationException } from "igniteui-react-core";
import { VisualModelExport } from "./VisualModelExport";
import { GridActiveCellChangedEventArgs } from "./GridActiveCellChangedEventArgs";
import { FilterFactory } from "igniteui-react-core";
import { Convert } from "igniteui-react-core";
import { GridRowEditStartedEventArgs } from "./GridRowEditStartedEventArgs";
import { GridRowEditEndedEventArgs } from "./GridRowEditEndedEventArgs";
import { timeSpanTotalSeconds, timeSpanFromMilliseconds, timeSpanTotalMilliseconds } from "igniteui-react-core";
import { GridAnimationPhaseSettings } from "./GridAnimationPhaseSettings";
import { GridAnimationManagerAnimationCreatedEventArgs } from "./GridAnimationManagerAnimationCreatedEventArgs";
import { GridAnimationManagerAnimationCompletedEventArgs } from "./GridAnimationManagerAnimationCompletedEventArgs";
import { GridAnimationManagerAnimationCanceledEventArgs } from "./GridAnimationManagerAnimationCanceledEventArgs";
import { GridColumnSpacer } from "./GridColumnSpacer";
import { GridColumnSpacerCollection } from "./GridColumnSpacerCollection";
import { CellStyleRequestedEventArgs } from "./CellStyleRequestedEventArgs";
import { Stack$1 } from "igniteui-react-core";
import { DataSourceSpecialRow } from "igniteui-react-core";
import { RowRange } from "./RowRange";
import { DefaultSectionInformation } from "igniteui-react-core";
import { Color } from "igniteui-react-core";
import { EasingFunctions } from "igniteui-react-core";
import { CalculationParameters } from "./CalculationParameters";
import { ColumnPropertySettersCollection } from "./ColumnPropertySettersCollection";
import { ColumnPropertySetter } from "./ColumnPropertySetter";
import { ResponsiveStateEnteringEventArgs } from "./ResponsiveStateEnteringEventArgs";
import { ResponsiveStateEnteredEventArgs } from "./ResponsiveStateEnteredEventArgs";
import { ResponsiveStateExitedEventArgs } from "./ResponsiveStateExitedEventArgs";
import { RectData } from "igniteui-react-core";
import { GridLayerExport } from "./GridLayerExport";
/**
 * @hidden
 */
export var IExternalGrid_$type = /*@__PURE__*/ new Type(null, 'IExternalGrid');
/**
 * @hidden
 */
var DefaultCellActionManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DefaultCellActionManager, _super);
    function DefaultCellActionManager(a, b) {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.a = null;
        _this.c = false;
        _this.d = false;
        _this.b = a;
        _this.a = b;
        return _this;
    }
    DefaultCellActionManager.prototype.clickExpansionIndicator = function () {
        if (this.b != null && this.a != null) {
            this.b.ss(this.a);
        }
    };
    DefaultCellActionManager.prototype.clickCell = function (a) {
        if (this.b != null && this.a != null) {
            this.b.ro(this.a, this.c, this.d, a);
        }
    };
    DefaultCellActionManager.prototype.dragStarted = function () {
        if (this.b != null && this.b.aq != null) {
            this.b.sq(this.b.aq, this.mousePosition.x, this.mousePosition.y, this.c);
            this.mouseUpCell(this.mousePosition.x, this.mousePosition.y);
        }
    };
    DefaultCellActionManager.prototype.previewPointerDownCell = function () {
        if (this.b != null && this.a != null) {
            this.b.rz(this.a);
        }
    };
    DefaultCellActionManager.prototype.previewPointerUpCell = function () {
        if (this.b != null && this.a != null) {
            this.b.r0(this.a);
        }
    };
    DefaultCellActionManager.prototype.pointerDownCell = function () {
        if (this.b != null && this.a != null) {
            this.b.rx(this.a);
        }
    };
    DefaultCellActionManager.prototype.pointerUpCell = function () {
        if (this.b != null && this.a != null) {
            this.b.ry(this.a);
        }
    };
    DefaultCellActionManager.prototype.mouseDownCell = function (a, b) {
        if (this.b != null && this.a != null) {
            this.b.rv(this.a, a, b);
        }
    };
    DefaultCellActionManager.prototype.mouseUpCell = function (a, b) {
        if (this.b != null && this.a != null) {
            this.b.rw(this.a, a, b);
        }
    };
    DefaultCellActionManager.prototype.mouseLeaveCell = function (a, b) {
        if (this.b != null && this.a != null) {
            this.b.ru(this.a, a, b);
        }
    };
    DefaultCellActionManager.prototype.mouseEnterCell = function (a, b) {
        if (this.b != null && this.a != null) {
            this.b.rt(this.a, a, b);
        }
    };
    DefaultCellActionManager.prototype.mouseIsOver = function (a, b) {
        if (this.b != null && this.a != null) {
            this.b.sw(this.a, a, b);
        }
    };
    DefaultCellActionManager.prototype.doubleClicked = function (a) {
        if (this.b != null && this.a != null) {
            this.b.rq(this.a, a);
        }
    };
    DefaultCellActionManager.prototype.getColumnFilterCondition = function () {
        if (this.b == null) {
            return null;
        }
        return this.b.o(this.a);
    };
    DefaultCellActionManager.prototype.getColumnPropertyType = function () {
        if (this.b == null) {
            return 11;
        }
        return this.b.p(this.a);
    };
    DefaultCellActionManager.prototype.columnFilterChanging = function (a) {
        if (this.b == null) {
            return;
        }
        this.b.qp(this.a, a);
    };
    DefaultCellActionManager.prototype.columnFilterChanged = function (a) {
        if (this.b == null) {
            return;
        }
        this.b.qo(this.a, a);
    };
    DefaultCellActionManager.prototype.isCellDown = function () {
        if (this.b != null && this.b.aq != null && this.a != null) {
            return this.b.aq.equals(this.a.k);
        }
        return false;
    };
    Object.defineProperty(DefaultCellActionManager.prototype, "isLeaveActionDesired", {
        get: function () {
            if (this.a.k.h) {
                return true;
            }
            return this.b.ig;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isEnterActionDesired", {
        get: function () {
            return this.b.ig;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isClickActionDesired", {
        get: function () {
            return this.b.hr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isHoverActionDesired", {
        get: function () {
            return this.b.h7;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isPreviewPointerDownActionDesired", {
        get: function () {
            return this.b.ic;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isPreviewPointerUpActionDesired", {
        get: function () {
            return this.b.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isPointerDownActionDesired", {
        get: function () {
            return this.b.ia;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isPointerUpActionDesired", {
        get: function () {
            return this.b.ib;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isControlPressed", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isShiftPressed", {
        get: function () {
            return this.d;
        },
        set: function (a) {
            this.d = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isDrag", {
        get: function () {
            return this.b.dragger.isDragActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isMouseDown", {
        get: function () {
            return this.b.aq != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "mousePosition", {
        get: function () {
            return this.b.wz;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isGridDragging", {
        get: function () {
            if (this.b != null && this.b.dragger != null) {
                return this.b.dragger.isDragActive;
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isEditRefocusDesired", {
        get: function () {
            if (this.b != null) {
                return this.b.ja();
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    DefaultCellActionManager.prototype.updateCellEditValue = function (a) {
        var b = typeCast(EditorCellModel.$, this.a);
        if (b != null) {
            b.ln = a;
            if (this.b.model.bf != null && this.b.model.be != null) {
                if (b.lk < this.b.model.bf.w || b.lk > this.b.model.be.w) {
                    this.b.qi(b.lk, b.lj, false);
                }
            }
        }
    };
    DefaultCellActionManager.prototype.startEditMode = function () {
        if (this.b.h2() && !this.b.cc.j && this.b.hj) {
            var a = this.b.aj.s();
            var b = this.b.model.d(a, this.b.c1.b);
            this.b.jb(b);
        }
    };
    DefaultCellActionManager.prototype.editorCellLostFocus = function () {
        if (this.b != null) {
            this.b.sr(typeCast(EditorCellModel.$, this.a));
        }
    };
    DefaultCellActionManager.prototype.cancelEditMode = function (a) {
        if (this.b != null && this.b.cc.j) {
            this.b.hk(a);
            if (this.b.cg == 3) {
                this.b.qx(a);
            }
        }
    };
    DefaultCellActionManager.$t = markType(DefaultCellActionManager, 'DefaultCellActionManager', Base.$, [ICellActionManager_$type]);
    return DefaultCellActionManager;
}(Base));
export { DefaultCellActionManager };
/**
 * @hidden
 */
export var IGridInfoRequestor_$type = /*@__PURE__*/ new Type(null, 'IGridInfoRequestor');
/**
 * @hidden
 */
var DefaultGridInfoRequestor = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DefaultGridInfoRequestor, _super);
    function DefaultGridInfoRequestor(a, b) {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.a = null;
        _this.b = a;
        _this.a = b;
        return _this;
    }
    DefaultGridInfoRequestor.prototype.getColumn = function () {
        if (this.b == null) {
            return null;
        }
        return this.b.a1(this.a.k);
    };
    DefaultGridInfoRequestor.prototype.getDensity = function () {
        if (this.b == null) {
            return 3;
        }
        return this.b.fl;
    };
    DefaultGridInfoRequestor.prototype.getTheme = function () {
        if (this.b == null) {
            return 0;
        }
        return 1;
    };
    DefaultGridInfoRequestor.prototype.setViewportChangedHandler = function (a) {
        if (this.b != null && a != null) {
            var b = this.b;
            b.viewportChanged = delegateCombine(b.viewportChanged, a);
        }
    };
    DefaultGridInfoRequestor.prototype.removeViewportChangedHandler = function (a) {
        if (this.b != null && a != null) {
            var b = this.b;
            b.viewportChanged = delegateRemove(b.viewportChanged, a);
        }
    };
    DefaultGridInfoRequestor.$t = markType(DefaultGridInfoRequestor, 'DefaultGridInfoRequestor', Base.$, [IGridInfoRequestor_$type]);
    return DefaultGridInfoRequestor;
}(Base));
export { DefaultGridInfoRequestor };
/**
 * @hidden
 */
var DateTimeColumnValueFormatter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DateTimeColumnValueFormatter, _super);
    function DateTimeColumnValueFormatter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = 0;
        _this.b = false;
        _this.f = null;
        _this.e = null;
        _this.c = null;
        _this.d = null;
        _this.g = null;
        _this.h = null;
        return _this;
    }
    DateTimeColumnValueFormatter.prototype.k = function () {
        this.b = true;
    };
    DateTimeColumnValueFormatter.prototype.j = function (a) {
        this.a = a.k2;
        this.b = false;
    };
    DateTimeColumnValueFormatter.prototype.i = function (a) {
        if (+a == +(dateMinValue())) {
            return "";
        }
        var b = (Intl && Intl.DateTimeFormat);
        if (b) {
            var format_ = null;
            switch (this.a) {
                case 4:
                    if (this.f == null) {
                        this.f = (new Intl.DateTimeFormat([], { month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }));
                    }
                    format_ = this.f;
                    break;
                case 5:
                    if (this.e == null) {
                        this.e = (new Intl.DateTimeFormat([], { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }));
                    }
                    format_ = this.e;
                    break;
                case 1:
                    if (this.c == null) {
                        this.c = (new Intl.DateTimeFormat([], { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }));
                    }
                    format_ = this.c;
                    break;
                case 0:
                    if (this.d == null) {
                        this.d = (new Intl.DateTimeFormat([], { month: 'numeric', day: 'numeric', year: 'numeric' }));
                    }
                    format_ = this.d;
                    break;
                case 3:
                    if (this.g == null) {
                        this.g = (new Intl.DateTimeFormat([], { hour: 'numeric', minute: 'numeric', second: 'numeric' }));
                    }
                    format_ = this.g;
                    break;
                case 2:
                    if (this.h == null) {
                        this.h = (new Intl.DateTimeFormat([], { hour: 'numeric', minute: 'numeric' }));
                    }
                    format_ = this.h;
                    break;
            }
            var date_ = a;
            return (format_.format(date_));
        }
        else {
            var date_ = a;
            switch (this.a) {
                case 4: return (date_.toLocaleString());
                case 5: return (date_.toLocaleString());
                case 1: return (date_.toLocaleDateString());
                case 0: return (date_.toLocaleDateString());
                case 3: return (date_.toLocaleTimeString());
                case 2: return (date_.toLocaleTimeString());
            }
            return a.toString();
        }
    };
    DateTimeColumnValueFormatter.$t = markType(DateTimeColumnValueFormatter, 'DateTimeColumnValueFormatter');
    return DateTimeColumnValueFormatter;
}(Base));
export { DateTimeColumnValueFormatter };
/**
 * @hidden
 */
var CellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellModel, _super);
    function CellModel() {
        var _this = _super.call(this) || this;
        _this.n = null;
        _this.r = null;
        _this.s = 0;
        _this.i2 = null;
        _this.j = null;
        _this.ej = 0;
        _this.a5 = false;
        _this.ba = false;
        _this.as = false;
        _this.aq = false;
        _this.a3 = false;
        _this.bb = false;
        _this.au = false;
        _this.a4 = false;
        _this.c = null;
        _this.ku = Rect.empty;
        _this.d = null;
        _this.am = false;
        _this.an = false;
        _this.al = false;
        _this.c1 = 0;
        _this.bc = new Dictionary$2(String_$type, Boolean_$type, 0);
        _this.cu = -1;
        _this.a = null;
        _this.be = null;
        _this.p = null;
        _this.gm = null;
        _this.bw = 0;
        _this.bx = 0;
        _this.c8 = 0;
        _this.c9 = 0;
        _this.bm = 1;
        _this.bl = 1;
        _this.bj = 1;
        _this.bq = 1;
        _this.bk = 1;
        _this.bo = 0;
        _this.bt = 0;
        _this.bp = 0;
        _this.bu = 0;
        _this.c0 = 0;
        _this.da = 0;
        _this.ao = false;
        _this.u = 0;
        _this.bs = 0;
        _this.bi = 0;
        _this.bn = 0;
        _this.e = 0;
        _this.g = 1;
        _this.j1 = null;
        _this.j2 = null;
        _this.jy = null;
        _this.jz = null;
        _this.jx = null;
        _this.j4 = null;
        _this.j9 = null;
        _this.j5 = null;
        _this.j6 = null;
        _this.ka = null;
        _this.kb = null;
        _this.j8 = null;
        _this.j7 = null;
        _this.br = 0.3;
        _this.gl = null;
        _this.gs = "";
        _this.kc = null;
        _this.j0 = null;
        _this.j3 = null;
        _this.ac = null;
        _this.aa = null;
        _this.y = 0;
        _this.bv = 0;
        _this.c5 = 0;
        _this.c7 = 0;
        _this.c6 = 0;
        _this.c4 = 0;
        _this.cn = 0;
        _this.cp = 0;
        _this.co = 0;
        _this.cm = 0;
        _this.cr = 0;
        _this.ct = 0;
        _this.cs = 0;
        _this.cq = 0;
        _this.cf = 1;
        _this.ch = 1;
        _this.cg = 1;
        _this.ce = 1;
        _this.cx = 2;
        _this.cz = 2;
        _this.cy = 2;
        _this.cw = 2;
        _this.cj = 0;
        _this.cl = 0;
        _this.ck = 0;
        _this.ci = 0;
        _this.l = 0;
        _this.aj = false;
        _this.ag = false;
        _this.w = 0;
        _this.ab = null;
        _this.ai = false;
        _this.ah = false;
        _this.gr = null;
        _this.a1 = false;
        _this.cv = -1;
        _this.ak = false;
        _this.gk = 0;
        _this.propertyChanged = null;
        _this.cellReconciling = null;
        _this.t = 0;
        _this.ej = -1;
        _this.jt();
        _this.kh = GridStyleRepository.aw;
        return _this;
    }
    Object.defineProperty(CellModel.prototype, "o", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            this.n = a;
        },
        enumerable: true,
        configurable: true
    });
    CellModel.ez = function (a) {
        if (CellModel.bf == null || CellModel.bf == undefined) {
            CellModel.bf = new Dictionary$2(String_$type, Number_$type, 0);
        }
        if (CellModel.bf.containsKey(a)) {
            return CellModel.bf.item(a);
        }
        var b = CellModel.c3;
        CellModel.c3++;
        CellModel.c2 = b;
        CellModel.bf.item(a, b);
        return b;
    };
    Object.defineProperty(CellModel.prototype, "t", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            var b = this.s;
            this.s = a;
            if (this.s != b) {
                this.jo("State", CellModel.f9, enumGetBox(ModelStates_$type, b), enumGetBox(ModelStates_$type, this.s));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (this.j != b) {
                this.jo("Path", CellModel.fv, b, this.j);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kv", {
        get: function () {
            return this.ku;
        },
        set: function (a) {
            this.ku = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "a6", {
        get: function () {
            return this.am;
        },
        set: function (a) {
            var b = this.am;
            this.am = a;
            if (this.am != b) {
                this.jo("IsRowPinned", CellModel.fd, b, this.am);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "a7", {
        get: function () {
            return this.an;
        },
        set: function (a) {
            var b = this.an;
            this.an = a;
            if (this.an != b) {
                this.jo("IsRowSticky", CellModel.fe, b, this.an);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "a2", {
        get: function () {
            return this.al;
        },
        set: function (a) {
            var b = this.al;
            this.al = a;
            if (this.al != b) {
                this.jo("IsLastStickyRow", CellModel.fc, b, this.al);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "e6", {
        get: function () {
            return this.c1;
        },
        set: function (a) {
            var b = this.c1;
            this.c1 = a;
            if (this.c1 != b) {
                this.jo("Indent", CellModel.e7, b, this.c1);
            }
        },
        enumerable: true,
        configurable: true
    });
    CellModel.prototype.at = function (a) {
        if (this.bc.containsKey(a)) {
            return this.bc.item(a);
        }
        return false;
    };
    CellModel.prototype.ax = function (propertyId_) {
        if (this.cu == -1) {
            return false;
        }
        var a = ((propertyId_ / 32) | 0);
        var b = propertyId_ % 32;
        return ((this.a[a] >> b) & 1) != 0;
    };
    CellModel.prototype.aw = function (a) {
        var b = CellModel.bf.f(a);
        if (b != undefined) {
            return this.ax(b);
        }
        if (this.at(a)) {
            return true;
        }
        return false;
    };
    CellModel.prototype.jg = function (propertyId_) {
        if (this.cu == -1) {
            this.cu = truncate(Math.ceil(CellModel.c2 / 32));
            this.a = new Array(propertyId_);
        }
        var a = ((propertyId_ / 32) | 0);
        var b = propertyId_ % 32;
        this.a[a] = this.a[a] | (1 << b);
    };
    CellModel.prototype.jd = function () {
        for (var a = 0; a < this.cu; a++) {
            this.a[a] = 0;
        }
    };
    CellModel.prototype.jh = function (a) {
        var b = CellModel.bf.f(a);
        if (b != undefined) {
            this.jg(b);
            return;
        }
        this.bc.item(a, true);
    };
    CellModel.prototype.jo = function (a, b, c, d) {
        this.jg(b);
        this.jr(a, c, d);
        if (this.o != null) {
            this.o.tm();
        }
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
    };
    CellModel.prototype.jr = function (a, b, c) {
        switch (a) {
            case "State":
                this.a5 = true;
                this.ba = true;
                this.as = true;
                this.bb = true;
                break;
            case "LeftOffset":
            case "TopOffset":
            case "LeftPercentOffset":
            case "TopPercentOffset":
            case "X":
            case "Y":
                this.a5 = true;
                break;
            case "Width":
            case "Height":
                this.ba = true;
                break;
            case "RowItem":
                this.jp();
                break;
            case "Background":
            case "SelectedBackground":
            case "SelectedStatus":
            case "HoverBackground":
            case "HoverStatus":
            case "IsLastStickyRow":
            case "StickyRowBackground":
            case "PinnedRowBackground":
            case "LastStickyRowBackground":
                this.jj();
                this.jq();
                break;
            case "IsRowSticky":
            case "IsRowPinned":
            case "PinnedRowOpacity":
                this.jj();
                this.jm();
                break;
            case "Border":
            case "ActivationBorder":
            case "ErrorBorder":
            case "BorderLeftWidth":
            case "BorderTopWidth":
            case "BorderBottomWidth":
            case "BorderRightWidth":
            case "ActivationBorderLeftWidth":
            case "ActivationBorderTopWidth":
            case "ActivationBorderBottomWidth":
            case "ActivationBorderRightWidth":
            case "ActivationStatus":
            case "EditError":
            case "ErrorBorderLeftWidth":
            case "ErrorBorderTopWidth":
            case "ErrorBorderBottomWidth":
            case "ErrorBorderRightWidth":
                this.aq = true;
                this.jk();
                break;
            case "PaddingLeft":
            case "PaddingTop":
            case "PaddingBottom":
            case "PaddingRight":
                this.jk();
                break;
            case "Opacity":
                this.jl();
                break;
            case "ContentOpacity":
            case "EditOpacity":
                this.jm();
                break;
            case "IsEdited":
            case "IsDeleted":
                this.jq();
                this.jm();
                this.jn();
                this.as = true;
                break;
            case "TextColor":
            case "DeletedTextColor":
            case "HoverTextColor":
                this.jq();
                break;
            case "FontInfo":
            case "EditFontInfo":
                this.jn();
                break;
            case "Path": break;
            default:
                this.as = true;
                break;
        }
    };
    CellModel.prototype.jp = function () {
    };
    CellModel.prototype.jj = function () {
        var a = this.kh;
        if (this.a2 && this.ko != null) {
            a = this.ko;
        }
        else if (this.a7 && this.ks != null) {
            a = this.ks;
        }
        else if (this.a6 && this.kp != null) {
            a = this.kp;
        }
        if (this.km != null) {
            a = this.kl(a, this.km, this.b3);
        }
        this.ke = this.kl(a, this.kq, this.b8);
    };
    CellModel.prototype.jk = function () {
        var a = false;
        if (this.by != 0 && this.kd != null) {
            a = true;
        }
        if (this.hm != null) {
            var b = this.er - this.eb;
            var c = this.ew - this.eg;
            var d = this.eu - this.ee;
            var e = this.ep - this.d9;
            this.d1 = Math.max(0, this.fp - b);
            this.d5 = Math.max(0, this.ft - c);
            this.d3 = Math.max(0, this.fr - d);
            this.dz = Math.max(0, this.fn - e);
            this.dp = Math.max(0, this.eb + b);
            this.du = Math.max(0, this.eg + c);
            this.ds = Math.max(0, this.ee + d);
            this.dm = Math.max(0, this.d9 + e);
            this.kf = this.kk;
        }
        else {
            if (a && (this.eb == 0 || this.eg == 0 || this.ee == 0 || this.d9 == 0)) {
                var f = this.dd - this.eb;
                var g = this.di - this.eg;
                var h = this.dg - this.ee;
                var i = this.db - this.d9;
                this.d1 = Math.max(0, this.fp - f);
                this.d5 = Math.max(0, this.ft - g);
                this.d3 = Math.max(0, this.fr - h);
                this.dz = Math.max(0, this.fn - i);
                this.dp = Math.max(0, this.eb + f);
                this.du = Math.max(0, this.eg + g);
                this.ds = Math.max(0, this.ee + h);
                this.dm = Math.max(0, this.d9 + i);
            }
            else {
                this.d1 = this.fp;
                this.d5 = this.ft;
                this.d3 = this.fr;
                this.dz = this.fn;
                this.dp = this.eb;
                this.du = this.eg;
                this.ds = this.ee;
                this.dm = this.d9;
            }
            var j = this.ki;
            this.kf = this.kl(j, this.kd, this.by);
        }
    };
    CellModel.prototype.jl = function () {
        this.b0 = this.b6;
    };
    CellModel.prototype.jm = function () {
        if (this.ay && !this.av) {
            this.bz = this.b2;
        }
        else if (this.a6 && !this.a7) {
            this.bz = this.b7;
        }
        else {
            this.bz = this.b1;
        }
    };
    CellModel.prototype.jq = function () {
        var a = this.kt;
        if (this.av) {
            a = this.kj;
        }
        else if (this.kn != null) {
            a = this.kl(a, this.kn, this.b3);
        }
        this.kg = a;
    };
    CellModel.prototype.jn = function () {
        if (this.ay || this.av) {
            this.ad = this.ae;
        }
        else {
            this.ad = this.af;
        }
    };
    CellModel.prototype.kl = function (a, b, c) {
        if (c == 0) {
            return a;
        }
        if (c == 1) {
            return b;
        }
        return BrushUtil.k(a, c, b, 0);
    };
    CellModel.prototype.jt = function () {
        this.ju();
    };
    CellModel.prototype.ju = function () {
        this.jd();
        if (this.be != null) {
            this.be.clear();
        }
        this.b8 = 0;
        this.as = true;
        this.a5 = true;
        this.ba = true;
        this.a3 = false;
    };
    CellModel.prototype.jv = function (a, b) {
        if (this.be == null) {
            this.be = new Dictionary$2(String_$type, Base.$, 0);
        }
        var c = null;
        if (this.be.containsKey(a)) {
            c = this.be.item(a);
        }
        this.be.item(a, b);
        var d = false;
        if (c == null && b != null) {
            d = true;
        }
        if (c != null) {
            if (!Base.equalsStatic(c, b)) {
                d = true;
            }
        }
        if (d) {
            this.jh(a);
            this.as = true;
            if (this.o != null) {
                this.o.tm();
            }
        }
    };
    CellModel.prototype.ap = function (a) {
        if (this.be == null) {
            return false;
        }
        return this.be.containsKey(a);
    };
    CellModel.prototype.js = function (a) {
        if (this.be == null) {
            return;
        }
        if (this.be.containsKey(a)) {
            this.be.removeItem(a);
        }
    };
    CellModel.prototype.gn = function (a) {
        if (this.be == null) {
            return null;
        }
        if (this.be.containsKey(a)) {
            return this.be.item(a);
        }
        return null;
    };
    Object.defineProperty(CellModel.prototype, "q", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            var b = this.p;
            this.p = a;
            if (this.p != b) {
                this.a3 = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "gq", {
        get: function () {
            return this.gm;
        },
        set: function (a) {
            var b = this.gm;
            this.gm = a;
            if (this.gm != b) {
                this.jo("RowItem", CellModel.f0, b, this.gm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "cc", {
        get: function () {
            return this.bw;
        },
        set: function (a) {
            var b = this.bw;
            this.bw = a;
            if (this.bw != b) {
                this.jo("X", CellModel.gi, b, this.bw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "cd", {
        get: function () {
            return this.bx;
        },
        set: function (a) {
            var b = this.bx;
            this.bx = a;
            if (this.bx != b) {
                this.jo("Y", CellModel.gj, b, this.bx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "f3", {
        get: function () {
            return this.c8;
        },
        set: function (a) {
            var b = this.c8;
            this.c8 = a;
            if (this.c8 != b) {
                this.jo("SnappedX", CellModel.f4, b, this.c8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "f5", {
        get: function () {
            return this.c9;
        },
        set: function (a) {
            var b = this.c9;
            this.c9 = a;
            if (this.c9 != b) {
                this.jo("SnappedY", CellModel.f6, b, this.c9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b2", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            var b = this.bm;
            this.bm = a;
            if (this.bm != b) {
                this.jo("EditOpacity", CellModel.eo, b, this.bm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b1", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            if (this.bl != b) {
                this.jo("ContentOpacity", CellModel.ei, b, this.bl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "bz", {
        get: function () {
            return this.bj;
        },
        set: function (a) {
            var b = this.bj;
            this.bj = a;
            if (this.bj != b) {
                this.jo("ActualContentOpacity", CellModel.dw, b, this.bj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b6", {
        get: function () {
            return this.bq;
        },
        set: function (a) {
            var b = this.bq;
            this.bq = a;
            if (this.bq != b) {
                this.jo("Opacity", CellModel.fl, b, this.bq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b0", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (this.bk != b) {
                this.jo("ActualOpacity", CellModel.dy, b, this.bk);
            }
        },
        enumerable: true,
        configurable: true
    });
    CellModel.prototype.ji = function () {
        if (this.cellReconciling != null) {
            this.cellReconciling(this);
        }
    };
    Object.defineProperty(CellModel.prototype, "b4", {
        get: function () {
            return this.bo;
        },
        set: function (a) {
            var b = this.bo;
            this.bo = a;
            if (this.bo != b) {
                this.jo("LeftOffset", CellModel.fh, b, this.bo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b9", {
        get: function () {
            return this.bt;
        },
        set: function (a) {
            var b = this.bt;
            this.bt = a;
            if (this.bt != b) {
                this.jo("TopOffset", CellModel.gc, b, this.bt);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b5", {
        get: function () {
            return this.bp;
        },
        set: function (a) {
            var b = this.bp;
            this.bp = a;
            if (this.bp != b) {
                this.jo("LeftPercentOffset", CellModel.fi, b, this.bp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ca", {
        get: function () {
            return this.bu;
        },
        set: function (a) {
            var b = this.bu;
            this.bu = a;
            if (this.bu != b) {
                this.jo("TopPercentOffset", CellModel.gd, b, this.bu);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "e0", {
        get: function () {
            return this.c0;
        },
        set: function (a) {
            var b = this.c0;
            this.c0 = a;
            if (this.c0 != b) {
                this.jo("Height", CellModel.e1, b, this.c0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "gg", {
        get: function () {
            return this.da;
        },
        set: function (a) {
            var b = this.da;
            this.da = a;
            if (this.da != b) {
                this.jo("Width", CellModel.gh, b, this.da);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "a9", {
        get: function () {
            return this.ao;
        },
        set: function (a) {
            var b = this.ao;
            this.ao = a;
            if (this.ao != b) {
                this.jo("IsSelected", CellModel.ff, b, this.ao);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "v", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            var b = this.u;
            this.u = a;
            if (this.u != b) {
                this.jo("ModelType", CellModel.fk, enumGetBox(ModelTypes_$type, b), enumGetBox(ModelTypes_$type, this.u));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b8", {
        get: function () {
            return this.bs;
        },
        set: function (a) {
            var b = this.bs;
            this.bs = a;
            if (this.bs != b) {
                this.jo("SelectedStatus", CellModel.f2, b, this.bs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "by", {
        get: function () {
            return this.bi;
        },
        set: function (a) {
            var b = this.bi;
            this.bi = a;
            if (this.bi != b) {
                this.jo("ActivationStatus", CellModel.dk, b, this.bi);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b3", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            var b = this.bn;
            this.bn = a;
            if (this.bn != b) {
                this.jo("HoverStatus", CellModel.e4, b, this.bn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "f", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            var b = this.e;
            this.e = a;
            if (this.e != b) {
                this.jo("HorizontalAlignment", CellModel.e2, enumGetBox(CellContentHorizontalAlignment_$type, b), enumGetBox(CellContentHorizontalAlignment_$type, this.e));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "h", {
        get: function () {
            return this.g;
        },
        set: function (a) {
            var b = this.g;
            this.g = a;
            if (this.g != b) {
                this.jo("VerticalAlignment", CellModel.ge, enumGetBox(CellContentVerticalAlignment_$type, b), enumGetBox(CellContentHorizontalAlignment_$type, this.e));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kh", {
        get: function () {
            return this.j1;
        },
        set: function (a) {
            var b = this.j1;
            this.j1 = a;
            if (this.j1 != b) {
                this.jo("Background", CellModel.d8, b, this.j1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ki", {
        get: function () {
            return this.j2;
        },
        set: function (a) {
            var b = this.j2;
            this.j2 = a;
            if (this.j2 != b) {
                this.jo("Border", CellModel.ed, b, this.j2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ke", {
        get: function () {
            return this.jy;
        },
        set: function (a) {
            var b = this.jy;
            this.jy = a;
            if (this.jy != b) {
                this.jo("ActualBackground", CellModel.dl, b, this.jy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kf", {
        get: function () {
            return this.jz;
        },
        set: function (a) {
            var b = this.jz;
            this.jz = a;
            if (this.jz != b) {
                this.jo("ActualBorder", CellModel.dr, b, this.jz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kd", {
        get: function () {
            return this.jx;
        },
        set: function (a) {
            var b = this.jx;
            this.jx = a;
            if (this.jx != b) {
                this.jo("ActivationBorder", CellModel.df, b, this.jx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kk", {
        get: function () {
            return this.j4;
        },
        set: function (a) {
            var b = this.j4;
            this.j4 = a;
            if (this.j4 != b) {
                this.jo("ErrorBorder", CellModel.et, b, this.j4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kq", {
        get: function () {
            return this.j9;
        },
        set: function (a) {
            var b = this.j9;
            this.j9 = a;
            if (this.j9 != b) {
                this.jo("SelectedBackground", CellModel.f1, b, this.j9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "km", {
        get: function () {
            return this.j5;
        },
        set: function (a) {
            var b = this.j5;
            this.j5 = a;
            if (this.j5 != b) {
                this.jo("HoverBackground", CellModel.e3, b, this.j5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kn", {
        get: function () {
            return this.j6;
        },
        set: function (a) {
            var b = this.j6;
            this.j6 = a;
            if (this.j6 != b) {
                this.jo("HoverTextColor", CellModel.e5, b, this.j6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kr", {
        get: function () {
            return this.ka;
        },
        set: function (a) {
            var b = this.ka;
            this.ka = a;
            if (this.ka != b) {
                this.jo("SortIndicatorColor", CellModel.f8, b, this.ka);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ks", {
        get: function () {
            return this.kb;
        },
        set: function (a) {
            var b = this.kb;
            this.kb = a;
            if (this.kb != b) {
                this.jo("StickyRowBackground", CellModel.ga, b, this.kb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kp", {
        get: function () {
            return this.j8;
        },
        set: function (a) {
            var b = this.j8;
            this.j8 = a;
            if (this.j8 != b) {
                this.jo("PinnedRowBackground", CellModel.fx, b, this.j8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ko", {
        get: function () {
            return this.j7;
        },
        set: function (a) {
            var b = this.j7;
            this.j7 = a;
            if (this.j7 != b) {
                this.jo("LastStickyRowBackground", CellModel.fg, b, this.j7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b7", {
        get: function () {
            return this.br;
        },
        set: function (a) {
            var b = this.br;
            this.br = a;
            if (this.br != b) {
                this.jo("PinnedRowOpacity", CellModel.fy, b, this.br);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "gp", {
        get: function () {
            return this.gl;
        },
        set: function (a) {
            var b = this.gl;
            this.gl = a;
            if (this.gl != b) {
                this.jo("OriginalValue", CellModel.fm, b, this.gl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ir", {
        get: function () {
            return this.gs;
        },
        set: function (a) {
            var b = this.gs;
            this.gs = a;
            if (this.gs != b) {
                this.jo("RenderValue", CellModel.fz, b, this.gs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kt", {
        get: function () {
            return this.kc;
        },
        set: function (a) {
            var b = this.kc;
            this.kc = a;
            if (this.kc != b) {
                this.jo("TextColor", CellModel.gb, b, this.kc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kg", {
        get: function () {
            return this.j0;
        },
        set: function (a) {
            var b = this.j0;
            this.j0 = a;
            if (this.j0 != b) {
                this.jo("ActualTextColor", CellModel.d7, b, this.j0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kj", {
        get: function () {
            return this.j3;
        },
        set: function (a) {
            var b = this.j3;
            this.j3 = a;
            if (this.j3 != b) {
                this.jo("DeletedTextColor", CellModel.ek, b, this.j3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "af", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            var b = this.ac;
            this.ac = a;
            if (this.ac != b) {
                this.jo("FontInfo", CellModel.ey, b, this.ac);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ad", {
        get: function () {
            return this.aa;
        },
        set: function (a) {
            var b = this.aa;
            this.aa = a;
            if (this.aa != b) {
                this.jo("ActualFontInfo", CellModel.dx, b, this.aa);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "z", {
        get: function () {
            return this.y;
        },
        set: function (a) {
            var b = this.y;
            this.y = a;
            if (this.y != b) {
                this.jo("LineBreakMode", CellModel.fj, enumGetBox(TextCellLineBreakMode_$type, b), enumGetBox(TextCellLineBreakMode_$type, this.y));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "cb", {
        get: function () {
            return this.bv;
        },
        set: function (a) {
            var b = this.bv;
            this.bv = a;
            if (this.bv != b) {
                this.jo("VirtualizationPercentage", CellModel.gf, b, this.bv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "fp", {
        get: function () {
            return this.c5;
        },
        set: function (a) {
            var b = this.c5;
            this.c5 = a;
            if (this.c5 != b) {
                this.jo("PaddingLeft", CellModel.fq, b, this.c5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ft", {
        get: function () {
            return this.c7;
        },
        set: function (a) {
            var b = this.c7;
            this.c7 = a;
            if (this.c7 != b) {
                this.jo("PaddingTop", CellModel.fu, b, this.c7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "fr", {
        get: function () {
            return this.c6;
        },
        set: function (a) {
            var b = this.c6;
            this.c6 = a;
            if (this.c6 != b) {
                this.jo("PaddingRight", CellModel.fs, b, this.c6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "fn", {
        get: function () {
            return this.c4;
        },
        set: function (a) {
            var b = this.c4;
            this.c4 = a;
            if (this.c4 != b) {
                this.jo("PaddingBottom", CellModel.fo, b, this.c4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "d1", {
        get: function () {
            return this.cn;
        },
        set: function (a) {
            var b = this.cn;
            this.cn = a;
            if (this.cn != b) {
                this.jo("ActualPaddingLeft", CellModel.d2, b, this.cn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "d5", {
        get: function () {
            return this.cp;
        },
        set: function (a) {
            var b = this.cp;
            this.cp = a;
            if (this.cp != b) {
                this.jo("ActualPaddingTop", CellModel.d6, b, this.cp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "d3", {
        get: function () {
            return this.co;
        },
        set: function (a) {
            var b = this.co;
            this.co = a;
            if (this.co != b) {
                this.jo("ActualPaddingRight", CellModel.d4, b, this.co);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dz", {
        get: function () {
            return this.cm;
        },
        set: function (a) {
            var b = this.cm;
            this.cm = a;
            if (this.cm != b) {
                this.jo("ActualPaddingBottom", CellModel.d0, b, this.cm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "eb", {
        get: function () {
            return this.cr;
        },
        set: function (a) {
            var b = this.cr;
            this.cr = a;
            if (this.cr != b) {
                this.jo("BorderLeftWidth", CellModel.ec, b, this.cr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "eg", {
        get: function () {
            return this.ct;
        },
        set: function (a) {
            var b = this.ct;
            this.ct = a;
            if (this.ct != b) {
                this.jo("BorderTopWidth", CellModel.eh, b, this.ct);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ee", {
        get: function () {
            return this.cs;
        },
        set: function (a) {
            var b = this.cs;
            this.cs = a;
            if (this.cs != b) {
                this.jo("BorderRightWidth", CellModel.ef, b, this.cs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "d9", {
        get: function () {
            return this.cq;
        },
        set: function (a) {
            var b = this.cq;
            this.cq = a;
            if (this.cq != b) {
                this.jo("BorderBottomWidth", CellModel.ea, b, this.cq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dd", {
        get: function () {
            return this.cf;
        },
        set: function (a) {
            var b = this.cf;
            this.cf = a;
            if (this.cf != b) {
                this.jo("ActivationBorderLeftWidth", CellModel.de, b, this.cf);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "di", {
        get: function () {
            return this.ch;
        },
        set: function (a) {
            var b = this.ch;
            this.ch = a;
            if (this.ch != b) {
                this.jo("ActivationBorderTopWidth", CellModel.dj, b, this.ch);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dg", {
        get: function () {
            return this.cg;
        },
        set: function (a) {
            var b = this.cg;
            this.cg = a;
            if (this.cg != b) {
                this.jo("ActivationBorderRightWidth", CellModel.dh, b, this.cg);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "db", {
        get: function () {
            return this.ce;
        },
        set: function (a) {
            var b = this.ce;
            this.ce = a;
            if (this.ce != b) {
                this.jo("ActivationBorderBottomWidth", CellModel.dc, b, this.ce);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "er", {
        get: function () {
            return this.cx;
        },
        set: function (a) {
            var b = this.cx;
            this.cx = a;
            if (this.cx != b) {
                this.jo("ErrorBorderLeftWidth", CellModel.es, b, this.cx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ew", {
        get: function () {
            return this.cz;
        },
        set: function (a) {
            var b = this.cz;
            this.cz = a;
            if (this.cz != b) {
                this.jo("ErrorBorderTopWidth", CellModel.ex, b, this.cz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "eu", {
        get: function () {
            return this.cy;
        },
        set: function (a) {
            var b = this.cy;
            this.cy = a;
            if (this.cy != b) {
                this.jo("ErrorBorderRightWidth", CellModel.ev, b, this.cy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ep", {
        get: function () {
            return this.cw;
        },
        set: function (a) {
            var b = this.cw;
            this.cw = a;
            if (this.cw != b) {
                this.jo("ErrorBorderBottomWidth", CellModel.eq, b, this.cw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dp", {
        get: function () {
            return this.cj;
        },
        set: function (a) {
            var b = this.cj;
            this.cj = a;
            if (this.cj != b) {
                this.jo("ActualBorderLeftWidth", CellModel.dq, b, this.cj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "du", {
        get: function () {
            return this.cl;
        },
        set: function (a) {
            var b = this.cl;
            this.cl = a;
            if (this.cl != b) {
                this.jo("ActualBorderTopWidth", CellModel.dv, b, this.cl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ds", {
        get: function () {
            return this.ck;
        },
        set: function (a) {
            var b = this.ck;
            this.ck = a;
            if (this.ck != b) {
                this.jo("ActualBorderRightWidth", CellModel.dt, b, this.ck);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dm", {
        get: function () {
            return this.ci;
        },
        set: function (a) {
            var b = this.ci;
            this.ci = a;
            if (this.ci != b) {
                this.jo("ActualBorderBottomWidth", CellModel.dn, b, this.ci);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "m", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            var b = this.l;
            this.l = a;
            if (this.l != b) {
                this.jo("SortDirection", CellModel.f7, enumGetBox(ColumnSortDirection_$type, b), enumGetBox(ColumnSortDirection_$type, this.l));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "az", {
        get: function () {
            return this.aj;
        },
        set: function (a) {
            var b = this.aj;
            this.aj = a;
            if (this.aj != b) {
                this.jo("IsExpanded", CellModel.fb, b, this.aj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ar", {
        get: function () {
            return this.ag;
        },
        set: function (a) {
            var b = this.ag;
            this.ag = a;
            if (this.ag != b) {
                this.jo("IsCollapsable", CellModel.e8, b, this.ag);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "x", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (this.w != b) {
                this.jo("Pinned", CellModel.fw, enumGetBox(PinnedPositions_$type, b), enumGetBox(PinnedPositions_$type, this.w));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ae", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            var b = this.ab;
            this.ab = a;
            if (this.ab != b) {
                this.jo("EditFontInfo", CellModel.em, b, this.ab);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ay", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            var b = this.ai;
            this.ai = a;
            if (this.ai != b) {
                this.jo("IsEdited", CellModel.fa, b, this.ai);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "av", {
        get: function () {
            return this.ah;
        },
        set: function (a) {
            var b = this.ah;
            this.ah = a;
            if (this.ah != b) {
                this.jo("IsDeleted", CellModel.e9, b, this.ah);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "hm", {
        get: function () {
            return this.gr;
        },
        set: function (a) {
            var b = this.gr;
            this.gr = a;
            if (this.gr != b) {
                this.jo("EditError", CellModel.el, b, this.gr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "en", {
        get: function () {
            return this.cv;
        },
        set: function (a) {
            this.cv = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "a0", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            this.ak = a;
        },
        enumerable: true,
        configurable: true
    });
    CellModel.prototype.jb = function () {
        this.jc();
    };
    CellModel.prototype.jc = function () {
        this.a5 = false;
        this.ba = false;
        this.as = false;
        this.aq = false;
        this.a3 = false;
        this.bb = false;
        this.au = false;
        this.jd();
    };
    CellModel.prototype.b = function (a) {
        if (a == null) {
            a = new CellModelExport();
        }
        a.r = this.cc;
        a.s = this.cd;
        a.n = this.f3;
        a.o = this.f5;
        a.k = this.e0;
        a.q = this.gg;
        a.m = this.b8;
        a.h = this.by;
        a.z = EnumUtil.getName(TextCellLineBreakMode_$type, this.z);
        a.a = AppearanceHelper.a(this.ke);
        a.b = AppearanceHelper.a(this.kf);
        a.l = this.b0;
        a.i = this.bz;
        a.t = this.e6;
        a.g = this.ar;
        a.d = this.f;
        a.e = this.h;
        a.aa = this.ir;
        a.p = this.cb;
        a.f = this.m;
        a.c = AppearanceHelper.a(this.kg);
        if (this.ad != null) {
            var b = this.ad;
            if (this.o != null && b.n == null) {
                var c = this.o.externalGrid.renderer;
                var d = FontUtil.getFontInfoFromString(c, b.fontString);
                b.n = d.n;
                b.d = d.d;
                b.o = d.o;
                b.q = d.q;
                b.r = d.r;
                b.s = d.s;
            }
            if (b.n != null) {
                a.u = b.n;
            }
            if (!isNaN_(b.d)) {
                a.j = b.d;
            }
            if (b.s != null) {
                a.y = b.s;
            }
            if (b.q != null) {
                a.w = b.q;
            }
            if (b.o != null) {
                a.v = b.q;
            }
        }
        return a;
    };
    CellModel.prototype.jf = function () {
        if (CellModel.bg == null) {
            CellModel.bg = new Dictionary$2(String_$type, Delegate_$type, 0);
            CellModel.bg.addItem("X", function (a, b) { return a.cc = typeGetValue(b); });
            CellModel.bg.addItem("Y", function (a, b) { return a.cd = typeGetValue(b); });
            CellModel.bg.addItem("SnappedX", function (a, b) { return a.f3 = typeGetValue(b); });
            CellModel.bg.addItem("SnappedY", function (a, b) { return a.f5 = typeGetValue(b); });
            CellModel.bg.addItem("ContentOpacity", function (a, b) { return a.b1 = b; });
            CellModel.bg.addItem("Opacity", function (a, b) { return a.b6 = b; });
            CellModel.bg.addItem("LeftOffset", function (a, b) { return a.b4 = b; });
            CellModel.bg.addItem("LeftPercentOffset", function (a, b) { return a.b5 = b; });
            CellModel.bg.addItem("TopOffset", function (a, b) { return a.b9 = b; });
            CellModel.bg.addItem("TopPercentOffset", function (a, b) { return a.ca = b; });
            CellModel.bg.addItem("Height", function (a, b) { return a.e0 = typeGetValue(b); });
            CellModel.bg.addItem("Width", function (a, b) { return a.gg = typeGetValue(b); });
            CellModel.bg.addItem("IsSelected", function (a, b) { return a.a9 = b; });
            CellModel.bg.addItem("ModelType", function (a, b) { return a.v = EnumUtil.getEnumValue(ModelTypes_$type, b); });
            CellModel.bg.addItem("SelectedStatus", function (a, b) { return a.b8 = b; });
            CellModel.bg.addItem("ActivationStatus", function (a, b) { return a.by = b; });
            CellModel.bg.addItem("HoverStatus", function (a, b) { return a.b3 = b; });
            CellModel.bg.addItem("HorizontalAlignment", function (a, b) { return a.f = EnumUtil.getEnumValue(CellContentHorizontalAlignment_$type, b); });
            CellModel.bg.addItem("VerticalAlignment", function (a, b) { return a.h = EnumUtil.getEnumValue(CellContentVerticalAlignment_$type, b); });
            CellModel.bg.addItem("Background", function (a, b) { return a.kh = b; });
            CellModel.bg.addItem("Border", function (a, b) { return a.ki = b; });
            CellModel.bg.addItem("ActivationBorder", function (a, b) { return a.kd = b; });
            CellModel.bg.addItem("SelectedBackground", function (a, b) { return a.kq = b; });
            CellModel.bg.addItem("HoverBackground", function (a, b) { return a.km = b; });
            CellModel.bg.addItem("RenderValue", function (a, b) { return a.ir = b; });
            CellModel.bg.addItem("OriginalValue", function (a, b) { return a.gp = b; });
            CellModel.bg.addItem("TextColor", function (a, b) { return a.kt = b; });
            CellModel.bg.addItem("SortIndicatorColor", function (a, b) { return a.kr = b; });
            CellModel.bg.addItem("FontInfo", function (a, b) { return a.af = b; });
            CellModel.bg.addItem("LineBreakMode", function (a, b) { return a.z = EnumUtil.getEnumValue(TextCellLineBreakMode_$type, b); });
            CellModel.bg.addItem("VirtualizationPercentage", function (a, b) { return a.cb = b; });
            CellModel.bg.addItem("PaddingLeft", function (a, b) { return a.fp = typeGetValue(b); });
            CellModel.bg.addItem("PaddingTop", function (a, b) { return a.ft = typeGetValue(b); });
            CellModel.bg.addItem("PaddingRight", function (a, b) { return a.fr = typeGetValue(b); });
            CellModel.bg.addItem("PaddingBottom", function (a, b) { return a.fn = typeGetValue(b); });
            CellModel.bg.addItem("BorderLeftWidth", function (a, b) { return a.eb = typeGetValue(b); });
            CellModel.bg.addItem("BorderTopWidth", function (a, b) { return a.eg = typeGetValue(b); });
            CellModel.bg.addItem("BorderRightWidth", function (a, b) { return a.ee = typeGetValue(b); });
            CellModel.bg.addItem("BorderBottomWidth", function (a, b) { return a.d9 = typeGetValue(b); });
            CellModel.bg.addItem("ActivationBorderLeftWidth", function (a, b) { return a.dd = typeGetValue(b); });
            CellModel.bg.addItem("ActivationBorderTopWidth", function (a, b) { return a.di = typeGetValue(b); });
            CellModel.bg.addItem("ActivationBorderRightWidth", function (a, b) { return a.dg = typeGetValue(b); });
            CellModel.bg.addItem("ActivationBorderBottomWidth", function (a, b) { return a.db = typeGetValue(b); });
            CellModel.bg.addItem("SortDirection", function (a, b) { return a.m = EnumUtil.getEnumValue(ColumnSortDirection_$type, b); });
            CellModel.bg.addItem("PinnedRowBackground", function (a, b) { return a.kp = b; });
            CellModel.bg.addItem("StickyRowBackground", function (a, b) { return a.ks = b; });
            CellModel.bg.addItem("LastStickyRowBackground", function (a, b) { return a.ko = b; });
            CellModel.bg.addItem("PinnedRowOpacity", function (a, b) { return a.b7 = b; });
            CellModel.bg.addItem("Pinned", function (a, b) { return a.x = EnumUtil.getEnumValue(PinnedPositions_$type, b); });
            CellModel.bg.addItem("IsEdited", function (a, b) { return a.ay = b; });
            CellModel.bg.addItem("IsDeleted", function (a, b) { return a.av = b; });
            CellModel.bg.addItem("DeletedTextColor", function (a, b) { return a.kj = b; });
            CellModel.bg.addItem("EditOpacity", function (a, b) { return a.b2 = b; });
            CellModel.bg.addItem("EditFontInfo", function (a, b) { return a.ae = b; });
            CellModel.bg.addItem("ErrorBorder", function (a, b) { return a.kk = b; });
            CellModel.bg.addItem("ErrorBorderLeftWidth", function (a, b) { return a.er = typeGetValue(b); });
            CellModel.bg.addItem("ErrorBorderTopWidth", function (a, b) { return a.ew = typeGetValue(b); });
            CellModel.bg.addItem("ErrorBorderBottomWidth", function (a, b) { return a.ep = typeGetValue(b); });
            CellModel.bg.addItem("ErrorBorderRightWidth", function (a, b) { return a.eu = typeGetValue(b); });
            CellModel.bg.addItem("EditError", function (a, b) { return a.hm = b; });
        }
    };
    CellModel.prototype.je = function () {
        if (CellModel.bd == null) {
            CellModel.bd = new Dictionary$2(String_$type, Delegate_$type, 0);
            CellModel.bd.addItem("X", function (a) { return a.cc; });
            CellModel.bd.addItem("Y", function (a) { return a.cd; });
            CellModel.bd.addItem("SnappedX", function (a) { return a.f3; });
            CellModel.bd.addItem("SnappedY", function (a) { return a.f5; });
            CellModel.bd.addItem("ContentOpacity", function (a) { return a.b1; });
            CellModel.bd.addItem("Opacity", function (a) { return a.b6; });
            CellModel.bd.addItem("LeftOffset", function (a) { return a.b4; });
            CellModel.bd.addItem("LeftPercentOffset", function (a) { return a.b5; });
            CellModel.bd.addItem("TopOffset", function (a) { return a.b9; });
            CellModel.bd.addItem("TopPercentOffset", function (a) { return a.ca; });
            CellModel.bd.addItem("Height", function (a) { return a.e0; });
            CellModel.bd.addItem("Width", function (a) { return a.gg; });
            CellModel.bd.addItem("IsSelected", function (a) { return a.a9; });
            CellModel.bd.addItem("ModelType", function (a) { return enumGetBox(ModelTypes_$type, a.v); });
            CellModel.bd.addItem("SelectedStatus", function (a) { return a.b8; });
            CellModel.bd.addItem("ActivationStatus", function (a) { return a.by; });
            CellModel.bd.addItem("HorizontalAlignment", function (a) { return enumGetBox(CellContentHorizontalAlignment_$type, a.f); });
            CellModel.bd.addItem("VerticalAlignment", function (a) { return enumGetBox(CellContentVerticalAlignment_$type, a.h); });
            CellModel.bd.addItem("Background", function (a) { return a.kh; });
            CellModel.bd.addItem("Border", function (a) { return a.ki; });
            CellModel.bd.addItem("ActivationBorder", function (a) { return a.kd; });
            CellModel.bd.addItem("SelectedBackground", function (a) { return a.kq; });
            CellModel.bd.addItem("HoverBackground", function (a) { return a.km; });
            CellModel.bd.addItem("RenderValue", function (a) { return a.ir; });
            CellModel.bd.addItem("OriginalValue", function (a) { return a.gp; });
            CellModel.bd.addItem("TextColor", function (a) { return a.kt; });
            CellModel.bd.addItem("SortIndicatorColor", function (a) { return a.kr; });
            CellModel.bd.addItem("FontInfo", function (a) { return a.af; });
            CellModel.bd.addItem("LineBreakMode", function (a) { return enumGetBox(TextCellLineBreakMode_$type, a.z); });
            CellModel.bd.addItem("VirtualizationPercentage", function (a) { return a.cb; });
            CellModel.bd.addItem("PaddingLeft", function (a) { return a.fp; });
            CellModel.bd.addItem("PaddingTop", function (a) { return a.ft; });
            CellModel.bd.addItem("PaddingRight", function (a) { return a.fr; });
            CellModel.bd.addItem("PaddingBottom", function (a) { return a.fn; });
            CellModel.bd.addItem("BorderLeftWidth", function (a) { return a.eb; });
            CellModel.bd.addItem("BorderTopWidth", function (a) { return a.eg; });
            CellModel.bd.addItem("BorderRightWidth", function (a) { return a.ee; });
            CellModel.bd.addItem("BorderBottomWidth", function (a) { return a.d9; });
            CellModel.bd.addItem("ActivationBorderLeftWidth", function (a) { return a.dd; });
            CellModel.bd.addItem("ActivationBorderTopWidth", function (a) { return a.di; });
            CellModel.bd.addItem("ActivationBorderRightWidth", function (a) { return a.dg; });
            CellModel.bd.addItem("ActivationBorderBottomWidth", function (a) { return a.db; });
            CellModel.bd.addItem("SortDirection", function (a) { return enumGetBox(ColumnSortDirection_$type, a.m); });
            CellModel.bd.addItem("PinnedRowBackground", function (a) { return a.kp; });
            CellModel.bd.addItem("StickyRowBackground", function (a) { return a.ks; });
            CellModel.bd.addItem("LastStickyRowBackground", function (a) { return a.ko; });
            CellModel.bd.addItem("PinnedRowOpacity", function (a) { return a.b7; });
            CellModel.bd.addItem("Pinned", function (a) { return enumGetBox(PinnedPositions_$type, a.x); });
            CellModel.bd.addItem("IsEdited", function (a) { return a.ay; });
            CellModel.bd.addItem("IsDeleted", function (a) { return a.av; });
            CellModel.bd.addItem("DeletedTextColor", function (a) { return a.kj; });
            CellModel.bd.addItem("EditOpacity", function (a) { return a.b2; });
            CellModel.bd.addItem("EditFontInfo", function (a) { return a.ae; });
            CellModel.bd.addItem("ErrorBorder", function (a) { return a.kk; });
            CellModel.bd.addItem("ErrorBorderLeftWidth", function (a) { return a.er; });
            CellModel.bd.addItem("ErrorBorderTopWidth", function (a) { return a.ew; });
            CellModel.bd.addItem("ErrorBorderBottomWidth", function (a) { return a.ep; });
            CellModel.bd.addItem("ErrorBorderRightWidth", function (a) { return a.eu; });
            CellModel.bd.addItem("EditError", function (a) { return a.hm; });
        }
    };
    CellModel.prototype.jw = function (a, b) {
        this.jf();
        if (CellModel.bg.containsKey(a)) {
            CellModel.bg.item(a)(this, b);
        }
        else {
            this.jv(a, b);
        }
    };
    CellModel.prototype.go = function (a) {
        this.je();
        if (CellModel.bd.containsKey(a)) {
            return CellModel.bd.item(a)(this);
        }
        if (this.ap(a)) {
            return this.gn(a);
        }
        return null;
    };
    CellModel.prototype.a8 = function (a) {
        return (a != 1 || (a == 1 && this.n.d3 == 1)) && a != 2 && a != 4 && a != 5;
    };
    CellModel.$t = markType(CellModel, 'CellModel');
    CellModel.c3 = 0;
    CellModel.c2 = 0;
    CellModel.bf = null;
    CellModel.f9 = CellModel.ez("State");
    CellModel.fv = CellModel.ez("Path");
    CellModel.fd = CellModel.ez("IsRowPinned");
    CellModel.fe = CellModel.ez("IsRowSticky");
    CellModel.fc = CellModel.ez("IsLastStickyRow");
    CellModel.e7 = CellModel.ez("Indent");
    CellModel.f0 = CellModel.ez("RowItem");
    CellModel.gi = CellModel.ez("X");
    CellModel.gj = CellModel.ez("Y");
    CellModel.f4 = CellModel.ez("SnappedX");
    CellModel.f6 = CellModel.ez("SnappedY");
    CellModel.eo = CellModel.ez("EditOpacity");
    CellModel.ei = CellModel.ez("ContentOpacity");
    CellModel.dw = CellModel.ez("ActualContentOpacity");
    CellModel.fl = CellModel.ez("Opacity");
    CellModel.dy = CellModel.ez("ActualOpacity");
    CellModel.fh = CellModel.ez("LeftOffset");
    CellModel.gc = CellModel.ez("TopOffset");
    CellModel.fi = CellModel.ez("LeftPercentOffset");
    CellModel.gd = CellModel.ez("TopPercentOffset");
    CellModel.e1 = CellModel.ez("Height");
    CellModel.gh = CellModel.ez("Width");
    CellModel.ff = CellModel.ez("IsSelected");
    CellModel.fk = CellModel.ez("ModelType");
    CellModel.f2 = CellModel.ez("SelectedStatus");
    CellModel.dk = CellModel.ez("ActivationStatus");
    CellModel.e4 = CellModel.ez("HoverStatus");
    CellModel.e2 = CellModel.ez("HorizontalAlignment");
    CellModel.ge = CellModel.ez("VerticalAlignment");
    CellModel.d8 = CellModel.ez("Background");
    CellModel.ed = CellModel.ez("Border");
    CellModel.dl = CellModel.ez("ActualBackground");
    CellModel.dr = CellModel.ez("ActualBorder");
    CellModel.df = CellModel.ez("ActivationBorder");
    CellModel.et = CellModel.ez("ErrorBorder");
    CellModel.f1 = CellModel.ez("SelectedBackground");
    CellModel.e3 = CellModel.ez("HoverBackground");
    CellModel.e5 = CellModel.ez("HoverTextColor");
    CellModel.f8 = CellModel.ez("SortIndicatorColor");
    CellModel.ga = CellModel.ez("StickyRowBackground");
    CellModel.fx = CellModel.ez("PinnedRowBackground");
    CellModel.fg = CellModel.ez("LastStickyRowBackground");
    CellModel.fy = CellModel.ez("PinnedRowOpacity");
    CellModel.fm = CellModel.ez("OriginalValue");
    CellModel.fz = CellModel.ez("RenderValue");
    CellModel.gb = CellModel.ez("TextColor");
    CellModel.d7 = CellModel.ez("ActualTextColor");
    CellModel.ek = CellModel.ez("DeletedTextColor");
    CellModel.ey = CellModel.ez("FontInfo");
    CellModel.dx = CellModel.ez("ActualFontInfo");
    CellModel.fj = CellModel.ez("LineBreakMode");
    CellModel.gf = CellModel.ez("VirtualizationPercentage");
    CellModel.fq = CellModel.ez("PaddingLeft");
    CellModel.fu = CellModel.ez("PaddingTop");
    CellModel.fs = CellModel.ez("PaddingRight");
    CellModel.fo = CellModel.ez("PaddingBottom");
    CellModel.d2 = CellModel.ez("ActualPaddingLeft");
    CellModel.d6 = CellModel.ez("ActualPaddingTop");
    CellModel.d4 = CellModel.ez("ActualPaddingRight");
    CellModel.d0 = CellModel.ez("ActualPaddingBottom");
    CellModel.ec = CellModel.ez("BorderLeftWidth");
    CellModel.eh = CellModel.ez("BorderTopWidth");
    CellModel.ef = CellModel.ez("BorderRightWidth");
    CellModel.ea = CellModel.ez("BorderBottomWidth");
    CellModel.de = CellModel.ez("ActivationBorderLeftWidth");
    CellModel.dj = CellModel.ez("ActivationBorderTopWidth");
    CellModel.dh = CellModel.ez("ActivationBorderRightWidth");
    CellModel.dc = CellModel.ez("ActivationBorderBottomWidth");
    CellModel.es = CellModel.ez("ErrorBorderLeftWidth");
    CellModel.ex = CellModel.ez("ErrorBorderTopWidth");
    CellModel.ev = CellModel.ez("ErrorBorderRightWidth");
    CellModel.eq = CellModel.ez("ErrorBorderBottomWidth");
    CellModel.dq = CellModel.ez("ActualBorderLeftWidth");
    CellModel.dv = CellModel.ez("ActualBorderTopWidth");
    CellModel.dt = CellModel.ez("ActualBorderRightWidth");
    CellModel.dn = CellModel.ez("ActualBorderBottomWidth");
    CellModel.f7 = CellModel.ez("SortDirection");
    CellModel.fb = CellModel.ez("IsExpanded");
    CellModel.e8 = CellModel.ez("IsCollapsable");
    CellModel.fw = CellModel.ez("Pinned");
    CellModel.em = CellModel.ez("EditFontInfo");
    CellModel.fa = CellModel.ez("IsEdited");
    CellModel.e9 = CellModel.ez("IsDeleted");
    CellModel.el = CellModel.ez("EditError");
    CellModel.bg = null;
    CellModel.bd = null;
    return CellModel;
}(Base));
export { CellModel };
/**
 * @hidden
 */
var DateTimeCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DateTimeCellModel, _super);
    function DateTimeCellModel() {
        var _this = _super.call(this) || this;
        _this.k5 = new Date();
        _this.lh = null;
        _this.kw = null;
        _this.ky = null;
        _this.lf = null;
        _this._formatOverride = null;
        _this.k1 = 0;
        _this.kz = null;
        _this.k3 = false;
        _this.k6 = dateMinValue();
        _this.jg(DateTimeCellModel.k8);
        _this.a0 = true;
        return _this;
    }
    Object.defineProperty(DateTimeCellModel.prototype, "k6", {
        get: function () {
            return this.k5;
        },
        set: function (a) {
            var b = this.k5;
            this.k5 = a;
            if (+(this.k5) != +b) {
                this.jo("DateTimeValue", DateTimeCellModel.k8, b, this.k5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeCellModel.prototype, "ln", {
        get: function () {
            return this.lh;
        },
        set: function (a) {
            var b = this.lh;
            this.lh = a;
            if (this.lh != b) {
                this.jo("FormatStringOverride", DateTimeCellModel.lb, b, this.lh);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeCellModel.prototype, "kx", {
        get: function () {
            return this.kw;
        },
        set: function (a) {
            var b = this.kw;
            this.kw = a;
            if (this.kw != b) {
                this.jo("FormatSpecifiers", DateTimeCellModel.la, b, this.kw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeCellModel.prototype, "lg", {
        get: function () {
            return this._formatOverride;
        },
        set: function (a) {
            var b = this._formatOverride;
            this._formatOverride = a;
            if (this._formatOverride != b) {
                this.jo("FormatOverride", DateTimeCellModel.k9, b, this._formatOverride);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeCellModel.prototype, "k2", {
        get: function () {
            return this.k1;
        },
        set: function (a) {
            var b = this.k1;
            this.k1 = a;
            if (this.k1 != b) {
                this.jo("DateTimeFormat", DateTimeCellModel.k7, enumGetBox(DateTimeFormats_$type, b), enumGetBox(DateTimeFormats_$type, this.k1));
            }
        },
        enumerable: true,
        configurable: true
    });
    DateTimeCellModel.prototype.lk = function (a) {
        if (this.ky != null) {
            return this.ky.i(a);
        }
        if (this._formatOverride != null) {
            var date_ = a;
            return (this._formatOverride.format(date_));
        }
        this.kz.j(this);
        return this.kz.i(a);
    };
    Object.defineProperty(DateTimeCellModel.prototype, "k0", {
        get: function () {
            return this.kz;
        },
        set: function (a) {
            var b = this.kz;
            this.kz = a;
            if (this.kz != b) {
                this.jo("Formatter", DateTimeCellModel.lc, b, this.kz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeCellModel.prototype, "k4", {
        get: function () {
            return this.k3;
        },
        set: function (a) {
            var b = this.k3;
            this.k3 = a;
            if (this.k3 != b) {
                this.jo("IsOffsetValue", DateTimeCellModel.ld, b, this.k3);
            }
        },
        enumerable: true,
        configurable: true
    });
    DateTimeCellModel.prototype.jr = function (a, b, c) {
        switch (a) {
            case "FormatStringOverride":
            case "FormatSpecifiers":
                if (this.ln != null) {
                    this.ky = new BindingFormatter();
                    this.ky.j = this.ln;
                    this.ky.d = this.kx;
                }
                else {
                    this.ky = null;
                }
                break;
        }
        _super.prototype.jr.call(this, a, b, c);
    };
    DateTimeCellModel.prototype.jw = function (a, b) {
        _super.prototype.jw.call(this, a, b);
        if (a == "DateTimeFormat") {
            this.k2 = EnumUtil.getEnumValue(DateTimeFormats_$type, b);
        }
        if (a == "DateTimeValue") {
            this.k6 = b;
        }
        if (a == "IsOffsetValue") {
            this.k4 = b;
        }
        if (a == "FormatOverride") {
            this.lg = b;
        }
    };
    DateTimeCellModel.prototype.go = function (a) {
        if (a == "DateTimeFormat") {
            return enumGetBox(DateTimeFormats_$type, this.k2);
        }
        if (a == "DateTimeValue") {
            return this.k6;
        }
        if (a == "IsOffsetValue") {
            return this.k4;
        }
        if (a == "FormatOverride") {
            return this.lg;
        }
        return _super.prototype.go.call(this, a);
    };
    DateTimeCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new DateTimeCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.af = this.k6;
        b.ag = this.k2;
        b.ae = this.k4;
        return b;
    };
    DateTimeCellModel.$t = markType(DateTimeCellModel, 'DateTimeCellModel', CellModel.$);
    DateTimeCellModel.k8 = CellModel.ez("DateTimeValue");
    DateTimeCellModel.lb = CellModel.ez("FormatStringOverride");
    DateTimeCellModel.la = CellModel.ez("FormatSpecifiers");
    DateTimeCellModel.k9 = CellModel.ez("FormatOverride");
    DateTimeCellModel.k7 = CellModel.ez("DateTimeFormat");
    DateTimeCellModel.lc = CellModel.ez("Formatter");
    DateTimeCellModel.ld = CellModel.ez("IsOffsetValue");
    return DateTimeCellModel;
}(CellModel));
export { DateTimeCellModel };
/**
 * @hidden
 */
var EditorCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EditorCellModel, _super);
    function EditorCellModel() {
        var _this = _super.call(this) || this;
        _this.k9 = 0;
        _this.k8 = 0;
        _this.k5 = true;
        _this.k0 = null;
        _this.ky = 0;
        _this.lp = null;
        _this.ln = null;
        _this.k2 = 0;
        _this.ll = null;
        _this.lo = null;
        _this.kw = null;
        _this.k4 = false;
        _this.i2 = "editorCell";
        return _this;
    }
    Object.defineProperty(EditorCellModel.prototype, "k7", {
        get: function () {
            return this.k5;
        },
        set: function (a) {
            var b = this.k5;
            this.k5 = a;
            if (b != this.k5) {
                this.jo("IsHidden", EditorCellModel.li, b, this.k5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "k1", {
        get: function () {
            return this.k0;
        },
        set: function (a) {
            var b = this.k0;
            this.k0 = a;
            if (b != this.k0) {
                this.jo("EditTarget", EditorCellModel.lf, b, this.k0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "kz", {
        get: function () {
            return this.ky;
        },
        set: function (a) {
            var b = this.ky;
            this.ky = a;
            if (b != this.ky) {
                this.jo("DataType", EditorCellModel.la, enumGetBox(DataSourceSchemaPropertyType_$type, b), enumGetBox(DataSourceSchemaPropertyType_$type, this.ky));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "lx", {
        get: function () {
            return this.lp;
        },
        set: function (a) {
            var b = this.lp;
            this.lp = a;
            if (b != this.lp) {
                this.jo("ErrorMessage", EditorCellModel.lg, b, this.lp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "k3", {
        get: function () {
            return this.k2;
        },
        set: function (a) {
            var b = this.k2;
            this.k2 = a;
            if (b != this.k2) {
                this.jo("EditorType", EditorCellModel.ld, enumGetBox(EditorType_$type, b), enumGetBox(EditorType_$type, this.k2));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "lm", {
        get: function () {
            return this.ll;
        },
        set: function (a) {
            var b = this.ll;
            this.ll = a;
            if (b != this.ll) {
                this.jo("EditorItemsSource", EditorCellModel.lb, b, this.ll);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "ls", {
        get: function () {
            return this.lo;
        },
        set: function (a) {
            var b = this.lo;
            this.lo = a;
            if (b != this.lo) {
                this.jo("EditorTextField", EditorCellModel.lc, b, this.lo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "kx", {
        get: function () {
            return this.kw;
        },
        set: function (a) {
            var b = this.kw;
            this.kw = a;
            if (b != this.kw) {
                this.jo("EditorValueField", EditorCellModel.le, b, this.kw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "k6", {
        get: function () {
            return this.k4;
        },
        set: function (a) {
            var b = this.k4;
            this.k4 = a;
            this.jo("Focus", EditorCellModel.lh, b, this.k4);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "lk", {
        get: function () {
            return this.k9;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "lj", {
        get: function () {
            return this.k8;
        },
        enumerable: true,
        configurable: true
    });
    EditorCellModel.prototype.jr = function (a, b, c) {
        _super.prototype.jr.call(this, a, b, c);
        switch (a) {
            case "IsHidden":
                this.a5 = true;
                break;
            case "EditTarget":
                this.l1(b);
                this.l3();
                this.as = true;
                break;
            case "OriginalValue":
            case "DataType":
                this.as = true;
                break;
            case "ErrorMessage":
                this.l3();
                this.as = true;
                break;
        }
    };
    EditorCellModel.prototype.jw = function (a, b) {
        _super.prototype.jw.call(this, a, b);
        if (a == "IsHidden") {
            this.k7 = b;
        }
        else if (a == "DataType") {
            this.kz = EnumUtil.getEnumValue(DataSourceSchemaPropertyType_$type, b);
        }
        else if (a == "ErrorMessage") {
            this.lx = b;
        }
        else if (a == "Focus") {
            this.k6 = b;
        }
    };
    EditorCellModel.prototype.go = function (a) {
        switch (a) {
            case "IsHidden": return this.k7;
            case "DataType": return enumGetBox(DataSourceSchemaPropertyType_$type, this.kz);
            case "ErrorMessage": return this.lx;
            case "Focus": return this.k6;
        }
        return _super.prototype.go.call(this, a);
    };
    EditorCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new EditorCellModelExport();
        }
        var b = _super.prototype.b.call(this, a);
        b.af = this.k7;
        b.ae = this.kz;
        b.ag = this.ln != null ? this.ln.toString() : null;
        b.ah = this.lx;
        return b;
    };
    EditorCellModel.prototype.l1 = function (a) {
        if (a != null) {
            var b = a;
            b.propertyChanged = delegateRemove(b.propertyChanged, runOn(this, this.l2));
        }
        if (this.k1 != null) {
            this.cc = this.k1.cc;
            this.cd = this.k1.cd;
            this.gg = this.k1.gg;
            this.e0 = this.k1.e0;
            this.k8 = this.k1.k.a0;
            this.k9 = this.k1.k.w;
            this.gp = this.k1.gp;
            this.lx = this.k1.hm;
            this.fp = this.k1.d1;
            this.ft = this.k1.d5;
            this.fr = this.k1.d3;
            this.fn = this.k1.dz;
            this.kd = this.k1.kd;
            this.dd = this.k1.dd + 1;
            this.di = this.k1.di + 1;
            this.dg = this.k1.dg + 1;
            this.db = this.k1.db + 1;
            this.by = 1;
            this.af = this.k1.af;
            var c = this.k1;
            c.propertyChanged = delegateCombine(c.propertyChanged, runOn(this, this.l2));
        }
        else {
            this.lx = null;
        }
    };
    EditorCellModel.prototype.l3 = function () {
        if (this.k1 != null) {
            if (this.lx != null) {
                this.kd = GridStyleRepository.bg;
            }
            else {
                this.kd = this.k1.kd;
            }
        }
    };
    EditorCellModel.prototype.l2 = function (a, b) {
        switch (b.propertyName) {
            case "X":
                this.cc = this.k1.cc;
                break;
            case "Y":
                this.cd = this.k1.cd;
                break;
            case "Width":
                this.gg = this.k1.gg;
                break;
            case "Height":
                this.e0 = this.k1.e0;
                break;
            case "Path":
                if (this.k9 != this.k1.k.w || this.k8 != this.k1.k.a0) {
                    this.k1 = null;
                }
                break;
            case "OriginalValue":
                this.ln = this.k1.gp;
                break;
        }
    };
    EditorCellModel.$t = markType(EditorCellModel, 'EditorCellModel', CellModel.$);
    EditorCellModel.li = CellModel.ez("IsHidden");
    EditorCellModel.lf = CellModel.ez("EditTarget");
    EditorCellModel.la = CellModel.ez("DataType");
    EditorCellModel.lg = CellModel.ez("ErrorMessage");
    EditorCellModel.ld = CellModel.ez("EditorType");
    EditorCellModel.lb = CellModel.ez("EditorItemsSource");
    EditorCellModel.lc = CellModel.ez("EditorTextField");
    EditorCellModel.le = CellModel.ez("EditorValueField");
    EditorCellModel.lh = CellModel.ez("Focus");
    return EditorCellModel;
}(CellModel));
export { EditorCellModel };
/**
 * @hidden
 */
var EditorRowCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EditorRowCellModel, _super);
    function EditorRowCellModel() {
        var _this = _super.call(this) || this;
        _this.ky = 0;
        _this.kw = null;
        _this.i2 = "editorRowCell";
        _this.a0 = false;
        return _this;
    }
    Object.defineProperty(EditorRowCellModel.prototype, "kx", {
        get: function () {
            return this.kw;
        },
        set: function (a) {
            var b = this.kw;
            this.kw = a;
            if (b != this.kw) {
                this.jo("EditTarget", EditorRowCellModel.kz, b, this.kw);
            }
        },
        enumerable: true,
        configurable: true
    });
    EditorRowCellModel.prototype.jr = function (a, b, c) {
        _super.prototype.jr.call(this, a, b, c);
        switch (a) {
            case "EditTarget":
                this.k1(b);
                break;
        }
    };
    EditorRowCellModel.prototype.k1 = function (a) {
        if (a != null) {
            var b = a;
            b.propertyChanged = delegateRemove(b.propertyChanged, runOn(this, this.k2));
        }
        if (this.kx != null) {
            this.cd = this.kx.cd;
            this.e0 = this.kx.e0;
            this.cc = this.o.model.b0;
            this.gg = this.o.model.absoluteWidth;
            this.ky = this.kx.k.w;
            var c = this.kx;
            c.propertyChanged = delegateCombine(c.propertyChanged, runOn(this, this.k2));
        }
    };
    EditorRowCellModel.prototype.k2 = function (a, b) {
        switch (b.propertyName) {
            case "Y":
                this.cd = this.kx.cd;
                break;
            case "Height":
                this.e0 = this.kx.e0;
                break;
            case "Path":
                if (this.ky != this.kx.k.w) {
                    this.kx = null;
                }
                break;
        }
    };
    EditorRowCellModel.$t = markType(EditorRowCellModel, 'EditorRowCellModel', CellModel.$);
    EditorRowCellModel.kz = CellModel.ez("EditTarget");
    return EditorRowCellModel;
}(CellModel));
export { EditorRowCellModel };
/**
 * @hidden
 */
var SummaryCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryCellModel, _super);
    function SummaryCellModel() {
        var _this = _super.call(this) || this;
        _this.k2 = null;
        _this.k3 = null;
        _this.la = null;
        _this.kw = null;
        _this.a0 = true;
        return _this;
    }
    Object.defineProperty(SummaryCellModel.prototype, "k4", {
        get: function () {
            return this.k2;
        },
        set: function (a) {
            var b = this.k2;
            this.k2 = a;
            if (this.k2 != b) {
                this.jo("ResolvedSummaryLabel", SummaryCellModel.ky, b, this.k2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryCellModel.prototype, "k6", {
        get: function () {
            return this.k3;
        },
        set: function (a) {
            var b = this.k3;
            this.k3 = a;
            if (this.k3 != b) {
                this.jo("ResolvedSummaryValue", SummaryCellModel.kz, b, this.k3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryCellModel.prototype, "lb", {
        get: function () {
            return this.la;
        },
        set: function (a) {
            var b = this.la;
            this.la = a;
            if (this.la != b) {
                this.jo("SummaryLabelTextColor", SummaryCellModel.k1, b, this.la);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryCellModel.prototype, "kx", {
        get: function () {
            return this.kw;
        },
        set: function (a) {
            var b = this.kw;
            this.kw = a;
            if (this.kw != b) {
                this.jo("SummaryLabelFontInfo", SummaryCellModel.k0, b, this.kw);
            }
        },
        enumerable: true,
        configurable: true
    });
    SummaryCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new SummaryCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.ai = this.k4;
        b.ao = this.k6;
        b.ae = AppearanceHelper.a(this.lb);
        b.af = AppearanceHelper.a(this.kt);
        if (this.kx != null) {
            var c = this.kx;
            if (this.o != null && c.n == null) {
                var d = this.o.externalGrid.renderer;
                var e = FontUtil.getFontInfoFromString(d, c.fontString);
                c.n = e.n;
                c.d = e.d;
                c.o = e.o;
                c.q = e.q;
                c.r = e.r;
                c.s = e.s;
            }
            if (c.n != null) {
                b.aj = c.n;
            }
            if (!isNaN_(c.d)) {
                b.ag = c.d;
            }
            if (c.s != null) {
                b.an = c.s;
            }
            if (c.q != null) {
                b.al = c.q;
            }
            if (c.o != null) {
                b.ak = c.q;
            }
        }
        if (this.af != null) {
            var f = this.af;
            if (this.o != null && f.n == null) {
                var g = this.o.externalGrid.renderer;
                var h = FontUtil.getFontInfoFromString(g, f.fontString);
                f.n = h.n;
                f.d = h.d;
                f.o = h.o;
                f.q = h.q;
                f.r = h.r;
                f.s = h.s;
            }
            if (f.n != null) {
                b.ap = f.n;
            }
            if (!isNaN_(f.d)) {
                b.ah = f.d;
            }
            if (f.s != null) {
                b.at = f.s;
            }
            if (f.q != null) {
                b.ar = f.q;
            }
            if (f.o != null) {
                b.aq = f.q;
            }
        }
        return b;
    };
    SummaryCellModel.prototype.a8 = function (a) {
        return a == 4 || a == 5;
    };
    SummaryCellModel.$t = markType(SummaryCellModel, 'SummaryCellModel', CellModel.$);
    SummaryCellModel.ky = CellModel.ez("ResolvedSummaryLabel");
    SummaryCellModel.kz = CellModel.ez("ResolvedSummaryValue");
    SummaryCellModel.k1 = CellModel.ez("SummaryLabelTextColor");
    SummaryCellModel.k0 = CellModel.ez("SummaryLabelFontInfo");
    return SummaryCellModel;
}(CellModel));
export { SummaryCellModel };
/**
 * @hidden
 */
var VerticalSeparatorCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(VerticalSeparatorCellModel, _super);
    function VerticalSeparatorCellModel() {
        var _this = _super.call(this) || this;
        _this.kw = true;
        return _this;
    }
    Object.defineProperty(VerticalSeparatorCellModel.prototype, "kx", {
        get: function () {
            return this.kw;
        },
        set: function (a) {
            var b = this.kw;
            this.kw = a;
            if (b != this.kw) {
                this.jo("IsHitTestVisible", VerticalSeparatorCellModel.ky, b, this.kw);
            }
        },
        enumerable: true,
        configurable: true
    });
    VerticalSeparatorCellModel.$t = markType(VerticalSeparatorCellModel, 'VerticalSeparatorCellModel', CellModel.$);
    VerticalSeparatorCellModel.ky = CellModel.ez("IsHitTestVisible");
    return VerticalSeparatorCellModel;
}(CellModel));
export { VerticalSeparatorCellModel };
/**
 * @hidden
 */
var ImageCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ImageCellModel, _super);
    function ImageCellModel() {
        var _this = _super.call(this) || this;
        _this.k3 = "";
        _this.ky = 0;
        _this.kw = 0;
        _this.f = 3;
        _this.a0 = true;
        return _this;
    }
    Object.defineProperty(ImageCellModel.prototype, "k4", {
        get: function () {
            return this.k3;
        },
        set: function (a) {
            var b = this.k3;
            this.k3 = a;
            if (this.k3 != b) {
                this.jo("ImagePath", ImageCellModel.k0, b, this.k3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageCellModel.prototype, "kz", {
        get: function () {
            return this.ky;
        },
        set: function (a) {
            var b = this.ky;
            this.ky = a;
            if (this.ky != b) {
                this.jo("ImageStretchOption", ImageCellModel.k2, enumGetBox(ImageStretchOptions_$type, b), enumGetBox(ImageStretchOptions_$type, this.ky));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageCellModel.prototype, "kx", {
        get: function () {
            return this.kw;
        },
        set: function (a) {
            var b = this.kw;
            this.kw = a;
            if (this.kw != b) {
                this.jo("ImageResourceType", ImageCellModel.k1, enumGetBox(ImageResourceType_$type, b), enumGetBox(ImageResourceType_$type, this.kw));
            }
        },
        enumerable: true,
        configurable: true
    });
    ImageCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new ImageCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.ae = this.k4;
        return b;
    };
    ImageCellModel.prototype.jw = function (a, b) {
        _super.prototype.jw.call(this, a, b);
        if (a == "ImageStretchOption") {
            this.kz = EnumUtil.getEnumValue(ImageStretchOptions_$type, b);
        }
        if (a == "ImageResourceType") {
            this.kx = EnumUtil.getEnumValue(ImageResourceType_$type, b);
        }
        if (a == "ImagePath") {
            this.k4 = b;
        }
    };
    ImageCellModel.prototype.go = function (a) {
        if (a == "ImageStretchOption") {
            return enumGetBox(ImageStretchOptions_$type, this.kz);
        }
        if (a == "ImageResourceType") {
            return enumGetBox(ImageResourceType_$type, this.kx);
        }
        if (a == "ImagePath") {
            return this.k4;
        }
        return _super.prototype.go.call(this, a);
    };
    ImageCellModel.$t = markType(ImageCellModel, 'ImageCellModel', CellModel.$);
    ImageCellModel.k0 = CellModel.ez("ImagePath");
    ImageCellModel.k2 = CellModel.ez("ImageStretchOption");
    ImageCellModel.k1 = CellModel.ez("ImageResourceType");
    return ImageCellModel;
}(CellModel));
export { ImageCellModel };
/**
 * @hidden
 */
var NumericCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(NumericCellModel, _super);
    function NumericCellModel() {
        var _this = _super.call(this) || this;
        _this.k4 = NaN;
        _this.kz = false;
        _this.ls = null;
        _this.kw = null;
        _this.ky = null;
        _this.lq = null;
        _this._formatOverride = null;
        _this.lt = null;
        _this.lv = null;
        _this.lu = null;
        _this.lw = "";
        _this.k6 = 5;
        _this.k7 = 0;
        _this.k8 = -1;
        _this.k0 = false;
        _this.f = 2;
        _this.a0 = true;
        return _this;
    }
    Object.defineProperty(NumericCellModel.prototype, "k5", {
        get: function () {
            return this.k4;
        },
        set: function (a) {
            var b = this.k4;
            this.k4 = a;
            if (this.k4 != b) {
                this.jo("NumericValue", NumericCellModel.ll, b, this.k4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "k1", {
        get: function () {
            return this.kz;
        },
        set: function (a) {
            var b = this.kz;
            this.kz = a;
            if (this.kz != b) {
                this.jo("HasDecimalValue", NumericCellModel.lc, b, this.kz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "lz", {
        get: function () {
            return this.ls;
        },
        set: function (a) {
            var b = this.ls;
            this.ls = a;
            if (this.ls != b) {
                this.jo("FormatStringOverride", NumericCellModel.lb, b, this.ls);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "kx", {
        get: function () {
            return this.kw;
        },
        set: function (a) {
            var b = this.kw;
            this.kw = a;
            if (this.kw != b) {
                this.jo("FormatSpecifiers", NumericCellModel.la, b, this.kw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "lr", {
        get: function () {
            return this._formatOverride;
        },
        set: function (a) {
            var b = this._formatOverride;
            this._formatOverride = a;
            if (this._formatOverride != b) {
                this.jo("FormatOverride", NumericCellModel.k9, b, this._formatOverride);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "l5", {
        get: function () {
            return this.lt;
        },
        set: function (a) {
            var b = this.lt;
            this.lt = a;
            if (this.lt != b) {
                this.jo("NegativePrefix", NumericCellModel.lj, b, this.lt);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "ma", {
        get: function () {
            return this.lv;
        },
        set: function (a) {
            var b = this.lv;
            this.lv = a;
            if (this.lv != b) {
                this.jo("PositivePrefix", NumericCellModel.lm, b, this.lv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "l7", {
        get: function () {
            return this.lu;
        },
        set: function (a) {
            var b = this.lu;
            this.lu = a;
            if (this.lu != b) {
                this.jo("NegativeSuffix", NumericCellModel.lk, b, this.lu);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "mc", {
        get: function () {
            return this.lw;
        },
        set: function (a) {
            var b = this.lw;
            this.lw = a;
            if (this.lw != b) {
                this.jo("PositiveSuffix", NumericCellModel.ln, b, this.lw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "ld", {
        get: function () {
            return this.k6;
        },
        set: function (a) {
            var b = this.k6;
            this.k6 = a;
            if (this.k6 != b) {
                this.jo("MaxFractionDigits", NumericCellModel.le, b, this.k6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "lf", {
        get: function () {
            return this.k7;
        },
        set: function (a) {
            var b = this.k7;
            this.k7 = a;
            if (this.k7 != b) {
                this.jo("MinFractionDigits", NumericCellModel.lg, b, this.k7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "lh", {
        get: function () {
            return this.k8;
        },
        set: function (a) {
            var b = this.k8;
            this.k8 = a;
            if (this.k8 != b) {
                this.jo("MinIntegerDigits", NumericCellModel.li, b, this.k8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "k3", {
        get: function () {
            return this.k0;
        },
        set: function (a) {
            var b = this.k0;
            this.k0 = a;
            if (this.k0 != b) {
                this.jo("ShowGroupingSeparator", NumericCellModel.lo, b, this.k0);
            }
        },
        enumerable: true,
        configurable: true
    });
    NumericCellModel.prototype.k2 = function () {
        if (this.ax(NumericCellModel.lg) || this.ax(NumericCellModel.le) || this.ax(NumericCellModel.li) || this.ax(NumericCellModel.ln) || this.ax(NumericCellModel.lk) || this.ax(NumericCellModel.lm) || this.ax(NumericCellModel.lj) || this.ax(NumericCellModel.k9) || this.ax(NumericCellModel.lo)) {
            return true;
        }
        return false;
    };
    NumericCellModel.prototype.jr = function (a, b, c) {
        switch (a) {
            case "FormatStringOverride":
            case "FormatSpecifiers":
                if (this.lz != null) {
                    this.ky = new BindingFormatter();
                    this.ky.j = this.lz;
                    this.ky.d = this.kx;
                }
                else {
                    this.ky = null;
                }
                break;
        }
        _super.prototype.jr.call(this, a, b, c);
    };
    NumericCellModel.prototype.jw = function (a, b) {
        _super.prototype.jw.call(this, a, b);
        if (a == "NumericValue") {
            this.k5 = b;
        }
        if (a == "NegativePrefix") {
            this.l5 = b;
        }
        if (a == "PositivePrefix") {
            this.ma = b;
        }
        if (a == "NegativeSuffix") {
            this.l7 = b;
        }
        if (a == "PositiveSuffix") {
            this.mc = b;
        }
        if (a == "MinFractionDigits") {
            this.lf = typeGetValue(b);
        }
        if (a == "MaxFractionDigits") {
            this.ld = typeGetValue(b);
        }
        if (a == "MinIntegerDigits") {
            this.lh = typeGetValue(b);
        }
        if (a == "ShowGroupingSeparator") {
            this.k3 = b;
        }
        if (a == "FormatOverride") {
            this.lr = b;
        }
    };
    NumericCellModel.prototype.go = function (a) {
        if (a == "NumericValue") {
            return this.k5;
        }
        if (a == "NegativePrefix") {
            return this.l5;
        }
        if (a == "PositivePrefix") {
            return this.ma;
        }
        if (a == "NegativeSuffix") {
            return this.l5;
        }
        if (a == "PositiveSuffix") {
            return this.mc;
        }
        if (a == "MinFractionDigits") {
            return this.lf;
        }
        if (a == "MaxFractionDigits") {
            return this.ld;
        }
        if (a == "MinIntegerDigits") {
            return this.lh;
        }
        if (a == "ShowGroupingSeparator") {
            return this.k3;
        }
        if (a == "FormatOverride") {
            return this.lr;
        }
        return _super.prototype.go.call(this, a);
    };
    NumericCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new NumericCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.ae = this.k5;
        return b;
    };
    NumericCellModel.$t = markType(NumericCellModel, 'NumericCellModel', CellModel.$);
    NumericCellModel.ll = CellModel.ez("NumericValue");
    NumericCellModel.lc = CellModel.ez("HasDecimalValue");
    NumericCellModel.lb = CellModel.ez("FormatStringOverride");
    NumericCellModel.la = CellModel.ez("FormatSpecifiers");
    NumericCellModel.k9 = CellModel.ez("FormatOverride");
    NumericCellModel.lj = CellModel.ez("NegativePrefix");
    NumericCellModel.lm = CellModel.ez("PositivePrefix");
    NumericCellModel.lk = CellModel.ez("NegativeSuffix");
    NumericCellModel.ln = CellModel.ez("PositiveSuffix");
    NumericCellModel.le = CellModel.ez("MaxFractionDigits");
    NumericCellModel.lg = CellModel.ez("MinFractionDigits");
    NumericCellModel.li = CellModel.ez("MinIntegerDigits");
    NumericCellModel.lo = CellModel.ez("ShowGroupingSeparator");
    return NumericCellModel;
}(CellModel));
export { NumericCellModel };
/**
 * @hidden
 */
var RowSeparatorModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RowSeparatorModel, _super);
    function RowSeparatorModel() {
        return _super.call(this) || this;
    }
    RowSeparatorModel.prototype.b = function (a) {
        if (a == null) {
            a = new RowSeparatorModelExport();
        }
        a = _super.prototype.b.call(this, a);
        return a;
    };
    RowSeparatorModel.$t = markType(RowSeparatorModel, 'RowSeparatorModel', CellModel.$);
    return RowSeparatorModel;
}(CellModel));
export { RowSeparatorModel };
/**
 * @hidden
 */
var SectionHeaderCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SectionHeaderCellModel, _super);
    function SectionHeaderCellModel() {
        var _this = _super.call(this) || this;
        _this.kw = null;
        _this.kx = null;
        _this.k8 = null;
        _this.k7 = null;
        _this.k0 = 4;
        _this.a0 = true;
        return _this;
    }
    Object.defineProperty(SectionHeaderCellModel.prototype, "ky", {
        get: function () {
            return this.kw;
        },
        set: function (a) {
            var b = this.kw;
            this.kw = a;
            if (this.kw != b) {
                this.jo("Groups", SectionHeaderCellModel.k2, b, this.kw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeaderCellModel.prototype, "kz", {
        get: function () {
            return this.kx;
        },
        set: function (a) {
            var b = this.kx;
            this.kx = a;
            if (this.kx != b) {
                this.jo("Summaries", SectionHeaderCellModel.k5, b, this.kx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeaderCellModel.prototype, "lc", {
        get: function () {
            return this.k8;
        },
        set: function (a) {
            var b = this.k8;
            this.k8 = a;
            if (this.k8 != b) {
                this.jo("ResolvedText", SectionHeaderCellModel.k4, b, this.k8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeaderCellModel.prototype, "la", {
        get: function () {
            return this.k7;
        },
        set: function (a) {
            var b = this.k7;
            this.k7 = a;
            if (this.k7 != b) {
                this.jo("ResolvedSummaryText", SectionHeaderCellModel.k3, b, this.k7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeaderCellModel.prototype, "k1", {
        get: function () {
            return this.k0;
        },
        set: function (a) {
            var b = this.k0;
            this.k0 = a;
            if (this.k0 != b) {
                this.jo("SummaryDisplayMode", SectionHeaderCellModel.k6, enumGetBox(GroupSummaryDisplayMode_$type, b), enumGetBox(GroupSummaryDisplayMode_$type, this.k0));
            }
        },
        enumerable: true,
        configurable: true
    });
    SectionHeaderCellModel.prototype.jw = function (a, b) {
        _super.prototype.jw.call(this, a, b);
        if (a == "Groups") {
            this.ky = b;
        }
        else if (a == "SummaryDisplayMode") {
            this.k1 = EnumUtil.getEnumValue(GroupSummaryDisplayMode_$type, b);
        }
    };
    SectionHeaderCellModel.prototype.go = function (a) {
        if (a == "Groups") {
            return this.ky;
        }
        else if (a == "IsCollapsable") {
            return this.ar;
        }
        else if (a == "SummaryDisplayMode") {
            return enumGetBox(GroupSummaryDisplayMode_$type, this.k1);
        }
        return _super.prototype.go.call(this, a);
    };
    SectionHeaderCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new SectionHeaderCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.af = new Array(this.ky.length);
        b.ag = new Array(this.ky.length);
        b.ae = new Array(this.ky.length);
        b.al = this.lc;
        b.ai = new Array(this.kz.length);
        b.ak = new Array(this.kz.length);
        b.aj = new Array(this.kz.length);
        b.ah = new Array(this.kz.length);
        b.am = this.la;
        for (var c = 0; c < this.ky.length; c++) {
            b.af[c] = this.ky[c].c;
            b.ag[c] = this.ky[c].a;
            b.ae[c] = this.ky[c].b;
        }
        for (var d = 0; d < this.kz.length; d++) {
            b.ai[d] = this.kz[d].e;
            b.ak[d] = this.kz[d].b;
            b.aj[d] = this.kz[d].a;
            b.ah[d] = this.kz[d].c;
        }
        return b;
    };
    SectionHeaderCellModel.prototype.a8 = function (a) {
        return a == 1;
    };
    SectionHeaderCellModel.$t = markType(SectionHeaderCellModel, 'SectionHeaderCellModel', CellModel.$);
    SectionHeaderCellModel.k2 = CellModel.ez("Groups");
    SectionHeaderCellModel.k5 = CellModel.ez("Summaries");
    SectionHeaderCellModel.k4 = CellModel.ez("ResolvedText");
    SectionHeaderCellModel.k3 = CellModel.ez("ResolvedSummaryText");
    SectionHeaderCellModel.k6 = CellModel.ez("SummaryDisplayMode");
    return SectionHeaderCellModel;
}(CellModel));
export { SectionHeaderCellModel };
/**
 * @hidden
 */
var TemplateCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateCellModel, _super);
    function TemplateCellModel() {
        var _this = _super.call(this) || this;
        _this.kx = null;
        _this.a0 = true;
        return _this;
    }
    Object.defineProperty(TemplateCellModel.prototype, "ky", {
        get: function () {
            return this.kx;
        },
        set: function (a) {
            var b = this.kx;
            this.kx = a;
            if (this.kx != b) {
                this.jo("Value", TemplateCellModel.kw, b, this.kx);
            }
        },
        enumerable: true,
        configurable: true
    });
    TemplateCellModel.prototype.jw = function (a, b) {
        _super.prototype.jw.call(this, a, b);
        if (a == "Value") {
            this.ky = b;
        }
    };
    TemplateCellModel.prototype.go = function (a) {
        if (a == "Value") {
            return this.ky;
        }
        return _super.prototype.go.call(this, a);
    };
    TemplateCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new TemplateCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.ae = this.ky;
        return b;
    };
    TemplateCellModel.$t = markType(TemplateCellModel, 'TemplateCellModel', CellModel.$);
    TemplateCellModel.kw = CellModel.ez("Value");
    return TemplateCellModel;
}(CellModel));
export { TemplateCellModel };
/**
 * @hidden
 */
var TextCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextCellModel, _super);
    function TextCellModel() {
        var _this = _super.call(this) || this;
        _this.kx = "";
        _this.a0 = true;
        return _this;
    }
    Object.defineProperty(TextCellModel.prototype, "ky", {
        get: function () {
            return this.kx;
        },
        set: function (a) {
            var b = this.kx;
            this.kx = a;
            if (this.kx != b) {
                this.jo("TextValue", TextCellModel.kw, b, this.kx);
            }
        },
        enumerable: true,
        configurable: true
    });
    TextCellModel.prototype.jw = function (a, b) {
        _super.prototype.jw.call(this, a, b);
        if (a == "TextValue") {
            this.ky = b;
        }
    };
    TextCellModel.prototype.go = function (a) {
        if (a == "TextValue") {
            return this.ky;
        }
        return _super.prototype.go.call(this, a);
    };
    TextCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new TextCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.af = this.ky;
        return b;
    };
    TextCellModel.$t = markType(TextCellModel, 'TextCellModel', CellModel.$);
    TextCellModel.kw = CellModel.ez("TextValue");
    return TextCellModel;
}(CellModel));
export { TextCellModel };
/**
 * @hidden
 */
var TextHeaderCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextHeaderCellModel, _super);
    function TextHeaderCellModel() {
        var _this = _super.call(this) || this;
        _this.k6 = false;
        _this.k4 = 0;
        _this.k0 = 0;
        _this.li = null;
        _this.k2 = 0;
        return _this;
    }
    Object.defineProperty(TextHeaderCellModel.prototype, "k7", {
        get: function () {
            return this.k6;
        },
        set: function (a) {
            var b = this.k6;
            this.k6 = a;
            if (this.k6 != b) {
                this.jo("IsColumnOptionsEnabled", TextHeaderCellModel.lb, b, this.k6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCellModel.prototype, "k5", {
        get: function () {
            return this.k4;
        },
        set: function (a) {
            var b = this.k4;
            this.k4 = a;
            if (this.k4 != b) {
                this.jo("SortIndicatorStyle", TextHeaderCellModel.lc, enumGetBox(SortIndicatorStyle_$type, b), enumGetBox(SortIndicatorStyle_$type, this.k4));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCellModel.prototype, "k1", {
        get: function () {
            return this.k0;
        },
        set: function (a) {
            var b = this.k0;
            this.k0 = a;
            if (this.k0 != b) {
                this.jo("ColumnOptionsIconAlignment", TextHeaderCellModel.k8, enumGetBox(ColumnOptionsIconAlignment_$type, b), enumGetBox(ColumnOptionsIconAlignment_$type, this.k0));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCellModel.prototype, "lj", {
        get: function () {
            return this.li;
        },
        set: function (a) {
            var b = this.li;
            this.li = a;
            if (this.li != b) {
                this.jo("ColumnOptionsIconColor", TextHeaderCellModel.la, b, this.li);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCellModel.prototype, "k3", {
        get: function () {
            return this.k2;
        },
        set: function (a) {
            var b = this.k2;
            this.k2 = a;
            if (this.k2 != b) {
                this.jo("ColumnOptionsIconBehavior", TextHeaderCellModel.k9, enumGetBox(ColumnOptionsIconBehavior_$type, b), enumGetBox(ColumnOptionsIconBehavior_$type, this.k2));
            }
        },
        enumerable: true,
        configurable: true
    });
    TextHeaderCellModel.prototype.jw = function (a, b) {
        _super.prototype.jw.call(this, a, b);
        if (a == "IsColumnOptionsEnabled") {
            this.k7 = b;
        }
        else if (a == "SortIndicatorStyle") {
            this.k5 = EnumUtil.getEnumValue(SortIndicatorStyle_$type, b);
        }
        else if (a == "ColumnOptionsIconAlignment") {
            this.k1 = EnumUtil.getEnumValue(ColumnOptionsIconAlignment_$type, b);
        }
        else if (a == "ColumnOptionsIconColor") {
            this.lj = b;
        }
        else if (a == "ColumnOptionsIconBehavior") {
            this.k3 = EnumUtil.getEnumValue(ColumnOptionsIconBehavior_$type, b);
        }
    };
    TextHeaderCellModel.prototype.go = function (a) {
        if (a == "IsColumnOptionsEnabled") {
            return this.k7;
        }
        if (a == "SortIndicatorStyle") {
            return enumGetBox(SortIndicatorStyle_$type, this.k5);
        }
        if (a == "ColumnOptionsIconAlignment") {
            return enumGetBox(ColumnOptionsIconAlignment_$type, this.k1);
        }
        if (a == "ColumnOptionsIconColor") {
            return this.lj;
        }
        if (a == "ColumnOptionsIconBehavior") {
            return enumGetBox(ColumnOptionsIconBehavior_$type, this.k3);
        }
        return _super.prototype.go.call(this, a);
    };
    TextHeaderCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new TextHeaderCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        return b;
    };
    TextHeaderCellModel.$t = markType(TextHeaderCellModel, 'TextHeaderCellModel', TextCellModel.$);
    TextHeaderCellModel.lb = CellModel.ez("IsColumnOptionsEnabled");
    TextHeaderCellModel.lc = CellModel.ez("SortIndicatorStyle");
    TextHeaderCellModel.k8 = CellModel.ez("ColumnOptionsIconAlignment");
    TextHeaderCellModel.la = CellModel.ez("ColumnOptionsIconColor");
    TextHeaderCellModel.k9 = CellModel.ez("ColumnOptionsIconBehavior");
    return TextHeaderCellModel;
}(TextCellModel));
export { TextHeaderCellModel };
/**
 * @hidden
 */
export var ICellPresenter_$type = /*@__PURE__*/ new Type(null, 'ICellPresenter');
/**
 * @hidden
 */
var DataSourceNotificationBridge = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataSourceNotificationBridge, _super);
    function DataSourceNotificationBridge(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.a = a;
        return _this;
    }
    DataSourceNotificationBridge.prototype.rangeActualized = function (a, b) {
        this.a.sh(a, b);
    };
    DataSourceNotificationBridge.prototype.notifySetItem = function (a, b, c) {
        this.a.tb(a, b, c);
    };
    DataSourceNotificationBridge.prototype.notifyClearItems = function () {
        this.a.r3();
    };
    DataSourceNotificationBridge.prototype.notifyInsertItem = function (a, b) {
        this.a.st(a, b);
    };
    DataSourceNotificationBridge.prototype.notifyRemoveItem = function (a, b) {
        this.a.sy(a, b);
    };
    DataSourceNotificationBridge.$t = markType(DataSourceNotificationBridge, 'DataSourceNotificationBridge', Base.$, [IDataSourceUpdateNotifier_$type]);
    return DataSourceNotificationBridge;
}(Base));
export { DataSourceNotificationBridge };
/**
 * @hidden
 */
var ColumnController = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnController, _super);
    function ColumnController(a, b, c) {
        var _this = _super.call(this) || this;
        _this.i = null;
        _this.n = false;
        _this.c = null;
        _this.a = null;
        _this.v = new HashSet$1(String_$type, 0);
        _this.m = false;
        _this.k = null;
        _this.l = null;
        _this.n = b;
        _this.i = a;
        _this.l = c;
        return _this;
    }
    Object.defineProperty(ColumnController.prototype, "p", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            if (b != this.n) {
                this.m = false;
            }
            this.u();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnController.prototype, "d", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.m = false;
            }
            this.u();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnController.prototype, "b", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (b != this.a) {
                this.m = false;
                this.v.clear();
                for (var c = 0; c < this.a.length; c++) {
                    this.v.add_1(this.a[c]);
                }
            }
            this.u();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnController.prototype, "j", {
        get: function () {
            return this.i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnController.prototype, "o", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            this.m = a;
        },
        enumerable: true,
        configurable: true
    });
    ColumnController.prototype.u = function () {
        if (this.m) {
            return false;
        }
        if (this.c == null) {
            return false;
        }
        var a = new Dictionary$2(String_$type, Boolean_$type, 0);
        for (var b = 0; b < this.i.count; b++) {
            var c = this.i._inner[b];
            if (!c.gb) {
                a.item(c.h4, true);
            }
        }
        var d = false;
        for (var e = this.i.count - 1; e >= 0; e--) {
            if (this.i._inner[e].gb) {
                this.k.removeExternalColumn(this.i._inner[e].externalObject);
            }
        }
        if (this.n && this.c != null) {
            d = this.q(a, this.c);
        }
        this.m = true;
        if (d) {
            this.l();
        }
        return d;
    };
    ColumnController.prototype.q = function (a, b) {
        var c = new GridColumnCollection();
        for (var d = 0; d < b.propertyNames.length; d++) {
            var e = b.propertyNames[d];
            if (!a.containsKey(e)) {
                if (this.b != null && !this.v.contains(e)) {
                    continue;
                }
                var f = this.e(e, b.propertyTypes[d]);
                c.add(f);
                a.item(e, true);
            }
        }
        var g = new Dictionary$2(String_$type, Boolean_$type, 0);
        for (var h = 0; h < c.count; h++) {
            g.item(c._inner[h].h4, true);
        }
        var i = false;
        var j = this.i.count;
        for (var k = 0; k < c.count; k++) {
            i = true;
            this.k.insertExternalColumnAtIndex(j + k, c._inner[k].externalObject);
        }
        return i;
    };
    ColumnController.prototype.e = function (a, b) {
        var c = null;
        switch (b) {
            case 8:
            case 9:
                c = this.k.createDateTimeColumn(a);
                break;
            case 5:
            case 6:
            case 7:
            case 1:
            case 3:
            case 4:
            case 10:
                c = this.k.createNumericColumn(a);
                break;
            case 11:
                c = this.k.createTextColumn(a);
                break;
            case 0:
            case 2:
                c = this.k.createTextColumn(a);
                break;
        }
        c.h4 = a;
        c.gb = true;
        c.il = this.t(a) ? c.h4 : (createGuid());
        return c;
    };
    ColumnController.prototype.t = function (a) {
        for (var b = 0; b < this.i.count; b++) {
            if (this.i._inner[b].il == a) {
                return false;
            }
        }
        return true;
    };
    ColumnController.prototype.h = function (a) {
        if (a.a0 < 0 || this.i.count == 0 || this.i.count <= a.a0) {
            return null;
        }
        return this.i._inner[a.a0];
    };
    ColumnController.prototype.f = function (a) {
        for (var b = 0; b < this.i.count; b++) {
            if (this.i._inner[b].g6 == a) {
                return this.i._inner[b];
            }
        }
        return null;
    };
    ColumnController.prototype.g = function (a) {
        for (var b = 0; b < this.i.count; b++) {
            if (this.i._inner[b].h6() == a) {
                return this.i._inner[b];
            }
        }
        return null;
    };
    ColumnController.prototype.r = function (a) {
        return false;
    };
    ColumnController.prototype.s = function (a) {
        return false;
    };
    ColumnController.$t = markType(ColumnController, 'ColumnController');
    return ColumnController;
}(Base));
export { ColumnController };
/**
 * @hidden
 */
var EditingManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EditingManager, _super);
    function EditingManager(a) {
        var _this = _super.call(this) || this;
        _this.g = null;
        _this.c = null;
        _this.b = null;
        _this.e = null;
        _this.l = -1;
        _this.p = 0;
        _this.o = 0;
        _this.r = null;
        _this.j = false;
        _this.q = null;
        _this.k = false;
        _this.g = a;
        _this.p = -1;
        _this.o = -1;
        return _this;
    }
    Object.defineProperty(EditingManager.prototype, "m", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            this.l = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditingManager.prototype, "d", {
        get: function () {
            return this.c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditingManager.prototype, "a", {
        get: function () {
            return this.d != null ? this.d.k1 : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditingManager.prototype, "n", {
        get: function () {
            return this.a != null ? this.a.en : -1;
        },
        enumerable: true,
        configurable: true
    });
    EditingManager.prototype.aa = function (a) {
        if (a == null || a.k.a0 < 0 || a.k.w < 0) {
            return;
        }
        if (this.c == null) {
            this.y(a);
        }
        if (this.e == null) {
            this.e = new EditorRowCellModel();
            this.e.k = new CellPath(1, -1001, 0, -1001);
            this.e.o = this.g;
            this.e.kh = GridStyleRepository.bf;
        }
        if (this.j && this.c.lx != null) {
            return;
        }
        if (this.c.k1 != a) {
            this.y(a);
        }
        this.j = true;
        this.c.kv = Rect.empty;
        this.c.k7 = false;
        a.a1 = true;
        if (this.g.cg == 3) {
            if (this.e.q != this.g.model.ar) {
                if (this.e.q != null) {
                    this.e.q.f(this.e.k);
                }
                this.g.model.ar.s(this.e.k, this.e);
            }
            this.e.q = this.g.model.ar;
            this.e.kx = a;
            this.e.by = 1;
            if (this.g.v9 != null) {
                this.e.kd = this.g.v9;
            }
            else {
                this.e.kd = GridStyleRepository.av;
            }
            this.e.dd = truncate(this.g.xb.c);
            this.e.di = truncate(this.g.xb.e);
            this.e.dg = truncate(this.g.xb.d);
            this.e.db = truncate(this.g.xb.b);
        }
        this.m = a.k.w;
        this.q = a.gq;
        this.w();
    };
    EditingManager.prototype.y = function (a) {
        if (a == null || a.k.a0 < 0 || a.k.w < 0) {
            return;
        }
        if (this.c == null) {
            this.c = new EditorCellModel();
            this.c.c = new DefaultCellActionManager(this.g, this.c);
            this.c.d = new DefaultGridInfoRequestor(this.g, this.c);
            this.c.k = new CellPath(1, -1000, 0, -1000);
            this.c.o = this.g;
            var b = this.g;
            b.viewportChanged = delegateCombine(b.viewportChanged, runOn(this, this.v));
        }
        if ((this.j && this.c.k1 != a) || (this.c.k1 == a)) {
            return;
        }
        this.b = this.g.actualColumns._inner[a.k.a0];
        var c = this.h(this.b, a.k.w);
        if (this.c.q != c) {
            if (this.c.q != null) {
                this.c.q.f(this.c.k);
            }
            c.s(this.c.k, this.c);
        }
        this.c.q = c;
        this.c.k1 = a;
        this.c.gp = a.gp;
        this.c.ln = a.gp;
        this.c.lx = a.hm;
        this.c.k3 = this.f(this.b);
        this.c.lm = this.b.g8;
        this.c.ls = this.b.h0;
        this.c.kx = this.b.em;
        if (!this.j) {
            this.c.kv = new Rect(0, 0, 0, 0, 0);
        }
        else {
            this.c.kv = Rect.empty;
        }
        this.c.kz = this.g.actualDataSource.resolveSchemaPropertyType(this.b.h4);
        this.p = a.k.w;
        this.o = a.k.a0;
        this.r = a.gp;
        this.w();
    };
    EditingManager.prototype.i = function (a, b) {
        if (this.c != null && this.j && this.o != -1 && this.p != -1) {
            var c = true;
            if (a) {
                c = this.g.jh(this.c.k1, this.o, this.q, this.r, this.c.ln);
            }
            else {
                if (this.n != -1) {
                    this.g.tq(this.n);
                }
                this.c.lx = null;
            }
            if (c && this.c.lx == null) {
                this.j = false;
                if (this.c.k1 != null) {
                    this.c.k1.a1 = false;
                }
                this.c.k7 = true;
                this.c.kv = new Rect(0, 0, 0, 0, 0);
                if (this.g.cg == 3 && b) {
                    this.e.kx = null;
                    this.e.by = 0;
                    this.e.cc = -1000;
                    this.e.cd = -1000;
                }
                this.w();
            }
        }
        return !this.j;
    };
    EditingManager.prototype.s = function () {
        if (this.e != null && this.g.cg == 3) {
            this.e.kx = null;
            this.e.by = 0;
            this.e.cc = -1000;
            this.e.cd = -1000;
            this.m = -1;
        }
    };
    EditingManager.prototype.x = function (a) {
        if (this.c != null) {
            this.c.lx = a;
            this.w();
        }
    };
    EditingManager.prototype.z = function (a) {
        if (this.c != null) {
            this.c.k1 = a;
        }
        if (this.e != null) {
            this.e.kx = a;
        }
        if (this.j) {
            a.a1 = true;
        }
        else {
            a.a1 = false;
        }
    };
    EditingManager.prototype.t = function () {
        if (this.c != null) {
            this.c.k6 = true;
        }
    };
    EditingManager.prototype.w = function () {
        this.g.renderingEngine.refresh(this.g.model, false);
    };
    EditingManager.prototype.h = function (a, b) {
        if (a.fk != 0) {
            if (this.g.ee.isRowPinned(b)) {
                return this.g.model.ar;
            }
            else {
                return this.g.model.av;
            }
        }
        else {
            if (this.g.ee.isRowPinned(b)) {
                return this.g.model.a2;
            }
            else {
                return this.g.model.ba;
            }
        }
    };
    EditingManager.prototype.v = function (a, b) {
        this.u();
    };
    EditingManager.prototype.u = function () {
        if (!this.j) {
            return;
        }
        var a = this.g.w0.top + this.g.k7 + this.g.l3 + this.g.model.cv;
        var b = this.g.w0.bottom;
        var c = this.g.w0.left;
        var d = this.g.w0.right;
        if (this.d.cc > d || this.d.cc + this.d.gg < c || this.d.cd > b || this.d.cd + this.d.e0 < a) {
            if (!this.g.hj && this.d.q != null) {
                this.g.dj.j(this.d.k, this.d.q, this.g.model);
                this.d.q = null;
            }
        }
        else {
            if (this.d.q == null && this.b != null && this.a != null) {
                var e = this.h(this.b, this.a.k.w);
                e.s(this.d.k, this.d);
                this.d.q = e;
            }
        }
        if (this.e.cd > b || this.e.cd + this.e.e0 < a) {
            if (this.e.q != null) {
                this.g.dj.j(this.e.k, this.e.q, this.g.model);
                this.e.q = null;
            }
        }
        else {
            if (this.e.q == null && this.b != null && this.a != null) {
                var f = this.g.model.ar;
                f.s(this.e.k, this.e);
                this.e.q = f;
            }
        }
    };
    EditingManager.prototype.f = function (a) {
        if (a == null) {
            return 1;
        }
        if (a.fc != 0) {
            return a.fc;
        }
        var b = this.g.actualDataSource.resolveSchemaPropertyType(a.h4);
        switch (b) {
            case 10:
            case 6:
            case 5:
            case 1:
            case 3:
            case 4:
            case 7: return 2;
            case 8: return 3;
            default: return 1;
        }
    };
    EditingManager.$t = markType(EditingManager, 'EditingManager');
    return EditingManager;
}(Base));
export { EditingManager };
/**
 * @hidden
 */
var Grid = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Grid, _super);
    function Grid() {
        var _this = _super.call(this) || this;
        _this.l9 = null;
        _this._propertySetter = null;
        _this.ei = null;
        _this.eg = null;
        _this.columnExchangingAnimationCompleted = null;
        _this.columnExchangingAnimationCanceled = null;
        _this.columnShowingAnimationCompleted = null;
        _this.columnShowingAnimationCanceled = null;
        _this.filterExpressionsChanging = null;
        _this.filterExpressionsChanged = null;
        _this.columnMovingAnimationCompleted = null;
        _this.columnMovingAnimationCanceled = null;
        _this.columnHidingAnimationCompleted = null;
        _this.columnHidingAnimationCanceled = null;
        _this.cellPreviewPointerDown = null;
        _this.cellPreviewPointerUp = null;
        _this.cellPointerDown = null;
        _this.cellPointerUp = null;
        _this.cellClicked = null;
        _this.ko = -1;
        _this.bu = 0;
        _this.bg = 0;
        _this.ea = null;
        _this.gt = true;
        _this.vj = null;
        _this.vk = null;
        _this.vb = null;
        _this.w5 = new Thickness(0, 1);
        _this.wz = null;
        _this.aq = null;
        _this.gl = false;
        _this.hl = false;
        _this.kr = -1;
        _this.kz = -1;
        _this.gv = false;
        _this.gu = false;
        _this.gb = false;
        _this.jy = 0;
        _this.j5 = 0;
        _this.j3 = 0;
        _this.j4 = 0;
        _this.jo = new Date();
        _this.jt = 0;
        _this.ju = 0;
        _this.jv = 0;
        _this.jw = 0;
        _this.at = null;
        _this.k5 = 0;
        _this.k4 = 0;
        _this.g4 = false;
        _this.kv = -1;
        _this.k6 = -1;
        _this.eo = 0;
        _this.an = null;
        _this.jr = -1;
        _this.j2 = 0;
        _this.jz = 0;
        _this.j0 = 0;
        _this.jm = new List$1(Number_$type, 0);
        _this.jn = new List$1(Number_$type, 0);
        _this.am = null;
        _this.h8 = false;
        _this.g7 = false;
        _this.g9 = false;
        _this.g6 = false;
        _this.co = new GridAnimationManager();
        _this._delayedExecutionManager = null;
        _this.ep = null;
        _this.ed = null;
        _this.a2 = null;
        _this.di = new GridLayerController();
        _this.fa = new SpatialEngine();
        _this.dd = null;
        _this.e4 = null;
        _this.ai = null;
        _this.e8 = null;
        _this.cc = null;
        _this.f4 = null;
        _this.e2 = null;
        _this.e0 = new SectionFooter();
        _this.fc = null;
        _this.fe = null;
        _this.ey = null;
        _this.d6 = null;
        _this.d8 = null;
        _this.bw = null;
        _this.bi = null;
        _this.em = null;
        _this.b = null;
        _this.c = null;
        _this.fg = new VisibilityEngine();
        _this._viewportManager = null;
        _this.jq = 0;
        _this.jp = 0;
        _this.fk = 2;
        _this.kk = truncate(DeviceUtils.g(36));
        _this.kw = -1;
        _this.b9 = ColumnWidth.a;
        _this.js = 0;
        _this.kj = truncate(DeviceUtils.g(36));
        _this.kp = -1;
        _this.k1 = truncate(DeviceUtils.g(0));
        _this.ma = null;
        _this.k0 = truncate(DeviceUtils.g(0));
        _this.ky = truncate(DeviceUtils.g(0));
        _this.kn = truncate(DeviceUtils.g(0));
        _this.d4 = 0;
        _this.cf = 1;
        _this.cd = 2;
        _this.gc = true;
        _this.ga = true;
        _this.kx = truncate(DeviceUtils.g(1));
        _this.gs = true;
        _this.by = 1;
        _this.bp = 0;
        _this.ak = 0;
        _this.ew = 1;
        _this.et = 1;
        _this.aw = 1;
        _this.c3 = new GridColumnAnimationSettings();
        _this.cq = new GridAnimationSettings();
        _this.br = 1;
        _this.bz = 1;
        _this.bd = 1;
        _this.ba = 1;
        _this.a4 = 1;
        _this.w6 = new Thickness(1, 0, 0, 0, 0);
        _this.dx = 5;
        _this.cl = 1;
        _this.dv = 1;
        _this.gg = false;
        _this.ab = new GridSelectedItemsCollection();
        _this.af = new GridSelectedKeysCollection();
        _this.dr = new GridSelectedCellsCollection();
        _this.dn = new GridSelectedCellRangesCollection();
        _this.gf = false;
        _this.aa = new GridSelectedItemsCollection();
        _this.ae = new GridSelectedKeysCollection();
        _this.gj = true;
        _this.gq = true;
        _this.gr = true;
        _this.u5 = null;
        _this.vq = null;
        _this.vt = null;
        _this.vx = null;
        _this.j1 = NaN;
        _this.fn = null;
        _this.jx = NaN;
        _this.va = null;
        _this.vs = null;
        _this.vi = null;
        _this.vh = null;
        _this.c0 = null;
        _this.cz = null;
        _this.u4 = null;
        _this.u6 = null;
        _this.vf = null;
        _this.e6 = 0;
        _this.fm = null;
        _this.vp = null;
        _this.vr = null;
        _this.fp = null;
        _this.fq = null;
        _this.fs = null;
        _this.vw = null;
        _this.fr = null;
        _this.ft = null;
        _this.v0 = null;
        _this.vu = null;
        _this.vy = null;
        _this.vv = null;
        _this.vz = null;
        _this.ku = truncate(DeviceUtils.g(2));
        _this.kq = truncate(DeviceUtils.g(1));
        _this.ve = null;
        _this.vc = null;
        _this.vg = null;
        _this.fo = null;
        _this.vl = null;
        _this.vd = null;
        _this.vo = null;
        _this.vm = null;
        _this.vn = null;
        _this.km = truncate(DeviceUtils.g(4));
        _this.kl = truncate(DeviceUtils.g(2));
        _this.u9 = null;
        _this.u7 = null;
        _this.g3 = false;
        _this.bk = 0;
        _this.u8 = null;
        _this.bm = 0;
        _this.u3 = null;
        _this.w4 = GridStyleRepository.bp;
        _this.w2 = GridStyleRepository.bp;
        _this.w3 = new Thickness(0, NaN);
        _this.gx = false;
        _this.uy = GridStyleRepository.r;
        _this.ux = new CornerRadius(0, NaN);
        _this.uw = GridStyleRepository.r;
        _this.gi = true;
        _this.f2 = new DefaultPlatformPixelConverter();
        _this.eb = null;
        _this.er = null;
        _this.fi = new VisualModel();
        _this.b4 = null;
        _this.a7 = null;
        _this.u = null;
        _this.b7 = null;
        _this.sortDescriptionsChanged = null;
        _this.groupDescriptionsChanged = null;
        _this.columnHiddenChanged = null;
        _this.columnPinnedChanged = null;
        _this.cellValueChanging = null;
        _this.dataCommitted = null;
        _this.dataCommitting = null;
        _this.g5 = false;
        _this.s = 0;
        _this.gn = false;
        _this.gm = false;
        _this.gd = false;
        _this.q = 0;
        _this.gp = false;
        _this.go = true;
        _this.ge = false;
        _this.d2 = 4;
        _this.f9 = true;
        _this.propertyChanged = null;
        _this.g2 = false;
        _this.y = null;
        _this.w = null;
        _this.d = null;
        _this.a = null;
        _this.f7 = true;
        _this.sizeChanged = null;
        _this.viewportChanged = null;
        _this.ks = -1;
        _this.kt = -1;
        _this.je = false;
        _this.actualColumnsChanged = null;
        _this.c5 = new GridColumnCollection();
        _this.gw = false;
        _this.jc = false;
        _this.jd = false;
        _this.f6 = false;
        _this.hr = false;
        _this.h7 = false;
        _this.ji = new List$1(Base.$, 0);
        _this.jj = new List$1(PrimaryKeyValue.$, 0);
        _this.jk = new List$1(Base.$, 0);
        _this.jl = new List$1(PrimaryKeyValue.$, 0);
        _this.f8 = false;
        _this.g8 = false;
        _this.k2 = -1;
        _this.k3 = -1;
        _this.ar = null;
        _this.as = null;
        _this.columnsAutoGenerated = null;
        _this.selectedItemsChanged = null;
        _this.selectedKeysChanged = null;
        _this.selectedCellsChanged = null;
        _this.activeCellChanged = null;
        _this.selectedCellRangesChanged = null;
        _this.au = null;
        _this.gh = false;
        _this.g1 = true;
        _this.g0 = true;
        _this.gz = true;
        _this.columnWidthChanged = null;
        _this.cellEditStarted = null;
        _this.cellEditEnded = null;
        _this.rowEditStarted = null;
        _this.rowEditEnded = null;
        _this.gy = false;
        _this.cj = 1;
        _this.ch = 0;
        _this.jf = false;
        _this.gk = true;
        _this.e3 = new SectionHeader();
        _this.ez = new RowSeparator();
        _this.d7 = new HeaderRowSeparator();
        _this.d9 = new HeaderSeparator();
        _this.bx = new ColumnResizingSeparator();
        _this.bj = new ColumnMovingSeparator();
        _this.en = new PinnedAreaSeparator();
        _this.fd = new SummaryRowRoot();
        _this.ff = new SummaryRowSection();
        _this.w3 = _this.w4;
        _this.ux = _this.uy;
        _this.u3 = GridStyleRepository.ax;
        _this.a2 = new ColumnController(_this.c5, _this.hc, runOn(_this, _this.rh));
        var a = _this.a2.j;
        a.collectionChanged = delegateCombine(a.collectionChanged, runOn(_this, _this.qc));
        _this.ed = new DataAdapter(_this.a2);
        _this.er = new ResponsiveStatesCollection();
        _this.ep = new ResponsiveEngine(_this);
        _this.ep.g = _this.er;
        _this.hr = _this.i3();
        _this.h7 = _this.i4();
        _this.e5 = new SelectionManager(_this, _this.cp);
        _this.aj = new ActivationManager(_this, _this.cp);
        _this.ab.ag(runOn(_this, _this.ua));
        _this.af.aj(runOn(_this, _this.ub));
        _this.dr.an(runOn(_this, _this.t9));
        var b = _this.dn;
        b.collectionChanged = delegateCombine(b.collectionChanged, runOn(_this, _this.t8));
        _this.aa.ag(runOn(_this, _this.tg));
        _this.ae.aj(runOn(_this, _this.th));
        _this.b4 = new ColumnSortDescriptionCollection();
        _this.a7 = new ColumnGroupDescriptionCollection();
        _this.b7 = new ColumnSummaryDescriptionCollection();
        _this.b4.l(runOn(_this, _this.uh));
        _this.a7.l(runOn(_this, _this.q3));
        _this.b7.l(runOn(_this, _this.uj));
        _this.u = new FilterExpressionCollection();
        _this.u.m(runOn(_this, _this.q0));
        _this.e9 = new SortManager(_this);
        _this.cc = new EditingManager(_this);
        _this.ea = new HoverManager(_this);
        return _this;
    }
    Object.defineProperty(Grid.prototype, "md", {
        get: function () {
            return this.l9;
        },
        set: function (a) {
            this.l9 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "propertySetter", {
        get: function () {
            return this._propertySetter;
        },
        set: function (a) {
            this._propertySetter = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "externalGrid", {
        get: function () {
            return this.ei;
        },
        set: function (a) {
            this.ei = a;
            if (this.a3 != null) {
                this.a3.k = this.ei;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dragger", {
        get: function () {
            return this.eg;
        },
        set: function (a) {
            if (this.eg != null) {
                var b = this.eg;
                b.onDrag = delegateRemove(b.onDrag, runOn(this, this.sk));
                var c = this.eg;
                c.onDragEnd = delegateCombine(c.onDragEnd, runOn(this, this.sm));
            }
            this.eg = a;
            var d = this.eg;
            d.onDrag = delegateCombine(d.onDrag, runOn(this, this.sk));
            var e = this.eg;
            e.onDragEnd = delegateCombine(e.onDragEnd, runOn(this, this.sm));
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.r5 = function (a) {
        if (this.columnExchangingAnimationCompleted != null) {
            this.columnExchangingAnimationCompleted(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.r4 = function (a) {
        if (this.columnExchangingAnimationCanceled != null) {
            this.columnExchangingAnimationCanceled(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.o = function (a) {
        var b = this.a1(a.k);
        if (b == null) {
            return null;
        }
        return b.eo;
    };
    Grid.prototype.p = function (a) {
        var b = this.a1(a.k);
        if (b == null) {
            return 11;
        }
        if (this.actualDataSource == null) {
            return 11;
        }
        return this.actualDataSource.resolveSchemaPropertyType(b.h4);
    };
    Grid.prototype.se = function (a) {
        if (this.columnShowingAnimationCompleted != null) {
            this.columnShowingAnimationCompleted(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.qp = function (a, b) {
        var _this = this;
        var c = this.a1(a.k);
        if (c == null) {
            return;
        }
        if (!Base.equalsStatic(c.eo, b)) {
            c.eo = b;
            if (this.filterExpressionsChanging != null) {
                this.filterExpressionsChanging(this, ((function () {
                    var $ret = new GridFilterExpressionsEventArgs();
                    $ret.a = _this.v;
                    return $ret;
                })()));
            }
        }
    };
    Grid.prototype.qo = function (a, b) {
        var c = this.a1(a.k);
        if (c == null) {
            return;
        }
        if (!Base.equalsStatic(c.eo, b)) {
            c.eo = b;
        }
    };
    Grid.prototype.sd = function (a) {
        if (this.columnShowingAnimationCanceled != null) {
            this.columnShowingAnimationCanceled(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.sb = function (a) {
        if (this.columnMovingAnimationCompleted != null) {
            this.columnMovingAnimationCompleted(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.sa = function (a) {
        if (this.columnMovingAnimationCanceled != null) {
            this.columnMovingAnimationCanceled(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.r7 = function (a) {
        if (this.columnHidingAnimationCompleted != null) {
            this.columnHidingAnimationCompleted(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.r6 = function (a) {
        if (this.columnHidingAnimationCanceled != null) {
            this.columnHidingAnimationCanceled(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.rz = function (a) {
        var _this = this;
        if (this.cellPreviewPointerDown != null) {
            this.cellPreviewPointerDown(a, ((function () {
                var $ret = new GridCellEventArgs();
                $ret.cellInfo = a;
                $ret.grid = _this;
                return $ret;
            })()));
        }
    };
    Grid.prototype.r0 = function (a) {
        var _this = this;
        if (this.cellPreviewPointerUp != null) {
            this.cellPreviewPointerUp(a, ((function () {
                var $ret = new GridCellEventArgs();
                $ret.cellInfo = a;
                $ret.grid = _this;
                return $ret;
            })()));
        }
    };
    Grid.prototype.rx = function (a) {
        var _this = this;
        if (this.cellPointerDown != null) {
            this.cellPointerDown(a, ((function () {
                var $ret = new GridCellEventArgs();
                $ret.cellInfo = a;
                $ret.grid = _this;
                return $ret;
            })()));
        }
    };
    Grid.prototype.ry = function (a) {
        var _this = this;
        if (this.cellPointerUp != null) {
            this.cellPointerUp(a, ((function () {
                var $ret = new GridCellEventArgs();
                $ret.cellInfo = a;
                $ret.grid = _this;
                return $ret;
            })()));
        }
    };
    Grid.prototype.s2 = function (a, b) {
        this.q8(a);
    };
    Grid.prototype.ss = function (a) {
        if (a.v == 2) {
            this.uq(a.k.w);
        }
    };
    Grid.prototype.uq = function (a) {
        if (this.cc.j) {
            if (!this.hk(true)) {
                return;
            }
            if (this.cg == 3) {
                this.qx(true);
            }
        }
        var b = !this.actualDataSource.getIsRowExpandedAtIndex(a);
        this.actualDataSource.setIsRowExpandedAtIndex(a, b);
        var c = this.actualDataSource.getRowLevel(a);
        if (a < this.model.bf.w) {
            this.t5(a - c);
        }
    };
    Grid.prototype.sr = function (a) {
        if (a != null && this.cg != 3) {
            this.hk(true);
        }
    };
    Grid.prototype.rq = function (a, b) {
        var _this = this;
        if (a.v == 1) {
            if (this.h2() && this.ce == 2 && b == 0) {
                this.jb(a);
            }
        }
        if (this.cellClicked != null) {
            this.cellClicked(a, ((function () {
                var $ret = new GridCellEventArgs();
                $ret.cellInfo = a;
                $ret.grid = _this;
                $ret.button = b;
                $ret.isDoubleClick = true;
                return $ret;
            })()));
        }
    };
    Grid.prototype.ro = function (a, b, c, d) {
        var _this = this;
        if (a.v == 1) {
            if (this.cc.j && a != this.cc.a) {
                if (!this.hk(true)) {
                    return;
                }
            }
            if (a.k.w != this.ko) {
                this.qx(true);
            }
            if (d == 0 && this.h2()) {
                if (this.ce == 1 || (this.cg == 3 && a.k.w == this.ko)) {
                    this.jb(a);
                }
            }
            if (a.k.ag) {
                var e = this.a3.h(a.k);
                if (e.ge && !this.cc.j && this.hj) {
                    this.cc.t();
                }
            }
        }
        else if (a.v == 2 || a.v == 3) {
            this.hk(true);
            this.qx(true);
        }
        if (d == 0) {
            this.k3 = -1;
            this.k2 = -1;
            this.at = null;
            this.jm.clear();
            this.jn.clear();
            if (a.v == 0 && this.d5 != 4) {
                this.e9.d(this.a1(a.k));
            }
            if (this.dy == 5) {
                if (a.k.ag && !a.k.av) {
                    var f = this.model.br._inner[a.k.a0].n;
                    if (this.dw == 1) {
                        if (b) {
                            this.tk(a.k.w, f);
                        }
                        else {
                            if (c && this.au != null) {
                                var g = f;
                                var h = a.k.w;
                                this.dp.remove(this.au);
                                this.qe(Math.min(this.au.k, g), Math.max(this.au.k, g), Math.min(this.au.l, h), Math.max(this.au.l, h));
                            }
                            else {
                                this.tr();
                                this.qe(f, f, a.k.w, a.k.w);
                            }
                        }
                    }
                    else if (this.dw == 0) {
                        this.tk(a.k.w, f);
                    }
                }
            }
            else {
                this.e5.z(a, c, b, this.dw == 0);
            }
            if (this.cm == 1) {
                this.aj.z(a);
            }
        }
        if (this.cellClicked != null) {
            this.cellClicked(a, ((function () {
                var $ret = new GridCellEventArgs();
                $ret.cellInfo = a;
                $ret.grid = _this;
                $ret.button = d;
                $ret.isDoubleClick = false;
                return $ret;
            })()));
        }
    };
    Grid.prototype.tk = function (a, b) {
        var c = false;
        for (var d = 0; d < this.dp.count; d++) {
            var e = this.dp._inner[d];
            if (e.k == b && e.i == b && e.l == a && e.j == a) {
                this.ts(this.dp._inner[d]);
                c = true;
                break;
            }
        }
        if (!c) {
            this.qe(b, b, a, a);
        }
    };
    Object.defineProperty(Grid.prototype, "bv", {
        get: function () {
            return this.bu;
        },
        set: function (a) {
            var b = this.bu;
            this.bu = a;
            if (b != this.bu) {
                this.sx("ColumnResizingMode", enumGetBox(ColumnResizingMode_$type, b), enumGetBox(ColumnResizingMode_$type, this.bu));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "bh", {
        get: function () {
            return this.bg;
        },
        set: function (a) {
            var b = this.bg;
            this.bg = a;
            if (b != this.bg) {
                this.sx("ColumnMovingMode", enumGetBox(ColumnMovingMode_$type, b), enumGetBox(ColumnMovingMode_$type, this.bg));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ig", {
        get: function () {
            return this.gt;
        },
        set: function (a) {
            var b = this.gt;
            this.gt = a;
            if (b != this.gt) {
                this.sx("IsRowHoverEnabled", b, this.gt);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wh", {
        get: function () {
            return this.vj;
        },
        set: function (a) {
            var b = this.vj;
            this.vj = a;
            if (b != this.vj) {
                this.sx("RowHoverBackground", b, this.vj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wi", {
        get: function () {
            return this.vk;
        },
        set: function (a) {
            var b = this.vk;
            this.vk = a;
            if (b != this.vk) {
                this.sx("RowHoverTextColor", b, this.vk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "v9", {
        get: function () {
            return this.vb;
        },
        set: function (a) {
            var b = this.vb;
            this.vb = a;
            if (b != this.vb) {
                this.sx("EditRowBorder", b, this.vb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "xb", {
        get: function () {
            return this.w5;
        },
        set: function (a) {
            var b = this.w5;
            this.w5 = a;
            if (b != this.w5) {
                this.sx("EditRowBorderWidth", b, this.w5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.rv = function (a, b, c) {
        this.aq = a.k.aa();
        this.wz = { $type: Point_$type, x: b, y: c };
        this.gl = a.a6 && a.a7;
        if (this.dragger != null && this.bv != 2 && this.aq.h) {
            var d = this.a3.j._inner[a.k.a0];
            if (d.gi) {
                var e = this.model.br._inner[this.aq.a0];
                this.j2 = e.k;
                this.jz = this.model.cf;
                this.j0 = this.model.cg;
                this.j3 = this.model.actualVisibleRegion.left;
                this.j4 = this.model.actualVisibleRegion.top;
                var f = this.dragger.view.transformPoint(b, c);
                this.l0 = truncate((f.x + this.j3)) - (intDivide(this.lc, 2));
                this.jr = -1;
                this.externalGrid.setResizeCursor();
                this.dragger.dragStart(b, c, this.model.actualVisibleRegion.x, this.model.actualVisibleRegion.y, 1, this.aq, false);
                if (this.bv == 0) {
                    this.tm();
                }
            }
        }
    };
    Grid.prototype.rw = function (a, b, c) {
        this.aq = null;
    };
    Grid.prototype.ru = function (a, b, c) {
        var d = 0;
        for (var e = 0; e < this.model.br.count; e++) {
            var f = this.model.br._inner[e];
            d += f.k;
        }
        var g = this.dragger.view.transformPoint(b, c);
        if ((this.dragger == null || !this.dragger.isDragActive) && g.x >= d) {
            this.externalGrid.setDefaultCursor();
        }
        if (this.ig) {
            this.ea.f(-1);
        }
    };
    Object.defineProperty(Grid.prototype, "ly", {
        get: function () {
            return this.kr;
        },
        set: function (a) {
            this.kr = a;
            this.hl = true;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.rt = function (a, b, c) {
        if (this.ig) {
            var d = false;
            var e = -1;
            if (a.k.ag || a.k.at || a.k.ah) {
                d = true;
                e = a.k.w;
                if (a.k.ah && this.cc.j) {
                    e = this.cc.a.k.w;
                }
            }
            else if (a.k.g || a.k.j) {
                d = true;
            }
            if (d) {
                if (this.je) {
                    this.ly = e;
                }
                else {
                    this.ea.f(e);
                }
            }
        }
    };
    Grid.prototype.sw = function (a, b, c) {
        if (this.dragger == null || !this.dragger.isDragActive) {
            if (a.k.h && this.bv != 2) {
                var d = this.a3.j._inner[a.k.a0];
                if (d.gi) {
                    this.externalGrid.setResizeCursor();
                }
            }
            else {
                this.externalGrid.setDefaultCursor();
            }
        }
        else if (this.dragger.dragType != 1 && this.dragger.dragType != 2) {
            this.externalGrid.setDefaultCursor();
        }
    };
    Grid.prototype.qk = function () {
        if (this.kz != -1) {
            this.f4.teardownTicking(this.kz);
            this.kz = -1;
        }
    };
    Grid.prototype.sq = function (a, b, c, d) {
        this.j3 = this.model.actualVisibleRegion.left;
        this.j4 = this.model.actualVisibleRegion.top;
        if ((this.dragger == null || !this.dragger.isDragActive) && a.g && !a.h && this.bh != 1) {
            var e = this.a1(a);
            if (e != null && e.gg) {
                this.externalGrid.ensureColumnsAreManual();
            }
            this.externalGrid.setHandCursor();
            this.dragger.dragStart(b, c, this.model.actualVisibleRegion.x, this.model.actualVisibleRegion.y, 2, a, d);
        }
        else if (this.dy == 5 && a.ag && !a.av) {
            if (!d) {
                this.tr();
            }
            this.k5 = a.w;
            this.k4 = this.model.br._inner[a.a0].n;
            this.g4 = this.gl;
            if (this.cm == 1) {
                this.aj.y(a);
            }
            this.dragger.dragStart(b, c, this.model.actualVisibleRegion.x, this.model.actualVisibleRegion.y, 0, a, d);
        }
        else if (this.dy == 2 && a.ag) {
            if (!d) {
                this.hn = true;
                this.ah.clear();
                this.ad.clear();
                this.hn = false;
                this.e5.a0();
            }
            this.gb = d;
            this.k5 = a.w;
            this.jm.clear();
            this.jn.clear();
            if (this.cm == 1) {
                this.aj.y(a);
            }
            this.dragger.dragStart(b, c, this.model.actualVisibleRegion.x, this.model.actualVisibleRegion.y, 3, a, d);
        }
    };
    Grid.prototype.sm = function (a, b) {
        this.qk();
        this.at = null;
        this.an = null;
        this.kv = -1;
        this.aq = null;
        this.gb = false;
        this.jm.clear();
        this.jn.clear();
        if (this.dragger == null) {
            return;
        }
        if (this.dragger.dragType == 1) {
            this.externalGrid.setDefaultCursor();
            if (this.bv == 0) {
                if (this.jr != -1) {
                    var c = this.model.br._inner[this.dragger.cellPath.a0];
                    this.cp.ag(this, this.c4, c, this.jr);
                }
                else {
                    this.renderingEngine.refresh(this.model, false);
                }
            }
        }
        else if (this.dragger.dragType == 2) {
            this.externalGrid.setDefaultCursor();
            if (this.bh == 0) {
                var d = true;
                if ((this.k6 != -1 && this.k6 != this.dragger.cellPath.a0) || this.eo != this.columns._inner[this.dragger.cellPath.a0].fk) {
                    var e = this.columns._inner[this.dragger.cellPath.a0].fk;
                    if (e != this.eo) {
                        this.jd = true;
                        this.rc(this.dragger.cellPath.a0, this.k6);
                        this.jd = false;
                        this.tf(this.columns._inner[this.k6], this.eo);
                    }
                    else {
                        this.rc(this.dragger.cellPath.a0, this.k6);
                    }
                    d = false;
                }
                if (d) {
                    this.tm();
                }
                this.k6 = -1;
            }
        }
    };
    Grid.prototype.sk = function (a, b) {
        if (this.dragger == null) {
            return;
        }
        this.jt = b.startX;
        this.ju = b.startY;
        this.jv = b.currentX;
        this.jw = b.currentY;
        switch (this.dragger.dragType) {
            case 0:
                this.so(false);
                break;
            case 1:
                this.sn();
                break;
            case 2:
                this.sl(false);
                break;
            case 3:
                this.sp(false, this.gb);
                break;
        }
    };
    Object.defineProperty(Grid.prototype, "l0", {
        get: function () {
            return this.kv;
        },
        set: function (a) {
            if (this.kv != a) {
                this.kv = a;
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.sl = function (a) {
        var _this = this;
        if (this.dragger == null) {
            return;
        }
        var b = this.jv + this.model.actualVisibleRegion.x;
        if (a || !this.hd(b, NaN)) {
            var c = this.dragger.cellPath.a0;
            var d = this.l0;
            this.eo = 0;
            for (var e = 0; e < this.model.br.count; e++) {
                var f = this.model.br._inner[e];
                if (f.a == 3) {
                    continue;
                }
                var g = f.l;
                if (f.d == 1) {
                    g = f.l + this.model.actualVisibleRegion.x;
                }
                var h = g + f.k;
                var i = g + (intDivide(f.k, 2));
                if ((f.n == 0 && b < g) || (b > g && b <= i)) {
                    d = g;
                    if (e != c) {
                        c = e < this.dragger.cellPath.a0 ? e : e - 1;
                    }
                    if (f.d != 1 && d < this.model.actualVisibleRegion.x + this.model.cf) {
                        d = this.model.actualVisibleRegion.x + this.model.cf;
                    }
                    this.eo = f.d;
                    break;
                }
                else if ((b > i && b < h) || (e == this.model.br.count - 1 && b > h)) {
                    d = h - this.la;
                    if (e != c) {
                        c = e < this.dragger.cellPath.a0 ? e + 1 : e;
                    }
                    this.eo = f.d;
                    break;
                }
            }
            if (d != this.l0) {
                var j = this.l0;
                this.l0 = truncate(d);
                if (j == -1) {
                    this.renderingEngine.invalidateVisibility(function () { return _this.fh.l(_this); });
                    this.renderingEngine.refresh(this.model, true);
                }
                else {
                    if (this.an == null) {
                        this.an = this.dj.c(new CellPath(1, -400, 0, -102), this.model);
                    }
                    this.an.cc = this.l0;
                    this.renderingEngine.refresh(this.model, false);
                }
                this.k6 = c;
            }
        }
    };
    Grid.prototype.sn = function () {
        var _this = this;
        var a = this.a3.h(this.dragger.cellPath);
        if (this.an == null) {
            this.an = this.dj.c(new CellPath(1, -400, 0, -102), this.model);
        }
        var b = (this.jv + this.model.actualVisibleRegion.x) - this.jt;
        var c = isNaN_(a.gq) ? isNaN_(this.j8) ? 0 : this.j8 : a.gq;
        this.jr = Math.max(this.j2 + b, Math.max(c, 10));
        var d = 20;
        if (a.fk == 1) {
            d = Math.min(20, this.w0.width - this.model.cf);
            var e = this.w0.width - d - this.model.cg;
            var f = this.jz + (this.jr - this.j2);
            if (f > e) {
                this.jr = this.jr - (f - e);
            }
        }
        else if (a.fk == 2) {
            d = Math.min(20, this.w0.width - this.model.cg);
            var g = this.w0.width - d - this.model.cf;
            var h = this.j0 + (this.jr - this.j2);
            if (h > g) {
                this.jr = this.jr - (h - g);
            }
        }
        if (this.bv == 0) {
            this.l0 = truncate((this.jt - this.j2 + this.jr)) - (intDivide(this.lc, 2));
            if (this.an != null) {
                this.an.cc = this.l0;
                this.renderingEngine.refresh(this.model, false);
            }
        }
        else {
            var i = ((function () {
                var $ret = new ColumnWidth();
                $ret.f = _this.jr;
                $ret.c = false;
                return $ret;
            })());
            if (!isNaN_(a.gq)) {
                i.e = a.gq;
            }
            a.width = i;
        }
    };
    Grid.prototype.so = function (a) {
        if (a || !this.hd(this.jv + this.model.actualVisibleRegion.x, this.jw + this.model.actualVisibleRegion.y)) {
            var b = this.jv + this.model.actualVisibleRegion.x;
            var c = this.w1(b, this.ju, this.jv, this.jw);
            var d = this.av(c, this.k5, this.k4, this.g4);
            this.t7(d);
        }
    };
    Grid.prototype.t7 = function (a) {
        if (this.at == null) {
            this.at = a;
            this.qd(this.at);
        }
        else {
            this.uv(a);
        }
    };
    Grid.prototype.sp = function (a, b) {
        if (a || !this.hd(this.jv + this.model.actualVisibleRegion.x, this.jw + this.model.actualVisibleRegion.y)) {
            var c = this.jv + this.model.actualVisibleRegion.x;
            var d = this.w1(c, this.ju, this.jv, this.jw);
            var e = this.av(d, this.k5, 0, this.g4);
            this.uc(e.l, e.j);
        }
    };
    Grid.prototype.uc = function (a, b) {
        for (var c = a; c <= b; c++) {
            if (this.jm.contains(c)) {
                continue;
            }
            if (!this.jn.contains(c)) {
                var d = this.ee.getRowKey(this.i(), c);
                if (d != null) {
                    if (this.e5.n(d)) {
                        this.jm.add(c);
                        continue;
                    }
                    else {
                        this.jn.add(c);
                        this.ah.add(d);
                    }
                }
            }
        }
        for (var e = 0; e < this.jn.count; e++) {
            if (this.jn._inner[e] < a || this.jn._inner[e] > b) {
                var f = this.ee.getRowKey(this.i(), this.jn._inner[e]);
                if (f != null) {
                    this.jn.removeAt(e);
                    e--;
                    this.ah.remove(f);
                }
            }
        }
    };
    Grid.prototype.w1 = function (a, b, c, d) {
        c += this.model.actualVisibleRegion.x;
        d += this.model.actualVisibleRegion.y;
        return new Rect(0, Math.min(a, c), Math.min(b, d), Math.abs(c - a), Math.abs(d - b));
    };
    Grid.prototype.ap = function (a, b) {
        if (this.fi == null) {
            return null;
        }
        return this.fi.e(a, b);
    };
    Grid.prototype.av = function (a, b, c, d) {
        var e = this.model.al.q;
        var f = this.model.a0.q;
        var g = this.model.a3.q;
        var h = this.model.an.q;
        var i = new List$1(CellModel.$, 1, f);
        i.o(e);
        i.o(g);
        i.o(h);
        var j = b;
        var k = c;
        var l = this.jv + this.model.actualVisibleRegion.x;
        for (var m = 0; m < i.count; m++) {
            var n = i._inner[m];
            if (!n.k.ag || n.k.av || n.k.ah || n.k.ai) {
                continue;
            }
            if (l < this.model.actualVisibleRegion.x + this.model.cf && n.k.d != 1) {
                continue;
            }
            if (l > this.model.actualVisibleRegion.right - this.model.cg && n.k.d != 2) {
                continue;
            }
            if (d) {
                if (!n.a6 || (n.a6 && !n.a7)) {
                    continue;
                }
            }
            else {
                if (n.a6 && n.a7) {
                    continue;
                }
            }
            var o = new Rect(0, n.cc, n.cd, n.gg, n.e0);
            if (a.intersectsWith(o)) {
                var p = this.model.br._inner[n.k.a0].n;
                var q = Math.abs(n.k.w - b);
                var r = Math.abs(Math.max(0, p) - c);
                var s = Math.abs(j - b);
                var t = Math.abs(k - c);
                if (q > s) {
                    j = n.k.w;
                }
                if (r > t && !n.k.av) {
                    k = p;
                }
            }
        }
        var u = new CellRange();
        u.k = Math.min(c, k);
        u.i = Math.max(c, k);
        u.l = Math.min(b, j);
        u.j = Math.max(b, j);
        return u;
    };
    Grid.prototype.hd = function (a, b) {
        var c = 20;
        var d = 20;
        var e = new Rect(0, this.model.actualVisibleRegion.x + d, this.model.actualVisibleRegion.y + c, Math.max(this.model.actualVisibleRegion.width - d * 2, 0), Math.max(this.model.actualVisibleRegion.height - c * 2, 0));
        var f = 5;
        var g = 1000;
        var h = 5;
        var i = 1000;
        if (!this.g4 && !isNaN_(b)) {
            if (b > e.bottom) {
                var j = b - e.bottom;
                this.j5 = Math.min(j * f, g);
                this.gv = true;
            }
            else if (b < e.top) {
                var k = e.top - b;
                this.j5 = -Math.min(k * f, g);
                this.gv = true;
            }
            else {
                this.j5 = 0;
                this.gv = false;
            }
        }
        if (a > e.right) {
            var l = a - e.right;
            this.jy = Math.min(l * h, i);
            this.gu = true;
        }
        else if (a < e.left) {
            var m = e.left - a;
            this.jy = -Math.min(m * h, i);
            this.gu = true;
        }
        else {
            this.jy = 0;
            this.gu = false;
        }
        if ((this.gv || this.gu) && this.kz == -1) {
            this.jo = dateNow();
            this.kz = this.f4.setupTicking(runOn(this, this.qv));
            this.f4.requestFrame(this.kz);
        }
        if (!this.gv && !this.gu) {
            this.qk();
        }
        return this.gu || this.gv;
    };
    Grid.prototype.qv = function () {
        if (this.dragger == null) {
            return;
        }
        var a = dateNow();
        var b = timeSpanTotalSeconds((+a - +(this.jo)));
        this.jo = a;
        this.j3 = Math.max(this.j3 + this.jy * b, 0);
        this.j4 = Math.max(this.j4 + this.j5 * b, 0);
        if (this.model.absoluteWidth > 0 && this.model.actualVisibleRegion.width > 0 && this.j3 + this.model.actualVisibleRegion.width > this.model.absoluteWidth) {
            this.j3 = Math.round(this.model.absoluteWidth - this.model.actualVisibleRegion.width);
        }
        if (this.model.absoluteHeight > 0 && this.model.actualVisibleRegion.height > 0 && this.j4 + this.model.actualVisibleRegion.height > this.model.absoluteHeight) {
            this.j4 = Math.round(this.model.absoluteHeight - this.model.actualVisibleRegion.height);
        }
        this.viewportManager.moveViewportTo(truncate(this.j3), truncate(this.j4));
        switch (this.dragger.dragType) {
            case 0:
                this.so(true);
                break;
            case 1:
                this.sn();
                break;
            case 2:
                this.sl(true);
                break;
            case 3:
                this.sp(true, this.gb);
                break;
        }
        this.f4.requestFrame(this.kz);
    };
    Grid.prototype.uv = function (a) {
        if (a.k != this.at.k || a.i != this.at.i || a.l != this.at.l || a.j != this.at.j) {
            this.at.k = a.k;
            this.at.i = a.i;
            this.at.l = a.l;
            this.at.j = a.j;
            this.g9 = true;
            this.e5.ay();
            this.g9 = false;
            this.rf(this.at);
        }
    };
    Grid.prototype.ty = function (a) {
        if (this.actualDataSource != null && this.actualDataSource.actualSchema != null) {
            a.m = this.actualDataSource.resolveSchemaPropertyType(a.f);
            a.o = true;
        }
    };
    Grid.prototype.tz = function (a) {
        if (this.actualDataSource != null && this.actualDataSource.actualSchema != null) {
            a.g = this.actualDataSource.resolveSchemaPropertyType(a.af);
            a.r = true;
        }
    };
    Grid.prototype.uj = function (a, b) {
        switch (b.action) {
            case 0:
                if (b.newItems != null) {
                    for (var c = 0; c < b.newItems.count; c++) {
                        var d = b.newItems.item(c);
                        if (!d.r) {
                            this.tz(d);
                        }
                    }
                }
                break;
        }
    };
    Grid.prototype.q3 = function (a, b) {
        var _this = this;
        switch (b.action) {
            case 0:
                if (b.newItems != null) {
                    for (var c = 0; c < b.newItems.count; c++) {
                        var d = b.newItems.item(c);
                        if (!d.o) {
                            this.ty(d);
                        }
                    }
                }
                break;
        }
        if (this.groupDescriptionsChanged != null) {
            this.groupDescriptionsChanged(this, ((function () {
                var $ret = new GridGroupDescriptionsChangedEventArgs();
                $ret.groupDescriptions = _this.a8;
                return $ret;
            })()));
        }
    };
    Grid.prototype.q0 = function (a, b) {
        var _this = this;
        if (this.filterExpressionsChanged != null) {
            this.filterExpressionsChanged(this, ((function () {
                var $ret = new GridFilterExpressionsEventArgs();
                $ret.a = _this.v;
                return $ret;
            })()));
        }
    };
    Grid.prototype.uh = function (a, b) {
        var e_1, _a;
        var _this = this;
        this.h8 = true;
        try {
            switch (b.action) {
                case 0:
                    if (b.newItems != null) {
                        for (var c = 0; c < b.newItems.count; c++) {
                            var d = b.newItems.item(c);
                            this.up(d.f, this.b6(d.c));
                        }
                    }
                    break;
                case 1:
                    if (b.oldItems != null) {
                        for (var e = 0; e < b.oldItems.count; e++) {
                            var f = b.oldItems.item(e);
                            this.up(f.f, 0);
                        }
                    }
                    break;
                case 2:
                    if (b.oldItems != null) {
                        for (var g = 0; g < b.oldItems.count; g++) {
                            var h = b.oldItems.item(g);
                            this.up(h.f, 0);
                        }
                    }
                    if (b.newItems != null) {
                        for (var i = 0; i < b.newItems.count; i++) {
                            var j = b.newItems.item(i);
                            this.up(j.f, this.b6(j.c));
                        }
                    }
                    break;
                case 4:
                    try {
                        for (var _b = tslib_1.__values(fromEnum(this.columns)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var k = _c.value;
                            k.e6 = 0;
                        }
                    }
                    catch (e_1_1) {
                        e_1 = { error: e_1_1 };
                    }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return))
                                _a.call(_b);
                        }
                        finally {
                            if (e_1)
                                throw e_1.error;
                        }
                    }
                    break;
            }
            if (this.sortDescriptionsChanged != null) {
                this.sortDescriptionsChanged(this, ((function () {
                    var $ret = new GridSortDescriptionsChangedEventArgs();
                    $ret.sortDescriptions = _this.b5;
                    return $ret;
                })()));
            }
        }
        finally {
            this.h8 = false;
        }
    };
    Grid.prototype.up = function (a, b) {
        for (var c = 0; c < this.columns.count; c++) {
            if (this.columns._inner[c].h4 == a) {
                this.columns._inner[c].e6 = b;
            }
        }
    };
    Grid.prototype.b6 = function (a) {
        switch (a) {
            case 0: return 1;
            case 1: return 2;
        }
        return 0;
    };
    Grid.prototype.ua = function (a, b) {
        var e_2, _a, e_3, _b, e_4, _c;
        var _this = this;
        if (!this.hn && this.actualDataSource != null) {
            if (!this.g7) {
                this.g7 = true;
                switch (b.action) {
                    case 0:
                        if (b.newItems != null) {
                            for (var c = 0; c < b.newItems.count; c++) {
                                var d = this.ee.getItemKey(this.i(), b.newItems.item(c));
                                this.ah.ae.insert(c + b.newStartingIndex, d);
                            }
                        }
                        break;
                    case 1:
                        if (b.oldItems != null) {
                            for (var e = 0; e < b.oldItems.count; e++) {
                                this.ah.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        break;
                    case 2:
                        if (b.oldItems != null) {
                            for (var f = 0; f < b.oldItems.count; f++) {
                                this.ah.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        if (b.newItems != null) {
                            for (var g = 0; g < b.newItems.count; g++) {
                                var h = this.ee.getItemKey(this.i(), b.newItems.item(g));
                                this.ah.ae.insert(g + b.newStartingIndex, h);
                            }
                        }
                        break;
                    case 4:
                        this.ah.clear();
                        try {
                            for (var _d = tslib_1.__values(fromEnum(this.ad.ae)), _e = _d.next(); !_e.done; _e = _d.next()) {
                                var i = _e.value;
                                var j = this.ee.getItemKey(this.i(), i);
                                this.ah.add(j);
                            }
                        }
                        catch (e_2_1) {
                            e_2 = { error: e_2_1 };
                        }
                        finally {
                            try {
                                if (_e && !_e.done && (_a = _d.return))
                                    _a.call(_d);
                            }
                            finally {
                                if (e_2)
                                    throw e_2.error;
                            }
                        }
                        break;
                }
                this.e5.a0();
                this.g7 = false;
            }
        }
        if (this.ij) {
            if (this.selectedItemsChanged != null) {
                var k_1 = null;
                if (b.newItems != null && b.newItems.count > 0) {
                    k_1 = new GridSelectedItemsCollection();
                    try {
                        for (var _f = tslib_1.__values(fromEn(b.newItems)), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var l = _g.value;
                            k_1.add1(l);
                        }
                    }
                    catch (e_3_1) {
                        e_3 = { error: e_3_1 };
                    }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return))
                                _b.call(_f);
                        }
                        finally {
                            if (e_3)
                                throw e_3.error;
                        }
                    }
                }
                var m_1 = null;
                if (b.oldItems != null && b.oldItems.count > 0) {
                    m_1 = new GridSelectedItemsCollection();
                    try {
                        for (var _h = tslib_1.__values(fromEn(b.oldItems)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var n = _j.value;
                            m_1.add1(n);
                        }
                    }
                    catch (e_4_1) {
                        e_4 = { error: e_4_1 };
                    }
                    finally {
                        try {
                            if (_j && !_j.done && (_c = _h.return))
                                _c.call(_h);
                        }
                        finally {
                            if (e_4)
                                throw e_4.error;
                        }
                    }
                }
                this.selectedItemsChanged(this, ((function () {
                    var $ret = new GridSelectedItemsChangedEventArgs();
                    $ret.addedItems = k_1;
                    $ret.removedItems = m_1;
                    $ret.currentItems = _this.ad;
                    return $ret;
                })()));
            }
        }
    };
    Grid.prototype.ub = function (a, b) {
        var e_5, _a, e_6, _b, e_7, _c;
        var _this = this;
        if (!this.hn && this.actualDataSource != null) {
            if (!this.g7) {
                this.g7 = true;
                switch (b.action) {
                    case 0:
                        if (b.newItems != null) {
                            for (var c = 0; c < b.newItems.count; c++) {
                                var d = this.ee.getItemForKey(b.newItems.item(c));
                                this.ad.ae.insert1(c + b.newStartingIndex, d);
                            }
                        }
                        break;
                    case 1:
                        if (b.oldItems != null) {
                            for (var e = 0; e < b.oldItems.count; e++) {
                                this.ad.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        break;
                    case 2:
                        if (b.oldItems != null) {
                            for (var f = 0; f < b.oldItems.count; f++) {
                                this.ad.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        if (b.newItems != null) {
                            for (var g = 0; g < b.newItems.count; g++) {
                                var h = this.ee.getItemForKey(b.newItems.item(g));
                                this.ad.ae.insert1(g + b.newStartingIndex, h);
                            }
                        }
                        break;
                    case 4:
                        this.ad.clear();
                        try {
                            for (var _d = tslib_1.__values(fromEnum(this.ah.ae)), _e = _d.next(); !_e.done; _e = _d.next()) {
                                var i = _e.value;
                                var j = this.ee.getItemForKey(i);
                                this.ad.add1(j);
                            }
                        }
                        catch (e_5_1) {
                            e_5 = { error: e_5_1 };
                        }
                        finally {
                            try {
                                if (_e && !_e.done && (_a = _d.return))
                                    _a.call(_d);
                            }
                            finally {
                                if (e_5)
                                    throw e_5.error;
                            }
                        }
                        break;
                }
                this.e5.a0();
                this.g7 = false;
            }
        }
        if (this.ij) {
            if (this.selectedKeysChanged != null) {
                var k_2 = null;
                if (b.newItems != null && b.newItems.count > 0) {
                    k_2 = new GridSelectedKeysCollection();
                    try {
                        for (var _f = tslib_1.__values(fromEn(b.newItems)), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var l = _g.value;
                            k_2.add(l);
                        }
                    }
                    catch (e_6_1) {
                        e_6 = { error: e_6_1 };
                    }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return))
                                _b.call(_f);
                        }
                        finally {
                            if (e_6)
                                throw e_6.error;
                        }
                    }
                }
                var m_2 = null;
                if (b.oldItems != null && b.oldItems.count > 0) {
                    m_2 = new GridSelectedKeysCollection();
                    try {
                        for (var _h = tslib_1.__values(fromEn(b.oldItems)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var n = _j.value;
                            m_2.add(n);
                        }
                    }
                    catch (e_7_1) {
                        e_7 = { error: e_7_1 };
                    }
                    finally {
                        try {
                            if (_j && !_j.done && (_c = _h.return))
                                _c.call(_h);
                        }
                        finally {
                            if (e_7)
                                throw e_7.error;
                        }
                    }
                }
                this.selectedKeysChanged(this, ((function () {
                    var $ret = new GridSelectedKeysChangedEventArgs();
                    $ret.addedKeys = k_2;
                    $ret.removedKeys = m_2;
                    $ret.currentKeys = _this.ah;
                    return $ret;
                })()));
            }
        }
    };
    Grid.prototype.t9 = function (a, b) {
        var e_8, _a, e_9, _b;
        var _this = this;
        switch (b.action) {
            case 0:
            case 2:
                for (var c = 0; c < b.newItems.count; c++) {
                    (typeCast(CellKey.$, b.newItems.item(c))).d = this;
                }
                break;
        }
        if (!this.hn) {
            this.g9 = true;
            this.e5.az();
            this.g9 = false;
        }
        if (this.ij) {
            var d_1 = null;
            if (b.newItems != null && b.newItems.count > 0) {
                d_1 = new GridSelectedCellsCollection();
                try {
                    for (var _c = tslib_1.__values(fromEn(b.newItems)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var e = _d.value;
                        d_1.add(e);
                    }
                }
                catch (e_8_1) {
                    e_8 = { error: e_8_1 };
                }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return))
                            _a.call(_c);
                    }
                    finally {
                        if (e_8)
                            throw e_8.error;
                    }
                }
            }
            var f_1 = null;
            if (b.oldItems != null && b.oldItems.count > 0) {
                f_1 = new GridSelectedCellsCollection();
                try {
                    for (var _e = tslib_1.__values(fromEn(b.oldItems)), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var g = _f.value;
                        f_1.add(g);
                    }
                }
                catch (e_9_1) {
                    e_9 = { error: e_9_1 };
                }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return))
                            _b.call(_e);
                    }
                    finally {
                        if (e_9)
                            throw e_9.error;
                    }
                }
            }
            if (this.selectedCellsChanged != null) {
                this.selectedCellsChanged(this, ((function () {
                    var $ret = new GridSelectedCellsChangedEventArgs();
                    $ret.addedCells = d_1;
                    $ret.removedCells = f_1;
                    $ret.currentCells = _this.ds;
                    return $ret;
                })()));
            }
        }
    };
    Grid.prototype.t8 = function (a, b) {
        var _this = this;
        this.g9 = true;
        this.e5.ay();
        this.g9 = false;
        if (this.ij) {
            if (this.selectedCellRangesChanged != null) {
                this.selectedCellRangesChanged(this, ((function () {
                    var $ret = new GridSelectedCellRangesChangedEventArgs();
                    $ret.currentRanges = _this.dp;
                    return $ret;
                })()));
            }
        }
    };
    Grid.prototype.tg = function (a, b) {
        var e_10, _a;
        if (!this.hm && this.actualDataSource != null) {
            if (!this.g6) {
                this.g6 = true;
                switch (b.action) {
                    case 0:
                        if (b.newItems != null) {
                            for (var c = 0; c < b.newItems.count; c++) {
                                var d = this.ee.getItemKey(this.i(), b.newItems.item(c));
                                this.ag.ae.insert(c + b.newStartingIndex, d);
                                this.ee.pinRow(d);
                            }
                        }
                        break;
                    case 1:
                        if (b.oldItems != null) {
                            for (var e = 0; e < b.oldItems.count; e++) {
                                this.ee.unpinRow(this.ag.ae._inner[b.oldStartingIndex]);
                                this.ag.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        break;
                    case 2:
                        if (b.oldItems != null) {
                            for (var f = 0; f < b.oldItems.count; f++) {
                                this.ee.unpinRow(this.ag.ae._inner[b.oldStartingIndex]);
                                this.ag.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        if (b.newItems != null) {
                            for (var g = 0; g < b.newItems.count; g++) {
                                var h = this.ee.getItemKey(this.i(), b.newItems.item(g));
                                this.ag.ae.insert(g + b.newStartingIndex, h);
                                this.ee.pinRow(h);
                            }
                        }
                        break;
                    case 4:
                        this.ag.clear();
                        this.ee.clearPinnedRows();
                        try {
                            for (var _b = tslib_1.__values(fromEnum(this.ac.ae)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var i = _c.value;
                                var j = this.ee.getItemKey(this.i(), i);
                                this.ag.add(j);
                                this.ee.pinRow(j);
                            }
                        }
                        catch (e_10_1) {
                            e_10 = { error: e_10_1 };
                        }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return))
                                    _a.call(_b);
                            }
                            finally {
                                if (e_10)
                                    throw e_10.error;
                            }
                        }
                        break;
                }
                this.g6 = false;
            }
        }
    };
    Grid.prototype.th = function (a, b) {
        var e_11, _a;
        if (!this.hm && this.actualDataSource != null) {
            if (!this.g6) {
                this.g6 = true;
                switch (b.action) {
                    case 0:
                        if (b.newItems != null) {
                            for (var c = 0; c < b.newItems.count; c++) {
                                var d = this.ee.getItemForKey(b.newItems.item(c));
                                this.ac.ae.insert1(c + b.newStartingIndex, d);
                                this.ee.pinRow(b.newItems.item(c));
                            }
                        }
                        break;
                    case 1:
                        if (b.oldItems != null) {
                            for (var e = 0; e < b.oldItems.count; e++) {
                                this.ee.unpinRow(b.oldItems.item(e));
                                this.ac.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        break;
                    case 2:
                        if (b.oldItems != null) {
                            for (var f = 0; f < b.oldItems.count; f++) {
                                this.ee.unpinRow(b.oldItems.item(f));
                                this.ac.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        if (b.newItems != null) {
                            for (var g = 0; g < b.newItems.count; g++) {
                                var h = this.ee.getItemForKey(b.newItems.item(g));
                                var i = this.ee.indexOfKey(b.newItems.item(g));
                                this.ac.ae.insert1(g + b.newStartingIndex, h);
                                this.ee.pinRow(b.newItems.item(g));
                            }
                        }
                        break;
                    case 4:
                        this.ac.clear();
                        this.ee.clearPinnedRows();
                        try {
                            for (var _b = tslib_1.__values(fromEnum(this.ag.ae)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var j = _c.value;
                                var k = this.ee.getItemForKey(j);
                                this.ac.add1(k);
                                this.ee.pinRow(j);
                            }
                        }
                        catch (e_11_1) {
                            e_11 = { error: e_11_1 };
                        }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return))
                                    _a.call(_b);
                            }
                            finally {
                                if (e_11)
                                    throw e_11.error;
                            }
                        }
                        break;
                }
                this.g6 = false;
            }
        }
    };
    Object.defineProperty(Grid.prototype, "cp", {
        get: function () {
            return this.co;
        },
        set: function (a) {
            this.co = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "delayedExecutionManager", {
        get: function () {
            return this._delayedExecutionManager;
        },
        set: function (a) {
            this._delayedExecutionManager = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "eq", {
        get: function () {
            return this.ep;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ee", {
        get: function () {
            return this.ed;
        },
        set: function (a) {
            this.ed = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "a3", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            this.a2 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dj", {
        get: function () {
            return this.di;
        },
        set: function (a) {
            this.di = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fb", {
        get: function () {
            return this.fa;
        },
        set: function (a) {
            this.fa = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "de", {
        get: function () {
            return this.dd;
        },
        set: function (a) {
            this.dd = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "e5", {
        get: function () {
            return this.e4;
        },
        set: function (a) {
            this.e4 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "aj", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            this.ai = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "e9", {
        get: function () {
            return this.e8;
        },
        set: function (a) {
            this.e8 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "tickProvider", {
        get: function () {
            return this.f4;
        },
        set: function (a) {
            this.f4 = a;
            this.dd = new GridEffectManager(this.f4, this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "e3", {
        get: function () {
            return this.e2;
        },
        set: function (a) {
            var b = this.e2;
            this.e2 = a;
            if (this.e2 == null) {
                this.e2 = new SectionHeader();
            }
            this.e2.grid = this;
            if (b != this.e2) {
                this.sx("SectionHeader", b, this.e2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "e1", {
        get: function () {
            return this.e0;
        },
        set: function (a) {
            this.e0 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fd", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            var b = this.fc;
            this.fc = a;
            if (this.fc == null) {
                this.fc = new SummaryRowRoot();
            }
            this.fc.grid = this;
            if (b != this.fc) {
                this.sx("SummaryRowRoot", b, this.fc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ff", {
        get: function () {
            return this.fe;
        },
        set: function (a) {
            var b = this.fe;
            this.fe = a;
            if (this.fe == null) {
                this.fe = new SummaryRowSection();
            }
            this.fe.grid = this;
            if (b != this.fe) {
                this.sx("SummaryRowSection", b, this.fe);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ez", {
        get: function () {
            return this.ey;
        },
        set: function (a) {
            var b = this.ey;
            this.ey = a;
            if (b != this.ey) {
                this.sx("RowSeparator", b, this.ey);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "d7", {
        get: function () {
            return this.d6;
        },
        set: function (a) {
            var b = this.d6;
            this.d6 = a;
            if (b != this.d6) {
                this.sx("HeaderRowSeparator", b, this.d6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "d9", {
        get: function () {
            return this.d8;
        },
        set: function (a) {
            var b = this.d8;
            this.d8 = a;
            if (b != this.d8) {
                this.sx("HeaderSeparator", b, this.d8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "bx", {
        get: function () {
            return this.bw;
        },
        set: function (a) {
            var b = this.bw;
            this.bw = a;
            if (b != this.bw) {
                this.sx("ColumnResizingSeparator", b, this.bw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "bj", {
        get: function () {
            return this.bi;
        },
        set: function (a) {
            var b = this.bi;
            this.bi = a;
            if (b != this.bi) {
                this.sx("ColumnMovingSeparator", b, this.bi);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "en", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            var b = this.em;
            this.em = a;
            if (b != this.em) {
                this.sx("PinnedAreaSeparator", b, this.em);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "f", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (b != this.b) {
                this.sx("AutoGenerateDesiredColumns", b, this.b);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "g", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.sx("DataSourceDesiredProperties", b, this.c);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fh", {
        get: function () {
            return this.fg;
        },
        set: function (a) {
            this.fg = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "viewportManager", {
        get: function () {
            return this._viewportManager;
        },
        set: function (a) {
            this._viewportManager = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "j7", {
        get: function () {
            return this.jq;
        },
        set: function (a) {
            this.jq = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "j6", {
        get: function () {
            return this.jp;
        },
        set: function (a) {
            this.jp = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fl", {
        get: function () {
            return this.fk;
        },
        set: function (a) {
            var b = this.fk;
            this.fk = a;
            if (b != this.fk) {
                this.sx("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, this.fk));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "k8", {
        get: function () {
            return this.kk;
        },
        set: function (a) {
            var b = this.kk;
            this.kk = a;
            if (b != this.kk) {
                this.sx("ActualRowHeight", b, this.kk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "l1", {
        get: function () {
            return this.kw;
        },
        set: function (a) {
            var b = this.kw;
            this.kw = a;
            if (b != this.kw) {
                this.sx("RowHeight", b, this.kw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "defaultColumnWidth", {
        get: function () {
            return this.b9;
        },
        set: function (a) {
            var b = this.b9;
            this.b9 = a;
            if (b != this.b9) {
                this.sx("DefaultColumnWidth", b, this.b9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "j8", {
        get: function () {
            return this.js;
        },
        set: function (a) {
            var b = this.js;
            this.js = a;
            if (b != this.js) {
                this.sx("DefaultColumnMinWidth", b, this.js);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "k7", {
        get: function () {
            return this.kj;
        },
        set: function (a) {
            var b = this.kj;
            this.kj = a;
            if (b != this.kj) {
                this.sx("ActualHeaderHeight", b, this.kj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "lt", {
        get: function () {
            return this.kp;
        },
        set: function (a) {
            var b = this.kp;
            this.kp = a;
            if (b != this.kp) {
                this.sx("HeaderHeight", b, this.kp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "l7", {
        get: function () {
            return this.k1;
        },
        set: function (a) {
            var b = this.k1;
            this.k1 = a;
            if (b != this.k1) {
                this.sx("SectionHeaderHeight", b, this.k1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "itemsSource", {
        get: function () {
            return this.ma;
        },
        set: function (a) {
            var b = this.ma;
            this.ma = a;
            if (b != this.ma) {
                this.sx("ItemsSource", b, this.ma);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "l5", {
        get: function () {
            return this.k0;
        },
        set: function (a) {
            var b = this.k0;
            this.k0 = a;
            if (b != this.k0) {
                this.sx("SectionFooterHeight", b, this.k0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "l4", {
        get: function () {
            return this.ky;
        },
        set: function (a) {
            var b = this.ky;
            this.ky = a;
            if (b != this.ky) {
                this.sx("RowSpacingHeight", b, this.ky);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ld", {
        get: function () {
            return this.kn;
        },
        set: function (a) {
            var b = this.kn;
            this.kn = a;
            if (b != this.kn) {
                this.sx("ColumnSpacingWidth", b, this.kn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "d5", {
        get: function () {
            return this.d4;
        },
        set: function (a) {
            var b = this.d4;
            this.d4 = a;
            if (b != this.d4) {
                this.sx("HeaderClickAction", enumGetBox(HeaderClickAction_$type, b), enumGetBox(HeaderClickAction_$type, this.d4));
                if ((this.d4 == 0 || this.d4 == 2) && (b == 1 || b == 3)) {
                    this.e9.h();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "cg", {
        get: function () {
            return this.cf;
        },
        set: function (a) {
            var b = this.cf;
            this.cf = a;
            if (b != this.cf) {
                this.sx("EditMode", enumGetBox(EditModeType_$type, b), enumGetBox(EditModeType_$type, this.cf));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ce", {
        get: function () {
            return this.cd;
        },
        set: function (a) {
            var b = this.cd;
            this.cd = a;
            if (b != this.cd) {
                this.sx("EditModeClickAction", enumGetBox(EditModeClickAction_$type, b), enumGetBox(EditModeClickAction_$type, this.cd));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hj", {
        get: function () {
            return this.gc;
        },
        set: function (a) {
            var b = this.gc;
            this.gc = a;
            if (b != this.gc) {
                this.sx("EditOnKeyPress", b, this.gc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hc", {
        get: function () {
            return this.ga;
        },
        set: function (a) {
            var b = this.ga;
            this.ga = a;
            if (b != this.ga) {
                this.sx("AutoGenerateColumns", b, this.ga);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "l3", {
        get: function () {
            return this.kx;
        },
        set: function (a) {
            var b = this.kx;
            this.kx = a;
            if (b != this.kx) {
                this.sx("RowSeparatorHeight", b, this.kx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "h9", {
        get: function () {
            return this.gs;
        },
        set: function (a) {
            var b = this.gs;
            this.gs = a;
            if (b != this.gs) {
                this.sx("IsPlaceholderRenderingEnabled", b, this.gs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.hs = function (a) {
        return this.b2(a) != 1 && this.ht;
    };
    Grid.prototype.b2 = function (a) {
        if (this.by == 0) {
            return a.e4();
        }
        return this.by;
    };
    Object.defineProperty(Grid.prototype, "b0", {
        get: function () {
            return this.by;
        },
        set: function (a) {
            var b = this.by;
            this.by = a;
            this.sx("ColumnAddingAnimationMode", enumGetBox(ColumnShowingAnimationMode_$type, b), enumGetBox(ColumnShowingAnimationMode_$type, this.by));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hz", {
        get: function () {
            return this.bp != 1 && this.ht;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "columnPropertyUpdatingAnimationMode", {
        get: function () {
            return this.bp;
        },
        set: function (a) {
            var b = this.bp;
            this.bp = a;
            this.sx("ColumnPropertyUpdatingAnimationMode", enumGetBox(ColumnPropertyUpdatingAnimationMode_$type, b), enumGetBox(ColumnPropertyUpdatingAnimationMode_$type, this.bp));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ht", {
        get: function () {
            return this.renderingEngine.initialRefreshFinished;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hp", {
        get: function () {
            return this.ak != 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "al", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            var b = this.ak;
            this.ak = a;
            this.sx("CellDataLoadedAnimationMode", enumGetBox(CellDataLoadedAnimationMode_$type, b), enumGetBox(CellDataLoadedAnimationMode_$type, this.ak));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ih", {
        get: function () {
            return this.ew != 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ex", {
        get: function () {
            return this.ew;
        },
        set: function (a) {
            var b = this.ew;
            this.ew = a;
            this.sx("RowSelectionAnimationMode", enumGetBox(RowSelectionAnimationMode_$type, b), enumGetBox(RowSelectionAnimationMode_$type, this.ew));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ie", {
        get: function () {
            return this.et != 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "eu", {
        get: function () {
            return this.et;
        },
        set: function (a) {
            var b = this.et;
            this.et = a;
            if (b != this.et) {
                this.sx("RowHoverAnimationMode", enumGetBox(RowHoverAnimationMode_$type, b), enumGetBox(RowHoverAnimationMode_$type, this.et));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hq", {
        get: function () {
            return this.aw != 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ax", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            var b = this.aw;
            this.aw = a;
            this.sx("CellSelectionAnimationMode", enumGetBox(CellSelectionAnimationMode_$type, b), enumGetBox(CellSelectionAnimationMode_$type, this.aw));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "c4", {
        get: function () {
            return this.c3;
        },
        set: function (a) {
            var b = this.c3;
            this.c3 = a;
            if (b != this.c3) {
                this.sx("ColumnAnimationSettings", b, this.c3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "cr", {
        get: function () {
            return this.cq;
        },
        set: function (a) {
            var b = this.cq;
            this.cq = a;
            if (b != this.cq) {
                this.sx("AnimationSettings", b, this.cq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.h0 = function (a) {
        return this.bt(a) != 1 && this.ht;
    };
    Grid.prototype.bt = function (a) {
        if (this.br == 0) {
            return a.e3();
        }
        return this.br;
    };
    Object.defineProperty(Grid.prototype, "bs", {
        get: function () {
            return this.br;
        },
        set: function (a) {
            var b = this.br;
            this.br = a;
            this.sx("ColumnResizingAnimationMode", enumGetBox(ColumnResizingAnimationMode_$type, b), enumGetBox(ColumnResizingAnimationMode_$type, this.br));
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.h1 = function (a) {
        return this.b3(a) != 1 && this.ht;
    };
    Grid.prototype.b3 = function (a) {
        if (this.bz == 0) {
            return a.e4();
        }
        return this.bz;
    };
    Object.defineProperty(Grid.prototype, "b1", {
        get: function () {
            return this.bz;
        },
        set: function (a) {
            var b = this.bz;
            this.bz = a;
            this.sx("ColumnShowingAnimationMode", enumGetBox(ColumnShowingAnimationMode_$type, b), enumGetBox(ColumnShowingAnimationMode_$type, this.bz));
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.hw = function (a) {
        return this.bf(a) != 1 && this.ht && !this.jd;
    };
    Grid.prototype.bf = function (a) {
        if (this.bd == 0) {
            return 2;
        }
        return this.bd;
    };
    Object.defineProperty(Grid.prototype, "be", {
        get: function () {
            return this.bd;
        },
        set: function (a) {
            var b = this.bd;
            this.bd = a;
            this.sx("ColumnMovingAnimationMode", enumGetBox(ColumnMovingAnimationMode_$type, b), enumGetBox(ColumnMovingAnimationMode_$type, this.bd));
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.hv = function (a) {
        return this.bc(a) != 1 && this.ht;
    };
    Grid.prototype.bc = function (a) {
        if (this.ba == 0) {
            return a.eu();
        }
        return this.ba;
    };
    Object.defineProperty(Grid.prototype, "bb", {
        get: function () {
            return this.ba;
        },
        set: function (a) {
            var b = this.ba;
            this.ba = a;
            this.sx("ColumnHidingAnimationMode", enumGetBox(ColumnHidingAnimationMode_$type, b), enumGetBox(ColumnHidingAnimationMode_$type, this.ba));
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.hu = function (a) {
        return this.a6(a) != 1 && this.ht;
    };
    Grid.prototype.a6 = function (a) {
        if (this.a4 == 0) {
            return a.et();
        }
        return this.a4;
    };
    Object.defineProperty(Grid.prototype, "a5", {
        get: function () {
            return this.a4;
        },
        set: function (a) {
            var b = this.a4;
            this.a4 = a;
            this.sx("ColumnExchangingAnimationMode", enumGetBox(ColumnExchangingAnimationMode_$type, b), enumGetBox(ColumnExchangingAnimationMode_$type, this.a4));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "inset", {
        get: function () {
            return this.w6;
        },
        set: function (a) {
            var b = this.w6;
            this.w6 = a;
            if (b != this.w6) {
                this.sx("Inset", b, this.w6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dy", {
        get: function () {
            return this.dx;
        },
        set: function (a) {
            var b = this.dx;
            this.dx = a;
            if (b != this.dx) {
                this.sx("SelectionMode", enumGetBox(GridSelectionMode_$type, b), enumGetBox(GridSelectionMode_$type, this.dx));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "cm", {
        get: function () {
            return this.cl;
        },
        set: function (a) {
            var b = this.cl;
            this.cl = a;
            if (b != this.cl) {
                this.sx("ActivationMode", enumGetBox(GridActivationMode_$type, b), enumGetBox(GridActivationMode_$type, this.cl));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dw", {
        get: function () {
            return this.dv;
        },
        set: function (a) {
            var b = this.dv;
            this.dv = a;
            if (b != this.dv) {
                this.sx("SelectionBehavior", enumGetBox(GridSelectionBehavior_$type, b), enumGetBox(GridSelectionBehavior_$type, this.dv));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hn", {
        get: function () {
            return this.gg;
        },
        set: function (a) {
            this.gg = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ad", {
        get: function () {
            return this.ab;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ah", {
        get: function () {
            return this.af;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ds", {
        get: function () {
            return this.dr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dp", {
        get: function () {
            return this.dn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hm", {
        get: function () {
            return this.gf;
        },
        set: function (a) {
            this.gf = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ac", {
        get: function () {
            return this.aa;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ag", {
        get: function () {
            return this.ae;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.ul = function (a, b) {
        var e_12, _a, e_13, _b, e_14, _c;
        if (this.actualDataSource == null) {
            return;
        }
        if (a.ae.count > 0 && b.ae.count == 0) {
            var c = this.i();
            try {
                for (var _d = tslib_1.__values(fromEnum(a.ae)), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var d = _e.value;
                    var e = this.ee.getItemKey(c, d);
                    b.ae.add(e);
                }
            }
            catch (e_12_1) {
                e_12 = { error: e_12_1 };
            }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return))
                        _a.call(_d);
                }
                finally {
                    if (e_12)
                        throw e_12.error;
                }
            }
        }
        else if (a.ae.count == 0 && b.ae.count > 0) {
            try {
                for (var _f = tslib_1.__values(fromEnum(b.ae)), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var f = _g.value;
                    var g = this.ee.getItemForKey(f);
                    a.ae.add1(g);
                }
            }
            catch (e_13_1) {
                e_13 = { error: e_13_1 };
            }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return))
                        _b.call(_f);
                }
                finally {
                    if (e_13)
                        throw e_13.error;
                }
            }
        }
        else {
            a.ae.clear();
            try {
                for (var _h = tslib_1.__values(fromEnum(b.ae)), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var h = _j.value;
                    var i = this.ee.getItemForKey(h);
                    a.ae.add1(i);
                }
            }
            catch (e_14_1) {
                e_14 = { error: e_14_1 };
            }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return))
                        _c.call(_h);
                }
                finally {
                    if (e_14)
                        throw e_14.error;
                }
            }
        }
    };
    Object.defineProperty(Grid.prototype, "hx", {
        get: function () {
            return this.gj;
        },
        set: function (a) {
            var b = this.gj;
            this.gj = a;
            if (b != this.gj) {
                this.sx("IsColumnOptionsEnabled", b, this.gj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "h5", {
        get: function () {
            return this.gq;
        },
        set: function (a) {
            var b = this.gq;
            this.gq = a;
            if (b != this.gq) {
                this.sx("IsGroupRowSticky", b, this.gq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "h6", {
        get: function () {
            return this.gr;
        },
        set: function (a) {
            var b = this.gr;
            this.gr = a;
            if (b != this.gr) {
                this.sx("IsHeaderSeparatorVisible", b, this.gr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "v3", {
        get: function () {
            return this.u5;
        },
        set: function (a) {
            var b = this.u5;
            this.u5 = a;
            if (b != this.u5) {
                this.sx("CellSelectedBackground", b, this.u5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wo", {
        get: function () {
            return this.vq;
        },
        set: function (a) {
            var b = this.vq;
            this.vq = a;
            if (b != this.vq) {
                this.sx("SectionHeaderSelectedBackground", b, this.vq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wr", {
        get: function () {
            return this.vt;
        },
        set: function (a) {
            var b = this.vt;
            this.vt = a;
            if (b != this.vt) {
                this.sx("SummaryRootBackground", b, this.vt);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wv", {
        get: function () {
            return this.vx;
        },
        set: function (a) {
            var b = this.vx;
            this.vx = a;
            if (b != this.vx) {
                this.sx("SummarySectionBackground", b, this.vx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ka", {
        get: function () {
            return this.j1;
        },
        set: function (a) {
            var b = this.j1;
            this.j1 = a;
            if (b != this.j1) {
                this.sx("PinnedRowOpacity", b, this.j1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fv", {
        get: function () {
            return this.fn;
        },
        set: function (a) {
            var b = this.fn;
            this.fn = a;
            if (b != this.fn) {
                this.sx("EditTextStyle", b, this.fn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "j9", {
        get: function () {
            return this.jx;
        },
        set: function (a) {
            var b = this.jx;
            this.jx = a;
            if (b != this.jx) {
                this.sx("EditOpacity", b, this.jx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "v8", {
        get: function () {
            return this.va;
        },
        set: function (a) {
            var b = this.va;
            this.va = a;
            if (b != this.va) {
                this.sx("DeletedTextColor", b, this.va);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wq", {
        get: function () {
            return this.vs;
        },
        set: function (a) {
            var b = this.vs;
            this.vs = a;
            if (b != this.vs) {
                this.sx("StickyRowBackground", b, this.vs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wg", {
        get: function () {
            return this.vi;
        },
        set: function (a) {
            var b = this.vi;
            this.vi = a;
            if (b != this.vi) {
                this.sx("PinnedRowBackground", b, this.vi);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wf", {
        get: function () {
            return this.vh;
        },
        set: function (a) {
            var b = this.vh;
            this.vh = a;
            if (b != this.vh) {
                this.sx("LastStickyRowBackground", b, this.vh);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "c1", {
        get: function () {
            return this.cz;
        },
        set: function (a) {
            var b = this.cz;
            this.cz = a;
            if (b != this.cz) {
                this.sx("ActiveCell", b, this.cz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "v2", {
        get: function () {
            return this.u4;
        },
        set: function (a) {
            var b = this.u4;
            this.u4 = a;
            if (b != this.u4) {
                this.sx("CellBackground", b, this.u4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "v4", {
        get: function () {
            return this.u6;
        },
        set: function (a) {
            var b = this.u6;
            this.u6 = a;
            if (b != this.u6) {
                this.sx("CellTextColor", b, this.u6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wd", {
        get: function () {
            return this.vf;
        },
        set: function (a) {
            var b = this.vf;
            this.vf = a;
            if (b != this.vf) {
                this.sx("HeaderSortIndicatorColor", b, this.vf);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "e7", {
        get: function () {
            return this.e6;
        },
        set: function (a) {
            var b = this.e6;
            this.e6 = a;
            if (b != this.e6) {
                this.sx("HeaderSortIndicatorStyle", enumGetBox(SortIndicatorStyle_$type, b), enumGetBox(SortIndicatorStyle_$type, this.e6));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fu", {
        get: function () {
            return this.fm;
        },
        set: function (a) {
            var b = this.fm;
            this.fm = a;
            if (b != this.fm) {
                this.sx("CellTextStyle", b, this.fm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wn", {
        get: function () {
            return this.vp;
        },
        set: function (a) {
            var b = this.vp;
            this.vp = a;
            if (b != this.vp) {
                this.sx("SectionHeaderBackground", b, this.vp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wp", {
        get: function () {
            return this.vr;
        },
        set: function (a) {
            var b = this.vr;
            this.vr = a;
            if (b != this.vr) {
                this.sx("SectionHeaderTextColor", b, this.vr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fx", {
        get: function () {
            return this.fp;
        },
        set: function (a) {
            var b = this.fp;
            this.fp = a;
            if (b != this.fp) {
                this.sx("SectionHeaderTextStyle", b, this.fp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fy", {
        get: function () {
            return this.fq;
        },
        set: function (a) {
            var b = this.fq;
            this.fq = a;
            if (b != this.fq) {
                this.sx("SummaryRootLabelTextStyle", b, this.fq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "f0", {
        get: function () {
            return this.fs;
        },
        set: function (a) {
            var b = this.fs;
            this.fs = a;
            if (b != this.fs) {
                this.sx("SummarySectionLabelTextStyle", b, this.fs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wu", {
        get: function () {
            return this.vw;
        },
        set: function (a) {
            var b = this.vw;
            this.vw = a;
            if (b != this.vw) {
                this.sx("SummaryRootValueTextColor", b, this.vw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fz", {
        get: function () {
            return this.fr;
        },
        set: function (a) {
            var b = this.fr;
            this.fr = a;
            if (b != this.fr) {
                this.sx("SummaryRootValueTextStyle", b, this.fr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "f1", {
        get: function () {
            return this.ft;
        },
        set: function (a) {
            var b = this.ft;
            this.ft = a;
            if (b != this.ft) {
                this.sx("SummarySectionValueTextStyle", b, this.ft);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wy", {
        get: function () {
            return this.v0;
        },
        set: function (a) {
            var b = this.v0;
            this.v0 = a;
            if (b != this.v0) {
                this.sx("SummarySectionValueTextColor", b, this.v0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ws", {
        get: function () {
            return this.vu;
        },
        set: function (a) {
            var b = this.vu;
            this.vu = a;
            if (b != this.vu) {
                this.sx("SummaryRootLabelTextColor", b, this.vu);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ww", {
        get: function () {
            return this.vy;
        },
        set: function (a) {
            var b = this.vy;
            this.vy = a;
            if (b != this.vy) {
                this.sx("SummarySectionLabelTextColor", b, this.vy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wt", {
        get: function () {
            return this.vv;
        },
        set: function (a) {
            var b = this.vv;
            this.vv = a;
            if (b != this.vv) {
                this.sx("SummaryRootSelectedBackground", b, this.vv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wx", {
        get: function () {
            return this.vz;
        },
        set: function (a) {
            var b = this.vz;
            this.vz = a;
            if (b != this.vz) {
                this.sx("SummarySectionSelectedBackground", b, this.vz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "lz", {
        get: function () {
            return this.ku;
        },
        set: function (a) {
            var b = this.ku;
            this.ku = a;
            if (b != this.ku) {
                this.sx("PinnedAreaSeparatorWidth", b, this.ku);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "lx", {
        get: function () {
            return this.kq;
        },
        set: function (a) {
            var b = this.kq;
            this.kq = a;
            if (b != this.kq) {
                this.sx("HeaderSeparatorWidth", b, this.kq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.k9 = function (a) {
        var b = 3;
        var c = Math.max(b - a, 0);
        if (c % 2 == 1) {
            c += 1;
        }
        return intDivide(c, 2);
    };
    Object.defineProperty(Grid.prototype, "wc", {
        get: function () {
            return this.ve;
        },
        set: function (a) {
            var b = this.ve;
            this.ve = a;
            if (b != this.ve) {
                this.sx("HeaderSeparatorBackground", b, this.ve);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wa", {
        get: function () {
            return this.vc;
        },
        set: function (a) {
            var b = this.vc;
            this.vc = a;
            if (b != this.vc) {
                this.sx("HeaderBackground", b, this.vc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "we", {
        get: function () {
            return this.vg;
        },
        set: function (a) {
            var b = this.vg;
            this.vg = a;
            if (b != this.vg) {
                this.sx("HeaderTextColor", b, this.vg);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fw", {
        get: function () {
            return this.fo;
        },
        set: function (a) {
            var b = this.fo;
            this.fo = a;
            if (b != this.fo) {
                this.sx("HeaderTextStyle", b, this.fo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wj", {
        get: function () {
            return this.vl;
        },
        set: function (a) {
            var b = this.vl;
            this.vl = a;
            if (b != this.vl) {
                this.sx("RowSeparatorBackground", b, this.vl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wb", {
        get: function () {
            return this.vd;
        },
        set: function (a) {
            var b = this.vd;
            this.vd = a;
            if (b != this.vd) {
                this.sx("HeaderRowSeparatorBackground", b, this.vd);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wm", {
        get: function () {
            return this.vo;
        },
        set: function (a) {
            var b = this.vo;
            this.vo = a;
            if (b != this.vo) {
                this.sx("RowSeparatorStickyRowBackground", b, this.vo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wk", {
        get: function () {
            return this.vm;
        },
        set: function (a) {
            var b = this.vm;
            this.vm = a;
            if (b != this.vm) {
                this.sx("RowSeparatorLastStickyRowBackground", b, this.vm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "wl", {
        get: function () {
            return this.vn;
        },
        set: function (a) {
            var b = this.vn;
            this.vn = a;
            if (b != this.vn) {
                this.sx("RowSeparatorPinnedRowBackground", b, this.vn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "lc", {
        get: function () {
            return this.km;
        },
        set: function (a) {
            var b = this.km;
            this.km = a;
            if (b != this.km) {
                this.sx("ColumnResizingSeparatorWidth", b, this.km);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "la", {
        get: function () {
            return this.kl;
        },
        set: function (a) {
            var b = this.kl;
            this.kl = a;
            if (b != this.kl) {
                this.sx("ColumnMovingSeparatorWidth", b, this.kl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "v7", {
        get: function () {
            return this.u9;
        },
        set: function (a) {
            var b = this.u9;
            this.u9 = a;
            if (b != this.u9) {
                this.sx("ColumnResizingSeparatorBackground", b, this.u9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "v5", {
        get: function () {
            return this.u7;
        },
        set: function (a) {
            var b = this.u7;
            this.u7 = a;
            if (b != this.u7) {
                this.sx("ColumnMovingSeparatorBackground", b, this.u7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "i8", {
        get: function () {
            return this.g3;
        },
        set: function (a) {
            var b = this.g3;
            this.g3 = a;
            if (b != this.g3) {
                this.sx("ShiftSectionContent", b, this.g3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "bl", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (b != this.bk) {
                this.sx("ColumnOptionsIconAlignment", enumGetBox(ColumnOptionsIconAlignment_$type, b), enumGetBox(ColumnOptionsIconAlignment_$type, this.bk));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "v6", {
        get: function () {
            return this.u8;
        },
        set: function (a) {
            var b = this.u8;
            this.u8 = a;
            if (b != this.u8) {
                this.sx("ColumnOptionsIconColor", b, this.u8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "bn", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            var b = this.bm;
            this.bm = a;
            if (b != this.bm) {
                this.sx("ColumnOptionsIconBehavior", enumGetBox(ColumnOptionsIconBehavior_$type, b), enumGetBox(ColumnOptionsIconBehavior_$type, this.bm));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "border", {
        get: function () {
            return this.u3;
        },
        set: function (a) {
            var b = this.u3;
            this.u3 = a;
            if (b != this.u3) {
                this.sx("Border", b, this.u3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "xa", {
        get: function () {
            return this.w4;
        },
        set: function (a) {
            var b = this.w4;
            this.w4 = a;
            if (b != this.w4) {
                this.sx("DefaultBorderWidth", b, this.w4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "w7", {
        get: function () {
            return this.w2;
        },
        set: function (a) {
            var b = this.w2;
            this.w2 = a;
            if (b != this.w2) {
                this.sx("ActualBorderWidth", b, this.w2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "w8", {
        get: function () {
            return this.w3;
        },
        set: function (a) {
            var b = this.w3;
            this.w3 = a;
            if (b != this.w3) {
                this.sx("BorderWidth", b, this.w3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ij", {
        get: function () {
            return this.gx;
        },
        set: function (a) {
            var b = this.gx;
            this.gx = a;
            if (b != this.gx) {
                this.sx("NotifyOnAllSelectionChanges", b, this.gx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "u2", {
        get: function () {
            return this.uy;
        },
        set: function (a) {
            var b = this.uy;
            this.uy = a;
            if (b != this.uy) {
                this.sx("DefaultCornerRadius", b, this.uy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "u1", {
        get: function () {
            return this.ux;
        },
        set: function (a) {
            var b = this.ux;
            this.ux = a;
            if (b != this.ux) {
                this.sx("CornerRadius", b, this.ux);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "uz", {
        get: function () {
            return this.uw;
        },
        set: function (a) {
            var b = this.uw;
            this.uw = a;
            if (b != this.uw) {
                this.sx("ActualCornerRadius", b, this.uw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ho", {
        get: function () {
            return this.gi;
        },
        set: function (a) {
            var b = this.gi;
            this.gi = a;
            if (this.gi != b) {
                this.sx("IsActiveCellStyleEnabled", b, this.gi);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "platformPixelConverter", {
        get: function () {
            return this.f2;
        },
        set: function (a) {
            this.f2 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "renderingEngine", {
        get: function () {
            return this.eb;
        },
        set: function (a) {
            this.eb = a;
            this.sz(this.eb);
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.sz = function (a) {
        if (a != null) {
            a.refresh(this.model, false);
        }
    };
    Object.defineProperty(Grid.prototype, "es", {
        get: function () {
            return this.er;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "model", {
        get: function () {
            return this.fi;
        },
        set: function (a) {
            this.fi = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "w0", {
        get: function () {
            return new Rect(0, this.fi.b3, this.fi.b8, this.fi.b9, this.fi.by);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "b5", {
        get: function () {
            return this.b4;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "a8", {
        get: function () {
            return this.a7;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "v", {
        get: function () {
            return this.u;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "b8", {
        get: function () {
            return this.b7;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "t", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            var b = this.s;
            this.s = a;
            this.g5 = true;
            if (b != this.s) {
                this.sx("SummaryScope", enumGetBox(DataSourceSummaryScope_$type, b), enumGetBox(DataSourceSummaryScope_$type, this.s));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "h3", {
        get: function () {
            return this.gm;
        },
        set: function (a) {
            var b = this.gm;
            this.gm = a;
            this.gn = true;
            if (b != this.gm) {
                this.sx("IsGroupCollapsable", b, this.gm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "r", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            var b = this.q;
            this.q = a;
            this.gd = true;
            if (b != this.q) {
                this.sx("GroupHeaderDisplayMode", enumGetBox(DataSourceSectionHeaderDisplayMode_$type, b), enumGetBox(DataSourceSectionHeaderDisplayMode_$type, this.q));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "h4", {
        get: function () {
            return this.go;
        },
        set: function (a) {
            var b = this.go;
            this.go = a;
            this.gp = true;
            if (b != this.go) {
                this.sx("IsGroupExpandedDefault", b, this.go);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "d3", {
        get: function () {
            return this.d2;
        },
        set: function (a) {
            var b = this.d2;
            this.d2 = a;
            this.ge = true;
            if (b != this.d2) {
                this.sx("GroupSummaryDisplayMode", enumGetBox(GroupSummaryDisplayMode_$type, b), enumGetBox(GroupSummaryDisplayMode_$type, this.d2));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hb", {
        get: function () {
            return this.f9;
        },
        set: function (a) {
            this.f9 = a;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.sx = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.ti(a, b, c);
    };
    Grid.prototype.tx = function () {
    };
    Grid.prototype.tn = function () {
        var _this = this;
        if (this.jq == 0) {
            return;
        }
        var a = this.model.absoluteWidth;
        var b = this.model.absoluteHeight;
        this.i2 = true;
        this.fb.r(this, this.model, truncate(this.j7));
        if (a != this.model.absoluteWidth || b != this.model.absoluteHeight) {
            this.externalGrid.onContentSizeChanged();
        }
        this.i2 = false;
        this.fh.v();
        this.renderingEngine.invalidateVisibility(function () { return _this.fh.l(_this); });
        this.renderingEngine.refresh(this.model, false);
    };
    Grid.prototype.to = function () {
        var _this = this;
        if (this.gh) {
            this.q2();
        }
        else {
            this.renderingEngine.invalidateVisibility(function () { return _this.fh.l(_this); });
            this.renderingEngine.refresh(this.model, true);
        }
    };
    Grid.prototype.q2 = function () {
        if (this.gh) {
            this.gh = false;
            this.tn();
            this.rb();
        }
    };
    Object.defineProperty(Grid.prototype, "i2", {
        get: function () {
            return this.g2;
        },
        set: function (a) {
            this.g2 = a;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.tm = function () {
        var _this = this;
        if (this.g2) {
            return;
        }
        this.renderingEngine.invalidateVisibility(function () { return _this.fh.l(_this); });
        this.renderingEngine.refresh(this.model, false);
    };
    Grid.prototype.q1 = function () {
        if (this.actualDataSource != null) {
            this.actualDataSource.flushAutoRefresh();
        }
        this.de.an(true);
        this.renderingEngine.refresh(this.model, true);
    };
    Object.defineProperty(Grid.prototype, "actualDataSource", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (this.w != b) {
                this.sx("ActualDataSource", b, this.w);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "l", {
        get: function () {
            return this.d;
        },
        set: function (a) {
            var b = this.d;
            this.d = a;
            if (this.d != b) {
                this.sx("PrimaryKey", b, this.d);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "e", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (this.a != b) {
                this.sx("ActualPrimaryKey", b, this.a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ha", {
        get: function () {
            return this.f7;
        },
        set: function (a) {
            this.f7 = a;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.ti = function (a, b, c) {
        var _this = this;
        if (a == "ItemsSource") {
            if (this.w != null) {
                var d = this.w;
                d.schemaChanged = delegateRemove(d.schemaChanged, runOn(this, this.qt));
                if (this.y != null) {
                    var e = this.y;
                    e.dataCommitted = delegateRemove(e.dataCommitted, runOn(this, this.qs));
                }
                this.w.updateNotifier = null;
                this.b5.b = null;
                this.a8.b = null;
                this.v.syncTarget = null;
                this.b8.b = null;
                this.e = this.m();
            }
            if (typeCast(IDataSource_$type, this.itemsSource) !== null) {
                this.actualDataSource = this.itemsSource;
            }
            else {
                var f = this.externalGrid.createLocalDataSource(this.itemsSource);
                this.actualDataSource = f;
            }
            if (this.w != null) {
                this.y = typeCast(IEditableDataSource_$type, this.actualDataSource);
                var g = this.w;
                g.schemaChanged = delegateCombine(g.schemaChanged, runOn(this, this.qt));
                if (this.y != null) {
                    var h = this.y;
                    h.dataCommitted = delegateCombine(h.dataCommitted, runOn(this, this.qs));
                }
                this.w.updateNotifier = new DataSourceNotificationBridge(this);
                if (this.w.isVirtual) {
                    this.model.bl = this.h9;
                }
                if (this.i1) {
                    this.b5.b = this.w.sortDescriptions;
                }
                if (this.i0) {
                    this.a8.b = this.w.groupDescriptions;
                }
                if (this.iz) {
                    this.v.syncTarget = this.w.filterExpressions;
                }
                this.b8.b = this.w.summaryDescriptions;
                this.w.propertiesRequested = this.n();
                if (this.l != null) {
                    this.actualDataSource.primaryKey = this.l;
                }
                this.e = this.m();
                if (this.w.actualSchema != null) {
                    if (this.renderingEngine != null) {
                        this.tj();
                    }
                    this.delayedExecutionManager.executeIn(function () { return _this.si(); }, 0);
                    this.ed.setDataSource(this.w);
                }
                this.hn = true;
                this.hm = true;
                this.g7 = true;
                this.g6 = true;
                this.ul(this.ad, this.ah);
                this.ul(this.ac, this.ag);
                this.e5.a0();
                this.hn = false;
                this.hm = false;
                this.g7 = false;
                this.g6 = false;
                for (var i = 0; i < this.ag.ae.count; ++i) {
                    this.ee.pinRow(this.ag.ae._inner[i]);
                }
                if (this.gn) {
                    this.actualDataSource.isSectionCollapsable = this.h3;
                }
                if (this.gd) {
                    this.actualDataSource.sectionHeaderDisplayMode = this.r;
                }
                if (this.g5) {
                    this.actualDataSource.summaryScope = this.t;
                }
                if (this.gp) {
                    this.actualDataSource.isSectionExpandedDefault = this.h4;
                }
                if (this.ge) {
                    switch (this.d3) {
                        case 1:
                        case 0:
                        case 4:
                            this.actualDataSource.includeSummaryRowsInSection = false;
                            break;
                        case 2:
                            this.actualDataSource.includeSummaryRowsInSection = true;
                            this.actualDataSource.isSectionSummaryRowsAtBottom = false;
                            break;
                        case 3:
                            this.actualDataSource.includeSummaryRowsInSection = true;
                            this.actualDataSource.isSectionSummaryRowsAtBottom = true;
                            break;
                    }
                }
                this.un();
            }
        }
        if (a == "AutoGenerateColumns") {
            this.a3.p = this.hc;
        }
        if (a == "AutoGenerateDesiredColumns") {
            this.a3.b = this.f;
        }
        if (a == "IsPlaceholderRenderingEnabled") {
            if (this.w != null && this.w.isVirtual) {
                this.model.bl = this.h9;
            }
        }
        if (a == "ColumnResizingMode") {
            this.h7 = this.i4();
        }
        if (a == "ActivationMode") {
            this.hr = this.i3();
        }
        if (a == "SelectionMode") {
            this.hr = this.i3();
            switch (this.dy) {
                case 1:
                    if (this.dp.count > 0) {
                        this.dp.clear();
                    }
                    if (this.ds.count > 0) {
                        this.ds.clear();
                    }
                    if (this.ah.count > 1) {
                        var j = this.ah._inner[this.ah.count - 1];
                        this.ah.clear();
                        this.ah.add(j);
                    }
                    break;
                case 2:
                    if (this.dp.count > 0) {
                        this.dp.clear();
                    }
                    if (this.ds.count > 0) {
                        this.ds.clear();
                    }
                    break;
                case 3:
                    if (this.ah.count > 0) {
                        this.ah.clear();
                    }
                    if (this.dp.count > 0) {
                        this.dp.clear();
                    }
                    if (this.ds.count > 1) {
                        var k = this.ds._inner[this.ds.count - 1];
                        this.ds.clear();
                        this.ds.add(k);
                    }
                    break;
                case 4:
                    if (this.ah.count > 0) {
                        this.ah.clear();
                    }
                    if (this.dp.count > 0) {
                        this.dp.clear();
                    }
                    break;
                case 5:
                    if (this.ds.count > 0) {
                        this.ds.clear();
                    }
                    if (this.ah.count > 0) {
                        this.ah.clear();
                    }
                    break;
                case 0:
                    if (this.ah.count > 0) {
                        this.ah.clear();
                    }
                    if (this.ds.count > 0) {
                        this.ds.clear();
                    }
                    if (this.dp.count > 0) {
                        this.dp.clear();
                    }
                    break;
            }
        }
        if (a == "RowSeparator") {
            var l = b;
            var m = c;
            if (l != null) {
                l.definitionPropertyUpdated = delegateRemove(l.definitionPropertyUpdated, runOn(this, this.t0));
                l.grid = null;
            }
            if (m != null) {
                m.definitionPropertyUpdated = delegateCombine(m.definitionPropertyUpdated, runOn(this, this.t0));
                m.grid = this;
            }
            if (this.i5()) {
                if (!l.d0.equals(m.d0)) {
                    this.cp.r(this, null, "Background", 2, l.d0, m.d0, false, true, false, false);
                }
                if (!l.d3.equals(m.d3)) {
                    this.cp.r(this, null, "LastStickyRowBackground", 2, l.d3, m.d3, false, true, false, false);
                }
                if (!l.d5.equals(m.d5)) {
                    this.cp.r(this, null, "StickyRowBackground", 2, l.d5, m.d5, false, true, false, false);
                }
                if (!l.d4.equals(m.d4)) {
                    this.cp.r(this, null, "PinnedRowBackground", 2, l.d4, m.d4, false, true, false, false);
                }
            }
        }
        if (a == "HeaderRowSeparator") {
            var n = b;
            var o = c;
            if (n != null) {
                n.definitionPropertyUpdated = delegateRemove(n.definitionPropertyUpdated, runOn(this, this.q4));
                n.grid = null;
            }
            if (o != null) {
                o.definitionPropertyUpdated = delegateCombine(o.definitionPropertyUpdated, runOn(this, this.q4));
                o.grid = this;
            }
        }
        if (a == "HeaderSeparator") {
            var p = b;
            var q = c;
            if (p != null) {
                p.definitionPropertyUpdated = delegateRemove(p.definitionPropertyUpdated, runOn(this, this.q5));
                p.grid = null;
            }
            if (q != null) {
                q.definitionPropertyUpdated = delegateCombine(q.definitionPropertyUpdated, runOn(this, this.q5));
                q.grid = this;
            }
        }
        if (a == "ColumnResizingSeparator") {
            var r = b;
            var s = c;
            if (r != null) {
                r.grid = null;
            }
            if (s != null) {
                s.grid = this;
            }
        }
        if (a == "ColumnMovingSeparator") {
            var t = b;
            var u = c;
            if (t != null) {
                t.grid = null;
            }
            if (u != null) {
                u.grid = this;
            }
        }
        if (a == "DataSourceDesiredProperties") {
            if (this.w != null) {
                this.w.propertiesRequested = this.g;
            }
        }
        if (a == "PrimaryKey") {
            if (this.actualDataSource != null && this.l != null) {
                this.actualDataSource.primaryKey = c;
            }
            this.e = this.m();
        }
        if (a == "ActualRowHeight" || a == "ActualHeaderHeight" || a == "RowSeparatorHeight" || a == "IsGroupRowSticky" || a == "IsHeaderSeparatorVisible" || a == "ShiftSectionContent" || a == "PinnedAreaSeparatorWidth") {
            this.h7 = this.i4();
            if (this.i5()) {
                this.tn();
            }
        }
        if (a == "DefaultColumnWidth" || a == "DefaultColumnMinWidth" || a == "Inset" || a == "HeaderSeparatorWidth") {
            if (this.model != null && this.model.br != null && this.model.br.count > 0) {
                this.tn();
            }
        }
        if (a == "SectionHeader") {
            if (b != null) {
                var v = typeCast(SectionHeader.$, b);
                v.sectionHeaderPropertyUpdating = delegateRemove(v.sectionHeaderPropertyUpdating, runOn(this, this.s5));
                v.grid = null;
            }
            if (this.e3 != null) {
                var w = this.e3;
                w.sectionHeaderPropertyUpdating = delegateCombine(w.sectionHeaderPropertyUpdating, runOn(this, this.s5));
                this.e3.grid = this;
            }
            this.model.bn = true;
            this.tn();
        }
        if (a == "PinnedAreaSeparator") {
            if (b != null) {
                var x = typeCast(PinnedAreaSeparator.$, b);
                x.grid = null;
            }
            if (this.en != null) {
                this.en.grid = this;
            }
            this.tn();
        }
        if (a == "ActiveCell") {
            this.c0 = typeCast(GridCellPosition.$, b);
            this.g8 = true;
            if (this.c1 != null && this.c1.b >= 0) {
                this.aj.aa(this.c1.b, this.c1.d, true);
            }
            else {
                this.aj.ac();
            }
            this.g8 = false;
        }
        if (a == "ReactsToSortChanges") {
            var y = c;
            if (!y) {
                this.b5.b = null;
            }
            else {
                if (this.w != null) {
                    this.b5.b = this.w.sortDescriptions;
                }
            }
        }
        if (a == "ReactsToGroupChanges") {
            var z = c;
            if (!z) {
                this.a8.b = null;
            }
            else {
                if (this.w != null) {
                    this.a8.b = this.w.groupDescriptions;
                }
            }
        }
        if (a == "ReactsToFilterChanges") {
            var aa = c;
            if (!aa) {
                this.v.syncTarget = null;
            }
            else {
                if (this.w != null) {
                    this.v.syncTarget = this.w.filterExpressions;
                }
            }
        }
        if (a == "IsGroupCollapsable") {
            if (this.actualDataSource != null) {
                this.actualDataSource.isSectionCollapsable = c;
            }
        }
        if (a == "GroupHeaderDisplayMode") {
            if (this.actualDataSource != null) {
                this.actualDataSource.sectionHeaderDisplayMode = EnumUtil.getEnumValue(DataSourceSectionHeaderDisplayMode_$type, c);
            }
        }
        if (a == "SummaryScope") {
            if (this.actualDataSource != null) {
                this.actualDataSource.summaryScope = EnumUtil.getEnumValue(DataSourceSummaryScope_$type, c);
            }
        }
        if (a == "IsGroupExpandedDefault") {
            if (this.actualDataSource != null) {
                this.actualDataSource.isSectionExpandedDefault = c;
            }
        }
        if (a == "GroupSummaryDisplayMode") {
            this.e3.en = this.d3;
            this.model.bn = true;
            if (this.actualDataSource != null) {
                switch (this.d3) {
                    case 1:
                    case 0:
                    case 4:
                        this.actualDataSource.includeSummaryRowsInSection = false;
                        break;
                    case 2:
                        this.actualDataSource.includeSummaryRowsInSection = true;
                        this.actualDataSource.isSectionSummaryRowsAtBottom = false;
                        break;
                    case 3:
                        this.actualDataSource.includeSummaryRowsInSection = true;
                        this.actualDataSource.isSectionSummaryRowsAtBottom = true;
                        break;
                }
            }
            this.tn();
        }
        if (a == "Density" || a == "RowHeight") {
            this.sj();
        }
        if (a == "HeaderHeight") {
            this.sj();
            this.externalGrid.setScrollerVerticalTrackInset(this.k7);
        }
        if (a == "DefaultBorderWidth" || a == "BorderWidth") {
            this.w7 = this.w9(this.w8, this.xa);
        }
        if (a == "DefaultCornerRadius" || a == "CornerRadius") {
            this.uz = this.u0(this.u1, this.u2);
        }
        if (a == "Border" || a == "ActualCornerRadius" || a == "ActualBorderWidth") {
            this.externalGrid.setBorder(this.border, this.w7.c, this.w7.e, this.w7.d, this.w7.b, this.uz.c, this.uz.d, this.uz.a, this.uz.b);
        }
        if (a == "EditMode") {
            this.un();
        }
    };
    Grid.prototype.un = function () {
        if (this.y != null) {
            if (this.cg == 2 || this.cg == 3) {
                this.y.isBatchingEnabled = true;
            }
            else {
                this.y.isBatchingEnabled = false;
            }
        }
    };
    Grid.prototype.u0 = function (a, b) {
        return new CornerRadius(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b, !isNaN_(a.a) ? a.a : b.a);
    };
    Grid.prototype.w9 = function (a, b) {
        return new Thickness(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.e) ? a.e : b.e, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b);
    };
    Grid.prototype.syncBorder = function () {
        if (this.externalGrid != null) {
            this.externalGrid.setBorder(this.border, this.w7.c, this.w7.e, this.w7.d, this.w7.b, this.uz.c, this.uz.d, this.uz.a, this.uz.b);
        }
    };
    Grid.prototype.sj = function () {
        if (this.l1 == -1) {
            switch (this.fl) {
                case 0:
                case 2:
                    this.k8 = GridStyleRepository.p;
                    break;
                case 3:
                    this.k8 = GridStyleRepository.o;
                    break;
                case 1:
                    this.k8 = GridStyleRepository.n;
                    break;
            }
        }
        else {
            this.k8 = this.l1;
        }
        if (this.lt == -1) {
            switch (this.fl) {
                case 0:
                case 2:
                    this.k7 = GridStyleRepository.p;
                    break;
                case 3:
                    this.k7 = GridStyleRepository.o;
                    break;
                case 1:
                    this.k7 = GridStyleRepository.n;
                    break;
            }
        }
        else {
            this.k7 = this.lt;
        }
    };
    Grid.prototype.m = function () {
        if (this.l != null) {
            return this.l;
        }
        if (this.actualDataSource != null) {
            return this.actualDataSource.actualPrimaryKey;
        }
        return null;
    };
    Grid.prototype.n = function () {
        if (!this.hc && this.g == null && this.w.propertiesRequested == null && this.columns.count > 0) {
            return this.h();
        }
        if (this.g != null) {
            return this.g;
        }
        return this.w.propertiesRequested;
    };
    Grid.prototype.h = function () {
        var a = new Array(this.columns.count);
        for (var b = 0; b < this.columns.count; b++) {
            a[b] = this.columns._inner[b].h4;
        }
        return a;
    };
    Grid.prototype.t0 = function (a, b) {
        this.t1(b.propertyName, b.animationType, b.oldValue, b.newValue, false);
    };
    Grid.prototype.q4 = function (a, b) {
        this.t1(b.propertyName, b.animationType, b.oldValue, b.newValue, true);
    };
    Grid.prototype.q5 = function (a, b) {
        this.q6(b.propertyName, b.animationType, b.oldValue, b.newValue);
    };
    Grid.prototype.t1 = function (a, b, c, d, e) {
        if (b == 10) {
            return;
        }
        if (a != null && stringStartsWith(a, "Actual")) {
            a = a.substr(6);
        }
        this.cp.r(this, null, a, b, c, d, e, true, false, false);
    };
    Grid.prototype.q6 = function (a, b, c, d) {
        if (b == 10) {
            return;
        }
        if (a != null && stringStartsWith(a, "Actual")) {
            a = a.substr(6);
        }
        for (var e = 0; e < this.model.br.count; e++) {
            var f = this.model.br._inner[e];
            this.cp.r(this, f, a, b, c, d, true, false, false, true);
        }
    };
    Grid.prototype.qt = function (a, b) {
        this.si();
    };
    Grid.prototype.qs = function (a, b) {
        if (this.dataCommitted != null) {
            this.dataCommitted(this, new GridDataCommittedEventArgs(b.commitID, b.changes));
        }
    };
    Grid.prototype.si = function () {
        this.ed.setDataSource(this.w);
        this.a3.d = this.w.actualSchema;
        this.uo();
        for (var a = 0; a < this.a8.i.count; a++) {
            this.ty(this.a8.i.item(a));
        }
        for (var b = 0; b < this.b8.i.count; b++) {
            this.tz(this.b8.i.item(b));
        }
        if (this.gh) {
            this.q2();
        }
        else {
            this.tn();
            this.rb();
        }
    };
    Grid.prototype.rh = function () {
        var e_15, _a;
        if (this.columnsAutoGenerated != null) {
            var a = new GridColumnsAutoGeneratedEventArgs();
            a.columns = this.actualColumns;
            this.columnsAutoGenerated(this, a);
        }
        try {
            for (var _b = tslib_1.__values(fromEnum(this.actualColumns)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var b = _c.value;
                b.gj = false;
            }
        }
        catch (e_15_1) {
            e_15 = { error: e_15_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_15)
                    throw e_15.error;
            }
        }
    };
    Grid.prototype.onSizeChanged = function (a, b) {
        this.j7 = a;
        this.j6 = b;
        this.ep.y(a, b);
        this.tn();
        if (this.sizeChanged != null) {
            this.sizeChanged(this, ((function () {
                var $ret = new GridSizeChangedEventArgs();
                $ret.b = a;
                $ret.a = b;
                return $ret;
            })()));
        }
    };
    Grid.prototype.notifyScrollStart = function () {
        this.je = true;
    };
    Grid.prototype.notifyScrollStop = function () {
        this.je = false;
        if (this.hl) {
            this.ea.f(this.ly);
            this.hl = false;
        }
    };
    Grid.prototype.setViewport = function (a, b, c, d) {
        this.ks = -1;
        this.kt = -1;
        var e = c - a;
        var f = new Rect(0, a, b, c - a, d - b);
        if (f.x != this.model.actualVisibleRegion.x || f.y != this.model.actualVisibleRegion.y || f.width != this.model.actualVisibleRegion.width || f.height != this.model.actualVisibleRegion.height) {
            var g_1 = this.model.actualVisibleRegion;
            this.model.actualVisibleRegion = f;
            this.to();
            if (this.viewportChanged != null) {
                this.viewportChanged(this, ((function () {
                    var $ret = new GridViewportChangedEventArgs();
                    $ret.g = f.x;
                    $ret.d = g_1.x;
                    $ret.h = f.y;
                    $ret.e = g_1.y;
                    $ret.f = f.width;
                    $ret.c = g_1.width;
                    $ret.a = f.height;
                    $ret.b = g_1.height;
                    return $ret;
                })()));
            }
        }
    };
    Object.defineProperty(Grid.prototype, "actualColumns", {
        get: function () {
            return this.a2.j;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "columns", {
        get: function () {
            return this.c5;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.sv = function (a, b, c) {
        var d = this.cb(a.k);
        d.cw(a, this, b, c);
        d.cx(a, this, b, c);
    };
    Grid.prototype.su = function (a, b, c, d) {
        a.i2 = d;
        var e = this.cb(a.k);
        e.cx(a, this, b, c);
    };
    Grid.prototype.a1 = function (a) {
        return this.a3.h(a);
    };
    Grid.prototype.q7 = function (a) {
        a.ga = true;
        a.gh = true;
    };
    Grid.prototype.qz = function (a, b) {
        var c = this.columns.indexOf(b);
        if (c == -1) {
            return;
        }
        if ((a != null && a.gg) || (b != null && b.gg)) {
            throw new InvalidOperationException(1, "Cannot exchange a column created from markup");
        }
        if (this.columns.contains(a)) {
            if (a.gh) {
                this.externalGrid.removeExternalColumn(a.externalObject);
            }
            else {
                return;
            }
        }
        var d = this.a5;
        if (d == 0) {
            d = a.et();
        }
        var e = false;
        if (d == 2 || d == 7) {
            e = true;
        }
        a.e8 = 3;
        if (e) {
            this.externalGrid.insertExternalColumnAtIndex(c + 1, a.externalObject);
        }
        else {
            this.externalGrid.insertExternalColumnAtIndex(c, a.externalObject);
        }
        b.fk = a.fk;
        if (!this.hu(a)) {
            a.gh = false;
            a.e8 = 5;
            this.externalGrid.removeExternalColumn(b.externalObject);
            this.r5(a);
        }
        this.tn();
        if (this.hu(a)) {
            var f = this.model.g(b.g6).a;
            b.e8 = 2;
            a.e8 = 1;
            this.cp.ai(this, this.c4, this.model.g(b.g6), this.model.g(a.g6), f);
        }
    };
    Grid.prototype.qc = function (a, b) {
        var _this = this;
        this.e5.aa();
        this.aj.af();
        this.e5.az();
        if (this.cc.j) {
            this.hk(false);
            if (this.cg == 3) {
                this.qx(false);
            }
        }
        if (this.jc) {
            return;
        }
        switch (b.action) {
            case 0:
                if (b.newItems != null) {
                    for (var c = 0; c < b.newItems.count; c++) {
                        this.r8(c + b.newStartingIndex, b.newItems.item(c));
                    }
                }
                break;
            case 1:
                if (b.oldItems != null) {
                    for (var d = 0; d < b.oldItems.count; d++) {
                        this.sc(b.oldStartingIndex, b.oldItems.item(d));
                    }
                }
                break;
            case 2:
                if (b.oldItems != null) {
                    for (var e = 0; e < b.oldItems.count; e++) {
                        this.sc(b.oldStartingIndex, b.oldItems.item(e));
                    }
                }
                if (b.newItems != null) {
                    for (var f = 0; f < b.newItems.count; f++) {
                        this.r8(f + b.newStartingIndex, b.newItems.item(f));
                    }
                }
                break;
            case 4:
                this.sf();
                break;
        }
        this.tn();
        if (!this.gw) {
            this.gw = true;
            this.delayedExecutionManager.executeIn(function () {
                _this.gw = false;
                if (_this.actualColumnsChanged != null) {
                    _this.actualColumnsChanged(_this, ((function () {
                        var $ret = new GridColumnsChangedEventArgs();
                        $ret.columns = _this.actualColumns;
                        return $ret;
                    })()));
                }
            }, 0);
        }
    };
    Grid.prototype.sf = function () {
        this.fb.w(this.dj, this.model);
    };
    Grid.prototype.sc = function (a, b) {
        b.grid = null;
        b.propertyChanged = delegateRemove(b.propertyChanged, runOn(this, this.qm));
        b.columnCellsPropertyUpdating = delegateRemove(b.columnCellsPropertyUpdating, runOn(this, this.qn));
        b.columnHeaderCellsPropertyUpdating = delegateRemove(b.columnHeaderCellsPropertyUpdating, runOn(this, this.qq));
        this.fb.v(this.dj, a, b, this.model);
        this.tn();
        b.e8 = 0;
        this.e5.ag(a, b);
    };
    Grid.prototype.r8 = function (a, b) {
        b.grid = this;
        b.propertyChanged = delegateCombine(b.propertyChanged, runOn(this, this.qm));
        b.columnCellsPropertyUpdating = delegateCombine(b.columnCellsPropertyUpdating, runOn(this, this.qn));
        b.columnHeaderCellsPropertyUpdating = delegateCombine(b.columnHeaderCellsPropertyUpdating, runOn(this, this.qq));
        this.fb.t(a, b, this.model);
        if (b.gh) {
            b.e8 = 3;
        }
        if (this.hs(b) && !b.gh && b.e8 != 3) {
            var c = b.e8;
            b.e8 = 1;
            this.tn();
            this.cp.aq(this, this.c4, this.model.g(b.g6), true, c);
        }
        else {
            this.tn();
        }
        for (var d = 0; d < this.b5.i.count; d++) {
            if (b.h4 == this.b5.i.item(d).f) {
                b.e6 = this.b6(this.b5.i.item(d).c);
                break;
            }
        }
        this.e5.ae(a, b);
    };
    Grid.prototype.qn = function (a, b, c, d, e) {
        if (b == "Pinned" || b == "IsHidden") {
            if (this.cc.j) {
                this.hk(false);
                if (this.cg == 3) {
                    this.qx(false);
                }
            }
        }
        if (b == "Width" || b == "MinWidth" || b == "Pinned") {
            this.tn();
            this.ql();
            if (b == "Width") {
                this.sg(a, d, e);
            }
            return;
        }
        if (c == 10) {
            return;
        }
        var f = this.model.g(a.g6);
        if (f == null) {
            return;
        }
        if (b != null && stringStartsWith(b, "Actual")) {
            b = b.substr(6);
        }
        if (b == "HeaderText") {
            this.qq(a, "TextValue", c, d, e);
            return;
        }
        if (b == "ColumnOptionsIconAlignment" || b == "ColumnOptionsIconColor" || b == "ColumnOptionsIconBehavior" || b == "IsColumnOptionsEnabled") {
            this.qq(a, b, c, d, e);
            return;
        }
        if (b == "FormatString") {
            if (typeCast(NumericColumn.$, a) !== null || typeCast(DateTimeColumn.$, a) !== null) {
                b = "FormatStringOverride";
            }
        }
        if (b == "SortDirection" && false == this.h8) {
            this.e9.f(a, a.e6);
        }
        this.cp.r(this, f, b, c, d, e, false, false, false, false);
    };
    Grid.prototype.s5 = function (a, b, c, d, e) {
        if (c == 10) {
            return;
        }
        if (b != null && stringStartsWith(b, "Actual")) {
            b = b.substr(6);
        }
        this.cp.r(this, null, b, c, d, e, false, false, true, false);
    };
    Grid.prototype.qq = function (a, b, c, d, e) {
        if (c == 10) {
            return;
        }
        var f = this.model.g(a.g6);
        if (f == null) {
            return;
        }
        if (b != null && stringStartsWith(b, "Actual")) {
            b = b.substr(6);
        }
        this.cp.r(this, f, b, c, d, e, true, false, false, false);
    };
    Grid.prototype.tf = function (a, b) {
        var c = b;
        if (c == null) {
            b = 0;
        }
        if ((typeof c == "number")) {
            var d = typeGetValue(c);
            if ((EnumUtil.getName(PinnedPositions_$type, d) == undefined)) {
                b = 0;
            }
            b = d;
        }
        else {
            b = (typeGetValue(EnumUtil.parse(PinnedPositions_$type, c, true)));
        }
        var e = this.columns.indexOf(a);
        if (e == -1) {
            return;
        }
        if (a.fk == b) {
            return;
        }
        this.hk(false);
        a.gz = this.fb.k(e, this, this.model);
        a.g0 = this.model.br._inner[e].n;
        a.fj = a.fk;
        a.fk = b;
        this.fb.s(this.model);
        var f = a.e8;
        if (this.hw(a)) {
            a.e8 = 6;
            this.cp.ak(this, this.c4, this.model.g(a.g6), f);
        }
    };
    Grid.prototype.rc = function (a, b) {
        var _this = this;
        this.externalGrid.ensureColumnsAreManual();
        var c = this.columns._inner[a];
        b = Math.min(this.columns.count - 1, Math.max(0, b));
        this.jc = true;
        if (c != null && c.gg) {
            throw new InvalidOperationException(1, "Can't move a column that was created from markup");
        }
        if (b > a) {
            var d = this.columns._inner[b - 1];
            if (d.gg) {
                throw new InvalidOperationException(1, "Can't move a column to before columns created from markup");
            }
        }
        else {
            var e = this.columns._inner[b];
            if (e.gg) {
                throw new InvalidOperationException(1, "Can't move a column to before columns created from markup");
            }
        }
        this.externalGrid.removeExternalColumn(c.externalObject);
        this.externalGrid.insertExternalColumnAtIndex(b, c.externalObject);
        this.jc = false;
        this.hk(false);
        this.r9(a, b, c);
        if (this.actualColumnsChanged != null) {
            this.actualColumnsChanged(this, ((function () {
                var $ret = new GridColumnsChangedEventArgs();
                $ret.columns = _this.actualColumns;
                return $ret;
            })()));
        }
    };
    Grid.prototype.rd = function (a) {
        this.ii(a, true, true);
    };
    Grid.prototype.re = function (a) {
        this.ii(a, false, true);
    };
    Grid.prototype.hf = function (a) {
        return this.ii(a, true, false);
    };
    Grid.prototype.hg = function (a) {
        return this.ii(a, false, false);
    };
    Grid.prototype.ii = function (a, b, c) {
        var d = this.actualColumns;
        var e = d.count - 1;
        var f = d._inner[a];
        var g = f.fk;
        var h = -1;
        var i = a;
        do {
            i += b ? -1 : 1;
            if (i < 0 || i > e) {
                break;
            }
            var j = d._inner[i];
            if (!j.gh && j.fk == g) {
                h = i;
            }
        } while (h == -1);
        if (h != -1) {
            if (c) {
                this.rc(a, h);
            }
            return true;
        }
        switch (f.fk) {
            case 0:
                var k = this.az(b);
                if (null == k) {
                    return false;
                }
                if (c) {
                    h = d.indexOf(k);
                    this.rc(a, h + (b ? 1 : -1));
                    f.fk = k.fk;
                }
                break;
            case 1:
                if (b) {
                    return false;
                }
                if (c) {
                    var l = this.ay(true);
                    if (l == null) {
                        this.tf(d._inner[a], 0);
                    }
                    else {
                        h = d.indexOf(l);
                        this.rc(a, h - 1);
                        f.fk = 0;
                    }
                }
                break;
            case 2:
                if (!b) {
                    return false;
                }
                if (c) {
                    var m = this.ay(false);
                    if (m == null) {
                        this.tf(d._inner[a], 0);
                    }
                    else {
                        h = d.indexOf(m);
                        this.rc(a, h + 1);
                        f.fk = 0;
                    }
                }
                break;
        }
        return true;
    };
    Grid.prototype.az = function (a) {
        var b = a ? 1 : 2;
        var c = this.actualColumns;
        var d = this.model.bx;
        var e = d.count - 1;
        var f = a ? 0 : e;
        var g = d._inner[f];
        var h = c._inner[g];
        var i = null;
        while (h.fk == b) {
            i = h;
            f += a ? 1 : -1;
            if (f < 0 || f > e) {
                break;
            }
            g = d._inner[f];
            h = c._inner[g];
        }
        return i;
    };
    Grid.prototype.ay = function (a) {
        var b = this.actualColumns;
        var c = this.model.bx;
        var d = c.count - 1;
        var e = a ? 0 : d;
        var f = c._inner[e];
        var g = b._inner[f];
        while (g.fk != 0) {
            e += a ? 1 : -1;
            if (e < 0 || e > d) {
                break;
            }
            f = c._inner[e];
            g = b._inner[f];
        }
        if (g.fk == 0) {
            return g;
        }
        else {
            return null;
        }
    };
    Grid.prototype.r9 = function (a, b, c) {
        c.gz = this.fb.k(a, this, this.model);
        c.gy = a;
        c.g0 = this.model.br._inner[a].n;
        var d = c.e8;
        this.fb.u(this.dj, this.model, a, b, c.g6);
        if (!this.hw(c) && d != 3) {
            c.e8 = 5;
        }
        this.tn();
        if (this.hw(c)) {
            c.e8 = 6;
            this.cp.ak(this, this.c4, this.model.g(c.g6), d);
        }
        this.e5.af(a, b, c);
    };
    Grid.prototype.qm = function (a, b) {
        var c = a;
        switch (b.propertyName) {
            case "Filter":
                this.uo();
                break;
            case "IsHidden":
                if (c.gh) {
                    if (this.hv(c)) {
                        var d = c.e8;
                        c.e8 = 2;
                        this.tn();
                        this.cp.aj(this, this.c4, this.model.g(c.g6), false, d);
                    }
                    else {
                        c.e8 = 3;
                        if (c.f7) {
                            this.externalGrid.ensureColumnsAreManual();
                            this.externalGrid.removeExternalColumn(c.externalObject);
                        }
                        this.tn();
                    }
                }
                else {
                    if (this.h1(c)) {
                        var e = c.e8;
                        c.e8 = 1;
                        this.tn();
                        this.cp.aq(this, this.c4, this.model.g(c.g6), false, e);
                    }
                    else {
                        c.e8 = 5;
                        this.cp.ah(this, this.model.g(c.g6));
                        this.de.ab();
                        this.tn();
                    }
                }
                if (this.columnHiddenChanged != null) {
                    this.columnHiddenChanged(this, ((function () {
                        var $ret = new ColumnHiddenChangedEventArgs();
                        $ret.a = c;
                        $ret.b = c.gh;
                        return $ret;
                    })()));
                }
                break;
            case "Pinned":
                if (this.columnPinnedChanged != null) {
                    this.columnPinnedChanged(this, ((function () {
                        var $ret = new ColumnPinnedChangedEventArgs();
                        $ret.a = c;
                        $ret.b = c.fk;
                        return $ret;
                    })()));
                }
                break;
        }
    };
    Grid.prototype.uo = function () {
        if (this.actualDataSource == null) {
            return;
        }
        var a = this.z(null);
        if (a != null) {
            a.markAutoGenerated();
            var b = false;
            if (this.v != null) {
                for (var c = 0; c < this.v.j.count; c++) {
                    if (this.v.j.item(c).isAutoGenerated) {
                        this.v.j.item(c, a);
                        b = true;
                        break;
                    }
                }
            }
            if (!b) {
                this.v.add(a);
            }
        }
        else {
            for (var d = this.v.j.count - 1; d >= 0; d--) {
                if (this.v.j.item(d).isAutoGenerated) {
                    this.v.removeAt(d);
                }
            }
        }
    };
    Grid.prototype.cb = function (a) {
        var b = this.ed.getRowType(a.w);
        if (b != 0 && b != 3) {
            if (a.at) {
                if (a.g) {
                    return this.d7;
                }
                return this.ez;
            }
            switch (b) {
                case 1: if (this.d3 != 1) {
                    return this.e3;
                }
                else {
                    return this.a1(a);
                }
                case 2: return this.e1;
                case 4: return this.fd;
                case 5: return this.ff;
                default: throw new NotSupportedException(0);
            }
        }
        else {
            if (a.at) {
                if (a.g) {
                    return this.d7;
                }
                return this.ez;
            }
            else {
                if (a.aq && this.dragger != null) {
                    if (this.dragger.dragType == 1) {
                        return this.bx;
                    }
                    else if (this.dragger.dragType == 2) {
                        return this.bj;
                    }
                }
                if (a.al || a.an || a.ak || a.am) {
                    return this.en;
                }
                var c = this.a1(a);
                if (a.g) {
                    if (a.h) {
                        return this.d9;
                    }
                    else {
                        return c.header;
                    }
                }
                else {
                    return c;
                }
            }
        }
    };
    Grid.prototype.n2 = function (a, b, c, d) {
        return this.cb(a).cl(a, b, c, d);
    };
    Grid.prototype.ao = function (a, b) {
        var c = this.cb(a);
        var d = c.k(a, b);
        d.o = this;
        return d;
    };
    Grid.prototype.mc = function () {
        return this.model.b();
    };
    Grid.prototype.n1 = function () {
        var a = this.model.b();
        return a.av();
    };
    Grid.prototype.ev = function (a) {
        return this.ee.getRowPathForRow(a);
    };
    Grid.prototype.t5 = function (a) {
        var e_16, _a;
        if (this.model.actualVisibleRegion.isEmpty) {
            return;
        }
        var b = truncate(this.model.actualVisibleRegion.left);
        if (this.ks != -1) {
            b = this.ks;
        }
        var c = 0;
        var d = 0;
        if (a < 0) {
            a = 0;
        }
        if (a >= this.ee.getRowCount()) {
            a = this.ee.getRowCount() - 1;
        }
        var e = 0;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.model.bv)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var f = _c.value;
                if (d + f.m > a) {
                    e = truncate(Math.floor(a - d));
                    var g = f.e(e);
                    c = f.f(e);
                    c += truncate(Math.round(g * ((a - d) - e)));
                }
                else {
                    d += f.m;
                    continue;
                }
            }
        }
        catch (e_16_1) {
            e_16 = { error: e_16_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_16)
                    throw e_16.error;
            }
        }
        var h = this.fh.i(this, this.model, new Rect(0, b, c, this.model.b9, this.model.by));
        var i = -1;
        var j = -1;
        var k = false;
        for (var l = 0; l < h.count; l++) {
            if (h._inner[l].m == e) {
                i = l;
                j = h._inner[l].n;
                break;
            }
            if (h._inner[l].m > e) {
                i = l - 1;
                break;
            }
            switch (h._inner[l].a) {
                case 3:
                case 5:
                    k = true;
                    break;
                case 1:
                    k = false;
                    break;
            }
        }
        if (i == -1) {
            i = h.count - 1;
        }
        var m = 0;
        for (var n = i; n >= 0; n--) {
            if (k) {
                if (h._inner[n].n >= j) {
                    if (h._inner[n].a != 3 && h._inner[n].a != 5) {
                        j = h._inner[n].n;
                        k = false;
                    }
                    m += h._inner[n].k + this.l3 + this.l4;
                }
            }
            else {
                if (h._inner[n].n > j) {
                    if (h._inner[n].a != 3) {
                        j = h._inner[n].n;
                    }
                    m += h._inner[n].k + this.l3 + this.l4;
                }
            }
        }
        c -= truncate(m);
        c = Math.max(c, 0);
        if (this.model.absoluteHeight > 0 && this.model.actualVisibleRegion.height > 0 && c + this.model.actualVisibleRegion.height > this.model.absoluteHeight) {
            c = truncate(Math.round(this.model.absoluteHeight - this.model.actualVisibleRegion.height));
        }
        if (c < 0) {
            c = 0;
        }
        this.kt = c;
        this.ks = b;
        this.viewportManager.moveViewportTo(b, c);
    };
    Grid.prototype.t4 = function (a) {
        var e_17, _a;
        var b = truncate(this.model.actualVisibleRegion.left);
        if (this.ks != -1) {
            b = this.ks;
        }
        var c = 0;
        var d = 0;
        if (a < 0) {
            a = 0;
        }
        if (a >= this.ee.getRowCount()) {
            a = this.ee.getRowCount() - 1;
        }
        var e = 0;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.model.bv)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var f = _c.value;
                if (d + f.m > a) {
                    var g = truncate(Math.floor(a - d));
                    var h = f.e(g);
                    e = h;
                    c = f.i + f.f(g);
                    c += truncate(Math.round(h * ((a - d) - g)));
                }
                else {
                    d += f.m;
                    continue;
                }
            }
        }
        catch (e_17_1) {
            e_17 = { error: e_17_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_17)
                    throw e_17.error;
            }
        }
        c -= this.model.ci;
        c = Math.max(c, 0);
        if (this.model.absoluteHeight > 0 && this.model.actualVisibleRegion.height > 0) {
            c -= truncate(Math.round(this.model.actualVisibleRegion.height - this.model.cu - (e + this.model.ci)));
        }
        if (this.model.absoluteHeight > 0 && this.model.actualVisibleRegion.height > 0 && c + this.model.actualVisibleRegion.height > this.model.absoluteHeight) {
            c = truncate(Math.round(this.model.absoluteHeight - this.model.actualVisibleRegion.height));
        }
        if (c < 0) {
            c = 0;
        }
        this.kt = c;
        this.ks = b;
        this.viewportManager.moveViewportTo(b, c);
    };
    Grid.prototype.i6 = function (a) {
        var b = this.le(a);
        if (b == -1) {
            return false;
        }
        this.t5(b);
        return true;
    };
    Grid.prototype.i7 = function (a) {
        var b = this.lf(a);
        if (b == -1) {
            return false;
        }
        this.t5(b);
        return true;
    };
    Grid.prototype.t2 = function (a) {
        var b = truncate(a);
        if (b < 0) {
            b = 0;
            a = 0;
        }
        if (a > this.model.br.count) {
            b = this.model.br.count - 1;
            a = this.model.br.count - 1;
        }
        var c = this.columns._inner[b];
        if (c.fk != 0) {
            return;
        }
        var d = this.fb.k(b, this, this.model);
        var e = truncate(this.model.actualVisibleRegion.top);
        if (this.kt != -1) {
            e = this.kt;
        }
        var f = d + truncate((this.model.br._inner[b].k * (a - b)));
        f -= this.model.cf;
        if (this.model.absoluteWidth > 0 && this.model.actualVisibleRegion.width > 0 && f + this.model.actualVisibleRegion.width > this.model.absoluteWidth) {
            f = truncate(Math.round(this.model.absoluteWidth - this.model.actualVisibleRegion.width));
        }
        if (f < 0) {
            f = 0;
        }
        this.kt = e;
        this.ks = f;
        this.viewportManager.moveViewportTo(f, e);
    };
    Grid.prototype.t3 = function (a) {
        var b = truncate(a);
        if (b < 0) {
            b = 0;
            a = 0;
        }
        if (a > this.model.br.count) {
            b = this.model.br.count - 1;
            a = this.model.br.count - 1;
        }
        var c = this.columns._inner[b];
        var d = this.fb.k(b, this, this.model);
        var e = truncate(this.model.actualVisibleRegion.top);
        if (this.kt != -1) {
            e = this.kt;
        }
        var f = d + truncate((this.model.br._inner[b].k * (a - b)));
        var g = this.model.actualVisibleRegion.width - this.model.cg;
        if (this.model.absoluteWidth > 0 && g > 0) {
            f -= truncate(Math.round(g - this.model.br._inner[b].k));
        }
        if (this.model.absoluteWidth > 0 && this.model.actualVisibleRegion.width > 0 && f + this.model.actualVisibleRegion.width > this.model.absoluteWidth) {
            f = truncate(Math.round(this.model.absoluteWidth - this.model.actualVisibleRegion.width));
        }
        if (f < 0) {
            f = 0;
        }
        this.kt = e;
        this.ks = f;
        this.viewportManager.moveViewportTo(f, e);
    };
    Grid.prototype.i9 = function (a) {
        return this.hs(a);
    };
    Grid.prototype.sh = function (a, b) {
        if (this.cm == 1 && this.c1 != null) {
            if (this.c1.b >= a && this.c1.b <= b) {
                if (this.activeCellChanged != null) {
                    var c = new GridActiveCellChangedEventArgs();
                    c.newActiveCell = this.c1;
                    c.oldActiveCell = this.c1;
                    this.activeCellChanged(this, c);
                }
            }
        }
        var d = this.ll();
        var e = this.lp();
        if (b < d || a > e) {
            return;
        }
        if (a < d) {
            a = d;
        }
        if (b > e) {
            b = e;
        }
        if (!this.i5()) {
            return;
        }
        this.cp.y(this, a, b, false);
        if (this.ee.getRowCount() != this.model.ck()) {
            this.tn();
        }
        else {
            this.to();
        }
        this.ql();
    };
    Grid.prototype.ql = function () {
        if (this.model.actualVisibleRegion.isEmpty) {
            return;
        }
        if (this.model.actualVisibleRegion.bottom > this.model.absoluteHeight || this.model.actualVisibleRegion.top > this.model.absoluteHeight) {
            var a = this.ee.getRowCount() - 1;
            if (a < 0) {
                a = 0;
            }
            this.t5(a);
        }
        if (this.model.actualVisibleRegion.right > this.model.absoluteWidth || this.model.actualVisibleRegion.left > this.model.absoluteWidth) {
            var b = this.a3.j.count - 1;
            if (b < 0) {
                b = 0;
            }
            this.t3(b);
        }
    };
    Grid.prototype.lh = function (a) {
        return this.fb.i(this.model, a.k);
    };
    Grid.prototype.i5 = function () {
        return this.model.be != null && this.model.bf != null && this.model.bf.w >= 0 && this.model.be.w >= 0;
    };
    Grid.prototype.lp = function () {
        return this.fb.i(this.model, this.model.be);
    };
    Grid.prototype.ll = function () {
        return this.fb.i(this.model, this.model.bf);
    };
    Grid.prototype.lj = function () {
        var a = this.fb.b(this.model.actualVisibleRegion.top + this.model.cl + this.model.cm + this.model.cv, this.model);
        return this.fb.i(this.model, a);
    };
    Grid.prototype.ln = function () {
        var a = this.fb.b(this.model.actualVisibleRegion.bottom - this.model.cu, this.model);
        return this.fb.i(this.model, a);
    };
    Grid.prototype.td = function () {
        var a = this.ll();
        var b = this.lp();
        this.ee.firstVisibleIndexRequested = a;
        this.ee.lastVisibleIndexRequested = b;
    };
    Object.defineProperty(Grid.prototype, "ic", {
        get: function () {
            return this.cellPreviewPointerDown != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "id", {
        get: function () {
            return this.cellPreviewPointerUp != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ia", {
        get: function () {
            return this.cellPointerDown != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ib", {
        get: function () {
            return this.cellPointerUp != null;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.i3 = function () {
        return this.dy != 0 || this.cellClicked != null || this.cm != 0 || this.bv != 2 || this.bh != 1;
    };
    Grid.prototype.i4 = function () {
        return (this.bv != 2 && this.h6) || this.bh != 1;
    };
    Grid.prototype.qh = function () {
        this.ji.clear();
        this.jj.clear();
        this.jk.clear();
        this.jl.clear();
        this.f8 = true;
    };
    Grid.prototype.qy = function () {
        if (this.f8) {
            this.hn = true;
            this.ut(this.ji, this.jj, this.jk, this.jl);
            this.hn = false;
        }
        this.f8 = false;
    };
    Grid.prototype.s3 = function (a, b) {
        if (!this.f8) {
            this.hn = true;
            this.qg(a, b);
            this.hn = false;
        }
        else {
            this.ji.add1(a);
            this.jj.add(b);
        }
    };
    Grid.prototype.s4 = function (a, b) {
        if (!this.f8) {
            this.hn = true;
            this.tw(a, b);
            this.hn = false;
        }
        else {
            this.jk.add1(a);
            this.jl.add(b);
        }
    };
    Grid.prototype.ta = function (a, b, c) {
        this.hn = true;
        this.us(a, b, c);
        this.hn = false;
    };
    Grid.prototype.rn = function (a, b, c) {
        if (!this.g8) {
            var d = new GridCellPosition();
            d.d = c;
            d.b = a;
            this.c1 = d;
        }
        if (this.activeCellChanged != null) {
            var e = new GridActiveCellChangedEventArgs();
            e.newActiveCell = this.c1;
            e.oldActiveCell = this.c0;
            this.activeCellChanged(this, e);
        }
        if (this.h2() && this.hj) {
            if (b >= 0 && b <= this.a3.j.count) {
                var f = this.a3.j._inner[b];
                if (f.ge) {
                    var g = this.model.d(b, a);
                    if (g != null) {
                        this.cc.y(g);
                    }
                    else {
                        this.as = new CellPath(1, b, 0, a);
                    }
                }
            }
        }
    };
    Grid.prototype.rp = function (a, b) {
        if (b == null) {
            return;
        }
        var c = this.c1;
        if (!this.g8) {
            var d = new GridCellPosition();
            d.d = b;
            d.b = a;
            this.c1 = d;
        }
        if (this.activeCellChanged != null) {
            var e = new GridActiveCellChangedEventArgs();
            e.newActiveCell = this.c1;
            e.oldActiveCell = c;
            this.activeCellChanged(this, e);
        }
    };
    Grid.prototype.ik = function (a, b) {
        if (this.cm == 0 || this.c1 == null) {
            return false;
        }
        var c = this.cz.b;
        var d = this.cz.d;
        if (c > this.ee.getRowCount() - 1) {
            return false;
        }
        var e = c + 1;
        if (b) {
            e = this.ee.getRowCount() - 1;
        }
        if (e > this.ee.getRowCount() - 1) {
            e = this.ee.getRowCount() - 1;
        }
        if (e == c) {
            return false;
        }
        var f = Math.min(this.aj.s(), this.actualColumns.count - 1);
        f = this.lg(f);
        var g = this.actualColumns._inner[f];
        if (d != g.h6()) {
            d = g.h6();
        }
        if (this.d3 != 1) {
            var h = this.ee.getRowType(e);
            if (h == 1 || h == 2) {
                d = null;
            }
        }
        this.c1 = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = e;
            $ret.d = d;
            return $ret;
        })());
        if (this.model.br.count > 0) {
            this.qi(e, this.model.br._inner[f].n, false);
        }
        if (this.dy == 2 && a) {
            if (this.k3 == -1) {
                this.k3 = c;
            }
            var i = Math.min(this.k3, e);
            var j = Math.max(this.k3, e);
            this.uc(i, j);
        }
        else if (this.dy == 5 && a) {
            if (this.k3 == -1) {
                this.k3 = c;
            }
            if (this.k2 == -1) {
                this.k2 = this.model.br._inner[f].n;
            }
            var k = new CellRange();
            k.l = Math.min(this.k3, e);
            k.k = Math.min(this.k2, this.model.br._inner[f].n);
            k.j = Math.max(this.k3, e);
            k.i = Math.max(this.k2, this.model.br._inner[f].n);
            this.t7(k);
        }
        else {
            this.k3 = -1;
            this.k2 = -1;
            this.at = null;
            this.jm.clear();
            this.jn.clear();
        }
        return true;
    };
    Grid.prototype.il = function (a, b) {
        if (this.cm == 0 || this.c1 == null || this.cc.j) {
            return false;
        }
        var c = this.aj.s();
        var d = this.actualColumns._inner[c];
        var e = this.lm(true);
        var f = this.actualColumns._inner[e];
        var g = this.cz.b;
        var h = this.cz.d;
        if (b) {
            if (g >= this.ee.getRowCount() - 1 && h == f.h6()) {
                return false;
            }
            g = this.ee.getRowCount() - 1;
        }
        else if (h == f.h6()) {
            return false;
        }
        h = f.h6();
        var i = this.ee.getRowType(g);
        if (i == 1 || i == 2) {
            h = null;
        }
        this.c1 = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = g;
            $ret.d = h;
            return $ret;
        })());
        if (f.fk == 1 && f.fk != d.fk) {
            var j = this.li();
            var k = this.model.br._inner[j].n;
            this.qi(g, k, false);
        }
        else if (f.fk == 2 && f.fk != d.fk) {
            var l = this.lm();
            var m = this.model.br._inner[l].n;
            this.qi(g, m, false);
        }
        else {
            this.qi(g, this.model.br._inner[e].n, false);
        }
        return true;
    };
    Grid.prototype.lm = function (a) {
        if (a === void 0) {
            a = false;
        }
        var b = this.actualColumns.count - 1;
        var c = this.fb.j(b, this.model);
        if (a) {
            while (b > 0 && (this.actualColumns._inner[c].gh || this.actualColumns._inner[c].fk == 1)) {
                b--;
                c = this.fb.j(b, this.model);
            }
        }
        else {
            while (b > 0 && (this.actualColumns._inner[c].gh || this.actualColumns._inner[c].fk != 0)) {
                b--;
                c = this.fb.j(b, this.model);
            }
        }
        return c;
    };
    Grid.prototype.li = function (a) {
        if (a === void 0) {
            a = false;
        }
        var b = 0;
        var c = this.fb.j(b, this.model);
        if (a) {
            while (b < this.actualColumns.count - 1 && (this.actualColumns._inner[c].gh || this.actualColumns._inner[c].fk == 2)) {
                b++;
                c = this.fb.j(b, this.model);
            }
        }
        else {
            while (b < this.actualColumns.count - 1 && (this.actualColumns._inner[c].gh || this.actualColumns._inner[c].fk != 0)) {
                b++;
                c = this.fb.j(b, this.model);
            }
        }
        return c;
    };
    Grid.prototype.lr = function (a, b) {
        if (b === void 0) {
            b = true;
        }
        var c = Math.max(0, a - 1);
        if (!b) {
            c = this.fb.j(c, this.model);
        }
        if (this.actualColumns._inner[c].gh) {
            var d = c;
            var e = this.model.br._inner[c].n;
            while (e > 0 && this.actualColumns._inner[d].gh) {
                e--;
                d = this.fb.j(e, this.model);
            }
            if (this.actualColumns._inner[d].gh) {
                d = c;
                e = this.model.br._inner[c].n;
                while (e < this.actualColumns.count - 1 && this.actualColumns._inner[d].gh) {
                    e++;
                    d = this.fb.j(e, this.model);
                }
                if (!this.actualColumns._inner[d].gh) {
                    c = d;
                }
            }
            else {
                c = d;
            }
        }
        return c;
    };
    Grid.prototype.lq = function (a, b) {
        if (b === void 0) {
            b = true;
        }
        var c = Math.min(this.actualColumns.count - 1, a + 1);
        if (!b) {
            c = this.fb.j(c, this.model);
        }
        return this.lg(c);
    };
    Grid.prototype.lg = function (a) {
        a = Math.min(a, this.actualColumns.count - 1);
        if (this.actualColumns._inner[a].gh) {
            var b = a;
            var c = this.model.br._inner[b].n;
            while (c < this.actualColumns.count - 1 && this.actualColumns._inner[b].gh) {
                c++;
                b = this.fb.j(c, this.model);
            }
            if (this.actualColumns._inner[b].gh) {
                b = a;
                c = this.model.br._inner[b].n;
                while (c > 0 && this.actualColumns._inner[b].gh) {
                    c--;
                    b = this.fb.j(c, this.model);
                }
                if (!this.actualColumns._inner[b].gh) {
                    a = b;
                }
            }
            else {
                a = b;
            }
        }
        return a;
    };
    Grid.prototype.qi = function (a, b, c) {
        b = Math.max(0, Math.min(b, this.model.br.count - 1));
        if (b <= this.lk()) {
            b = this.fb.j(b, this.model);
            if (this.model.br._inner[b].d == 0) {
                this.t2(b);
            }
        }
        else if (b >= this.lo()) {
            b = this.fb.j(b, this.model);
            if (this.model.br._inner[b].d == 0) {
                this.t3(b);
            }
        }
        if (a <= this.lj()) {
            this.t5(a);
        }
        else if (a >= this.ln()) {
            if (c) {
                this.t5(a);
            }
            else {
                this.t4(a);
            }
        }
    };
    Grid.prototype.iq = function (a, b) {
        if (this.cc.j) {
            return false;
        }
        var c = this.aj.s();
        var d = this.actualColumns._inner[c];
        var e = this.li(true);
        var f = this.actualColumns._inner[e];
        var g = this.cz.b;
        var h = this.cz.d;
        if (b) {
            if (g <= 0 && h == f.h6()) {
                return false;
            }
            g = 0;
        }
        else if (h == f.h6()) {
            return false;
        }
        h = f.h6();
        if (this.d3 != 1) {
            var i = this.ee.getRowType(g);
            if (i == 1 || i == 2) {
                h = null;
            }
        }
        this.c1 = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = g;
            $ret.d = h;
            return $ret;
        })());
        if (f.fk == 1 && f.fk != d.fk) {
            var j = this.li();
            var k = this.model.br._inner[j].n;
            this.qi(g, k, false);
        }
        else if (f.fk == 2 && f.fk != d.fk) {
            var l = this.lm();
            var m = this.model.br._inner[l].n;
            this.qi(g, m, false);
        }
        else {
            this.qi(g, this.model.br._inner[e].n, false);
        }
        return true;
    };
    Grid.prototype.is = function (a, b) {
        if (this.cm == 0 || this.c1 == null) {
            return false;
        }
        if (b) {
            return this.iq(false, false);
        }
        var c = this.aj.s();
        var d = this.model.br._inner[c].n;
        var e = this.cz.b;
        var f = this.cz.d;
        if (f == null) {
            return false;
        }
        var g = this.lr(d, false);
        var h = this.model.br._inner[g].n;
        var i = this.actualColumns._inner[g];
        if (f == i.h6()) {
            return false;
        }
        f = i.h6();
        this.c1 = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = e;
            $ret.d = f;
            return $ret;
        })());
        if (this.model.br.count > 0) {
            if (i.fk == 0) {
                this.qi(e, this.model.br._inner[g].n, false);
            }
        }
        if (this.dy == 5 && a) {
            if (this.k3 == -1) {
                this.k3 = e;
            }
            if (this.k2 == -1) {
                this.k2 = d;
            }
            var j = new CellRange();
            j.l = Math.min(this.k3, e);
            j.k = Math.min(this.k2, h);
            j.j = Math.max(this.k3, e);
            j.i = Math.max(this.k2, h);
            this.t7(j);
        }
        else {
            this.k2 = -1;
            this.at = null;
        }
        return true;
    };
    Grid.prototype.it = function (a, b) {
        if (this.cm == 0 || this.c1 == null) {
            return false;
        }
        var c = this.cz.d;
        var d = this.aj.s();
        var e = this.ll();
        var f = this.lp();
        var g = f - e;
        var h = Math.min(f + 1, this.ee.getRowCount() - 1);
        if (!this.cc.j) {
            var i = this.ee.getRowType(h);
            if (i == 1 || i == 2) {
                c = null;
            }
            this.c1 = ((function () {
                var $ret = new GridCellPosition();
                $ret.b = h;
                $ret.d = c;
                return $ret;
            })());
        }
        this.qi(h, this.model.br._inner[d].n, true);
        return true;
    };
    Grid.prototype.iu = function (a, b) {
        if (this.cm == 0 || this.c1 == null) {
            return false;
        }
        var c = this.cz.d;
        var d = this.aj.s();
        var e = this.ll();
        var f = this.lp();
        var g = f - e;
        var h = Math.max(e - g - 1, 0);
        if (!this.cc.j) {
            var i = this.ee.getRowType(h);
            if (i == 1 || i == 2) {
                c = null;
            }
            this.c1 = ((function () {
                var $ret = new GridCellPosition();
                $ret.b = h;
                $ret.d = c;
                return $ret;
            })());
        }
        this.qi(h, this.model.br._inner[d].n, false);
        return true;
    };
    Grid.prototype.iv = function (a, b) {
        if (this.cm == 0 || this.c1 == null) {
            return false;
        }
        if (b) {
            return this.il(false, false);
        }
        var c = this.aj.s();
        var d = this.model.br._inner[c].n;
        var e = this.cz.b;
        var f = this.cz.d;
        if (f == null) {
            return false;
        }
        var g = this.lq(d, false);
        var h = this.model.br._inner[g].n;
        var i = this.actualColumns._inner[g];
        if (f == i.h6()) {
            return false;
        }
        f = i.h6();
        this.c1 = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = e;
            $ret.d = f;
            return $ret;
        })());
        if (this.model.br.count > 0) {
            if (i.fk == 0) {
                this.qi(e, this.model.br._inner[g].n, false);
            }
        }
        if (this.dy == 5 && a) {
            if (this.k3 == -1) {
                this.k3 = e;
            }
            if (this.k2 == -1) {
                this.k2 = d;
            }
            var j = new CellRange();
            j.l = Math.min(this.k3, e);
            j.k = Math.min(this.k2, h);
            j.j = Math.max(this.k3, e);
            j.i = Math.max(this.k2, h);
            this.t7(j);
        }
        else {
            this.k2 = -1;
            this.at = null;
        }
        return true;
    };
    Grid.prototype.ix = function (a, b) {
        if (this.cm == 0 || this.c1 == null) {
            return false;
        }
        var c = this.aj.s();
        var d = this.model.br._inner[c].n;
        var e = this.cz.b;
        var f = this.cz.d;
        var g = e;
        var h = f;
        var i = c;
        var j = 0;
        if (g >= 0 && g < this.ee.getRowCount()) {
            j = this.ee.getRowType(g);
        }
        var k = this.d3 != 1 && j == 1;
        var l = j != 1 && j != 2 && j != 4 && j != 5;
        var m = this.actualColumns._inner[c];
        var n = this.actualColumns._inner[c];
        if (a) {
            var o = void 0;
            var p = null;
            do {
                o = this.lr(d, false);
                p = this.actualColumns._inner[o];
                if (h == p.h6() || k) {
                    if (g > 0) {
                        g--;
                        j = this.ee.getRowType(g);
                        k = j == 1;
                        l = j != 1 && j != 2 && j != 4 && j != 5;
                        if (this.d3 != 1 && j == 1) {
                            o = this.li(true);
                        }
                        else {
                            o = this.lm(true);
                        }
                        p = this.actualColumns._inner[o];
                    }
                    else {
                        return false;
                    }
                }
                d = this.model.br._inner[o].n;
                h = p.h6();
            } while (this.cc.j && g >= 0 && (!l || !p.ge));
            if (this.d3 != 1) {
                if (j == 1 || j == 2) {
                    var q = this.lm();
                    var r = this.actualColumns._inner[q];
                    this.aj.aa(e, r.h6(), false);
                    h = null;
                }
            }
            i = o;
            n = p;
        }
        else {
            var s = void 0;
            var t = null;
            do {
                s = this.lq(d, false);
                t = this.actualColumns._inner[s];
                if (h == t.h6() || k) {
                    if (g < this.ee.getRowCount() - 1) {
                        s = this.li(true);
                        t = this.actualColumns._inner[s];
                        g++;
                        j = this.ee.getRowType(g);
                        k = j == 1;
                        l = j != 1 && j != 2 && j != 4 && j != 5;
                    }
                    else {
                        return false;
                    }
                }
                d = this.model.br._inner[s].n;
                h = t.h6();
            } while (this.cc.j && g < this.ee.getRowCount() - 1 && (!l || !t.ge));
            if (this.d3 != 1) {
                if (j == 1 || j == 2) {
                    var u = this.li();
                    var v = this.actualColumns._inner[u];
                    this.aj.aa(e, v.h6(), false);
                    h = null;
                }
            }
            i = s;
            n = t;
        }
        if (this.cc.j && (f != h || e != g)) {
            this.hk(true);
            if (!this.cc.j) {
                this.c1 = ((function () {
                    var $ret = new GridCellPosition();
                    $ret.b = g;
                    $ret.d = h;
                    return $ret;
                })());
                this.qi(g, this.model.br._inner[i].n, false);
                this.jg();
            }
        }
        else {
            this.c1 = ((function () {
                var $ret = new GridCellPosition();
                $ret.b = g;
                $ret.d = h;
                return $ret;
            })());
            if (n.fk == 1 && n.fk != m.fk) {
                var w = this.li();
                var x = this.model.br._inner[w].n;
                this.qi(g, x, false);
            }
            else if (n.fk == 2 && n.fk != m.fk) {
                var y = this.lm();
                var z = this.model.br._inner[y].n;
                this.qi(g, z, false);
            }
            else {
                this.qi(g, this.model.br._inner[i].n, false);
            }
        }
        return true;
    };
    Grid.prototype.te = function () {
    };
    Grid.prototype.iy = function (a, b) {
        if (this.cm == 0 || this.c1 == null) {
            return false;
        }
        var c = this.cz.b;
        var d = this.cz.d;
        if (c < 0) {
            return false;
        }
        var e = c - 1;
        if (b) {
            e = 0;
        }
        if (e < 0) {
            e = 0;
        }
        if (e == c) {
            return false;
        }
        var f = Math.min(this.aj.s(), this.actualColumns.count - 1);
        f = this.lg(f);
        var g = this.actualColumns._inner[f];
        if (d != g.h6()) {
            d = g.h6();
        }
        if (this.d3 != 1) {
            var h = this.ee.getRowType(e);
            if (h == 1 || h == 2) {
                d = null;
            }
        }
        this.c1 = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = e;
            $ret.d = d;
            return $ret;
        })());
        if (this.model.br.count > 0) {
            this.qi(e, this.model.br._inner[f].n, false);
        }
        if (this.dy == 2 && a) {
            if (this.k3 == -1) {
                this.k3 = c;
            }
            var i = Math.min(this.k3, e);
            var j = Math.max(this.k3, e);
            this.uc(i, j);
        }
        else if (this.dy == 5 && a) {
            if (this.k3 == -1) {
                this.k3 = c;
            }
            if (this.k2 == -1) {
                this.k2 = this.model.br._inner[f].n;
            }
            var k = new CellRange();
            k.l = Math.min(this.k3, e);
            k.k = Math.min(this.k2, this.model.br._inner[f].n);
            k.j = Math.max(this.k3, e);
            k.i = Math.max(this.k2, this.model.br._inner[f].n);
            this.t7(k);
        }
        else {
            this.k3 = -1;
            this.k2 = -1;
            this.at = null;
            this.jm.clear();
            this.jn.clear();
        }
        return true;
    };
    Grid.prototype.im = function (a, b) {
        if (this.cc.j) {
            if (this.hk(true)) {
                if (this.cg == 3) {
                    this.qx(true);
                }
                switch (this.ci) {
                    case 1:
                        this.ik(false, false);
                        break;
                    case 4:
                        this.ix(true, false);
                        break;
                    case 2:
                        this.ix(false, false);
                        break;
                    case 3:
                        this.iy(false, false);
                        break;
                }
            }
        }
        else {
            if (this.cm != 0 && this.c1 != null) {
                var c = this.ee.getRowType(this.c1.b);
                if (c == 1) {
                    this.uq(this.c1.b);
                }
                else if (this.h2() && this.ck == 1 && c == 0) {
                    var d = this.aj.s();
                    var e = this.actualColumns._inner[d];
                    if (e != null && e.ge) {
                        var f = this.model.d(d, this.c1.b);
                        return this.jb(f);
                    }
                }
                else {
                    switch (this.ck) {
                        case 2:
                            this.ik(false, false);
                            break;
                        case 5:
                            this.ix(true, false);
                            break;
                        case 3:
                            this.ix(false, false);
                            break;
                        case 4:
                            this.iy(false, false);
                            break;
                    }
                }
            }
        }
        return false;
    };
    Grid.prototype.io = function () {
        if (!this.cc.j) {
            this.hn = true;
            if (this.dy == 1 || this.dy == 2) {
                this.qu();
                this.jm.clear();
                this.jn.clear();
                this.k3 = -1;
                this.k2 = -1;
            }
            else if (this.dy == 3 || this.dy == 4) {
                if (this.ds.am.count > 0) {
                    var a = this.ij;
                    this.ij = true;
                    this.ds.clear();
                    this.ij = a;
                    this.e5.az();
                }
            }
            else if (this.dy == 5) {
                if (this.dp.count > 0) {
                    var b = this.ij;
                    this.ij = true;
                    this.dp.clear();
                    this.ij = b;
                    this.e5.ay();
                }
                this.at = null;
                this.k3 = -1;
                this.k2 = -1;
            }
            this.hn = false;
        }
        if (this.h2()) {
            if (this.cc.n != -1) {
                this.y.rejectPendingTransaction(this.cc.n);
            }
            this.hk(false);
            if (this.cg == 3) {
                this.qx(false);
            }
        }
        return false;
    };
    Grid.prototype.ip = function () {
        return this.jg();
    };
    Grid.prototype.iw = function (a, b) {
        if (this.cm == 1 && this.c1 != null) {
            if (this.dy == 1 || this.dy == 2) {
                var c = null;
                var d = this.ee.getRowType(this.c1.b);
                if (d == 0 || d == 5 || d == 4 || d == 3) {
                    var e = this.a3.g(this.c1.d);
                    var f = this.model.g(e.g6);
                    c = this.model.d(f.n, this.c1.b);
                }
                else if (d == 1 || d == 2) {
                    c = this.model.d(-400, this.c1.b);
                }
                if (c != null) {
                    this.e5.z(c, a, b, true);
                }
            }
        }
        return false;
    };
    Grid.prototype.jg = function () {
        if (this.cc.j) {
            this.hk(true);
            return true;
        }
        if (this.cm != 0 && this.c1 != null) {
            var a = this.ee.getRowType(this.c1.b);
            if (this.h2() && (a == 0 || a == 3)) {
                var b = this.aj.s();
                var c = this.actualColumns._inner[b];
                if (c != null && c.ge) {
                    var d = this.model.d(b, this.c1.b);
                    if (d == null) {
                        this.ar = new CellPath(1, b, 0, this.c1.b);
                    }
                    else {
                        this.jb(d);
                    }
                    return true;
                }
            }
        }
        return false;
    };
    Grid.prototype.jb = function (a) {
        if (!this.h2() || a == null || a.k.a0 < 0 || a.k.w < 0 || a.k.aw || a.cb > 0) {
            return false;
        }
        this.ar = null;
        this.cc.i(true, false);
        var b = false;
        if (this.cg == 3) {
            if (a.k.w != this.cc.m) {
                this.qx(true);
                b = true;
            }
        }
        var c = this.a1(a.k);
        if (!c.ge) {
            return false;
        }
        this.cc.aa(a);
        if (a.x == 0) {
            this.qi(a.k.w, a.k.a0, false);
        }
        this.ko = a.k.w;
        var d = this.actualColumns._inner[this.cc.o];
        var e = this.cc.m;
        var f = this.cc.q;
        if (b) {
            this.s1(e, f);
        }
        this.rs(d, e, f);
        return true;
    };
    Grid.prototype.hk = function (a, b) {
        if (b === void 0) {
            b = true;
        }
        if (this.cc.j) {
            var c = this.actualColumns._inner[this.cc.o];
            var d = this.cc.m;
            var e = this.cc.q;
            if (this.cc.i(a, b)) {
                this.rr(c, d, e);
                if (!this.hj) {
                    this.externalGrid.focusScroller();
                }
                return true;
            }
            return false;
        }
        return true;
    };
    Grid.prototype.qx = function (a) {
        if (this.cg != 3 || this.ko == -1) {
            return;
        }
        this.ko = -1;
        var b = this.cc.m;
        var c = this.cc.q;
        this.cc.s();
        this.s0(b, c);
        if (a) {
            if (this.hb) {
                if (this.he) {
                    this.qr();
                }
                else {
                    this.qj();
                }
            }
        }
        else {
            this.qj();
        }
    };
    Grid.prototype.r1 = function (a, b) {
        this.hn = true;
        if (!this.g9) {
            var c = this.ds.af(a, this.a3.f(b).h6());
        }
        if (this.selectedCellsChanged != null) {
            var d = new GridSelectedCellsChangedEventArgs();
            d.addedCells = new GridSelectedCellsCollection();
            d.addedCells.add(this.ds.ai(a, b));
            d.removedCells = new GridSelectedCellsCollection();
            d.currentCells = this.ds;
            this.selectedCellsChanged(this, d);
        }
        this.hn = false;
    };
    Grid.prototype.r2 = function (a, b) {
        this.hn = true;
        var c = this.ds.ai(a, b);
        if (c != null) {
            if (!this.g9) {
                this.ds.remove(c);
            }
            if (this.selectedCellsChanged != null) {
                var d = new GridSelectedCellsChangedEventArgs();
                d.addedCells = new GridSelectedCellsCollection();
                d.removedCells = new GridSelectedCellsCollection();
                d.removedCells.add(c);
                d.currentCells = this.ds;
                this.selectedCellsChanged(this, d);
            }
        }
        this.hn = false;
    };
    Grid.prototype.ut = function (a, b, c, d) {
        if (a.count == 0 && b.count == 0 && c.count == 0 && d.count == 0) {
            return;
        }
        var e = this.ij;
        this.ij = false;
        if (!this.g7) {
            if (a.count > 0) {
                this.ad.o(a);
                this.ah.o(b);
            }
            if (c.count > 0) {
                this.ah.af = true;
                this.ad.af = true;
                for (var f = c.count - 1; f >= 0; f--) {
                    var g = this.ah.ai(d._inner[f]);
                    if (g >= 0) {
                        this.ad.removeAt(g);
                        this.ah.removeAt(g);
                    }
                }
                this.ad.af = false;
                this.ah.af = false;
            }
        }
        this.ij = e;
        this.s6(c, a);
        this.s9(d, b);
    };
    Grid.prototype.qf = function (a, b) {
        var c = this.ij;
        this.ij = false;
        if (!this.g7) {
            this.ad.o(a);
            this.ah.o(b);
        }
        this.ij = c;
        this.s6(null, a);
        this.s9(null, b);
    };
    Grid.prototype.qg = function (a, b) {
        var c = this.ij;
        this.ij = false;
        if (!this.g7) {
            this.ad.add1(a);
            this.ah.add(b);
        }
        this.ij = c;
        this.s7(null, a);
        this.s8(null, b);
    };
    Grid.prototype.us = function (a, b, c) {
        var d = this.ij;
        this.ij = false;
        var e = this.ad.ae._inner[a];
        if (!this.g7) {
            this.ad.ae._inner[a] = b;
        }
        this.ij = d;
        this.s7(b, b);
    };
    Grid.prototype.tv = function (a, b) {
        var c = this.ij;
        this.ij = false;
        if (!this.g7) {
            for (var d = 0; d < a.count; d++) {
                this.ad.remove1(a._inner[d]);
                this.ah.remove(b._inner[d]);
            }
        }
        this.ij = c;
        this.s6(a, null);
        this.s9(b, null);
    };
    Grid.prototype.tw = function (a, b) {
        var c = this.ij;
        this.ij = false;
        if (!this.g7) {
            this.ad.remove1(a);
            this.ah.remove(b);
        }
        this.ij = c;
        this.s7(a, null);
        this.s8(b, null);
    };
    Grid.prototype.s7 = function (a, b) {
        if (!this.jf && this.selectedItemsChanged != null) {
            var c = new GridSelectedItemsChangedEventArgs();
            c.currentItems = this.ad;
            if (a != null) {
                var d = new GridSelectedItemsCollection();
                d.add1(a);
                c.removedItems = d;
            }
            if (b != null) {
                var e = new GridSelectedItemsCollection();
                e.add1(b);
                c.addedItems = e;
            }
            this.selectedItemsChanged(this, c);
        }
    };
    Grid.prototype.s8 = function (a, b) {
        if (!this.jf && this.selectedKeysChanged != null) {
            var c = new GridSelectedKeysChangedEventArgs();
            c.currentKeys = this.ah;
            if (a != null) {
                c.removedKeys = new GridSelectedKeysCollection();
                c.removedKeys.add(a);
            }
            if (b != null) {
                c.addedKeys = new GridSelectedKeysCollection();
                c.addedKeys.add(b);
            }
            this.selectedKeysChanged(this, c);
        }
    };
    Grid.prototype.s6 = function (a, b) {
        if (!this.jf && this.selectedItemsChanged != null) {
            var c = new GridSelectedItemsChangedEventArgs();
            c.currentItems = this.ad;
            if (a != null) {
                c.removedItems = new GridSelectedItemsCollection();
                c.removedItems.o(a);
            }
            if (b != null) {
                c.addedItems = new GridSelectedItemsCollection();
                c.addedItems.o(b);
            }
            this.selectedItemsChanged(this, c);
        }
    };
    Grid.prototype.s9 = function (a, b) {
        if (!this.jf && this.selectedKeysChanged != null) {
            var c = new GridSelectedKeysChangedEventArgs();
            c.currentKeys = this.ah;
            if (a != null) {
                c.removedKeys = new GridSelectedKeysCollection();
                c.removedKeys.o(a);
            }
            if (b != null) {
                c.addedKeys = new GridSelectedKeysCollection();
                c.addedKeys.o(b);
            }
            this.selectedKeysChanged(this, c);
        }
    };
    Grid.prototype.qe = function (a, b, c, d) {
        var e = new CellRange();
        e.k = a;
        e.i = b;
        e.l = c;
        e.j = d;
        this.qd(e);
    };
    Grid.prototype.qd = function (a) {
        this.dp.add(a);
        this.au = a;
        if (this.selectedCellRangesChanged != null) {
            var b = new GridSelectedCellRangesChangedEventArgs();
            b.addedRanges = ((function () {
                var $ret = new GridSelectedCellRangesCollection();
                $ret.add(a);
                return $ret;
            })());
            b.currentRanges = this.dp;
            this.selectedCellRangesChanged(this, b);
        }
    };
    Grid.prototype.ts = function (a) {
        if (this.dp.contains(a)) {
            this.dp.remove(a);
            if (this.selectedCellRangesChanged != null) {
                var b = new GridSelectedCellRangesChangedEventArgs();
                b.removedRanges = ((function () {
                    var $ret = new GridSelectedCellRangesCollection();
                    $ret.add(a);
                    return $ret;
                })());
                b.currentRanges = this.dp;
                this.selectedCellRangesChanged(this, b);
            }
        }
    };
    Grid.prototype.tr = function () {
        if (this.dp.count > 0) {
            var a = new GridSelectedCellRangesCollection();
            for (var b = 0; b < this.dp.count; b++) {
                a.add(this.dp._inner[b]);
            }
            this.dp.clear();
            if (this.selectedCellRangesChanged != null) {
                var c = new GridSelectedCellRangesChangedEventArgs();
                c.removedRanges = a;
                c.currentRanges = this.dp;
                this.selectedCellRangesChanged(this, c);
            }
        }
    };
    Grid.prototype.rf = function (a) {
        if (this.dp.contains(a)) {
            if (this.selectedCellRangesChanged != null) {
                var b = new GridSelectedCellRangesChangedEventArgs();
                b.updatedRanges = ((function () {
                    var $ret = new GridSelectedCellRangesCollection();
                    $ret.add(a);
                    return $ret;
                })());
                b.currentRanges = this.dp;
                this.selectedCellRangesChanged(this, b);
            }
        }
    };
    Grid.prototype.tb = function (a, b, c) {
        this.q8(a);
        if (b != c) {
            this.e5.aj(a);
            this.aj.aj(a);
        }
    };
    Grid.prototype.q8 = function (a) {
        this.cp.al(this, a, a);
    };
    Grid.prototype.r3 = function () {
        if (this.cc.j) {
            this.hk(false);
            this.ko = -1;
        }
        this.e5.ad();
        this.tn();
        this.rb();
    };
    Grid.prototype.rb = function () {
        if (!this.i5()) {
            return;
        }
        var a = this.ll();
        var b = this.lp();
        this.q9(a, b);
    };
    Grid.prototype.q9 = function (a, b) {
        var c = this.ll();
        var d = this.lp();
        if (b < c || a > d) {
            return;
        }
        if (a < c) {
            a = c;
        }
        if (b > d) {
            b = d;
        }
        this.cp.y(this, a, b, true);
        this.model.bn = true;
        this.to();
    };
    Grid.prototype.lk = function () {
        return this.fb.o(this.model.actualVisibleRegion.left + this.model.cf, this, this.model);
    };
    Grid.prototype.lo = function () {
        return this.fb.o(this.model.actualVisibleRegion.right - this.model.cg, this, this.model);
    };
    Grid.prototype.ra = function (a, b) {
        var c = this.fb.i(this.model, a);
        var d = this.fb.i(this.model, b);
        this.q9(c, d);
    };
    Grid.prototype.tj = function () {
        var _this = this;
        if (!this.gh) {
            this.gh = true;
            this.fh.v();
            this.renderingEngine.invalidateVisibility(function () { return _this.fh.l(_this); });
            this.renderingEngine.refresh(this.model, false);
        }
    };
    Grid.prototype.st = function (a, b) {
        var c = this.ee.getRowPathForRow(a);
        this.de.ae(c);
        this.e5.ah(this.fb.i(this.model, c));
        this.aj.ah(this.fb.i(this.model, c));
        this.tj();
    };
    Grid.prototype.sy = function (a, b) {
        var c = this.ee.getRowPathForRow(a);
        this.de.af(c);
        this.e5.ai(this.fb.i(this.model, c));
        this.aj.ai(this.fb.i(this.model, c));
        if (this.dy == 1 || this.dy == 2) {
            if (this.e != null) {
                var d = this.ee.getItemKey(this.e, b);
                for (var e = 0; e < this.ah.count; e++) {
                    if (this.ah._inner[e].equals(d)) {
                        this.ah.removeAt(e);
                        e--;
                    }
                }
            }
            else {
                for (var f = 0; f < this.ad.count; f++) {
                    if (this.ad._inner[f] == b) {
                        this.ad.removeAt(f);
                        f--;
                    }
                }
            }
        }
        else if (this.dy == 3 || this.dy == 4) {
            var g = this.ee.getItemKey(this.e, b);
            for (var h = 0; h < this.ds.count; h++) {
                if (this.ds._inner[h].primaryKey.equals(g)) {
                    this.ds.removeAt(h);
                    h--;
                }
            }
        }
        this.tj();
    };
    Grid.prototype.ud = function (a) {
        for (var b = 0; b < this.ep.g.count; b++) {
            if (this.ep.g._inner[b].n == a) {
                this.ue(this.ep.g._inner[b]);
            }
        }
    };
    Grid.prototype.ue = function (a) {
        this.ep.x(a);
    };
    Grid.prototype.rm = function (a, b, c) {
        if (this.w != null) {
            this.w.notifySetItem(a, b, c);
        }
    };
    Grid.prototype.rg = function () {
        if (this.w != null) {
            this.w.notifyClearItems();
        }
    };
    Grid.prototype.ri = function (a, b) {
        if (this.w != null) {
            this.w.notifyInsertItem(a, b);
        }
        ;
    };
    Grid.prototype.rj = function (a, b) {
        if (this.w != null) {
            this.w.notifyRemoveItem(a, b);
        }
        ;
    };
    Grid.prototype.le = function (a) {
        if (this.w == null) {
            return -1;
        }
        return this.w.indexOfItem(a);
    };
    Grid.prototype.lf = function (a) {
        if (this.w == null) {
            return -1;
        }
        return this.w.indexOfKey(a);
    };
    Grid.prototype.i = function () {
        if (this.actualDataSource != null) {
            return this.actualDataSource.actualPrimaryKey;
        }
        return this.e;
    };
    Grid.prototype.mf = function (a) {
        var b = a.b != null ? a.b : this.a3.g(a.j);
        var c = null;
        if (a.h != null) {
            c = a.h;
        }
        else if (a.primaryKey != null) {
            if (this.i() == null && a.primaryKey.key == null && a.primaryKey.value.length == 1) {
                c = a.primaryKey.value[0];
            }
            else {
                c = this.ee.getItemForKey(a.primaryKey);
            }
        }
        if (b != null && c != null) {
            return this.actualDataSource.getItemProperty(c, b.h4);
        }
        return null;
    };
    Grid.prototype.mg = function (a, b) {
        if (b < 0 || b > this.a3.j.count) {
            return null;
        }
        if (a < 0 || a > this.ee.getRowCount() - 1) {
            return null;
        }
        var c = this.actualDataSource.getItemAtIndex(a);
        if (c == null) {
            return null;
        }
        else {
            var d = this.ee.getRowType(a);
            if (d != 0 && d != 3) {
                return null;
            }
        }
        var e = this.fb.j(b, this.model);
        var f = this.a3.j._inner[e];
        return this.actualDataSource.getItemProperty(c, f.h4);
    };
    Grid.prototype.a0 = function (a) {
        var b = this.fb.j(a, this.model);
        if (b >= 0 && b < this.a3.j.count) {
            return this.a3.j._inner[b];
        }
        return null;
    };
    Grid.prototype.j = function () {
        if (this.actualDataSource != null) {
            return this.actualDataSource.getRootSummaryResults();
        }
        return null;
    };
    Grid.prototype.k = function (a) {
        if (this.actualDataSource != null) {
            return this.actualDataSource.getSectionSummaryResults(a);
        }
        return null;
    };
    Object.defineProperty(Grid.prototype, "i1", {
        get: function () {
            return this.g1;
        },
        set: function (a) {
            var b = this.g1;
            this.g1 = a;
            if (b != this.g1) {
                this.sx("ReactsToSortChanges", b, this.g1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "i0", {
        get: function () {
            return this.g0;
        },
        set: function (a) {
            var b = this.g0;
            this.g0 = a;
            if (b != this.g0) {
                this.sx("ReactsToGroupChanges", b, this.g0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "iz", {
        get: function () {
            return this.gz;
        },
        set: function (a) {
            var b = this.gz;
            this.gz = a;
            if (b != this.gz) {
                this.sx("ReactsToFilterChanges", b, this.gz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.z = function (a) {
        var b = null;
        for (var c = 0; c < this.a3.j.count; c++) {
            var d = this.a3.j._inner[c];
            if (d != a && d.eo != null) {
                var e = this.actualDataSource.resolveSchemaPropertyType(d.h4);
                var f = d.eo.a(d.h4, e);
                if (b != null) {
                    b = FilterFactory.instance.and(b, f);
                }
                else {
                    b = f;
                }
            }
        }
        return b;
    };
    Grid.prototype.jh = function (a, b, c, d, e) {
        if (this.actualDataSource != null && b >= 0 && b < this.actualColumns.count) {
            var f_2 = this.actualColumns._inner[b];
            var g = this.actualDataSource.resolveSchemaPropertyType(f_2.h4);
            var h_1 = null;
            try {
                h_1 = this.mb(g, e);
            }
            catch (i) {
                this.cc.x(i.message);
                return false;
            }
            if (h_1 == null && d != null || h_1 != null && d == null || !Base.equalsStatic(h_1, d)) {
                if (this.cc.n != -1) {
                    this.y.rejectPendingTransaction(this.cc.n);
                }
                this.cc.x(null);
                var j = this.ee.getItemKey(this.e, c);
                var k_3 = this.y.updatePropertyAtKey(j.value, f_2.h4, h_1, true);
                this.gy = true;
                if (this.cellValueChanging != null) {
                    var l = ((function () {
                        var $ret = new GridCellValueChangingEventArgs();
                        $ret.c = k_3;
                        $ret.cellInfo = a;
                        $ret.b = f_2;
                        $ret.item = c;
                        $ret.f = d;
                        $ret.e = h_1;
                        return $ret;
                    })());
                    this.cellValueChanging(this, l);
                    var m = this.y.getTransactionErrorByID(k_3);
                    if (m != null) {
                        this.cc.x(m);
                        if (a != null) {
                            a.en = k_3;
                        }
                        return false;
                    }
                    var n = this.y.isPendingTransaction(k_3);
                    if (n && this.hb) {
                        this.qb(k_3);
                        this.uu(f_2, j, h_1);
                    }
                }
                else {
                    this.qb(k_3);
                    this.uu(f_2, j, h_1);
                }
                this.gy = false;
            }
            else {
                if (this.cc.n != -1) {
                    var o = this.y.getTransactionErrorByID(this.cc.n);
                    if (o != null) {
                        this.cc.x(o);
                        return false;
                    }
                }
            }
        }
        return true;
    };
    Grid.prototype.uu = function (a, b, c) {
        if (this.e != null) {
            var d = false;
            var e = -1;
            for (var f = 0; f < this.e.length; f++) {
                if (a.h4 == this.e[f]) {
                    d = true;
                    e = f;
                    break;
                }
            }
            if (d) {
                if (this.dy == 1 || this.dy == 2) {
                    var g = this.ah.ae.indexOf(b);
                    if (g > -1) {
                        b.value[e] = c;
                        this.ah.ae.item(g, b);
                        var h = this.g7;
                        this.g7 = true;
                        this.e5.a0();
                        this.g7 = h;
                    }
                }
                else if (this.dy == 3 || this.dy == 4) {
                    var i = -1;
                    for (var j = 0; j < this.ds.am.count; j++) {
                        if (this.ds._inner[j].primaryKey.equals(b)) {
                            i = j;
                            break;
                        }
                    }
                    if (i > -1) {
                        b.value[e] = c;
                        this.ds._inner[i].primaryKey = b;
                        var k = this.g7;
                        this.g7 = true;
                        this.e5.az();
                        this.g7 = k;
                    }
                }
            }
        }
    };
    Grid.prototype.mb = function (a, b) {
        if (b == null) {
            return null;
        }
        switch (a) {
            case 2: return Convert.toBoolean(b);
            case 10: return Convert.toByte1(b);
            case 8: return Convert.toDateTime(b);
            case 6: return Convert.toDecimal2(b);
            case 5: return Convert.toDouble3(b);
            case 1: return Convert.toInt321(b);
            case 3: return Convert.toInt64(b);
            case 11: return b;
            case 0: return b.toString();
        }
        return b;
    };
    Grid.prototype.sg = function (a, b, c) {
        if (this.columnWidthChanged != null) {
            var d = ((function () {
                var $ret = new GridColumnWidthChangedEventArgs();
                $ret.a = a;
                $ret.c = b;
                $ret.b = c;
                return $ret;
            })());
            this.columnWidthChanged(a.externalObject, d);
        }
    };
    Grid.prototype.rs = function (a, b, c) {
        if (this.cellEditStarted != null) {
            this.cellEditStarted(this, ((function () {
                var $ret = new GridCellEditStartedEventArgs();
                $ret.a = a;
                $ret.b = b;
                $ret.item = c;
                return $ret;
            })()));
        }
    };
    Grid.prototype.rr = function (a, b, c) {
        if (this.cellEditEnded != null) {
            this.cellEditEnded(this, ((function () {
                var $ret = new GridCellEditEndedEventArgs();
                $ret.a = a;
                $ret.b = b;
                $ret.item = c;
                return $ret;
            })()));
        }
    };
    Grid.prototype.s1 = function (a, b) {
        if (this.rowEditStarted != null) {
            this.rowEditStarted(this, ((function () {
                var $ret = new GridRowEditStartedEventArgs();
                $ret.a = a;
                $ret.item = b;
                return $ret;
            })()));
        }
    };
    Grid.prototype.s0 = function (a, b) {
        if (this.rowEditEnded != null) {
            this.rowEditEnded(this, ((function () {
                var $ret = new GridRowEditEndedEventArgs();
                $ret.a = a;
                $ret.item = b;
                return $ret;
            })()));
        }
    };
    Grid.prototype.h2 = function () {
        return this.y != null && !this.y.isReadOnly && this.cg != 0;
    };
    Object.defineProperty(Grid.prototype, "hi", {
        get: function () {
            if (this.y != null) {
                return this.y.canUndo;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hh", {
        get: function () {
            if (this.y != null) {
                return this.y.canRedo;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "he", {
        get: function () {
            if (this.y != null) {
                return this.y.canCommit;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.qr = function () {
        if (this.h2() && this.he) {
            if (this.cc.j && this.cc.n != -1) {
                this.hk(false);
            }
            var a = this.y.commitEdits(true);
            if (a != -1) {
                var b = this.y.getAggregatedChanges(a);
                if (this.dataCommitting != null) {
                    var c = new GridDataCommittingEventArgs(a, b);
                    this.dataCommitting(this, c);
                    if (this.y.isPendingCommit(a) && this.hb) {
                        this.qa(a);
                    }
                }
                else {
                    this.qa(a);
                }
            }
        }
    };
    Grid.prototype.qj = function () {
        if (this.h2()) {
            this.y.cancelEdits();
        }
    };
    Grid.prototype.qa = function (a) {
        if (this.h2()) {
            this.y.acceptPendingCommit(a);
        }
    };
    Grid.prototype.tp = function (a) {
        if (this.h2()) {
            this.y.rejectPendingCommit(a);
        }
    };
    Grid.prototype.um = function () {
        if (this.h2()) {
            this.y.undo();
        }
    };
    Grid.prototype.tl = function () {
        if (this.h2()) {
            this.y.redo();
        }
    };
    Grid.prototype.ur = function (a, b, c) {
        if (this.h2()) {
            this.y.updatePropertyAtKey(a, b, c, false);
            if (this.cg != 2) {
                this.qr();
            }
        }
    };
    Grid.prototype.tu = function (a) {
        if (this.h2()) {
            this.y.removeItemByKey(a);
            if (this.cg != 2) {
                this.qr();
            }
        }
    };
    Grid.prototype.tt = function (a) {
        if (this.h2()) {
            this.y.removeItem(a);
            if (this.cg != 2) {
                this.qr();
            }
        }
    };
    Grid.prototype.qb = function (a) {
        if (this.h2()) {
            this.y.acceptPendingTransaction(a);
            if (!this.y.isBatchingEnabled) {
                this.qr();
            }
        }
    };
    Grid.prototype.tq = function (a) {
        if (this.h2()) {
            this.y.rejectPendingTransaction(a);
        }
    };
    Grid.prototype.uf = function (a, b) {
        if (this.h2()) {
            this.y.setTransactionError(a, b);
        }
    };
    Grid.prototype.ui = function () {
        if (this.cm != 1 || this.c1 == null) {
            return;
        }
        var a = this.a3.g(this.c1.d);
        if (a.ge) {
            var b = this.model.g(a.g6);
            var c = this.model.d(b.n, this.c1.b);
            if (c != null) {
                if (this.jb(c)) {
                    this.cc.t();
                }
            }
        }
    };
    Grid.prototype.qw = function (a) {
        this.hk(a);
    };
    Object.defineProperty(Grid.prototype, "ck", {
        get: function () {
            return this.cj;
        },
        set: function (a) {
            var b = this.cj;
            this.cj = a;
            if (b != this.cj) {
                this.sx("EnterBehavior", enumGetBox(EnterKeyBehaviors_$type, b), enumGetBox(EnterKeyBehaviors_$type, this.cj));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ci", {
        get: function () {
            return this.ch;
        },
        set: function (a) {
            var b = this.ch;
            this.ch = a;
            if (b != this.ch) {
                this.sx("EnterBehaviorAfterEdit", enumGetBox(EnterKeyBehaviorAfterEdit_$type, b), enumGetBox(EnterKeyBehaviorAfterEdit_$type, this.ch));
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.t6 = function () {
        if (this.dy == 2) {
            this.e5.ak();
        }
    };
    Grid.prototype.qu = function () {
        if (this.dy == 1 || this.dy == 2) {
            if (this.ad.ae.count > 0) {
                var a = new List$1(Base.$, 0);
                var b = new List$1(PrimaryKeyValue.$, 0);
                for (var c = 0; c < this.ad.ae.count; c++) {
                    a.add1(this.ad.ae._inner[c]);
                    b.add(this.ah.ae._inner[c]);
                }
                this.hn = true;
                this.ad.clear();
                this.ah.clear();
                this.jf = true;
                this.e5.a0();
                this.jf = false;
                this.hn = false;
                this.s6(a, null);
                this.s9(b, null);
            }
        }
    };
    Grid.prototype.ir = function (a, b, c) {
        switch (a) {
            case 30:
                if (c) {
                    this.t6();
                    return true;
                }
                break;
        }
        return false;
    };
    Grid.prototype.ja = function () {
        if (!this.hj) {
            return false;
        }
        var a = this.aj.s();
        var b = this.actualColumns._inner[a];
        if (typeCast(TemplateColumn.$, b) !== null) {
            return false;
        }
        if (this.aq != null && this.aq.a0 >= 0 && this.aq.a0 < this.actualColumns.count) {
            b = this.actualColumns._inner[this.aq.a0];
            if (typeCast(TemplateColumn.$, b) !== null) {
                return false;
            }
        }
        return this.hj;
    };
    Object.defineProperty(Grid.prototype, "hy", {
        get: function () {
            return this.gk;
        },
        set: function (a) {
            var b = this.gk;
            this.gk = a;
            if (b != this.gk) {
                this.sx("IsColumnOptionsSummariesEnabled", b, this.gk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.$t = markType(Grid, 'Grid', Base.$, [INotifyPropertyChanged_$type]);
    return Grid;
}(Base));
export { Grid };
/**
 * @hidden
 */
var GridColumnsAutoGeneratedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridColumnsAutoGeneratedEventArgs, _super);
    function GridColumnsAutoGeneratedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = null;
        return _this;
    }
    Object.defineProperty(GridColumnsAutoGeneratedEventArgs.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (a) {
            this._columns = a;
        },
        enumerable: true,
        configurable: true
    });
    GridColumnsAutoGeneratedEventArgs.$t = markType(GridColumnsAutoGeneratedEventArgs, 'GridColumnsAutoGeneratedEventArgs', EventArgs.$);
    return GridColumnsAutoGeneratedEventArgs;
}(EventArgs));
export { GridColumnsAutoGeneratedEventArgs };
/**
 * @hidden
 */
var GridColumnsChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridColumnsChangedEventArgs, _super);
    function GridColumnsChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = null;
        return _this;
    }
    Object.defineProperty(GridColumnsChangedEventArgs.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (a) {
            this._columns = a;
        },
        enumerable: true,
        configurable: true
    });
    GridColumnsChangedEventArgs.$t = markType(GridColumnsChangedEventArgs, 'GridColumnsChangedEventArgs', EventArgs.$);
    return GridColumnsChangedEventArgs;
}(EventArgs));
export { GridColumnsChangedEventArgs };
/**
 * @hidden
 */
var GridSelectedCellsChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridSelectedCellsChangedEventArgs, _super);
    function GridSelectedCellsChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._currentCells = null;
        _this._addedCells = null;
        _this._removedCells = null;
        return _this;
    }
    Object.defineProperty(GridSelectedCellsChangedEventArgs.prototype, "currentCells", {
        get: function () {
            return this._currentCells;
        },
        set: function (a) {
            this._currentCells = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridSelectedCellsChangedEventArgs.prototype, "addedCells", {
        get: function () {
            return this._addedCells;
        },
        set: function (a) {
            this._addedCells = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridSelectedCellsChangedEventArgs.prototype, "removedCells", {
        get: function () {
            return this._removedCells;
        },
        set: function (a) {
            this._removedCells = a;
        },
        enumerable: true,
        configurable: true
    });
    GridSelectedCellsChangedEventArgs.$t = markType(GridSelectedCellsChangedEventArgs, 'GridSelectedCellsChangedEventArgs', EventArgs.$);
    return GridSelectedCellsChangedEventArgs;
}(EventArgs));
export { GridSelectedCellsChangedEventArgs };
/**
 * @hidden
 */
var GridCellEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridCellEventArgs, _super);
    function GridCellEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._cellInfo = null;
        _this._grid = null;
        _this._button = 0;
        _this._isDoubleClick = false;
        return _this;
    }
    Object.defineProperty(GridCellEventArgs.prototype, "cellInfo", {
        get: function () {
            return this._cellInfo;
        },
        set: function (a) {
            this._cellInfo = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridCellEventArgs.prototype, "grid", {
        get: function () {
            return this._grid;
        },
        set: function (a) {
            this._grid = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridCellEventArgs.prototype, "button", {
        get: function () {
            return this._button;
        },
        set: function (a) {
            this._button = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridCellEventArgs.prototype, "isDoubleClick", {
        get: function () {
            return this._isDoubleClick;
        },
        set: function (a) {
            this._isDoubleClick = a;
        },
        enumerable: true,
        configurable: true
    });
    GridCellEventArgs.$t = markType(GridCellEventArgs, 'GridCellEventArgs', EventArgs.$);
    return GridCellEventArgs;
}(EventArgs));
export { GridCellEventArgs };
/**
 * @hidden
 */
var ColumnHiddenChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnHiddenChangedEventArgs, _super);
    function ColumnHiddenChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.b = false;
        return _this;
    }
    ColumnHiddenChangedEventArgs.$t = markType(ColumnHiddenChangedEventArgs, 'ColumnHiddenChangedEventArgs');
    return ColumnHiddenChangedEventArgs;
}(Base));
export { ColumnHiddenChangedEventArgs };
/**
 * @hidden
 */
var ColumnPinnedChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnPinnedChangedEventArgs, _super);
    function ColumnPinnedChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.b = 0;
        return _this;
    }
    ColumnPinnedChangedEventArgs.$t = markType(ColumnPinnedChangedEventArgs, 'ColumnPinnedChangedEventArgs');
    return ColumnPinnedChangedEventArgs;
}(Base));
export { ColumnPinnedChangedEventArgs };
/**
 * @hidden
 */
var GridCellValueChangingEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridCellValueChangingEventArgs, _super);
    function GridCellValueChangingEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.c = 0;
        _this._cellInfo = null;
        _this.b = null;
        _this._item = null;
        _this.f = null;
        _this.e = null;
        return _this;
    }
    Object.defineProperty(GridCellValueChangingEventArgs.prototype, "cellInfo", {
        get: function () {
            return this._cellInfo;
        },
        set: function (a) {
            this._cellInfo = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridCellValueChangingEventArgs.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (a) {
            this._item = a;
        },
        enumerable: true,
        configurable: true
    });
    GridCellValueChangingEventArgs.$t = markType(GridCellValueChangingEventArgs, 'GridCellValueChangingEventArgs');
    return GridCellValueChangingEventArgs;
}(Base));
export { GridCellValueChangingEventArgs };
/**
 * @hidden
 */
var GridColumnWidthChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridColumnWidthChangedEventArgs, _super);
    function GridColumnWidthChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.c = null;
        _this.b = null;
        return _this;
    }
    GridColumnWidthChangedEventArgs.$t = markType(GridColumnWidthChangedEventArgs, 'GridColumnWidthChangedEventArgs');
    return GridColumnWidthChangedEventArgs;
}(Base));
export { GridColumnWidthChangedEventArgs };
/**
 * @hidden
 */
var GridCellEditStartedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridCellEditStartedEventArgs, _super);
    function GridCellEditStartedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.b = 0;
        _this._item = null;
        return _this;
    }
    Object.defineProperty(GridCellEditStartedEventArgs.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (a) {
            this._item = a;
        },
        enumerable: true,
        configurable: true
    });
    GridCellEditStartedEventArgs.$t = markType(GridCellEditStartedEventArgs, 'GridCellEditStartedEventArgs');
    return GridCellEditStartedEventArgs;
}(Base));
export { GridCellEditStartedEventArgs };
/**
 * @hidden
 */
var GridCellEditEndedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridCellEditEndedEventArgs, _super);
    function GridCellEditEndedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.b = 0;
        _this._item = null;
        return _this;
    }
    Object.defineProperty(GridCellEditEndedEventArgs.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (a) {
            this._item = a;
        },
        enumerable: true,
        configurable: true
    });
    GridCellEditEndedEventArgs.$t = markType(GridCellEditEndedEventArgs, 'GridCellEditEndedEventArgs');
    return GridCellEditEndedEventArgs;
}(Base));
export { GridCellEditEndedEventArgs };
/**
 * @hidden
 */
var GridAnimationManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridAnimationManager, _super);
    function GridAnimationManager() {
        var _this = _super.call(this) || this;
        _this.l = new List$1(Number_$type, 0);
        _this.i = false;
        _this.animationCreated = null;
        _this.animationCompleted = null;
        _this.animationCanceled = null;
        _this.g = new GridColumnAnimationSettings();
        _this.f = new GridAnimationSettings();
        _this.k = new Dictionary$2(Number_$type, List$1.$.specialize(Delegate_$type), 0);
        _this.e = null;
        _this.d = null;
        _this.e = new GridAnimationPhaseSettings();
        _this.e.l = 0;
        _this.e.e = true;
        _this.e.n = 0;
        _this.d = new GridAnimationPhaseSettings();
        _this.d.l = 0;
        _this.d.e = true;
        _this.d.n = 0;
        return _this;
    }
    Object.defineProperty(GridAnimationManager.prototype, "h", {
        get: function () {
            return this.g;
        },
        enumerable: true,
        configurable: true
    });
    GridAnimationManager.prototype.p = function () {
        var a = GridAnimationManager.o;
        GridAnimationManager.o++;
        return a;
    };
    GridAnimationManager.prototype.ar = function () {
        this.i = true;
        this.l = new List$1(Number_$type, 0);
    };
    GridAnimationManager.prototype.m = function () {
        this.i = false;
        return this.l;
    };
    GridAnimationManager.prototype.w = function (a) {
        if (this.i) {
            this.l.add(a);
        }
        if (this.animationCreated != null) {
            this.animationCreated(this, ((function () {
                var $ret = new GridAnimationManagerAnimationCreatedEventArgs();
                $ret.a = a;
                return $ret;
            })()));
        }
    };
    GridAnimationManager.prototype.u = function (a) {
        if (this.i) {
            this.l.remove(a);
        }
        if (this.animationCanceled != null) {
            this.animationCanceled(this, ((function () {
                var $ret = new GridAnimationManagerAnimationCanceledEventArgs();
                $ret.a = a;
                return $ret;
            })()));
        }
    };
    GridAnimationManager.prototype.v = function (a) {
        if (this.i) {
            this.l.remove(a);
        }
        if (this.animationCompleted != null) {
            this.animationCompleted(this, ((function () {
                var $ret = new GridAnimationManagerAnimationCompletedEventArgs();
                $ret.a = a;
                return $ret;
            })()));
        }
    };
    GridAnimationManager.prototype.aq = function (a, b, c, d, e) {
        var _this = this;
        if (c == null) {
            return;
        }
        var f = this.p();
        this.w(f);
        var g;
        var h;
        var i = a.a3.f(c.o);
        if (i == null) {
            return;
        }
        var j = new GridEffectGroup(1);
        j.effectsFinished = delegateCombine(j.effectsFinished, function (k, l) {
            i.e8 = 5;
            c.a = 5;
            a.model.bk = false;
            a.tn();
            a.se(i);
            _this.v(f);
        });
        j.effectsCanceled = delegateCombine(j.effectsCanceled, function (k, l) {
            a.model.bk = false;
            a.sd(i);
            _this.u(f);
        });
        if (d) {
            if (i.fe != null && i.fe.n != null) {
                g = i.fe.n;
            }
            else if (b != null && b.n != null) {
                g = b.n;
            }
            else {
                g = this.g.n;
            }
            if (i.fe != null && i.fe.m != null) {
                h = i.fe.m;
            }
            else if (b != null && b.m != null) {
                h = b.m;
            }
            else {
                h = this.g.m;
            }
        }
        else {
            if (i.fe != null && i.fe.x != null) {
                g = i.fe.x;
            }
            else if (b != null && b.x != null) {
                g = b.x;
            }
            else {
                g = this.g.x;
            }
            if (i.fe != null && i.fe.w != null) {
                h = i.fe.w;
            }
            else if (b != null && b.w != null) {
                h = b.w;
            }
            else {
                h = this.g.w;
            }
        }
        var k = a.b0;
        if (!d) {
            k = a.b1;
        }
        if (k == 0) {
            k = i.e4();
        }
        if (e == 3 || e == 0) {
            switch (k) {
                case 2:
                case 4:
                case 5:
                case 7:
                case 9:
                case 10:
                case 6:
                    c.h = -1;
                    break;
                case 3:
                case 8:
                    c.h = 1;
                    break;
            }
        }
        a.model.bk = true;
        var l = new ColumnEffect();
        l.bx(g);
        l.al = true;
        l.bq = 0;
        l.x = function (m, n, o, p, q) {
            var r = o;
            var s = n;
            var t = p;
            t.h = s + (r - s) * m;
        };
        l.o = function (m, n) { return c.h; };
        j.g(l);
        a.de.u(c, l);
        var m = new ColumnCellsEffect();
        m.t = 1;
        m.bx(h);
        m.al = true;
        m.bq = 0;
        m.x = function (n, o, p, q, r) {
            var s = p;
            var t = o;
            var u = q;
            switch (k) {
                case 6:
                case 2:
                case 3:
                case 7:
                case 8:
                    u.b5 = t + (s - t) * n;
                    break;
                case 4:
                case 5:
                case 9:
                case 10:
                    u.b9 = t + (s - t) * n;
                    break;
            }
        };
        m.o = function (n, o) {
            var p = n;
            var q = p.b5;
            if (k == 4 || k == 5 || k == 9 || k == 10) {
                q = p.b9;
            }
            if (e == 0 || e == 3) {
                switch (k) {
                    case 6:
                        q = 0;
                        p.b5 = q;
                        p.ca = q;
                        p.b4 = 0;
                        p.b9 = 0;
                        break;
                    case 2:
                    case 7:
                        q = -1;
                        p.b5 = q;
                        p.b4 = 0;
                        p.ca = 0;
                        p.b9 = 0;
                        break;
                    case 3:
                    case 8:
                        q = 1;
                        p.b5 = q;
                        p.b4 = 0;
                        p.ca = 0;
                        p.b9 = 0;
                        break;
                    case 4:
                    case 9:
                        q = (a.j6 + a.model.ci) * -1;
                        p.b9 = q;
                        p.b4 = 0;
                        p.b5 = 0;
                        p.ca = 0;
                        break;
                    case 5:
                    case 10:
                        q = (a.j6 + a.model.ci) * 1;
                        p.b9 = q;
                        p.b4 = 0;
                        p.b5 = 0;
                        p.ca = 0;
                        break;
                }
            }
            return q;
        };
        if (a.model.bm()) {
            m.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            m.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        j.g(m);
        if (k == 4 || k == 9) {
            m.ao = true;
        }
        a.de.t(c, m);
        var n = new ColumnCellsEffect();
        n.t = 2;
        n.bx(h);
        n.al = true;
        n.bq = 1;
        n.x = function (o, p, q, r, s) {
            var t = q;
            var u = p;
            var v = r;
            var w = u + (t - u) * o;
            if (w < 0) {
                w = 0;
            }
            v.b1 = w;
        };
        n.o = function (o, p) {
            var q = o;
            if (e == 0 || e == 3) {
                switch (k) {
                    case 10:
                    case 7:
                    case 8:
                    case 9:
                        q.b1 = -1;
                        break;
                    case 6:
                        q.b1 = 0;
                        break;
                }
            }
            return q.b1;
        };
        if (a.model.bm()) {
            n.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            n.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        j.g(n);
        if (k == 4 || k == 9) {
            n.ao = true;
        }
        a.de.t(c, n);
    };
    GridAnimationManager.prototype.ai = function (a, b, c, d, e) {
        var _this = this;
        if (c == null || d == null) {
            return;
        }
        var f = this.p();
        this.w(f);
        c.a = 2;
        d.a = 1;
        var g;
        var h;
        var i = a.a3.f(d.o);
        var j = a.a3.f(c.o);
        if (i == null || j == null) {
            return;
        }
        if (i.fe != null && i.fe.o != null) {
            g = i.fe.o;
        }
        else if (j.fe != null && j.fe.o != null) {
            g = j.fe.o;
        }
        else if (b != null && b.x != null) {
            g = b.o;
        }
        else {
            g = this.g.o;
        }
        if (i.fe != null && i.fe.p != null) {
            h = i.fe.p;
        }
        else if (j.fe != null && j.fe.p != null) {
            h = j.fe.p;
        }
        else if (b != null && b.p != null) {
            h = b.p;
        }
        else {
            h = this.g.p;
        }
        var k = a.a5;
        if (k == 0) {
            k = i.et();
        }
        var l = false;
        if (k == 2 || k == 7) {
            l = true;
        }
        if (l) {
            d.h = 1;
        }
        else {
            d.h = -1;
        }
        if (this.k.containsKey(c.o)) {
            this.k.addItem(d.o, new List$1(Delegate_$type, 0));
            this.k.item(c.o).add(function () {
                c = a.model.g(c.o);
                d = a.model.g(d.o);
                if (c == null || d == null) {
                    return;
                }
                j.e8 = 2;
                c.a = 2;
                i.e8 = 1;
                d.a = 1;
                _this.x(a, c, d, g, h, i, j, k, l, f);
            });
        }
        else {
            this.k.addItem(d.o, new List$1(Delegate_$type, 0));
            this.x(a, c, d, g, h, i, j, k, l, f);
        }
    };
    GridAnimationManager.prototype.x = function (a, b, c, d, e, f, g, h, i, j) {
        var _this = this;
        if (b == null || c == null) {
            return;
        }
        var k = new GridEffectGroup(1);
        k.effectsFinished = delegateCombine(k.effectsFinished, function (l, m) {
            var n = a.model.g(b.o);
            var o = a.model.g(c.o);
            var p = new GridEffectGroup(1);
            p.effectsFinished = delegateCombine(p.effectsFinished, function (q, r) {
                g.e8 = 3;
                b.a = 3;
                a.columns.remove(g);
                f.e8 = 5;
                c.a = 5;
                a.model.bk = false;
                a.tn();
                if (_this.k.containsKey(c.o)) {
                    var s = _this.k.item(c.o);
                    if (s.count == 0) {
                        _this.k.removeItem(c.o);
                    }
                    else {
                        var t = s._inner[0];
                        s.removeAt(0);
                        t();
                    }
                }
                a.r5(f);
                _this.v(j);
            });
            p.effectsCanceled = delegateCombine(p.effectsCanceled, function (q, r) {
                a.model.bk = false;
                a.r4(f);
                _this.u(j);
            });
            _this.t(a, n, o, d, g, i, p);
            _this.s(a, n, o, d, f, g, i, p);
        });
        k.effectsCanceled = delegateCombine(k.effectsCanceled, function (l, m) {
            a.r4(f);
            var n = new GridEffectGroup(1);
            n.effectsFinished = delegateCombine(n.effectsFinished, function (o, p) {
                g.e8 = 3;
                b.a = 3;
                a.columns.remove(g);
                a.model.bk = false;
                a.tn();
            });
            n.effectsCanceled = delegateCombine(n.effectsCanceled, function (o, p) { return a.model.bk = false; });
            var o = a.model.g(b.o);
            var p = a.model.g(c.o);
            _this.t(a, o, p, d, g, i, n);
        });
        var l = new ColumnCellsEffect();
        l.t = 1;
        l.bx(e);
        l.al = true;
        k.g(l);
        if (c.d != 0) {
            a.model.bk = true;
        }
        if (i) {
            l.bq = -1 - b.h;
        }
        else {
            l.bq = 1 + b.h;
        }
        var m = false;
        switch (h) {
            case 4:
            case 9:
                l.bq = (a.j6 + a.model.ci) * -1;
                m = true;
                break;
            case 5:
            case 10:
                l.bq = (a.j6 + a.model.ci) * 1;
                m = true;
                break;
        }
        if (m) {
            l.bi = 0;
        }
        l.x = function (n, o, p, q, r) {
            var s = p;
            var t = o;
            var u = q;
            switch (h) {
                case 2:
                case 3:
                case 7:
                case 8:
                    u.b5 = t + (s - t) * n;
                    break;
                case 4:
                case 5:
                case 9:
                case 10:
                    u.b9 = t + (s - t) * n;
                    break;
            }
        };
        l.o = function (n, o) {
            var p = n;
            var q = p.b5;
            if (h == 4 || h == 5 || h == 9 || h == 10) {
                q = p.b9;
            }
            if (h == 6) {
                q = 0;
            }
            switch (h) {
                case 2:
                case 7:
                case 6:
                    p.b5 = q;
                    p.b4 = 0;
                    p.ca = 0;
                    p.b9 = 0;
                    break;
                case 3:
                case 8:
                    p.b5 = q;
                    p.b4 = 0;
                    p.ca = 0;
                    p.b9 = 0;
                    break;
                case 4:
                case 9:
                    q = p.b9;
                    p.b9 = q;
                    p.b4 = 0;
                    p.b5 = 0;
                    p.ca = 0;
                    break;
                case 5:
                case 10:
                    q = p.b9;
                    p.b9 = q;
                    p.b4 = 0;
                    p.b5 = 0;
                    p.ca = 0;
                    break;
            }
            return q;
        };
        if (a.model.bm()) {
            l.g = new CellPath(0, 0, b.m, a.model.bf.x, a.model.bf.w);
            l.e = new CellPath(0, 0, b.m, a.model.be.x, a.model.be.w);
        }
        l.onFinished = delegateCombine(l.onFinished, function (n) {
        });
        if (h == 4 || h == 9) {
            l.ao = true;
        }
        a.de.t(b, l);
        var n = new ColumnCellsEffect();
        n.t = 1;
        n.bx(e);
        n.al = true;
        k.g(n);
        if (i) {
            n.bq = -1;
        }
        else {
            n.bq = 1;
        }
        if (m) {
            n.bq = 0;
        }
        if (m) {
            n.bi = 0;
        }
        n.x = function (o, p, q, r, s) {
            var t = q;
            var u = p;
            var v = r;
            switch (h) {
                case 2:
                case 3:
                case 7:
                case 8:
                    v.b5 = u + (t - u) * o;
                    break;
                case 4:
                case 5:
                case 9:
                case 10:
                    v.b9 = u + (t - u) * o;
                    break;
            }
        };
        n.o = function (o, p) {
            var q = o;
            var r = q.b5;
            if (h == 4 || h == 5 || h == 9 || h == 10) {
                r = q.b9;
            }
            if (h == 6) {
                r = n.bq;
            }
            else {
                r = 0;
            }
            switch (h) {
                case 2:
                case 7:
                case 6:
                    q.b5 = r;
                    q.b4 = 0;
                    q.ca = 0;
                    q.b9 = 0;
                    break;
                case 3:
                case 8:
                    q.b5 = r;
                    q.b4 = 0;
                    q.ca = 0;
                    q.b9 = 0;
                    break;
                case 4:
                case 9:
                    r = (a.j6 + a.model.ci) * 1;
                    q.b9 = r;
                    q.b4 = 0;
                    q.b5 = 1;
                    q.ca = 0;
                    break;
                case 5:
                case 10:
                    r = (a.j6 + a.model.ci) * -1;
                    q.b9 = r;
                    q.b4 = 0;
                    q.b5 = 1;
                    q.ca = 0;
                    break;
            }
            return r;
        };
        if (a.model.bm()) {
            n.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            n.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        if (h == 5 || h == 10) {
            n.ao = true;
        }
        a.de.t(c, n);
        var o = new ColumnCellsEffect();
        o.t = 2;
        o.bx(e);
        o.al = true;
        o.bq = 0;
        k.g(o);
        if (h != 6 && h != 10 && h != 7 && h != 9) {
            o.bq = 1;
        }
        o.x = function (p, q, r, s, t) {
            var u = r;
            var v = q;
            var w = s;
            w.b6 = v + (u - v) * p;
        };
        o.o = function (p, q) {
            var r = p;
            var s = r.b6;
            return s;
        };
        if (a.model.bm()) {
            o.g = new CellPath(0, 0, b.m, a.model.bf.x, a.model.bf.w);
            o.e = new CellPath(0, 0, b.m, a.model.be.x, a.model.be.w);
        }
        o.onFinished = delegateCombine(o.onFinished, function (p) {
        });
        if (h == 5 || h == 10) {
            o.ao = true;
        }
        a.de.t(b, o);
        var p = new ColumnCellsEffect();
        p.t = 2;
        p.bx(e);
        p.al = true;
        p.bq = 1;
        k.g(p);
        p.x = function (q, r, s, t, u) {
            var v = s;
            var w = r;
            var x = t;
            x.b6 = w + (v - w) * q;
        };
        p.o = function (q, r) {
            var s = q;
            var t = s.b6;
            if (h == 6 || h == 10 || h == 8 || h == 7 || h == 9) {
                t = 0;
            }
            s.b6 = t;
            return t;
        };
        if (a.model.bm()) {
            p.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            p.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        if (h == 5 || h == 10) {
            p.ao = true;
        }
        a.de.t(c, p);
    };
    GridAnimationManager.prototype.t = function (a, b, c, d, e, f, g) {
        var _this = this;
        if (b == null) {
            return;
        }
        var h = new ColumnEffect();
        h.bx(d);
        h.al = true;
        g.g(h);
        if (f) {
            h.bq = -1;
        }
        else {
            h.bq = 1;
        }
        h.x = function (i, j, k, l, m) {
            var n = k;
            var o = j;
            var p = l;
            p.h = o + (n - o) * i;
        };
        h.o = function (i, j) {
            if (_this.j(b, c)) {
                b.h = h.bq;
                return h.bq;
            }
            return b.h;
        };
        a.de.u(b, h);
    };
    GridAnimationManager.prototype.s = function (a, b, c, d, e, f, g, h) {
        var _this = this;
        if (c == null) {
            return;
        }
        var i = new ColumnEffect();
        i.bx(d);
        i.al = true;
        i.bq = 0;
        h.g(i);
        i.x = function (j, k, l, m, n) {
            var o = l;
            var p = k;
            var q = m;
            q.h = p + (o - p) * j;
        };
        i.o = function (j, k) {
            if (_this.j(b, c)) {
                c.h = i.bq;
                return c.h;
            }
            return c.h;
        };
        a.de.u(c, i);
        var j = new ColumnCellsEffect();
        j.bx(d);
        j.al = true;
        j.bq = 0;
        h.g(j);
        j.x = function (k, l, m, n, o) {
            var p = m;
            var q = l;
            var r = n;
            r.b5 = q + (p - q) * k;
        };
        j.o = function (k, l) {
            var m = k;
            if (_this.j(b, c)) {
                m.b5 = j.bq;
                return m.b5;
            }
            return m.b5;
        };
        a.de.t(c, j);
    };
    GridAnimationManager.prototype.j = function (a, b) {
        if (a == null) {
            return true;
        }
        if (b == null) {
            return true;
        }
        if (a.b == null && b.b == null) {
            return true;
        }
        if (a.b == null && (b.b.c && b.b.f == 1)) {
            return true;
        }
        if ((a.b.c && a.b.f == 1) && b.b == null) {
            return true;
        }
        if (a.b.c && b.b.c && a.b.f == b.b.f) {
            return true;
        }
        if (!a.b.c && !b.b.c && a.b.f == b.b.f) {
            return true;
        }
        return false;
    };
    GridAnimationManager.prototype.ag = function (a, b, c, d) {
        var _this = this;
        if (c == null) {
            return;
        }
        var e = a.a3.f(c.o);
        if (e == null) {
            return;
        }
        var f = this.p();
        this.w(f);
        var g;
        if (e.fe != null && e.fe.v != null) {
            g = e.fe.v;
        }
        else if (b != null && b.v != null) {
            g = b.v;
        }
        else {
            g = this.g.v;
        }
        var h = new ColumnEffect();
        h.bx(g);
        h.al = true;
        h.bq = d;
        h.onFinished = delegateCombine(h.onFinished, function (i) { return _this.v(f); });
        h.onCanceled = delegateCombine(h.onCanceled, function (i, j) { return _this.u(f); });
        h.x = function (i, j, k, l, m) {
            var n = k;
            var o = j;
            var p = l;
            var q = o + (n - o) * i;
            var r = ((function () {
                var $ret = new ColumnWidth();
                $ret.f = q;
                $ret.c = false;
                return $ret;
            })());
            if (!isNaN_(e.gq)) {
                r.e = e.gq;
            }
            e.width = r;
        };
        h.o = function (i, j) { return c.k; };
        if (!a.h0(e)) {
            h.ba = 0;
        }
        a.de.u(c, h);
    };
    GridAnimationManager.prototype.ak = function (a, b, c, d) {
        var _this = this;
        if (c == null) {
            return;
        }
        var e = this.p();
        this.w(e);
        var f;
        var g;
        var h = a.a3.f(c.o);
        if (h == null) {
            return;
        }
        if (h.fe != null && h.fe.t != null) {
            f = h.fe.t;
        }
        else if (b != null && b.t != null) {
            f = b.t;
        }
        else {
            f = this.g.t;
        }
        if (h.fe != null && h.fe.s != null) {
            g = h.fe.s;
        }
        else if (b != null && b.w != null) {
            g = b.s;
        }
        else {
            g = this.g.s;
        }
        var i = a.be;
        var j = new GridEffectGroup(1);
        j.effectsFinished = delegateCombine(j.effectsFinished, function (k, l) {
            var m = a.model.g(c.o);
            var n = a.model.bt(m);
            for (var o_1 = 0; o_1 < n.count; o_1++) {
                a.model.cz(n._inner[o_1]);
            }
            h.e8 = 5;
            a.tn();
            a.sb(h);
            _this.v(e);
        });
        j.effectsCanceled = delegateCombine(j.effectsCanceled, function (k, l) {
            a.sa(h);
            _this.u(e);
        });
        if (i == 0) {
            i = 2;
        }
        var k = 0;
        var l = c.h;
        c.h = 0;
        k = a.fb.k(c.m, a, a.model);
        c.h = l;
        var m = a.fb.j(h.g0, a.model);
        var n = m;
        var o = false;
        if (c.n < h.g0) {
            o = true;
        }
        var p = null;
        if (d != 6) {
            p = a.model.h(n, c, (c.k + a.model.cc) - c.f(a.model), c.b == null || c.b.c, o);
        }
        var q = a.model.bt(c);
        for (var r = 0; r < q.count; r++) {
            q._inner[r].e = true;
        }
        var s = c.m;
        var t = null;
        var u = a.model.bw;
        if (u._inner[s].count > 0) {
            for (var v = 0; v < u._inner[s].count; v++) {
                if (u._inner[s]._inner[v].n == c.o) {
                    t = u._inner[s]._inner[v];
                    break;
                }
            }
        }
        var w;
        if (t != null) {
            w = t;
            w.e = false;
        }
        else {
            w = a.model.h(s, c, 0, c.b == null || c.b.c, !o);
            w.e = false;
        }
        var x = h.gz;
        var y = GridAnimationManager.as(a.model, c, h, k, x);
        k = y.p3;
        x = y.p4;
        var z = k - x;
        var aa = -1 * z;
        c.h = aa / c.k;
        c.a = 6;
        var ab = new ColumnEffect();
        ab.bx(f);
        ab.al = true;
        ab.bq = 0;
        var ac = c.k;
        var ad = false;
        var ae = 0;
        var af = c.m;
        var ag = a.fb.k(c.m, a, a.model);
        var ah = this.n(a, c, c.m);
        ag = this.q(a, c, ag, a.model.bt(c), ah);
        j.g(ab);
        ab.x = function (ai, aj, ak, al, am) {
            var an = ak;
            var ao = aj;
            var ap = al;
            ap.h = ao + (an - ao) * ai;
            if (ap.k > 0) {
                var aq = a.fb.l(ap.m, am, true);
                x = h.gz;
                var ar = GridAnimationManager.as(a.model, c, h, aq, x);
                aq = ar.p3;
                x = ar.p4;
                if (aq - x != z) {
                    var as = aq - x;
                    var at = z - as;
                    var au = ae + (at / ap.k);
                    var av = au / (1 - ai);
                    ab.by(av, am, ap.o);
                    ap.h = au;
                    ae = au;
                    z = as;
                    ap.h = av + (an - av) * ai;
                }
                if (!ad) {
                    var aw = a.model.bs(ap);
                    for (var ax = 0; ax < aw.count; ax++) {
                        var ay = aw._inner[ax];
                        ay.b5 += (ae - ap.h);
                    }
                }
                ae = ap.h;
                af = ap.m;
                var az = a.model.bt(ap);
                ah = _this.n(a, ap, ap.m);
                ag = _this.q(a, ap, ag, az, ah);
            }
        };
        ab.o = function (ai, aj) {
            ae = c.h;
            return c.h;
        };
        a.de.u(c, ab);
        var ai = new ColumnCellsEffect();
        ai.ar = true;
        ai.bx(g);
        ai.al = true;
        ai.bq = 0;
        j.g(ai);
        ai.x = function (aj, ak, al, am, an) {
            if (aj > 0) {
                ad = true;
            }
            if (ad) {
                var ao = al;
                var ap = ak;
                var aq = am;
                var ar = ap + (ao - ap) * aj;
                aq.b5 = ar;
            }
        };
        ai.o = function (aj, ak) {
            var al = aj;
            return al.b5;
        };
        if (a.model.bm()) {
            ai.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            ai.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        a.de.t(c, ai);
    };
    GridAnimationManager.as = function (a, b, c, d, e) {
        if (a.b3 > a.b0) {
            if (b.d == 1) {
                e += truncate(a.b0);
                d += truncate(a.b3);
            }
            else if (b.d == 0 && c.fj == 1) {
                e += truncate(a.b3);
                d += truncate(a.b0);
            }
        }
        if (a.b6 < a.absoluteWidth - a.b1) {
            var f = a.absoluteWidth - a.b1 - a.b6;
            if (b.d == 2) {
                d -= truncate(f);
            }
            else if (b.d == 0 && c.fj == 2) {
                e -= truncate(f);
            }
        }
        return {
            p3: d,
            p4: e
        };
    };
    GridAnimationManager.prototype.q = function (a, b, c, d, e) {
        if (e > 0) {
            var f = 0;
            for (var g = 0; g < d.count; g++) {
                if (!d._inner[g].e) {
                    if (e > d._inner[g].i) {
                        f = Math.abs(d._inner[g].i - e);
                        d._inner[g].i = e;
                    }
                }
            }
            var h = 0;
            for (var i = 0; i < d.count; i++) {
                if (d._inner[i].e) {
                    h += d._inner[i].i;
                }
            }
            var j = h - f;
            if (j < 0) {
                j = 0;
            }
            var k = 1;
            if (h == 0) {
                k = 0;
            }
            else {
                k = j / h;
            }
            for (var l = 0; l < d.count; l++) {
                if (d._inner[l].e) {
                    d._inner[l].i = d._inner[l].i * k;
                }
            }
        }
        if (b.o == 0) {
            c = a.fb.k(b.m, a, a.model);
        }
        return c;
    };
    GridAnimationManager.prototype.n = function (a, b, c) {
        var d = a.fb.l(c, a.model, true);
        var e = d + b.k;
        var f = a.fb.l(b.m, a.model, false);
        if (d > f) {
            return Math.max(0, (f + b.k) - d);
        }
        else {
            return Math.max(0, (d + b.k) - f);
        }
    };
    GridAnimationManager.prototype.aj = function (a, b, c, d, e) {
        var _this = this;
        if (c == null) {
            return;
        }
        var f = this.p();
        this.w(f);
        var g;
        var h;
        var i = a.a3.f(c.o);
        if (i == null) {
            return;
        }
        if (i.fe != null && i.fe.q != null) {
            g = i.fe.q;
        }
        else if (b != null && b.q != null) {
            g = b.q;
        }
        else {
            g = this.g.q;
        }
        if (i.fe != null && i.fe.r != null) {
            h = i.fe.r;
        }
        else if (b != null && b.r != null) {
            h = b.r;
        }
        else {
            h = this.g.r;
        }
        var j = a.bb;
        var k = new GridEffectGroup(1);
        k.effectsFinished = delegateCombine(k.effectsFinished, function (l, m) {
            i.e8 = 3;
            c.a = 3;
            if (i.f7) {
                a.externalGrid.ensureColumnsAreManual();
                a.externalGrid.removeExternalColumn(i.externalObject);
            }
            a.model.bk = false;
            a.tn();
            a.r7(i);
            _this.v(f);
        });
        k.effectsCanceled = delegateCombine(k.effectsCanceled, function (l, m) {
            a.model.bk = false;
            a.r6(i);
            _this.u(f);
        });
        if (j == 0) {
            j = i.eu();
        }
        var l = 0;
        switch (j) {
            case 2:
            case 7:
                l = -1;
                break;
            case 3:
            case 8:
                l = 1;
                break;
            case 4:
            case 9:
                l = (a.j6 + a.model.ci) * -1;
                break;
            case 5:
            case 10:
                l = (a.j6 + a.model.ci) * 1;
                break;
        }
        a.model.bk = true;
        var m = new ColumnCellsEffect();
        m.bx(g);
        m.t = 1;
        m.al = true;
        m.bq = l;
        k.g(m);
        m.x = function (n, o, p, q, r) {
            var s = p;
            var t = o;
            var u = q;
            switch (j) {
                case 2:
                case 3:
                case 7:
                case 8:
                    u.b5 = t + (s - t) * n;
                    break;
                case 4:
                case 5:
                case 9:
                case 10:
                    u.b9 = t + (s - t) * n;
                    break;
            }
        };
        m.o = function (n, o) {
            var p = n;
            var q = p.b5;
            if (j == 4 || j == 5) {
                q = p.b9;
            }
            return q;
        };
        if (a.model.bm()) {
            m.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            m.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        if (j == 5 || j == 10) {
            m.ao = true;
        }
        a.de.t(c, m);
        var n = 0;
        switch (j) {
            case 2:
            case 4:
            case 5:
            case 7:
            case 9:
            case 10:
            case 6:
                n = -1;
                break;
            case 3:
            case 8:
                n = 1;
                break;
        }
        var o = new ColumnEffect();
        o.bx(h);
        o.al = true;
        o.bq = n;
        k.g(o);
        o.x = function (p, q, r, s, t) {
            var u = r;
            var v = q;
            var w = s;
            w.h = v + (u - v) * p;
        };
        o.o = function (p, q) { return c.h; };
        a.de.u(c, o);
        var p = new ColumnCellsEffect();
        p.t = 2;
        p.bx(g);
        p.al = true;
        if (j == 6 || j == 10 || j == 7 || j == 8 || j == 9) {
            p.bq = 0;
        }
        else {
            p.bq = 1;
        }
        p.x = function (q, r, s, t, u) {
            var v = s;
            var w = r;
            var x = t;
            var y = w + (v - w) * q;
            if (y < 0) {
                y = 0;
            }
            x.b1 = y;
        };
        p.o = function (q, r) {
            var s = q;
            if (e == 0 || e == 3) {
                switch (j) {
                    case 10:
                    case 7:
                    case 8:
                    case 9:
                        s.b1 = 1;
                        break;
                    case 6:
                        s.b1 = 1;
                        break;
                }
            }
            return s.b1;
        };
        if (a.model.bm()) {
            p.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            p.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        k.g(p);
        if (j == 5 || j == 10) {
            p.ao = true;
        }
        a.de.t(c, p);
    };
    GridAnimationManager.prototype.r = function (a, b, c, d, e, f, g, h, i, j) {
        var _this = this;
        if (!a.model.bm()) {
            return;
        }
        var k = this.p();
        this.w(k);
        var l = this.g.u;
        if (a.c4 != null && a.c4.u != null) {
            l = a.c4.u;
        }
        var m = a.columnPropertyUpdatingAnimationMode;
        var n = new ColumnCellsEffect();
        n.bx(l);
        n.t = 7;
        n.as = true;
        if (g) {
            n.v = 5;
        }
        if (j) {
            n.v = 6;
        }
        n.bs = c;
        n.al = true;
        n.bq = f;
        n.onFinished = delegateCombine(n.onFinished, function (o) { return _this.v(k); });
        n.onCanceled = delegateCombine(n.onCanceled, function (o, p) { return _this.u(k); });
        if (m == 0) {
            m = 2;
        }
        if (d == 11) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.at) || (!h && t.k.at)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                t.jw(c, q);
            };
        }
        if (d == 5 || d == 4 || d == 9 || d == 8 || (m != 3 && (d == 7 || d == 1 || d == 3))) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.at) || (!h && t.k.at)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                if (o > 0.5) {
                    t.jw(c, q);
                }
                else {
                    t.jw(c, p);
                }
            };
        }
        if (m == 3 && d == 1) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.at) || (!h && t.k.at)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                var u = p;
                var v = q;
                var w = u + (v - u) * o;
                t.jw(c, w);
            };
        }
        if (d == 0) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.at) || (!h && t.k.at)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                var u = p;
                var v = q;
                var w = u + (v - u) * o;
                t.jw(c, w);
            };
        }
        if (d == 2) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.at) || (!h && t.k.at)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                var u = p;
                var v = q;
                var w = BrushUtil.k(u, o, v, 0);
                t.jw(c, w);
            };
        }
        if (d == 3) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.at) || (!h && t.k.at)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                var u = p;
                var v = q;
                if (u != null) {
                    u.t(a.externalGrid.renderer);
                }
                if (v != null) {
                    v.t(a.externalGrid.renderer);
                }
                var w = new FontInfo();
                FontUtil.interpolateFont(w, o, u, v);
                t.jw(c, w);
            };
        }
        if (d == 6) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.at) || (!h && t.k.at)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                var u = typeGetValue(p);
                var v = typeGetValue(q);
                var w = truncate((Math.round(u + (v - u) * o)));
                t.jw(c, w);
            };
        }
        n.o = function (o, p) {
            var q = o;
            return q.go(c);
        };
        if (a.model.bm()) {
            if (h) {
                n.g = new CellPath(0, 0, -300, a.model.bf.x, a.model.bf.w);
                n.e = new CellPath(0, 0, -300, a.model.be.x, a.model.be.w);
            }
            else if (i) {
                n.g = new CellPath(0, 0, -400, a.model.bf.x, a.model.bf.w);
                n.e = new CellPath(0, 0, -400, a.model.be.x, a.model.be.w);
            }
            else {
                n.g = new CellPath(0, 0, b.m, a.model.bf.x, a.model.bf.w);
                n.e = new CellPath(0, 0, b.m, a.model.be.x, a.model.be.w);
            }
        }
        if (!a.hz || d == 11) {
            n.ba = 0;
        }
        if (h) {
            a.de.x(n);
        }
        else if (i) {
            a.de.y(n);
        }
        else {
            a.de.t(b, n);
        }
    };
    GridAnimationManager.prototype.al = function (a, b, c) {
        var _this = this;
        var d = this.p();
        this.w(d);
        var e = this.e;
        var f = a.model;
        var g = new GridEffectGroup(1);
        g.effectsCanceled = delegateCombine(g.effectsCanceled, function (h, i) { return _this.u(d); });
        g.effectsFinished = delegateCombine(g.effectsFinished, function (h, i) { return _this.v(d); });
        for (var h = b; h <= c; h++) {
            var i = new RowCellsEffect();
            g.g(i);
            i.t = 6;
            i.bx(e);
            i.al = true;
            i.bq = 1;
            i.x = function (j, k, l, m, n) {
            };
            i.o = function (j, k) {
                var l = j;
                if (l.k.ag) {
                    var m = a.ee.getDataRow(l.k);
                    l.ej = m;
                    if (m == -1) {
                        return l.ir;
                    }
                    var n = a.ee.getRowType(m);
                    if (l.a8(n)) {
                        var o = a.ee.resolveValueForPath(a, l.k);
                        var p = a.n2(l.k, a, o, m);
                        a.su(l, o, a.ee.resolveRow(m), p);
                    }
                }
                return l.ir;
            };
            var j = a.ev(h);
            if (a.model.bm()) {
                i.g = new CellPath(0, 0, a.model.cn, j.x, j.w);
                i.e = new CellPath(0, 0, a.model.cq, j.x, j.w);
            }
            if (!a.ih) {
                i.ba = 0;
            }
            a.de.v(j, i);
        }
    };
    GridAnimationManager.prototype.ah = function (a, b) {
        var _this = this;
        if (b == null) {
            return;
        }
        var c = this.p();
        this.w(c);
        var d = this.d;
        var e = a.model;
        var f = new GridEffectGroup(1);
        f.effectsFinished = delegateCombine(f.effectsFinished, function (g, h) { return _this.v(c); });
        f.effectsCanceled = delegateCombine(f.effectsCanceled, function (g, h) { return _this.u(c); });
        var g = a.a3.f(b.o);
        if (g == null) {
            return;
        }
        var h = new ColumnEffect();
        f.g(h);
        h.bx(d);
        h.al = true;
        h.bq = 1;
        h.x = function (i, j, k, l, m) {
        };
        h.o = function (i, j) {
            var k = i;
            k.g = 0;
            k.h = 0;
            k.j = 0;
            a.tn();
            return k.g;
        };
        a.de.u(b, h);
        var i = new ColumnCellsEffect();
        f.g(i);
        i.t = 1;
        i.bx(d);
        i.al = true;
        i.bq = 1;
        i.x = function (j, k, l, m, n) {
        };
        i.o = function (j, k) {
            var l = j;
            l.b4 = 0;
            l.b5 = 0;
            l.b9 = 0;
            l.ca = 0;
            l.b1 = 1;
            return l.b4;
        };
        a.de.t(b, i);
    };
    GridAnimationManager.prototype.y = function (a, b, c, d) {
        var _this = this;
        var e = this.p();
        this.w(e);
        var f = this.f.f;
        if (a.cr != null && a.cr.f != null) {
            f = a.cr.f;
        }
        var g = a.al;
        var h = a.model;
        var i = new GridEffectGroup(1);
        i.effectsFinished = delegateCombine(i.effectsFinished, function (j, k) { return _this.v(e); });
        i.effectsCanceled = delegateCombine(i.effectsCanceled, function (j, k) { return _this.u(e); });
        for (var j = 0; j < h.br.count; j++) {
            var k = h.br._inner[j];
            var l = a.a3.f(k.o);
            if (l == null) {
                continue;
            }
            var m = new ColumnCellsEffect();
            i.g(m);
            m.t = 3;
            m.bx(f);
            m.al = true;
            m.bq = 0;
            if (g == 0) {
                g = 2;
            }
            m.x = function (n, o, p, q, r) {
                var s = q;
                var t = o;
                var u = p;
                if (s.k.ag) {
                    var v = a.a1(s.k);
                    if (a.ee.isPlaceholderValue(s.k)) {
                        n = 0;
                    }
                }
                s.cb = t + (u - t) * n;
            };
            m.o = function (n, o) {
                var p = n;
                if (p.k.ag) {
                    var q = a.ee.getDataRow(p.k);
                    p.ej = q;
                    if (q == -1) {
                        return p.cb;
                    }
                    var r = a.ee.resolveValueForPath(a, p.k);
                    var s = false;
                    if (r == null && a.ee.isPlaceholderValue(p.k)) {
                        s = true;
                    }
                    if (p.a8(a.ee.getRowType(p.k.w))) {
                        var t = a.n2(p.k, a, r, q);
                        a.su(p, r, a.ee.resolveRow(q), t);
                    }
                    if (s) {
                        p.cb = 1;
                    }
                }
                return p.cb;
            };
            if (a.model.bm()) {
                m.g = new CellPath(0, 0, k.m, a.model.bf.x, a.model.bf.w);
                m.e = new CellPath(0, 0, k.m, a.model.be.x, a.model.be.w);
            }
            if (!a.hp || d) {
                m.ba = 0;
            }
            a.de.t(k, m);
        }
    };
    GridAnimationManager.prototype.af = function (a, b, c, d, e) {
        var _this = this;
        var f = this.p();
        this.w(f);
        var g = this.f.f;
        if (a.cr != null && a.cr.f != null) {
            g = a.cr.f;
        }
        var h = a.al;
        var i = a.model;
        if (d < 0 || d >= i.br.count) {
            return;
        }
        var j = i.br._inner[d];
        var k = a.a3.f(j.o);
        if (k == null) {
            return;
        }
        var l = new ColumnCellsEffect();
        l.onFinished = delegateCombine(l.onFinished, function (m) { return _this.v(f); });
        l.onCanceled = delegateCombine(l.onCanceled, function (m, n) { return _this.u(f); });
        l.t = 3;
        l.bx(g);
        l.al = true;
        l.bq = 0;
        if (h == 0) {
            h = 2;
        }
        l.x = function (m, n, o, p, q) {
            var r = p;
            var s = n;
            var t = o;
            if (r.k.ag) {
                var u = a.a1(r.k);
                if (a.ee.isPlaceholderValue(r.k)) {
                    m = 0;
                }
            }
            r.cb = s + (t - s) * m;
        };
        l.o = function (m, n) {
            var o = m;
            if (o.k.ag) {
                var p = a.ee.getDataRow(o.k);
                o.ej = p;
                if (p == -1) {
                    return o.cb;
                }
                var q = a.ee.resolveValueForPath(a, o.k);
                var r = false;
                if (q == null && a.ee.isPlaceholderValue(o.k)) {
                    r = true;
                }
                if (o.a8(a.ee.getRowType(o.k.w))) {
                    var s = a.n2(o.k, a, q, p);
                    a.su(o, q, a.ee.resolveRow(p), s);
                }
                if (r) {
                    o.cb = 1;
                }
            }
            return o.cb;
        };
        if (a.model.bm()) {
            l.g = new CellPath(0, 0, j.m, a.model.bf.x, a.model.bf.w);
            l.e = new CellPath(0, 0, j.m, a.model.be.x, a.model.be.w);
        }
        if (!a.hp || e) {
            l.ba = 0;
        }
        a.de.t(j, l);
    };
    GridAnimationManager.prototype.an = function (a, b) {
        var _this = this;
        var c = this.p();
        this.w(c);
        var d = this.f.h;
        if (a.c4 != null && a.cr.h != null) {
            d = a.cr.h;
        }
        var e = a.ex;
        var f = a.model;
        var g = new RowCellsEffect();
        g.onFinished = delegateCombine(g.onFinished, function (h) { return _this.v(c); });
        g.onCanceled = delegateCombine(g.onCanceled, function (h, i) { return _this.u(c); });
        g.t = 5;
        g.bx(d);
        g.al = true;
        g.bq = 1;
        if (e == 0) {
            e = 2;
        }
        g.x = function (h, i, j, k, l) {
            var m = k;
            var n = i;
            var o = j;
            if (m.k.ag) {
                m.b8 = n + (o - n) * h;
            }
            else {
                m.b8 = 0;
            }
        };
        g.o = function (h, i) {
            var j = h;
            return j.b8;
        };
        var h = a.ev(b);
        if (a.model.bm()) {
            g.g = new CellPath(0, 0, a.model.cn, h.x, h.w);
            g.g.d = a.model.br._inner[a.model.cn].d;
            g.e = new CellPath(0, 0, a.model.cq, h.x, h.w);
            g.e.d = a.model.br._inner[a.model.cq].d;
        }
        if (!a.ih || a.dragger.isDragActive) {
            g.ba = 0;
        }
        a.de.v(h, g);
    };
    GridAnimationManager.prototype.ap = function (a, b) {
        var _this = this;
        var c = this.p();
        this.w(c);
        var d = this.f.h;
        if (a.c4 != null && a.cr.h != null) {
            d = a.cr.h;
        }
        var e = a.ex;
        var f = a.model;
        var g = new RowCellsEffect();
        g.onFinished = delegateCombine(g.onFinished, function (h) { return _this.v(c); });
        g.onCanceled = delegateCombine(g.onCanceled, function (h, i) { return _this.u(c); });
        g.t = 5;
        g.bx(d);
        g.al = true;
        g.bq = 0;
        if (e == 0) {
            e = 2;
        }
        g.x = function (h, i, j, k, l) {
            var m = k;
            var n = i;
            var o = j;
            if (m.k.ag) {
                m.b8 = n + (o - n) * h;
            }
            else {
                m.b8 = 0;
            }
        };
        g.o = function (h, i) {
            var j = h;
            return j.b8;
        };
        var h = a.ev(b);
        if (a.model.bm()) {
            g.g = new CellPath(0, 0, a.model.cn, h.x, h.w);
            g.g.d = a.model.br._inner[a.model.cn].d;
            g.e = new CellPath(0, 0, a.model.cq, h.x, h.w);
            g.e.d = a.model.br._inner[a.model.cq].d;
        }
        if (!a.ih || a.dragger.isDragActive) {
            g.ba = 0;
        }
        a.de.v(h, g);
    };
    GridAnimationManager.prototype.ad = function (a, b, c, d) {
        var _this = this;
        var e = this.p();
        this.w(e);
        var f = this.f.h;
        if (a.cr != null && a.cr.h != null) {
            f = a.cr.h;
        }
        var g = a.model;
        var h = new CellEffect();
        h.onFinished = delegateCombine(h.onFinished, function (i) { return _this.v(e); });
        h.onCanceled = delegateCombine(h.onCanceled, function (i, j) { return _this.u(e); });
        h.t = 5;
        h.bx(f);
        h.al = true;
        h.bq = 1;
        h.x = function (i, j, k, l, m) {
            var n = l;
            var o = j;
            var p = k;
            if (n.k.ag) {
                n.b8 = o + (p - o) * i;
            }
            else {
                n.b8 = 0;
            }
        };
        h.o = function (i, j) {
            var k = i;
            return k.b8;
        };
        var i = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            h.g = new CellPath(0, 0, a.model.cn, i.x, i.w);
            h.e = new CellPath(0, 0, a.model.cq, i.x, i.w);
        }
        if (!a.hq || a.dragger.isDragActive) {
            h.ba = 0;
        }
        a.de.r(i, h, d);
    };
    GridAnimationManager.prototype.z = function (a, b, c, d) {
        var _this = this;
        var e = this.p();
        this.w(e);
        var f = this.f.e;
        if (a.cr != null && a.cr.e != null) {
            f = a.cr.e;
        }
        var g = a.model;
        var h = new CellEffect();
        h.onFinished = delegateCombine(h.onFinished, function (i) { return _this.v(e); });
        h.onCanceled = delegateCombine(h.onCanceled, function (i, j) { return _this.u(e); });
        h.t = 8;
        h.bx(f);
        h.al = true;
        h.bq = 1;
        h.x = function (i, j, k, l, m) {
            var n = l;
            var o = j;
            var p = k;
            if (n.k.ag) {
                n.by = o + (p - o) * i;
            }
            else {
                n.by = 0;
            }
        };
        h.o = function (i, j) {
            var k = i;
            return k.by;
        };
        var i = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            h.g = new CellPath(0, 0, c, i.x, i.w);
            h.e = new CellPath(0, 0, c, i.x, i.w);
        }
        a.de.r(i, h, d);
    };
    GridAnimationManager.prototype.ae = function (a, b, c, d) {
        var _this = this;
        var e = this.p();
        this.w(e);
        var f = this.f.h;
        if (a.cr != null && a.cr.h != null) {
            f = a.cr.h;
        }
        var g = a.model;
        var h = new CellEffect();
        h.onFinished = delegateCombine(h.onFinished, function (i) { return _this.v(e); });
        h.onCanceled = delegateCombine(h.onCanceled, function (i, j) { return _this.u(e); });
        h.t = 5;
        h.bx(f);
        h.al = true;
        h.bq = 0;
        h.x = function (i, j, k, l, m) {
            var n = l;
            var o = j;
            var p = k;
            if (n.k.ag) {
                n.b8 = o + (p - o) * i;
            }
            else {
                n.b8 = 0;
            }
        };
        h.o = function (i, j) {
            var k = i;
            return k.b8;
        };
        var i = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            h.g = new CellPath(0, 0, a.model.cn, i.x, i.w);
            h.e = new CellPath(0, 0, a.model.cq, i.x, i.w);
        }
        if (!a.hq || a.dragger.isDragActive) {
            h.ba = 0;
        }
        a.de.r(i, h, d);
    };
    GridAnimationManager.prototype.aa = function (a, b, c, d) {
        var _this = this;
        var e = this.p();
        this.w(e);
        var f = this.f.e;
        if (a.cr != null && a.cr.e != null) {
            f = a.cr.e;
        }
        var g = a.model;
        var h = new CellEffect();
        h.onFinished = delegateCombine(h.onFinished, function (i) { return _this.v(e); });
        h.onCanceled = delegateCombine(h.onCanceled, function (i, j) { return _this.u(e); });
        h.t = 8;
        h.bx(f);
        h.al = true;
        h.bq = 0;
        h.x = function (i, j, k, l, m) {
            var n = l;
            var o = j;
            var p = k;
            if (n.k.ag) {
                n.by = o + (p - o) * i;
            }
            else {
                n.by = 0;
            }
        };
        h.o = function (i, j) {
            var k = i;
            return k.by;
        };
        var i = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            h.g = new CellPath(0, 0, c, i.x, i.w);
            h.e = new CellPath(0, 0, c, i.x, i.w);
        }
        a.de.r(i, h, d);
    };
    GridAnimationManager.prototype.ab = function (a, b, c) {
        var _this = this;
        var d = this.p();
        this.w(d);
        var e = this.f.h;
        if (a.cr != null && a.cr.h != null) {
            e = a.cr.h;
        }
        var f = a.model;
        var g = new CellPositionEffect();
        g.onFinished = delegateCombine(g.onFinished, function (h) { return _this.v(d); });
        g.onCanceled = delegateCombine(g.onCanceled, function (h, i) { return _this.u(d); });
        g.t = 5;
        g.bx(e);
        g.al = true;
        g.bq = 1;
        g.x = function (h, i, j, k, l) {
            var m = k;
            var n = i;
            var o = j;
            if (m.k.ag) {
                m.b8 = n + (o - n) * h;
            }
            else {
                m.b8 = 0;
            }
        };
        g.o = function (h, i) {
            var j = h;
            return j.b8;
        };
        var h = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            g.g = new CellPath(0, 0, a.model.cn, h.x, h.w);
            g.e = new CellPath(0, 0, a.model.cq, h.x, h.w);
        }
        if (!a.hq || a.dragger.isDragActive) {
            g.ba = 0;
        }
        a.de.s(h, g);
    };
    GridAnimationManager.prototype.ac = function (a, b, c) {
        var _this = this;
        var d = this.p();
        this.w(d);
        var e = this.f.h;
        if (a.cr != null && a.cr.h != null) {
            e = a.cr.h;
        }
        var f = a.model;
        var g = new CellPositionEffect();
        g.onFinished = delegateCombine(g.onFinished, function (h) { return _this.v(d); });
        g.onCanceled = delegateCombine(g.onCanceled, function (h, i) { return _this.u(d); });
        g.t = 5;
        g.bx(e);
        g.al = true;
        g.bq = 0;
        g.x = function (h, i, j, k, l) {
            var m = k;
            var n = i;
            var o = j;
            if (m.k.ag) {
                m.b8 = n + (o - n) * h;
            }
            else {
                m.b8 = 0;
            }
        };
        g.o = function (h, i) {
            var j = h;
            return j.b8;
        };
        var h = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            g.g = new CellPath(0, 0, a.model.cn, h.x, h.w);
            g.e = new CellPath(0, 0, a.model.cq, h.x, h.w);
        }
        if (!a.hq || a.dragger.isDragActive) {
            g.ba = 0;
        }
        a.de.s(h, g);
    };
    GridAnimationManager.prototype.am = function (a, b) {
        var _this = this;
        var c = this.p();
        this.w(c);
        var d = this.f.g;
        if (a.c4 != null && a.cr.g != null) {
            d = a.cr.g;
        }
        var e = new RowCellsEffect();
        e.onFinished = delegateCombine(e.onFinished, function (f) { return _this.v(c); });
        e.onCanceled = delegateCombine(e.onCanceled, function (f, g) { return _this.u(c); });
        e.t = 5;
        e.bx(d);
        e.al = true;
        e.bq = 1;
        e.x = function (f, g, h, i, j) {
            var k = i;
            var l = g;
            var m = h;
            if (k.k.ag) {
                k.b3 = l + (m - l) * f;
            }
            else {
                k.b3 = 0;
            }
        };
        e.o = function (f, g) {
            var h = f;
            return h.b3;
        };
        var f = a.ev(b);
        if (a.model.bm()) {
            e.g = new CellPath(0, 0, a.model.cn, f.x, f.w);
            e.g.d = a.model.br._inner[a.model.cn].d;
            e.e = new CellPath(0, 0, a.model.cq, f.x, f.w);
            e.e.d = a.model.br._inner[a.model.cq].d;
        }
        if (!a.ie) {
            e.ba = 0;
        }
        a.de.v(f, e);
    };
    GridAnimationManager.prototype.ao = function (a, b) {
        var _this = this;
        var c = this.p();
        this.w(c);
        var d = this.f.g;
        if (a.c4 != null && a.cr.g != null) {
            d = a.cr.g;
        }
        var e = new RowCellsEffect();
        e.onFinished = delegateCombine(e.onFinished, function (f) { return _this.v(c); });
        e.onCanceled = delegateCombine(e.onCanceled, function (f, g) { return _this.u(c); });
        e.t = 5;
        e.bx(d);
        e.al = true;
        e.bq = 0;
        e.x = function (f, g, h, i, j) {
            var k = i;
            var l = g;
            var m = h;
            if (k.k.ag) {
                k.b3 = l + (m - l) * f;
            }
            else {
                k.b3 = 0;
            }
        };
        e.o = function (f, g) {
            var h = f;
            return h.b3;
        };
        var f = a.ev(b);
        if (a.model.bm()) {
            e.g = new CellPath(0, 0, a.model.cn, f.x, f.w);
            e.g.d = a.model.br._inner[a.model.cn].d;
            e.e = new CellPath(0, 0, a.model.cq, f.x, f.w);
            e.e.d = a.model.br._inner[a.model.cq].d;
        }
        if (!a.ie) {
            e.ba = 0;
        }
        a.de.v(f, e);
    };
    GridAnimationManager.$t = markType(GridAnimationManager, 'GridAnimationManager');
    GridAnimationManager.o = 0;
    return GridAnimationManager;
}(Base));
export { GridAnimationManager };
/**
 * @hidden
 */
var CellKey = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellKey, _super);
    function CellKey() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.e = null;
        _this.g = null;
        _this.i = null;
        _this.a = null;
        _this.c = null;
        return _this;
    }
    Object.defineProperty(CellKey.prototype, "primaryKey", {
        get: function () {
            if (this.e == null && this.g != null && this.d != null) {
                this.e = this.d.ee.getItemKey(this.d.i(), this.g);
            }
            return this.e;
        },
        set: function (a) {
            this.e = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellKey.prototype, "h", {
        get: function () {
            if (this.g == null && this.e != null && this.d != null) {
                this.g = this.d.ee.getItemForKey(this.primaryKey);
            }
            return this.g;
        },
        set: function (a) {
            this.g = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellKey.prototype, "j", {
        get: function () {
            return this.i;
        },
        set: function (a) {
            this.i = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellKey.prototype, "b", {
        get: function () {
            if ((this.a == null || this.a.grid != this.d) && this.d != null) {
                this.a = this.d.a3.g(this.j);
            }
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellKey.prototype, "d", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
        },
        enumerable: true,
        configurable: true
    });
    CellKey.$t = markType(CellKey, 'CellKey');
    return CellKey;
}(Base));
export { CellKey };
/**
 * @hidden
 */
var GridSelectedCellsCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridSelectedCellsCollection, _super);
    function GridSelectedCellsCollection() {
        return _super.call(this, CellKey.$, 0) || this;
    }
    GridSelectedCellsCollection.prototype.an = function (a) {
        this.collectionChanged = delegateCombine(this.collectionChanged, a);
    };
    GridSelectedCellsCollection.prototype.ao = function (a) {
        this.collectionChanged = delegateRemove(this.collectionChanged, a);
    };
    Object.defineProperty(GridSelectedCellsCollection.prototype, "am", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    GridSelectedCellsCollection.prototype.ai = function (a, b) {
        for (var c = 0; c < this.count; c++) {
            if (this._inner[c].primaryKey != null && this._inner[c].primaryKey.equals(a) && this._inner[c].b != null && this._inner[c].b.g6 == b) {
                return this._inner[c];
            }
        }
        return null;
    };
    GridSelectedCellsCollection.prototype.aj = function (a, b) {
        for (var c = 0; c < this.count; c++) {
            if (this._inner[c].primaryKey.equals(a) && this._inner[c].j == b) {
                return this._inner[c];
            }
        }
        return null;
    };
    GridSelectedCellsCollection.prototype.ak = function (a, b) {
        for (var c = 0; c < this.count; c++) {
            if (this._inner[c].h == a && this._inner[c].j == b) {
                return this._inner[c];
            }
        }
        return null;
    };
    GridSelectedCellsCollection.prototype.ae = function (a, b) {
        return this.af(a, b.h6());
    };
    GridSelectedCellsCollection.prototype.af = function (a, b) {
        if (this.aj(a, b) != null) {
            return null;
        }
        var c = new CellKey();
        c.primaryKey = a;
        c.j = b;
        this.add(c);
        return c;
    };
    GridSelectedCellsCollection.prototype.ag = function (a, b) {
        return this.ah(a, b.h6());
    };
    GridSelectedCellsCollection.prototype.ah = function (a, b) {
        if (this.ak(a, b) != null) {
            return null;
        }
        var c = new CellKey();
        c.h = a;
        c.j = b;
        this.add(c);
        return c;
    };
    GridSelectedCellsCollection.prototype.al = function (a, b) {
        var c = this.ai(a, b);
        if (c != null) {
            this.remove(c);
        }
        return c;
    };
    GridSelectedCellsCollection.$t = markType(GridSelectedCellsCollection, 'GridSelectedCellsCollection', ObservableCollection$1.$.specialize(CellKey.$));
    return GridSelectedCellsCollection;
}(ObservableCollection$1));
export { GridSelectedCellsCollection };
/**
 * @hidden
 */
var DefinitionBase = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DefinitionBase, _super);
    function DefinitionBase() {
        var _this = _super.call(this) || this;
        _this.bl = null;
        _this.t = null;
        _this.dr = null;
        _this.ds = null;
        _this.dh = null;
        _this.dt = null;
        _this.dk = null;
        _this.a2 = truncate(DeviceUtils.g(0));
        _this.a4 = truncate(DeviceUtils.g(0));
        _this.a3 = truncate(DeviceUtils.g(0));
        _this.a1 = truncate(DeviceUtils.g(0));
        _this.ay = truncate(DeviceUtils.g(1));
        _this.a0 = truncate(DeviceUtils.g(1));
        _this.az = truncate(DeviceUtils.g(1));
        _this.ax = truncate(DeviceUtils.g(1));
        _this.a6 = truncate(DeviceUtils.g(2));
        _this.a8 = truncate(DeviceUtils.g(2));
        _this.a7 = truncate(DeviceUtils.g(2));
        _this.a5 = truncate(DeviceUtils.g(2));
        _this.r = null;
        _this.dj = null;
        _this.di = null;
        _this.dl = null;
        _this.dw = null;
        _this.dp = null;
        _this.dv = null;
        _this.dn = null;
        _this.du = null;
        _this.dm = null;
        _this.ar = 1;
        _this.b = 4;
        _this.g = 4;
        _this.a = 0;
        _this.f = 1;
        _this.w = 0;
        _this.v = 0;
        _this.dx = null;
        _this.dq = null;
        _this.as = NaN;
        _this.aq = 0;
        _this.ac = null;
        _this.ab = null;
        _this.dataBinding = null;
        _this.dataBound = null;
        _this.propertyChanged = null;
        _this.ag = false;
        _this.am = new HashSet$1(String_$type, 0);
        _this.ao = new List$1(String_$type, 0);
        _this.al = new Dictionary$2(String_$type, CellPropertyAnimationType_$type, 0);
        _this.definitionPropertyUpdated = null;
        _this.z = null;
        _this.cellStyleKeyRequested = null;
        _this.d0 = _this.eb();
        _this.d5 = _this.ef();
        _this.d4 = _this.ed();
        _this.d3 = _this.ec();
        _this.at = _this.av();
        _this.d6 = _this.eg();
        _this.ad = _this.af();
        _this.d2 = GridStyleRepository.bg;
        return _this;
    }
    Object.defineProperty(DefinitionBase.prototype, "externalObject", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            this.t = typeCast(IExternalDefinitionBase_$type, this.bl);
            if (this.bl != b) {
                this.c2("ExternalObject", 10, b, this.bl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d7", {
        get: function () {
            return this.dr;
        },
        set: function (a) {
            var b = this.dr;
            this.dr = a;
            if (this.dr != b) {
                this.c2("Background", 10, b, this.dr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d8", {
        get: function () {
            return this.ds;
        },
        set: function (a) {
            var b = this.ds;
            this.ds = a;
            if (this.ds != b) {
                this.c2("Border", 10, b, this.ds);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "dy", {
        get: function () {
            return this.dh;
        },
        set: function (a) {
            var b = this.dh;
            this.dh = a;
            if (this.dh != b) {
                this.c2("ActivationBorder", 10, b, this.dh);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d9", {
        get: function () {
            return this.dt;
        },
        set: function (a) {
            var b = this.dt;
            this.dt = a;
            if (this.dt != b) {
                this.c2("ErrorBorder", 10, b, this.dt);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d1", {
        get: function () {
            return this.dk;
        },
        set: function (a) {
            var b = this.dk;
            this.dk = a;
            if (this.dk != b) {
                this.c2("ActualBorder", 2, b, this.dk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "be", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            var b = this.a2;
            this.a2 = a;
            if (this.a2 != b) {
                this.c2("BorderLeftWidth", 6, b, this.a2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bg", {
        get: function () {
            return this.a4;
        },
        set: function (a) {
            var b = this.a4;
            this.a4 = a;
            if (this.a4 != b) {
                this.c2("BorderTopWidth", 6, b, this.a4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bf", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            var b = this.a3;
            this.a3 = a;
            if (this.a3 != b) {
                this.c2("BorderRightWidth", 6, b, this.a3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bd", {
        get: function () {
            return this.a1;
        },
        set: function (a) {
            var b = this.a1;
            this.a1 = a;
            if (this.a1 != b) {
                this.c2("BorderBottomWidth", 6, b, this.a1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ba", {
        get: function () {
            return this.ay;
        },
        set: function (a) {
            var b = this.ay;
            this.ay = a;
            if (this.ay != b) {
                this.c2("ActivationBorderLeftWidth", 6, b, this.ay);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bc", {
        get: function () {
            return this.a0;
        },
        set: function (a) {
            var b = this.a0;
            this.a0 = a;
            if (this.a0 != b) {
                this.c2("ActivationBorderTopWidth", 6, b, this.a0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bb", {
        get: function () {
            return this.az;
        },
        set: function (a) {
            var b = this.az;
            this.az = a;
            if (this.az != b) {
                this.c2("ActivationBorderRightWidth", 6, b, this.az);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "a9", {
        get: function () {
            return this.ax;
        },
        set: function (a) {
            var b = this.ax;
            this.ax = a;
            if (this.ax != b) {
                this.c2("ActivationBorderBottomWidth", 6, b, this.ax);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bi", {
        get: function () {
            return this.a6;
        },
        set: function (a) {
            var b = this.a6;
            this.a6 = a;
            if (this.a6 != b) {
                this.c2("ErrorBorderLeftWidth", 6, b, this.a6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bk", {
        get: function () {
            return this.a8;
        },
        set: function (a) {
            var b = this.a8;
            this.a8 = a;
            if (this.a8 != b) {
                this.c2("ErrorBorderTopWidth", 6, b, this.a8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bj", {
        get: function () {
            return this.a7;
        },
        set: function (a) {
            var b = this.a7;
            this.a7 = a;
            if (this.a7 != b) {
                this.c2("ErrorBorderRightWidth", 6, b, this.a7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bh", {
        get: function () {
            return this.a5;
        },
        set: function (a) {
            var b = this.a5;
            this.a5 = a;
            if (this.a5 != b) {
                this.c2("ErrorBorderBottomWidth", 6, b, this.a5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "grid", {
        get: function () {
            return this.r;
        },
        set: function (a) {
            var b = this.r;
            this.r = a;
            this.c0(b, a);
        },
        enumerable: true,
        configurable: true
    });
    DefinitionBase.prototype.c0 = function (a, b) {
        if (a != null) {
            a.propertyChanged = delegateRemove(a.propertyChanged, runOn(this, this.c1));
        }
        if (b != null) {
            b.propertyChanged = delegateCombine(b.propertyChanged, runOn(this, this.c1));
        }
        this.c7();
        this.cz(a, b);
    };
    DefinitionBase.prototype.cz = function (a, b) {
    };
    DefinitionBase.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "IsActiveCellStyleEnabled":
                this.c7();
                break;
        }
    };
    Object.defineProperty(DefinitionBase.prototype, "d0", {
        get: function () {
            return this.dj;
        },
        set: function (a) {
            var b = this.dj;
            this.dj = a;
            if (this.dj != b) {
                this.c2("ActualBackground", 2, b, this.dj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "dz", {
        get: function () {
            return this.di;
        },
        set: function (a) {
            var b = this.di;
            this.di = a;
            if (this.di != b) {
                this.c2("ActualActivationBorder", 2, b, this.di);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d2", {
        get: function () {
            return this.dl;
        },
        set: function (a) {
            var b = this.dl;
            this.dl = a;
            if (this.dl != b) {
                this.c2("ActualErrorBorder", 2, b, this.dl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ej", {
        get: function () {
            return this.dw;
        },
        set: function (a) {
            var b = this.dw;
            this.dw = a;
            if (this.dw != b) {
                this.c2("PinnedBackground", 10, b, this.dw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d5", {
        get: function () {
            return this.dp;
        },
        set: function (a) {
            var b = this.dp;
            this.dp = a;
            if (this.dp != b) {
                this.c2("ActualStickyRowBackground", 2, b, this.dp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ei", {
        get: function () {
            return this.dv;
        },
        set: function (a) {
            var b = this.dv;
            this.dv = a;
            if (this.dv != b) {
                this.c2("PinnedRowBackground", 10, b, this.dv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d4", {
        get: function () {
            return this.dn;
        },
        set: function (a) {
            var b = this.dn;
            this.dn = a;
            if (this.dn != b) {
                this.c2("ActualPinnedRowBackground", 2, b, this.dn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "eh", {
        get: function () {
            return this.du;
        },
        set: function (a) {
            var b = this.du;
            this.du = a;
            if (this.du != b) {
                this.c2("LastStickyRowBackground", 10, b, this.du);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d3", {
        get: function () {
            return this.dm;
        },
        set: function (a) {
            var b = this.dm;
            this.dm = a;
            if (this.dm != b) {
                this.c2("ActualLastStickyRowBackground", 2, b, this.dm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "au", {
        get: function () {
            return this.ar;
        },
        set: function (a) {
            var b = this.ar;
            this.ar = a;
            if (this.ar != b) {
                this.c2("ContentOpacity", 0, b, this.ar);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "e", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (this.b != b) {
                this.c2("HorizontalAlignment", 10, enumGetBox(CellContentHorizontalAlignment_$type, b), enumGetBox(CellContentHorizontalAlignment_$type, this.b));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "j", {
        get: function () {
            return this.g;
        },
        set: function (a) {
            var b = this.g;
            this.g = a;
            if (this.g != b) {
                this.c2("VerticalAlignment", 10, enumGetBox(CellContentVerticalAlignment_$type, b), enumGetBox(CellContentVerticalAlignment_$type, this.g));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "c", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (this.a != b) {
                this.c2("ActualHorizontalAlignment", 4, enumGetBox(CellContentHorizontalAlignment_$type, b), enumGetBox(CellContentHorizontalAlignment_$type, this.a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "h", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            var b = this.f;
            this.f = a;
            if (this.f != b) {
                this.c2("VerticalAlignment", 4, enumGetBox(CellContentVerticalAlignment_$type, b), enumGetBox(CellContentVerticalAlignment_$type, this.f));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "y", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (this.w != b) {
                this.c2("LineBreakMode", 10, enumGetBox(TextCellLineBreakMode_$type, b), enumGetBox(TextCellLineBreakMode_$type, this.w));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "x", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            if (this.v != b) {
                this.c2("ActualLineBreakMode", 4, enumGetBox(TextCellLineBreakMode_$type, b), enumGetBox(TextCellLineBreakMode_$type, this.v));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ek", {
        get: function () {
            return this.dx;
        },
        set: function (a) {
            var b = this.dx;
            this.dx = a;
            if (this.dx != b) {
                this.c2("TextColor", 10, b, this.dx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d6", {
        get: function () {
            return this.dq;
        },
        set: function (a) {
            var b = this.dq;
            this.dq = a;
            if (this.dq != b) {
                this.c2("ActualTextColor", 2, b, this.dq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "aw", {
        get: function () {
            return this.as;
        },
        set: function (a) {
            var b = this.as;
            this.as = a;
            if (this.as != b) {
                this.c2("PinnedRowOpacity", 10, b, this.as);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "at", {
        get: function () {
            return this.aq;
        },
        set: function (a) {
            var b = this.aq;
            this.aq = a;
            if (this.aq != b) {
                this.c2("ActualPinnedRowOpacity", 0, b, this.aq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "textStyle", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            var b = this.ac;
            this.ac = a;
            if (this.ac != b) {
                this.c2("FontInfo", 10, b, this.ac);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ad", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            var b = this.ab;
            this.ab = a;
            if (this.ab != b) {
                this.c2("ActualFontInfo", 3, b, this.ab);
            }
        },
        enumerable: true,
        configurable: true
    });
    DefinitionBase.prototype.k = function (a, b) {
        var c = this.l(a);
        c.i2 = b;
        return c;
    };
    DefinitionBase.prototype.cl = function (a, b, c, d) {
        var e = this.cm(a, b, c);
        if (this.cellStyleKeyRequested == null) {
            return e;
        }
        var f = new CellStyleRequestedEventArgs();
        f.resolvedValue = c;
        f.rowNumber = d;
        f.styleKey = e;
        this.cellStyleKeyRequested(this, f);
        return f.styleKey;
    };
    DefinitionBase.prototype.cw = function (a, b, c, d) {
        a.a4 = b.model.bl;
        a.f = this.c;
        a.h = this.h;
        a.b4 = 0;
        a.b9 = 0;
        a.b5 = 0;
        a.ca = 0;
        a.b1 = 1;
        a.cb = 0;
        a.b6 = 1;
        a.b1 = this.au;
        a.kt = this.d6;
        a.kh = this.d0;
        a.kd = this.dz;
        a.dd = this.ba;
        a.di = this.bc;
        a.dg = this.bb;
        a.db = this.a9;
        a.kk = this.d2;
        a.er = this.bi;
        a.ew = this.bk;
        a.eu = this.bj;
        a.ep = this.bh;
        if (this.ag) {
            a.ki = this.d1;
            a.eb = this.be;
            a.ee = this.bf;
            a.eg = this.bg;
            a.d9 = this.bd;
        }
        else {
            if (a.ki != null) {
                a.ki = null;
                a.eb = 0;
                a.eg = 0;
                a.ee = 0;
                a.d9 = 0;
            }
        }
        if (this.grid != null) {
            if (this.ad != null) {
                this.ad.t(this.grid.externalGrid.renderer);
            }
        }
        a.af = this.ad;
        a.z = this.x;
        a.ks = this.d5;
        a.kp = this.d4;
        a.ko = this.d3;
        a.b7 = this.at;
        if (a.c == null) {
            a.c = new DefaultCellActionManager(b, a);
        }
        if (a.d == null) {
            a.d = new DefaultGridInfoRequestor(b, a);
        }
    };
    DefinitionBase.prototype.cx = function (a, b, c, d) {
        if (this.dataBinding != null) {
            var e = this.n(a, b, c, d);
            this.dataBinding(this, e);
            c = e.resolvedValue;
            d = e.rowObject;
        }
        this.cy(a, b, c, d);
        if (this.dataBound != null) {
            this.dataBound(this, this.n(a, b, c, d));
        }
    };
    DefinitionBase.prototype.n = function (a, b, c, d) {
        var e = new DataBindingEventArgs();
        e.cellInfo = a;
        e.resolvedValue = c;
        e.rowObject = d;
        return e;
    };
    DefinitionBase.prototype.cy = function (a, b, c, d) {
        a.gq = d;
        if (!a.k.g && this.ai()) {
            var e = this.aa;
            var f = e.o;
            var g = f.count;
            var h = e.p;
            var i = e.q;
            for (var j = 0; j < g; j++) {
                if (h._inner[j]) {
                    continue;
                }
                a.jv(f._inner[j], i._inner[j]);
            }
        }
    };
    DefinitionBase.prototype.c5 = function () {
        for (var a = 0; a < this.ao.count; a++) {
            if (!this.ak(this.ao._inner[a])) {
                this.aj(this.ao._inner[a]);
            }
        }
    };
    DefinitionBase.prototype.aj = function (a) {
        if (this.ah(a)) {
            var b = 11;
            if (this.al.containsKey(a)) {
                b = this.al.item(a);
            }
            this.c3(a, b, this.bn(a), this.bn(a));
            return true;
        }
        return false;
    };
    DefinitionBase.prototype.ak = function (a) {
        if (stringStartsWith(a, "Actual")) {
            return false;
        }
        switch (a) {
            case "Background":
                this.c2("ActualBackground", 2, this.d0, this.d0);
                return true;
            case "ContentOpacity":
                this.c2("ContentOpacity", 0, this.au, this.au);
                return true;
            case "FontInfo":
                this.c2("ActualFontInfo", 3, this.ad, this.ad);
                return true;
            case "HorizontalAlignment":
                this.c2("ActualHorizontalAlignment", 4, enumGetBox(CellContentHorizontalAlignment_$type, this.c), enumGetBox(CellContentHorizontalAlignment_$type, this.c));
                return true;
            case "TextColor":
                this.c2("ActualTextColor", 2, this.d6, this.d6);
                return true;
            case "VerticalAlignment":
                this.c2("VerticalAlignment", 4, enumGetBox(CellContentVerticalAlignment_$type, this.h), enumGetBox(CellContentVerticalAlignment_$type, this.h));
                return true;
            case "Border":
                this.c2("ActualBorder", 2, this.d1, this.d1);
                return true;
            case "ActivationBorder":
                this.c2("ActualActivationBorder", 2, this.dz, this.dz);
                return true;
            case "BorderLeftWidth":
                this.c2("BorderLeftWidth", 0, this.be, this.be);
                return true;
            case "BorderTopWidth":
                this.c2("BorderTopWidth", 0, this.bg, this.bg);
                return true;
            case "BorderRightWidth":
                this.c2("BorderRightWidth", 0, this.bf, this.bf);
                return true;
            case "BorderBottomWidth":
                this.c2("BorderBottomWidth", 0, this.bd, this.bd);
                return true;
            case "ActivationBorderLeftWidth":
                this.c2("ActivationBorderLeftWidth", 0, this.ba, this.ba);
                return true;
            case "ActivationBorderTopWidth":
                this.c2("ActivationBorderTopWidth", 0, this.bc, this.bc);
                return true;
            case "ActivationBorderRightWidth":
                this.c2("ActivationBorderRightWidth", 0, this.bb, this.bb);
                return true;
            case "ActivationBorderBottomWidth":
                this.c2("ActivationBorderBottomWidth", 0, this.a9, this.a9);
                return true;
        }
        return false;
    };
    DefinitionBase.prototype.c2 = function (a, b, c, d) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.c3(a, b, c, d);
        if (this.definitionPropertyUpdated != null) {
            this.definitionPropertyUpdated(this, ((function () {
                var $ret = new DefinitionPropertyUpdatedEventArgs();
                $ret.propertyName = a;
                $ret.animationType = b;
                $ret.newValue = d;
                $ret.oldValue = c;
                return $ret;
            })()));
        }
    };
    DefinitionBase.prototype.c8 = function () {
        if (this.d7 != null) {
            this.d0 = this.d7;
        }
        else {
            this.d0 = this.eb();
        }
    };
    DefinitionBase.prototype.df = function () {
        if (this.ek != null) {
            this.d6 = this.ek;
        }
        else {
            this.d6 = this.eg();
        }
    };
    DefinitionBase.prototype.dg = function () {
        this.ad = this.textStyle;
    };
    DefinitionBase.prototype.dd = function () {
        if (!isNaN_(this.aw)) {
            this.at = this.aw;
        }
        else {
            this.at = this.av();
        }
    };
    DefinitionBase.prototype.dc = function () {
        if (this.ei != null) {
            this.d4 = this.ei;
        }
        else {
            this.d4 = this.ed();
        }
    };
    DefinitionBase.prototype.de = function () {
        if (this.ej != null) {
            this.d5 = this.ej;
        }
        else {
            this.d5 = this.ef();
        }
    };
    DefinitionBase.prototype.db = function () {
        if (this.eh != null) {
            this.d3 = this.eh;
        }
        else {
            this.d3 = this.ec();
        }
    };
    DefinitionBase.prototype.c3 = function (a, b, c, d) {
        this.cv(a, b);
        switch (a) {
            case "TextColor":
                this.df();
                break;
            case "Background":
                this.c8();
                break;
            case "PinnedBackground":
                this.de();
                break;
            case "PinnedRowBackground":
                this.dc();
                break;
            case "LastStickyRowBackground":
                this.db();
                break;
            case "PinnedRowOpacity":
                this.dd();
                break;
            case "VerticalAlignment":
                if (this.j == 4) {
                    this.h = this.i();
                }
                else {
                    this.h = this.j;
                }
                break;
            case "HorizontalAlignment":
                if (this.e == 4) {
                    this.c = this.d();
                }
                else {
                    this.c = this.e;
                }
                break;
            case "LineBreakMode":
                this.x = this.y;
                break;
            case "FontInfo":
                this.dg();
                break;
            case "Border":
            case "BorderLeftWidth":
            case "BorderTopWidth":
            case "BorderRightWidth":
            case "BorderBottomWidth":
                this.c9();
                break;
            case "ActivationBorder":
                this.c7();
                break;
            case "ErrorBorder":
                this.da();
                break;
        }
    };
    DefinitionBase.prototype.c9 = function () {
        if (this.be != 0 || this.bg != 0 || this.bf != 0 || this.bd != 0) {
            if (this.d8 != null) {
                this.ag = true;
                this.d1 = this.d8;
            }
            else if (this.d1 != null) {
                this.ag = true;
            }
        }
    };
    DefinitionBase.prototype.c7 = function () {
        if (this.grid != null && this.grid.ho) {
            if (this.dy == null) {
                this.dz = this.ea();
            }
            else {
                this.dz = this.dy;
            }
        }
        else {
            this.dy = null;
        }
    };
    DefinitionBase.prototype.da = function () {
        if (this.d9 != null) {
            this.d2 = this.d9;
        }
        else {
            this.d2 = GridStyleRepository.bg;
        }
    };
    Object.defineProperty(DefinitionBase.prototype, "an", {
        get: function () {
            return this.am;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ap", {
        get: function () {
            return this.ao;
        },
        enumerable: true,
        configurable: true
    });
    DefinitionBase.prototype.cv = function (a, b) {
        if (this.am.contains(a)) {
            return;
        }
        this.am.add_1(a);
        this.ao.add(a);
        this.al.addItem(a, b);
    };
    DefinitionBase.prototype.d = function () {
        if (this.e != 4) {
            return this.e;
        }
        return 0;
    };
    DefinitionBase.prototype.i = function () {
        if (this.j != 4) {
            return this.j;
        }
        return 1;
    };
    DefinitionBase.prototype.eg = function () {
        return GridStyleRepository.bn;
    };
    DefinitionBase.prototype.ea = function () {
        return GridStyleRepository.av;
    };
    DefinitionBase.prototype.af = function () {
        return GridStyleRepository.l;
    };
    DefinitionBase.prototype.eb = function () {
        return GridStyleRepository.aw;
    };
    DefinitionBase.prototype.ef = function () {
        return null;
    };
    DefinitionBase.prototype.ed = function () {
        return null;
    };
    DefinitionBase.prototype.ec = function () {
        return null;
    };
    DefinitionBase.prototype.ee = function () {
        return GridStyleRepository.ba;
    };
    DefinitionBase.prototype.av = function () {
        return 0.3;
    };
    DefinitionBase.prototype.c6 = function (a, b, c) {
        if (this.z == null) {
            this.z = new FastIterationDictionary$2(String_$type, Base.$, 0);
        }
        var d = null;
        if (this.z.d(a)) {
            d = this.z.item(a);
        }
        this.z.item(a, c);
        var e = false;
        if (d == null && c != null) {
            e = true;
        }
        if (d != null) {
            if (!Base.equalsStatic(d, c)) {
                e = true;
            }
        }
        if (e) {
            this.c2(a, b, d, c);
        }
    };
    DefinitionBase.prototype.ai = function () {
        if (this.z == null) {
            return false;
        }
        return this.z.r > 0;
    };
    Object.defineProperty(DefinitionBase.prototype, "aa", {
        get: function () {
            return this.z;
        },
        enumerable: true,
        configurable: true
    });
    DefinitionBase.prototype.ah = function (a) {
        if (this.z == null) {
            return false;
        }
        return this.z.d(a);
    };
    DefinitionBase.prototype.c4 = function (a) {
        if (this.z == null) {
            return;
        }
        if (this.z.d(a)) {
            this.z.f(a);
        }
    };
    DefinitionBase.prototype.bn = function (a) {
        if (this.z == null) {
            return null;
        }
        if (this.z.d(a)) {
            return this.z.item(a);
        }
        return null;
    };
    DefinitionBase.prototype.ck = function (a, b, c) {
        var d = stringEmpty();
        switch (b) {
            case 10:
                if (c != null) {
                    var override_ = c;
                    var val_ = typeGetValue(a);
                    d = (override_.format(val_));
                }
                else {
                    d = (typeGetValue(a)).toString();
                }
                break;
            case 8:
                if (c != null) {
                    var override_ = c;
                    var val_ = a;
                    d = (override_.format(val_));
                }
                else {
                    d = a.toString();
                }
                break;
            case 5:
                if (c != null) {
                    var override_ = c;
                    var val_ = a;
                    d = (override_.format(val_));
                }
                else {
                    d = a.toString();
                }
                break;
            case 1:
                if (c != null) {
                    var override_ = c;
                    var val_ = typeGetValue(a);
                    d = (override_.format(val_));
                }
                else {
                    d = (typeGetValue(a)).toString();
                }
                break;
            case 3:
                if (c != null) {
                    var override_ = c;
                    var val_ = typeGetValue(a);
                    d = (override_.format(val_));
                }
                else {
                    d = typeGetValue(a).toString();
                }
                break;
            case 4:
                if (c != null) {
                    var override_ = c;
                    var val_ = typeGetValue(a);
                    d = (override_.format(val_));
                }
                else {
                    d = typeGetValue(a).toString();
                }
                break;
            case 7:
                if (c != null) {
                    var override_ = c;
                    var val_ = a;
                    d = (override_.format(val_));
                }
                else {
                    d = a.toString();
                }
                break;
            case 6:
                if (c != null) {
                    var override_ = c;
                    var val_ = a;
                    d = (override_.format(val_));
                }
                else {
                    d = a.toString();
                }
                break;
            case 0:
            case 2:
            case 11:
                d = a.toString();
                break;
        }
        return d;
    };
    DefinitionBase.prototype.u = function (a, b) {
        var c = b != null ? b.value.toString() : stringEmpty();
        var d = a.g;
        if (a.n == 4) {
            d = 1;
        }
        var e = b.value;
        switch (d) {
            case 10:
                if (a.w != null) {
                    var override_ = a.w;
                    var val_ = typeGetValue(e);
                    c = (override_.format(val_));
                }
                else {
                    c = (typeGetValue(e)).toString();
                }
                break;
            case 8:
                if (a.w != null) {
                    var override_ = a.w;
                    var val_ = e;
                    c = (override_.format(val_));
                }
                else {
                    c = e.toString();
                }
                break;
            case 5:
                if (a.w != null) {
                    var override_ = a.w;
                    var val_ = e;
                    c = (override_.format(val_));
                }
                else {
                    var summaryValue_ = e;
                    var maxFractionDigits_ = a.u;
                    c = (parseFloat(summaryValue_.toFixed(maxFractionDigits_)).toString());
                }
                break;
            case 1:
                if (a.w != null) {
                    var override_ = a.w;
                    var val_ = typeGetValue(e);
                    c = (override_.format(val_));
                }
                else {
                    c = (typeGetValue(e)).toString();
                }
                break;
            case 3:
                if (a.w != null) {
                    var override_ = a.w;
                    var val_ = typeGetValue(e);
                    c = (override_.format(val_));
                }
                else {
                    c = typeGetValue(e).toString();
                }
                break;
            case 4:
                if (a.w != null) {
                    var override_ = a.w;
                    var val_ = typeGetValue(e);
                    c = (override_.format(val_));
                }
                else {
                    c = typeGetValue(e).toString();
                }
                break;
            case 7:
                if (a.w != null) {
                    var override_ = a.w;
                    var val_ = e;
                    c = (override_.format(val_));
                }
                else {
                    var summaryValue_ = e;
                    var maxFractionDigits_ = a.u;
                    c = (parseFloat(summaryValue_.toFixed(maxFractionDigits_)).toString());
                }
                break;
            case 6:
                if (a.w != null) {
                    var override_ = a.w;
                    var val_ = e;
                    c = (override_.format(val_));
                }
                else {
                    var summaryValue_ = e;
                    var maxFractionDigits_ = a.u;
                    c = (parseFloat(summaryValue_.toFixed(maxFractionDigits_)).toString());
                }
                break;
            case 0:
            case 2:
            case 11:
                c = e.toString();
                break;
        }
        var f = a.ac != null ? a.ac : a.j != null ? a.j.displayName : stringEmpty();
        if (a.f != null) {
            c = a.f.i(e);
        }
        var g = stringIsNullOrWhiteSpace(a.ae) ? a.af : a.ae;
        var h = g + " " + f + " = " + c;
        if (a.e != null) {
            h = a.e.i(e);
        }
        var i = a.o(b, c, h);
        h = i.e;
        c = i.d;
        return ((function () {
            var $ret = new SummaryData();
            $ret.e = g;
            $ret.b = e;
            $ret.a = a.n;
            $ret.c = i.e;
            $ret.d = i.d;
            return $ret;
        })());
    };
    DefinitionBase.$t = markType(DefinitionBase, 'DefinitionBase', Base.$, [INotifyPropertyChanged_$type]);
    return DefinitionBase;
}(Base));
export { DefinitionBase };
/**
 * @hidden
 */
var Column = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Column, _super);
    function Column() {
        var _this = _super.call(this) || this;
        _this.g6 = 0;
        _this.e7 = 0;
        _this.gv = truncate(DeviceUtils.g(12));
        _this.gx = truncate(DeviceUtils.g(1));
        _this.gw = truncate(DeviceUtils.g(12));
        _this.gu = truncate(DeviceUtils.g(1));
        _this.he = stringEmpty();
        _this.gs = 0;
        _this.gr = 0;
        _this.gt = 0;
        _this.fh = 0;
        _this.hc = null;
        _this.hd = null;
        _this.ha = null;
        _this.jp = null;
        _this.jk = null;
        _this.jn = null;
        _this.ji = null;
        _this.jo = null;
        _this.jj = null;
        _this.fd = null;
        _this.e9 = null;
        _this.gn = NaN;
        _this.f0 = false;
        _this.fv = false;
        _this.f3 = false;
        _this.en = null;
        _this.ff = null;
        _this.fz = true;
        _this.f2 = true;
        _this.f1 = false;
        _this.f4 = false;
        _this.e5 = 0;
        _this.fi = 0;
        _this.fu = false;
        _this.ev = 0;
        _this.ew = 0;
        _this.jg = null;
        _this.jl = null;
        _this.e0 = 0;
        _this.ez = 0;
        _this.fr = true;
        _this.fw = true;
        _this.fs = true;
        _this.fx = true;
        _this.fy = true;
        _this.jm = null;
        _this.jh = null;
        _this.gm = NaN;
        _this.gl = 0;
        _this.fo = null;
        _this.fn = null;
        _this.fb = 0;
        _this.g7 = null;
        _this.hb = null;
        _this.el = null;
        _this.columnCellsPropertyUpdating = null;
        _this.columnHeaderCellsPropertyUpdating = null;
        _this.fl = null;
        _this.ft = false;
        _this.ft = true;
        _this.header = new TextHeader();
        _this.ft = false;
        _this.c = _this.d();
        _this.h = _this.i();
        _this.ju = _this.jy();
        _this.js = _this.jx();
        _this.g6 = Column.g5++;
        return _this;
    }
    Column.prototype.jy = function () {
        return GridStyleRepository.ba;
    };
    Column.prototype.jx = function () {
        return GridStyleRepository.a1;
    };
    Object.defineProperty(Column.prototype, "e8", {
        get: function () {
            return this.e7;
        },
        set: function (a) {
            var b = this.e7;
            this.e7 = a;
            if (this.e7 != b) {
                this.c2("State", 10, enumGetBox(ColumnStates_$type, b), enumGetBox(ColumnStates_$type, this.e7));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "g2", {
        get: function () {
            return this.gv;
        },
        set: function (a) {
            var b = this.gv;
            this.gv = a;
            if (this.gv != b) {
                this.c2("PaddingLeft", 6, b, this.gv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "g4", {
        get: function () {
            return this.gx;
        },
        set: function (a) {
            var b = this.gx;
            this.gx = a;
            if (this.gx != b) {
                this.c2("PaddingTop", 6, b, this.gx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "g3", {
        get: function () {
            return this.gw;
        },
        set: function (a) {
            var b = this.gw;
            this.gw = a;
            if (this.gw != b) {
                this.c2("PaddingRight", 6, b, this.gw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "g1", {
        get: function () {
            return this.gu;
        },
        set: function (a) {
            var b = this.gu;
            this.gu = a;
            if (this.gu != b) {
                this.c2("PaddingBottom", 6, b, this.gu);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "il", {
        get: function () {
            return this.he;
        },
        set: function (a) {
            var b = this.he;
            this.he = a;
            if (this.he != b) {
                this.c2("Name", 10, b, this.he);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gz", {
        get: function () {
            return this.gs;
        },
        set: function (a) {
            this.gs = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gy", {
        get: function () {
            return this.gr;
        },
        set: function (a) {
            this.gr = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "g0", {
        get: function () {
            return this.gt;
        },
        set: function (a) {
            this.gt = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "fj", {
        get: function () {
            return this.fh;
        },
        set: function (a) {
            this.fh = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "h4", {
        get: function () {
            return this.hc;
        },
        set: function (a) {
            this.hc = a;
            if (this.h8 == null) {
                this.hl = this.h4;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "h8", {
        get: function () {
            return this.hd;
        },
        set: function (a) {
            var b = this.hd;
            this.hd = a;
            if (this.hd != b) {
                this.c2("HeaderText", 8, b, this.hd);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "hl", {
        get: function () {
            return this.ha;
        },
        set: function (a) {
            var b = this.ha;
            this.ha = a;
            if (this.ha != b) {
                this.c2("ActualHeaderText", 8, b, this.ha);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "j1", {
        get: function () {
            return this.jp;
        },
        set: function (a) {
            var b = this.jp;
            this.jp = a;
            if (this.jp != b) {
                this.c2("SelectedBackground", 10, b, this.jp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ju", {
        get: function () {
            return this.jk;
        },
        set: function (a) {
            var b = this.jk;
            this.jk = a;
            if (this.jk != b) {
                this.c2("ActualSelectedBackground", 2, b, this.jk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "jz", {
        get: function () {
            return this.jn;
        },
        set: function (a) {
            var b = this.jn;
            this.jn = a;
            if (this.jn != b) {
                this.c2("RowHoverBackground", 10, b, this.jn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "js", {
        get: function () {
            return this.ji;
        },
        set: function (a) {
            var b = this.ji;
            this.ji = a;
            if (this.ji != b) {
                this.c2("ActualHoverBackground", 2, b, this.ji);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "j0", {
        get: function () {
            return this.jo;
        },
        set: function (a) {
            var b = this.jo;
            this.jo = a;
            if (this.jo != b) {
                this.c2("RowHoverTextColor", 10, b, this.jo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "jt", {
        get: function () {
            return this.jj;
        },
        set: function (a) {
            var b = this.jj;
            this.jj = a;
            if (this.jj != b) {
                this.c2("ActualRowHoverTextColor", 2, b, this.jj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "fe", {
        get: function () {
            return this.fd;
        },
        set: function (a) {
            var b = this.fd;
            this.fd = a;
            if (this.fd != b) {
                this.c2("AnimationSettings", 10, b, "AnimationSettings");
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "width", {
        get: function () {
            return this.e9;
        },
        set: function (a) {
            var b = this.e9;
            this.e9 = a;
            if (this.e9 != b) {
                this.c2("Width", 10, b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gq", {
        get: function () {
            return this.gn;
        },
        set: function (a) {
            var b = this.gn;
            this.gn = a;
            if (this.gn != b) {
                this.c2("MinWidth", 10, b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gg", {
        get: function () {
            return this.f0;
        },
        set: function (a) {
            var b = this.f0;
            this.f0 = a;
            if (this.f0 != b) {
                this.c2("IsFromMarkup", 10, b, this.f0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gb", {
        get: function () {
            return this.fv;
        },
        set: function (a) {
            var b = this.fv;
            if (a) {
                this.gj = true;
            }
            this.fv = a;
            if (this.fv != b) {
                this.c2("IsAutoGenerated", 10, b, this.fv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gj", {
        get: function () {
            return this.f3;
        },
        set: function (a) {
            var self_ = this;
            var value_ = a;
            this.f3 = value_;
            self_.___mustPassByValue = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "eo", {
        get: function () {
            return this.en;
        },
        set: function (a) {
            var b = this.en;
            this.en = a;
            if (this.en != b) {
                this.c2("Filter", 10, b, this.en);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "header", {
        get: function () {
            return this.ff;
        },
        set: function (a) {
            var b = this.ff;
            this.ff = a;
            if (this.ff != b) {
                this.c2("Header", 10, b, this.ff);
            }
            this.ff.grid = this.grid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gf", {
        get: function () {
            return this.fz;
        },
        set: function (a) {
            var b = this.fz;
            this.fz = a;
            if (this.fz != b) {
                this.c2("IsFilteringEnabled", 10, b, this.fz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gi", {
        get: function () {
            return this.f2;
        },
        set: function (a) {
            var b = this.f2;
            this.f2 = a;
            if (this.f2 != b) {
                this.c2("IsResizingEnabled", 10, b, this.f2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gh", {
        get: function () {
            return this.f1;
        },
        set: function (a) {
            var b = this.f1;
            this.f1 = a;
            if (this.f1 != b) {
                this.c2("IsHidden", 10, b, this.f1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gk", {
        get: function () {
            return this.f4;
        },
        set: function (a) {
            var b = this.f4;
            this.f4 = a;
            if (this.f4 != b) {
                this.c2("ShouldRemoveWhenHidden", 10, b, this.f4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "e6", {
        get: function () {
            return this.e5;
        },
        set: function (a) {
            var b = this.e5;
            this.e5 = a;
            if (this.e5 != b) {
                this.c2("SortDirection", 11, enumGetBox(ColumnSortDirection_$type, b), enumGetBox(ColumnSortDirection_$type, this.e5));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "fk", {
        get: function () {
            return this.fi;
        },
        set: function (a) {
            var b = this.fi;
            this.fi = a;
            if (this.fi != b) {
                this.c2("Pinned", 11, enumGetBox(PinnedPositions_$type, b), enumGetBox(PinnedPositions_$type, this.fi));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ga", {
        get: function () {
            return this.fu;
        },
        set: function (a) {
            var b = this.fu;
            this.fu = a;
            if (this.fu != b) {
                this.c2("InternalShouldRemoveWhenHidden", 10, b, this.fu);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "f7", {
        get: function () {
            if (this.fu) {
                return true;
            }
            return this.f4;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ex", {
        get: function () {
            return this.ev;
        },
        set: function (a) {
            var b = this.ev;
            this.ev = a;
            if (this.ev != b) {
                this.c2("ActualColumnOptionsIconAlignment", 4, enumGetBox(ColumnOptionsIconAlignment_$type, b), enumGetBox(ColumnOptionsIconAlignment_$type, this.ev));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ey", {
        get: function () {
            return this.ew;
        },
        set: function (a) {
            var b = this.ew;
            this.ew = a;
            if (this.ew != b) {
                this.c2("ColumnOptionsIconAlignment", 10, enumGetBox(ColumnOptionsIconAlignment_$type, b), enumGetBox(ColumnOptionsIconAlignment_$type, this.ew));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "jq", {
        get: function () {
            return this.jg;
        },
        set: function (a) {
            var b = this.jg;
            this.jg = a;
            if (this.jg != b) {
                this.c2("ActualColumnOptionsIconColor", 2, b, this.jg);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "jv", {
        get: function () {
            return this.jl;
        },
        set: function (a) {
            var b = this.jl;
            this.jl = a;
            if (this.jl != b) {
                this.c2("ColumnOptionsIconColor", 10, b, this.jl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "e2", {
        get: function () {
            return this.e0;
        },
        set: function (a) {
            var b = this.e0;
            this.e0 = a;
            if (this.e0 != b) {
                this.c2("ColumnOptionsIconBehavior", 10, enumGetBox(ColumnOptionsIconBehavior_$type, b), enumGetBox(ColumnOptionsIconBehavior_$type, this.e0));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "e1", {
        get: function () {
            return this.ez;
        },
        set: function (a) {
            var b = this.ez;
            this.ez = a;
            if (this.ez != b) {
                this.c2("ActualColumnOptionsIconBehavior", 4, enumGetBox(ColumnOptionsIconBehavior_$type, b), enumGetBox(ColumnOptionsIconBehavior_$type, this.ez));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "f5", {
        get: function () {
            return this.fr;
        },
        set: function (a) {
            var b = this.fr;
            this.fr = a;
            if (this.fr != b) {
                this.c2("ActualIsColumnOptionsEnabled", 5, b, this.fr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gc", {
        get: function () {
            return this.fw;
        },
        set: function (a) {
            var b = this.fw;
            this.fw = a;
            if (this.fw != b) {
                this.c2("IsColumnOptionsEnabled", 10, b, this.fw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "f6", {
        get: function () {
            return this.fs;
        },
        set: function (a) {
            var b = this.fs;
            this.fs = a;
            if (this.fs != b) {
                this.c2("ActualIsColumnOptionsSummariesEnabled", 5, b, this.fs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gd", {
        get: function () {
            return this.fx;
        },
        set: function (a) {
            var b = this.fx;
            this.fx = a;
            if (b != this.fx) {
                this.c2("IsColumnOptionsSummariesEnabled", 10, b, this.fx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ge", {
        get: function () {
            return this.fy;
        },
        set: function (a) {
            var b = this.fy;
            this.fy = a;
            if (this.fy != b) {
                this.c2("IsEditable", 10, b, this.fy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "jw", {
        get: function () {
            return this.jm;
        },
        set: function (a) {
            var b = this.jm;
            this.jm = a;
            if (this.jm != b) {
                this.c2("DeletedTextColor", 10, b, this.jm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "jr", {
        get: function () {
            return this.jh;
        },
        set: function (a) {
            var b = this.jh;
            this.jh = a;
            if (this.jh != b) {
                this.c2("ActualDeletedTextColor", 2, b, this.jh);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gp", {
        get: function () {
            return this.gm;
        },
        set: function (a) {
            var b = this.gm;
            this.gm = a;
            if (this.gm != b) {
                this.c2("EditOpacity", 10, b, this.gm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "go", {
        get: function () {
            return this.gl;
        },
        set: function (a) {
            var b = this.gl;
            this.gl = a;
            if (this.gl != b) {
                this.c2("ActualEditOpacity", 0, b, this.gl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "textEditStyle", {
        get: function () {
            return this.fo;
        },
        set: function (a) {
            var b = this.fo;
            this.fo = a;
            if (this.fo != b) {
                this.c2("EditFontInfo", 10, b, this.fo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "fp", {
        get: function () {
            return this.fn;
        },
        set: function (a) {
            var b = this.fn;
            this.fn = a;
            if (this.fn != b) {
                this.c2("ActualEditFontInfo", 3, b, this.fn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "fc", {
        get: function () {
            return this.fb;
        },
        set: function (a) {
            var b = this.fb;
            this.fb = a;
            if (b != this.fb) {
                this.c2("EditorTypeInternal", 4, enumGetBox(EditorType_$type, b), enumGetBox(EditorType_$type, this.fb));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "g8", {
        get: function () {
            return this.g7;
        },
        set: function (a) {
            var b = this.g7;
            this.g7 = a;
            if (b != this.g7) {
                this.c2("EditorItemsSourceInternal", 9, b, this.g7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "h0", {
        get: function () {
            return this.hb;
        },
        set: function (a) {
            var b = this.hb;
            this.hb = a;
            if (b != this.hb) {
                this.c2("EditorTextFieldInternal", 8, b, this.hb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "em", {
        get: function () {
            return this.el;
        },
        set: function (a) {
            var b = this.el;
            this.el = a;
            if (b != this.el) {
                this.c2("EditorValueFieldInternal", 8, b, this.el);
            }
        },
        enumerable: true,
        configurable: true
    });
    Column.prototype.ed = function () {
        return GridStyleRepository.a4;
    };
    Column.prototype.ef = function () {
        return GridStyleRepository.bb;
    };
    Column.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        a.gp = c;
        a.ay = b.ee.isEditedValue(d, this.h4);
        a.av = b.ee.isDeletedRow(d);
        a.en = b.ee.getPendingEditID(d, this.h4);
        a.hm = b.ee.getError(a.en);
        if (b.cc.a == a) {
            b.cc.d.gp = a.gp;
        }
        if (b.e5.p(a)) {
            a.b8 = 1;
        }
        else {
            a.b8 = 0;
        }
        if (b.aj.m(a)) {
            a.by = 1;
        }
        else {
            a.by = 0;
        }
        if (b.ea.c(a.k.w)) {
            a.b3 = 1;
        }
        else {
            a.b3 = 0;
        }
    };
    Column.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        a.kq = this.ju;
        a.km = this.js;
        a.kn = this.jt;
        a.fp = this.g2;
        a.ft = this.g4;
        a.fr = this.g3;
        a.fn = this.g1;
        if (this.grid != null) {
            if (this.fp != null) {
                this.fp.t(this.grid.externalGrid.renderer);
            }
        }
        a.ae = this.fp;
        a.b2 = this.go;
        a.kj = this.jr;
    };
    Column.prototype.c3 = function (a, b, c, d) {
        _super.prototype.c3.call(this, a, b, c, d);
        switch (a) {
            case "Header":
                var e = c;
                var f = d;
                if (e != null) {
                    e.definitionPropertyUpdated = delegateRemove(e.definitionPropertyUpdated, runOn(this, this.i0));
                }
                if (f != null) {
                    f.definitionPropertyUpdated = delegateCombine(f.definitionPropertyUpdated, runOn(this, this.i0));
                    if (f.e == 4) {
                        f.c = this.ep();
                    }
                    if (f.j == 4) {
                        f.h = this.eq();
                    }
                    if (!this.ft) {
                        f.c5();
                    }
                }
                break;
            case "HeaderText":
                this.hl = d;
                break;
            case "SelectedBackground":
                this.jf();
                break;
            case "ActualHorizontalAlignment":
                if (this.header != null) {
                    if (this.header.e == 4) {
                        this.header.c = this.ep();
                    }
                }
                break;
            case "VerticalAlignment":
                if (this.header != null) {
                    if (this.header.j == 4) {
                        this.header.h = this.eq();
                    }
                }
                break;
            case "SortDirection":
                this.jc(this, "SortDirection", 11, c, d);
                break;
            case "ActualLastStickyRowBackground":
                if (c != null && this.d3 == null) {
                    d = this.d5;
                }
                break;
            case "ColumnOptionsIconAlignment":
                this.i4();
                break;
            case "ColumnOptionsIconColor":
                this.i7();
                break;
            case "ColumnOptionsIconBehavior":
                this.i6();
                break;
            case "IsColumnOptionsEnabled":
                this.i5();
                break;
            case "IsColumnOptionsSummariesEnabled":
                this.i8();
                break;
            case "DeletedTextColor":
                this.i9();
                break;
            case "EditOpacity":
                this.jb();
                break;
            case "EditFontInfo":
                this.ja();
                break;
            case "RowHoverBackground":
                this.jd();
                break;
            case "RowHoverTextColor":
                this.je();
                break;
        }
        this.i3(a, b, c, d);
    };
    Column.prototype.eq = function () {
        return this.h;
    };
    Column.prototype.ep = function () {
        return this.c;
    };
    Column.prototype.jc = function (a, b, c, d, e) {
        if (this.columnHeaderCellsPropertyUpdating != null) {
            this.columnHeaderCellsPropertyUpdating(this, b, c, d, e);
        }
    };
    Column.prototype.i0 = function (a, b) {
        this.jc(this, b.propertyName, b.animationType, b.oldValue, b.newValue);
    };
    Column.prototype.cz = function (a, b) {
        if (this.header != null) {
            this.header.grid = b;
        }
        this.jf();
        this.jf();
        this.c8();
        this.df();
        this.dg();
        this.de();
        this.db();
        this.dc();
        this.dd();
        this.jb();
        this.ja();
        this.i9();
        this.i4();
        this.i7();
        this.i6();
        this.i5();
        this.i8();
        this.jd();
        this.je();
    };
    Column.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "CellSelectedBackground":
                this.jf();
                break;
            case "CellBackground":
                this.c8();
                break;
            case "CellTextColor":
                this.df();
                break;
            case "CellTextStyle":
                this.dg();
                break;
            case "StickyRowBackground":
                this.de();
                break;
            case "LastStickyRowBackground":
                this.db();
                break;
            case "PinnedRowBackground":
                this.dc();
                break;
            case "PinnedRowOpacity":
                this.dd();
                break;
            case "ColumnOptionsIconAlignment":
                this.i4();
                break;
            case "ColumnOptionsIconColor":
                this.i7();
                break;
            case "ColumnOptionsIconBehavior":
                this.i6();
                break;
            case "IsColumnOptionsEnabled":
                this.i5();
                break;
            case "IsColumnOptionsSummariesEnabled":
                this.i8();
                break;
            case "DeletedTextColor":
                this.i9();
                break;
            case "EditOpacity":
                this.jb();
                break;
            case "EditTextStyle":
                this.ja();
                break;
            case "RowHoverBackground":
                this.jd();
                break;
            case "RowHoverTextColor":
                this.je();
                break;
        }
    };
    Column.prototype.jd = function () {
        if (this.jz == null) {
            if (this.grid != null && this.grid.wh != null) {
                this.js = this.grid.wh;
                return;
            }
            this.js = this.jx();
        }
        else {
            this.js = this.jz;
        }
    };
    Column.prototype.je = function () {
        if (this.j0 == null) {
            if (this.grid != null && this.grid.wi != null) {
                this.jt = this.grid.wi;
                return;
            }
            this.jt = null;
        }
        else {
            this.jt = this.j0;
        }
    };
    Column.prototype.jf = function () {
        if (this.j1 == null) {
            if (this.grid != null && this.grid.v3 != null) {
                this.ju = this.grid.v3;
                return;
            }
            this.ju = this.jy();
        }
        else {
            this.ju = this.j1;
        }
    };
    Column.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.v2 != null) {
                this.d0 = this.grid.v2;
            }
            else {
                this.d0 = this.eb();
            }
        }
        else {
            this.d0 = this.d7;
        }
    };
    Column.prototype.df = function () {
        if (this.ek == null) {
            if (this.grid != null && this.grid.v4 != null) {
                this.d6 = this.grid.v4;
                return;
            }
            this.d6 = this.eg();
        }
        else {
            this.d6 = this.ek;
        }
    };
    Column.prototype.dg = function () {
        if (this.textStyle == null) {
            if (this.grid != null && this.grid.fu != null) {
                this.ad = this.grid.fu;
                return;
            }
            this.ad = this.af();
        }
        else {
            this.ad = this.textStyle;
        }
    };
    Column.prototype.dd = function () {
        if (isNaN_(this.aw)) {
            if (this.grid != null && !isNaN_(this.grid.ka)) {
                this.at = this.grid.ka;
                return;
            }
            this.at = this.av();
        }
        else {
            this.at = this.aw;
        }
    };
    Column.prototype.i9 = function () {
        if (this.jw == null) {
            if (this.grid != null && this.grid.v8 != null) {
                this.jr = this.grid.v8;
                return;
            }
            this.jr = GridStyleRepository.bm;
        }
        else {
            this.jr = this.jw;
        }
    };
    Column.prototype.jb = function () {
        if (isNaN_(this.gp)) {
            if (this.grid != null && !isNaN_(this.grid.j9)) {
                this.go = this.grid.j9;
                return;
            }
            this.go = GridStyleRepository.m;
        }
        else {
            this.go = this.gp;
        }
    };
    Column.prototype.ja = function () {
        if (this.textEditStyle == null) {
            if (this.grid != null && this.grid.fv != null) {
                this.fp = this.grid.fv;
                return;
            }
            this.fp = GridStyleRepository.k;
        }
        else {
            this.fp = this.textEditStyle;
        }
    };
    Column.prototype.dc = function () {
        if (this.ei == null) {
            if (this.grid != null && this.grid.wg != null) {
                this.d4 = this.grid.wg;
                return;
            }
            this.d4 = this.ed();
        }
        else {
            this.d4 = this.ei;
        }
    };
    Column.prototype.de = function () {
        if (this.ej == null) {
            if (this.grid != null && this.grid.wq != null) {
                this.d5 = this.grid.wq;
                return;
            }
            this.d5 = this.ef();
        }
        else {
            this.d5 = this.ej;
        }
    };
    Column.prototype.db = function () {
        if (this.eh == null) {
            if (this.grid != null && this.grid.wf != null) {
                this.d3 = this.grid.wf;
                return;
            }
            this.d3 = this.ec();
        }
        else {
            this.d3 = this.eh;
        }
    };
    Column.prototype.i4 = function () {
        if (this.ey == 0) {
            if (this.grid != null && this.grid.bl != 0) {
                this.ex = this.grid.bl;
                return;
            }
            this.ex = GridStyleRepository.a;
        }
        else {
            this.ex = this.ey;
        }
    };
    Column.prototype.i7 = function () {
        if (this.jv == null) {
            if (this.grid != null && this.grid.v6 != null) {
                this.jq = this.grid.v6;
                return;
            }
            this.jq = GridStyleRepository.az;
        }
        else {
            this.jq = this.jv;
        }
    };
    Column.prototype.i6 = function () {
        if (this.e2 == 0) {
            if (this.grid != null && this.grid.bn != 0) {
                this.e1 = this.grid.bn;
                return;
            }
            this.e1 = GridStyleRepository.b;
        }
        else {
            this.e1 = this.e2;
        }
    };
    Column.prototype.i5 = function () {
        if (this.grid != null) {
            this.f5 = this.grid.hx && this.gc;
        }
        else {
            this.f5 = false;
        }
    };
    Column.prototype.i8 = function () {
        if (this.grid != null) {
            this.f6 = this.grid.hy && this.gd;
        }
        else {
            this.f6 = false;
        }
    };
    Column.prototype.i3 = function (a, b, c, d) {
        if (this.columnCellsPropertyUpdating != null) {
            this.columnCellsPropertyUpdating(this, a, b, c, d);
        }
    };
    Column.prototype.eu = function () {
        if (this.c == 0) {
            return 3;
        }
        return 2;
    };
    Column.prototype.e4 = function () {
        if (this.c == 0) {
            return 3;
        }
        return 2;
    };
    Column.prototype.et = function () {
        return 2;
    };
    Column.prototype.e3 = function () {
        return 2;
    };
    Column.prototype.h6 = function () {
        return this.il != null && this.il != "" ? this.il : this.h4;
    };
    Column.prototype.i2 = function (a, b, c) {
        if (this.fl == null) {
            this.fl = new FastIterationDictionary$2(String_$type, Base.$, 0);
        }
        var d = null;
        if (this.fl.d(a)) {
            d = this.fl.item(a);
        }
        this.fl.item(a, c);
        var e = false;
        if (d == null && c != null) {
            e = true;
        }
        if (d != null) {
            if (!Base.equalsStatic(d, c)) {
                e = true;
            }
        }
        if (e) {
            this.jc(this, a, b, d, c);
        }
    };
    Column.prototype.f9 = function () {
        if (this.fl == null) {
            return false;
        }
        return this.fl.r > 0;
    };
    Object.defineProperty(Column.prototype, "fm", {
        get: function () {
            return this.fl;
        },
        enumerable: true,
        configurable: true
    });
    Column.prototype.f8 = function (a) {
        if (this.fl == null) {
            return false;
        }
        return this.fl.d(a);
    };
    Column.prototype.i1 = function (a) {
        if (this.fl == null) {
            return;
        }
        if (this.fl.d(a)) {
            this.fl.f(a);
        }
    };
    Column.prototype.g9 = function (a) {
        if (this.fl == null) {
            return null;
        }
        if (this.fl.d(a)) {
            return this.fl.item(a);
        }
        return null;
    };
    Column.$t = markType(Column, 'Column', DefinitionBase.$);
    Column.g5 = 0;
    return Column;
}(DefinitionBase));
export { Column };
/**
 * @hidden
 */
var GridColumnCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridColumnCollection, _super);
    function GridColumnCollection() {
        return _super.call(this, Column.$, 0) || this;
    }
    GridColumnCollection.$t = markType(GridColumnCollection, 'GridColumnCollection', ObservableCollection$1.$.specialize(Column.$));
    return GridColumnCollection;
}(ObservableCollection$1));
export { GridColumnCollection };
/**
 * @hidden
 */
var GridEffectGroup = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridEffectGroup, _super);
    function GridEffectGroup(a) {
        var _rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _rest[_i - 1] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this.c = null;
        _this.f = 0;
        _this.a = false;
        _this.b = false;
        _this.effectsFinished = null;
        _this.effectsCanceled = null;
        a = (a == void 0) ? 0 : a;
        switch (a) {
            case 0:
                {
                    var c = _rest[0];
                    _this.a = c;
                    _this.c = new List$1(GridEffect.$, 0);
                    _this.b = false;
                }
                break;
            case 1:
                {
                    var c = [true];
                    {
                        var e = c[0];
                        _this.a = e;
                        _this.c = new List$1(GridEffect.$, 0);
                        _this.b = false;
                    }
                }
                break;
        }
        return _this;
    }
    GridEffectGroup.prototype.k = function () {
        this.b = false;
        for (var a = 0; a < this.c.count; a++) {
            var b = this.c._inner[a];
            b.onFinished = delegateRemove(b.onFinished, runOn(this, this.i));
            var c = this.c._inner[a];
            c.onCanceled = delegateRemove(c.onCanceled, runOn(this, this.h));
        }
        this.f = 0;
        this.c.clear();
    };
    GridEffectGroup.prototype.g = function (a) {
        this.c.add(a);
        a.onFinished = delegateCombine(a.onFinished, runOn(this, this.i));
        a.onCanceled = delegateCombine(a.onCanceled, runOn(this, this.h));
    };
    GridEffectGroup.prototype.h = function (a, b) {
        this.b = true;
        this.f++;
        if (this.f == this.c.count) {
            this.j();
        }
    };
    GridEffectGroup.prototype.i = function (a) {
        this.f++;
        if (this.f == this.c.count) {
            this.j();
        }
    };
    GridEffectGroup.prototype.j = function () {
        if (this.b) {
            if (this.effectsCanceled != null) {
                this.effectsCanceled(this, new EventArgs());
            }
        }
        else {
            if (this.effectsFinished != null) {
                this.effectsFinished(this, new EventArgs());
            }
        }
        if (this.a) {
            this.k();
        }
    };
    GridEffectGroup.$t = markType(GridEffectGroup, 'GridEffectGroup');
    return GridEffectGroup;
}(Base));
export { GridEffectGroup };
/**
 * @hidden
 */
var HoverManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(HoverManager, _super);
    function HoverManager(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.b = false;
        _this.d = -1;
        _this.e = -1;
        _this.a = a;
        return _this;
    }
    HoverManager.prototype.f = function (a) {
        var _this = this;
        this.d = a;
        if (!this.b) {
            this.a.delayedExecutionManager.executeIn(function () {
                if (_this.d != _this.e) {
                    if (_this.e > -1) {
                        _this.a.cp.ao(_this.a, _this.e);
                    }
                    if (_this.d > -1) {
                        _this.a.cp.am(_this.a, _this.d);
                    }
                    _this.e = _this.d;
                }
                _this.b = false;
            }, 0);
            this.b = true;
        }
    };
    HoverManager.prototype.c = function (a) {
        return this.e == a;
    };
    HoverManager.$t = markType(HoverManager, 'HoverManager');
    return HoverManager;
}(Base));
export { HoverManager };
/**
 * @hidden
 */
var RecyclingManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RecyclingManager, _super);
    function RecyclingManager() {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.b = new Dictionary$2(String_$type, Stack$1.$.specialize(CellModel.$), 0);
        return _this;
    }
    RecyclingManager.prototype.a = function (a) {
        if (!this.b.containsKey(a)) {
            this.b.addItem(a, new Stack$1(CellModel.$));
            return null;
        }
        var b = this.b.item(a);
        if (b.f > 0) {
            var c = b.e();
            if (c.t == 2) {
                c.t = 1;
            }
            return c;
        }
        return null;
    };
    RecyclingManager.prototype.c = function (a) {
        a.t = 1;
        if (!this.b.containsKey(a.i2)) {
            this.b.addItem(a.i2, new Stack$1(CellModel.$));
        }
        this.b.item(a.i2).h(a);
    };
    RecyclingManager.$t = markType(RecyclingManager, 'RecyclingManager');
    return RecyclingManager;
}(Base));
export { RecyclingManager };
/**
 * @hidden
 */
var ActivationManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ActivationManager, _super);
    function ActivationManager(a, b) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.b = null;
        _this.c = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
        _this.e = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
        _this.d = new FastIterationDictionary$2(Number_$type, String_$type, 0);
        _this.f = new FastIterationDictionary$2(String_$type, Number_$type, 0);
        _this.k = false;
        _this.l = false;
        _this.q = -1;
        _this.t = -1;
        _this.p = -1;
        _this.r = -1;
        _this.u = null;
        _this.a = a;
        _this.b = b;
        return _this;
    }
    Object.defineProperty(ActivationManager.prototype, "g", {
        get: function () {
            if (this.k) {
                this.ab();
                this.k = false;
            }
            return this.c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivationManager.prototype, "i", {
        get: function () {
            if (this.k) {
                this.ab();
                this.k = false;
            }
            return this.e;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivationManager.prototype, "h", {
        get: function () {
            if (this.k) {
                this.ab();
                this.k = false;
            }
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivationManager.prototype, "j", {
        get: function () {
            if (this.k) {
                this.ab();
                this.k = false;
            }
            return this.f;
        },
        enumerable: true,
        configurable: true
    });
    ActivationManager.prototype.ak = function (a) {
        if (!a.k.ag) {
            return;
        }
        if (this.m(a)) {
            this.ae(a);
        }
        else {
            this.z(a);
        }
    };
    ActivationManager.prototype.m = function (a) {
        var b = false;
        var c = this.a.ee.getDataRow(a.k);
        if (c == -1) {
            return false;
        }
        if (this.q < 0) {
            return false;
        }
        if (c != this.q) {
            return false;
        }
        if (typeCast(SectionHeaderCellModel.$, a) !== null) {
            return true;
        }
        if (this.i.d(a.k.a0)) {
            var d = this.i.item(a.k.a0);
            if (d >= 0) {
                b = this.n(c, d);
            }
        }
        return b;
    };
    ActivationManager.prototype.n = function (a, b) {
        return this.q == a && b == this.t;
    };
    ActivationManager.prototype.o = function () {
        return this.a.cm == 1;
    };
    ActivationManager.prototype.ac = function () {
        if (this.q >= 0 && this.t >= 0) {
            this.ad(this.q, this.t, true);
        }
    };
    ActivationManager.prototype.ae = function (a) {
        var b = this.a.ee.getDataRow(a.k);
        if (b == -1) {
            return;
        }
        if (this.i.d(a.k.a0)) {
            var c = this.i.item(a.k.a0);
            if (this.n(b, c)) {
                this.ad(b, c, true);
            }
        }
    };
    ActivationManager.prototype.z = function (a) {
        this.y(a.k);
    };
    ActivationManager.prototype.y = function (a) {
        if (!a.ag) {
            return;
        }
        if (!this.o()) {
            return;
        }
        if (this.q >= 0 && this.t != null) {
            this.ad(this.q, this.t, false);
        }
        var b = this.a.ee.getDataRow(a);
        if (b == -1) {
            return;
        }
        if (a.a0 == -400) {
            if (this.q != b) {
                this.x(b, 0);
            }
        }
        if (this.i.d(a.a0)) {
            var c = this.i.item(a.a0);
            if (!this.n(b, c)) {
                this.w(b, c, true);
            }
        }
    };
    ActivationManager.prototype.aa = function (a, b, c) {
        this.r = -1;
        this.u = null;
        var d = this.t;
        if (b == null) {
            if (this.a.d3 != 1) {
                var e = this.a.ee.getRowType(a);
                if (this.a.ee.isRowSpanning(e) && this.t == -1) {
                    d = this.i.item(0);
                }
            }
        }
        else if (this.j.d(b)) {
            d = this.j.item(b);
        }
        if (d != -1) {
            if (this.q >= 0 && this.t >= 0) {
                if (a != this.q || d != this.t) {
                    this.ad(this.q, this.t, false);
                    this.w(a, d, c);
                }
            }
            else if (this.q == -1 && this.t == -1) {
                this.w(a, d, c);
            }
        }
        else {
            this.r = a;
            this.u = b;
        }
    };
    ActivationManager.prototype.x = function (a, b) {
        if (!this.i.d(b)) {
            return;
        }
        var c = this.i.item(b);
        if (a != this.q || c != this.t) {
            this.q = a;
            this.t = c;
            this.p = b;
            if (a >= 0 && b >= 0) {
                if (a >= 0 && a < this.a.ee.getRowCount()) {
                    if (this.a.d3 != 1) {
                        var d = this.a.ee.getRowType(a);
                        if (this.a.ee.isRowSpanning(d)) {
                            b = -400;
                            c = -400;
                        }
                    }
                }
                this.b.z(this.a, a, b, c);
            }
            this.a.rn(a, b, this.v(c));
        }
    };
    ActivationManager.prototype.w = function (a, b, c) {
        if (!this.g.d(b)) {
            return;
        }
        var d = this.g.item(b);
        if (a != this.q || b != this.t) {
            this.q = a;
            this.t = b;
            this.p = d;
            if (a >= 0 && d >= 0) {
                if (a >= 0 && a < this.a.ee.getRowCount()) {
                    if (this.a.d3 != 1) {
                        var e = this.a.ee.getRowType(a);
                        if (this.a.ee.isRowSpanning(e)) {
                            d = -400;
                            b = -400;
                        }
                    }
                }
                this.b.z(this.a, a, d, b);
            }
            if (c) {
                this.a.rn(a, d, this.v(b));
            }
        }
    };
    ActivationManager.prototype.ad = function (a, b, c) {
        if (this.n(a, b)) {
            this.t = -1;
            this.q = -1;
            this.p = -1;
            if (a >= 0) {
                if (this.g.d(b)) {
                    var d = this.g.item(b);
                    if (d >= 0) {
                        if (a >= 0 && a < this.a.ee.getRowCount()) {
                            if (this.a.d3 != 1) {
                                var e = this.a.ee.getRowType(a);
                                if (this.a.ee.isRowSpanning(e)) {
                                    d = -400;
                                    b = -400;
                                }
                            }
                        }
                        this.b.aa(this.a, a, d, b);
                    }
                }
            }
            if (c) {
                this.a.rp(a, this.v(b));
            }
        }
    };
    ActivationManager.prototype.ag = function () {
        this.q = -1;
        this.t = -1;
        this.p = -1;
    };
    ActivationManager.prototype.ah = function (a) {
    };
    ActivationManager.prototype.ai = function (a) {
    };
    ActivationManager.prototype.v = function (a) {
        if (!this.h.d(a)) {
            return null;
        }
        return this.h.item(a);
    };
    ActivationManager.prototype.aj = function (a) {
    };
    ActivationManager.prototype.af = function () {
        this.k = true;
        if (this.r != -1 && this.u != null) {
            var a = this.r;
            var b = this.u;
            this.r = -1;
            this.u = null;
            this.aa(a, b, true);
        }
    };
    ActivationManager.prototype.ab = function () {
        this.c.u();
        this.e.u();
        this.d.u();
        this.f.u();
        for (var a = 0; a < this.a.actualColumns.count; a++) {
            this.c.s(this.a.actualColumns._inner[a].g6, a);
            this.e.s(a, this.a.actualColumns._inner[a].g6);
            this.d.s(this.a.actualColumns._inner[a].g6, this.a.actualColumns._inner[a].h6());
            this.f.s(this.a.actualColumns._inner[a].h6(), this.a.actualColumns._inner[a].g6);
        }
    };
    ActivationManager.prototype.s = function () {
        if (this.g.d(this.t)) {
            return this.g.item(this.t);
        }
        if (this.p != -1) {
            return this.p;
        }
        return 0;
    };
    ActivationManager.$t = markType(ActivationManager, 'ActivationManager');
    return ActivationManager;
}(Base));
export { ActivationManager };
/**
 * @hidden
 */
var SelectionManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SelectionManager, _super);
    function SelectionManager(a, b) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.b = null;
        _this.g = new FastIterationDictionary$2(PrimaryKeyValue.$, Number_$type, 0);
        _this.f = new FastIterationDictionary$2(PrimaryKeyValue.$, FastIterationDictionary$2.$.specialize(Number_$type, Number_$type), 0);
        _this.d = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
        _this.e = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
        _this.j = false;
        _this.t = new List$1(CellRange.$, 0);
        _this.s = new List$1(CellRange.$, 0);
        _this.k = false;
        _this.u = -1;
        _this.c = null;
        _this.a = a;
        _this.b = b;
        return _this;
    }
    Object.defineProperty(SelectionManager.prototype, "h", {
        get: function () {
            if (this.j) {
                this.y();
                this.j = false;
            }
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectionManager.prototype, "i", {
        get: function () {
            if (this.j) {
                this.y();
                this.j = false;
            }
            return this.e;
        },
        enumerable: true,
        configurable: true
    });
    SelectionManager.prototype.as = function (a) {
        if (!a.k.ag) {
            return;
        }
        if (this.p(a)) {
            this.av(a);
        }
        else {
            this.ao(a);
        }
    };
    SelectionManager.prototype.ar = function (a) {
        if (!a.k.ag) {
            return;
        }
        this.k = true;
        this.ao(a);
        this.k = false;
    };
    SelectionManager.prototype.p = function (a) {
        var b = this.a.ee.getDataRow(a.k);
        if (b == -1) {
            return false;
        }
        if (this.a.ee.isPlaceholderItem(b)) {
            return false;
        }
        var c = this.a.ee.getRowKey(this.a.i(), b);
        if (c == null) {
            return false;
        }
        var d = this.g.d(c);
        if (d) {
            var e = this.g.item(c);
            if (e == -1) {
                this.g.item(c, b);
            }
            else if (this.g.item(c) != b) {
                return false;
            }
            var f = this.a.ah.ai(c);
            if (f >= 0) {
                if (this.a.ad.ae._inner[f] == null) {
                    var g = this.a.ee.resolveValueForRow(a.k);
                    this.a.ta(f, g, c);
                }
            }
        }
        if (!d) {
            if (this.i.d(a.k.a0)) {
                var h = this.i.item(a.k.a0);
                if (h >= 0) {
                    d = this.l(c, h);
                    if (d && this.f.item(c).item(h) == -1) {
                        this.f.item(c).item(h, b);
                    }
                }
            }
        }
        if (!d) {
            if (a.k.a0 >= 0) {
                var i = this.a.model.br._inner[a.k.a0];
                for (var j = 0; j < this.s.count; j++) {
                    if (this.s._inner[j].b(a.k.w, i.n)) {
                        d = true;
                        break;
                    }
                }
            }
        }
        if (!d) {
            if (this.a.ee.isRowPinned(b)) {
                var k = typeCast(DataSourceSpecialRow.$, c.value[0]);
                if (k != null) {
                    var l = this.a.ee.getItemKey(this.a.i(), k.targetRow);
                    d = this.g.d(l);
                    if (!d) {
                        if (this.i.d(a.k.a0)) {
                            var m = this.i.item(a.k.a0);
                            if (m >= 0) {
                                d = this.l(l, m);
                            }
                        }
                    }
                }
            }
        }
        return d;
    };
    SelectionManager.prototype.n = function (a) {
        return this.g.d(a);
    };
    SelectionManager.prototype.l = function (a, b) {
        return this.f.d(a) && this.f.item(a).d(b);
    };
    SelectionManager.prototype.o = function () {
        return this.a.dy == 1 || this.a.dy == 2;
    };
    SelectionManager.prototype.m = function () {
        return this.a.dy == 3 || this.a.dy == 4;
    };
    SelectionManager.prototype.av = function (a) {
        var b = this.a.ee.getDataRow(a.k);
        if (b == -1) {
            return;
        }
        if (this.a.ee.isPlaceholderItem(b)) {
            return;
        }
        var c = this.a.ee.getRowKey(this.a.i(), b);
        if (this.n(c)) {
            this.aw(c, b, false);
        }
        if (this.i.d(a.k.a0)) {
            var d = this.i.item(a.k.a0);
            if (this.l(c, d)) {
                this.at(c, b, d);
            }
        }
    };
    SelectionManager.prototype.ao = function (a) {
        if (this.a.dy == 0) {
            return;
        }
        if (this.a.dy == 1 || this.k) {
            var b = this.g.o;
            var c = this.g.p;
            var d = new List$1(PrimaryKeyValue.$, 0);
            var e = new List$1(Number_$type, 0);
            for (var f = 0; f < b.count; f++) {
                if (c._inner[f]) {
                    continue;
                }
                d.add(b._inner[f]);
                e.add(this.g.q._inner[f]);
            }
            this.a.qh();
            this.g.g = true;
            for (var g = 0; g < d.count; g++) {
                this.aw(d._inner[g], e._inner[g], false);
            }
            this.g.g = false;
            this.a.qy();
        }
        if (this.a.dy == 3 || this.k) {
            var h = this.f.o;
            var i = this.f.p;
            var j = new List$1(PrimaryKeyValue.$, 0);
            var k = new List$1(Number_$type, 0);
            var l = new List$1(Number_$type, 0);
            for (var m = 0; m < h.count; m++) {
                if (i._inner[m]) {
                    continue;
                }
                var n = h._inner[m];
                var o = this.f.item(n).o;
                var p = this.f.item(n).q;
                var q = this.f.item(n).p;
                for (var r = 0; r < o.count; r++) {
                    if (q._inner[r]) {
                        continue;
                    }
                    var s = o._inner[r];
                    var t = p._inner[r];
                    if (this.i.d(a.k.a0) && this.i.item(a.k.a0) == s && a.k.w == t) {
                        continue;
                    }
                    j.add(n);
                    k.add(s);
                    l.add(t);
                }
            }
            for (var u = 0; u < j.count; u++) {
                this.at(j._inner[u], l._inner[u], k._inner[u]);
            }
        }
        var v = this.a.ee.getDataRow(a.k);
        if (v == -1) {
            return;
        }
        if (this.a.ee.isPlaceholderItem(v)) {
            return;
        }
        var w = this.a.ee.getRowKey(this.a.i(), v);
        if (w == null) {
            return;
        }
        if (this.o()) {
            this.ap(w, v, false);
        }
        else if (this.m()) {
            this.an(w, v, a.k.a0);
        }
    };
    SelectionManager.prototype.ap = function (a, b, c) {
        var d = true;
        var e = false;
        if (!c) {
            if (this.a.ee.getRowType(b) == 3) {
                var f = typeCast(DataSourceSpecialRow.$, a.value[0]);
                if (f.targetRow != null) {
                    var g = this.a.ee.getItemKey(this.a.i(), f.targetRow);
                    var h = this.a.ee.indexOfVisibleItemByKey(this.a.i(), g, this.a.ll(), this.a.lp());
                    this.aq(g, h, f.targetRow, true);
                }
                e = true;
                d = false;
            }
        }
        var i = null;
        if (!e) {
            i = this.a.ee.resolveValueForDataRow(b);
            if (this.a.ag.contains(a)) {
                var j = this.v(a);
                if (j >= 0) {
                    var k = this.a.ee.getRowKey(this.a.i(), j);
                    if (!this.n(k)) {
                        this.aq(k, j, null, false);
                    }
                }
            }
        }
        this.aq(a, b, i, d);
    };
    SelectionManager.prototype.aq = function (a, b, c, d) {
        if (!this.g.d(a)) {
            this.g.s(a, b);
            if (this.a.model.bf != null && this.a.model.be != null) {
                var e = (b >= this.a.model.bf.w && b <= this.a.model.be.w);
                if (c == null || (this.a.h5 && typeCast(DataSourceSpecialRow.$, c) !== null)) {
                    e = true;
                }
                if (e) {
                    this.b.an(this.a, b);
                }
            }
        }
        if (d && c != null) {
            this.a.s3(c, a);
        }
    };
    SelectionManager.prototype.ax = function (a, b, c, d) {
        if (this.g.d(a)) {
            this.g.f(a);
            if (this.a.model.bf != null && this.a.model.be != null) {
                var e = (b >= this.a.model.bf.w && b <= this.a.model.be.w);
                if (c == null || (this.a.h5 && typeCast(DataSourceSpecialRow.$, c) !== null)) {
                    e = true;
                }
                if (e) {
                    var f = this.a.ee.getRowKey(this.a.i(), b);
                    if (f != null && f.equals(a) && b >= 0) {
                        this.b.ap(this.a, b);
                    }
                }
            }
        }
        if (d && c != null) {
            this.a.s4(c, a);
        }
    };
    SelectionManager.prototype.aw = function (a, b, c) {
        var d = true;
        var e = false;
        if (!c) {
            if (this.a.ee.getRowType(b) == 3) {
                var f = typeCast(DataSourceSpecialRow.$, a.value[0]);
                if (f.targetRow != null) {
                    var g = this.a.ee.getItemKey(this.a.i(), f.targetRow);
                    var h = this.a.ee.indexOfVisibleItemByKey(this.a.i(), g, this.a.ll(), this.a.lp());
                    this.ax(g, h, f.targetRow, true);
                }
                e = true;
                d = false;
            }
        }
        var i = null;
        if (!e) {
            i = this.a.ee.resolveValueForDataRow(b);
            if (this.a.ag.contains(a)) {
                var j = this.v(a);
                if (j >= 0) {
                    var k = this.a.ee.getRowKey(this.a.i(), j);
                    if (this.n(k)) {
                        this.ax(k, j, null, false);
                    }
                }
            }
        }
        this.ax(a, b, i, d);
    };
    SelectionManager.prototype.an = function (a, b, c) {
        if (!this.i.d(c)) {
            return;
        }
        var d = this.i.item(c);
        var e = true;
        if (this.a.ee.getRowType(b) == 3) {
            var f = typeCast(DataSourceSpecialRow.$, a.value[0]);
            if (f.targetRow != null) {
                var g = this.a.ee.getItemKey(this.a.i(), f.targetRow);
                var h = this.a.ee.indexOfVisibleItemByKey(this.a.i(), g, this.a.ll(), this.a.lp());
                this.al(g, d, c, h, true);
            }
            e = false;
        }
        else {
            if (this.a.ag.contains(a)) {
                var i = this.v(a);
                if (i >= 0) {
                    var j = this.a.ee.getRowKey(this.a.i(), i);
                    if (!this.l(j, d)) {
                        this.al(j, d, c, i, false);
                    }
                }
            }
        }
        this.al(a, d, c, b, e);
    };
    SelectionManager.prototype.am = function (a, b, c) {
        if (!this.h.d(c)) {
            return;
        }
        var d = this.h.item(c);
        if (!this.f.d(a)) {
            var e = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
            e.s(c, b);
            this.f.s(a, e);
            if (b >= 0 && d >= 0) {
                this.b.ad(this.a, b, d, c);
            }
            this.a.r1(a, c);
        }
        else {
            if (!this.f.item(a).d(c)) {
                this.f.item(a).s(c, b);
                if (b >= 0) {
                    this.b.ad(this.a, b, d, c);
                }
                this.a.r1(a, c);
            }
        }
    };
    SelectionManager.prototype.al = function (a, b, c, d, e) {
        if (!this.f.d(a)) {
            if (b >= 0) {
                var f = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
                f.s(b, d);
                this.f.s(a, f);
                if (d >= 0) {
                    this.b.ad(this.a, d, c, b);
                }
                if (e) {
                    this.a.r1(a, b);
                }
            }
        }
        else {
            if (!this.f.item(a).d(b)) {
                this.f.item(a).s(b, d);
                if (d >= 0) {
                    this.b.ad(this.a, d, c, b);
                }
                if (e) {
                    this.a.r1(a, b);
                }
            }
        }
    };
    SelectionManager.prototype.au = function (a, b, c, d) {
        if (this.l(a, c)) {
            this.f.item(a).f(c);
            if (this.f.item(a).r == 0) {
                this.f.f(a);
            }
            if (b >= 0) {
                var e = this.a.ee.getRowKey(this.a.i(), b);
                if (e != null && e.equals(a) && b >= 0) {
                    if (this.h.d(c)) {
                        var f = this.h.item(c);
                        if (f >= 0) {
                            this.b.ae(this.a, b, f, c);
                        }
                    }
                }
            }
            if (d) {
                this.a.r2(a, c);
            }
        }
    };
    SelectionManager.prototype.at = function (a, b, c) {
        var d = true;
        if (this.a.ee.getRowType(b) == 3) {
            var e = typeCast(DataSourceSpecialRow.$, a.value[0]);
            if (e.targetRow != null) {
                var f = this.a.ee.getItemKey(this.a.i(), e.targetRow);
                var g = this.a.ee.indexOfVisibleItemByKey(this.a.i(), f, this.a.ll(), this.a.lp());
                this.au(f, g, c, true);
            }
            d = false;
        }
        else {
            if (this.a.ag.contains(a)) {
                var h = this.v(a);
                if (h >= 0) {
                    var i = this.a.ee.getRowKey(this.a.i(), h);
                    if (this.l(i, c)) {
                        this.au(i, h, c, false);
                    }
                }
            }
        }
        this.au(a, b, c, d);
    };
    SelectionManager.prototype.v = function (a) {
        var b = -1;
        var c = this.a.ee.getStickyRows();
        if (c != null) {
            for (var d = 0; d < c.length; d++) {
                var e = typeCast(DataSourceSpecialRow.$, this.a.actualDataSource.getItemAtIndex(c[d]));
                if (e != null && e.rowType == 3) {
                    var f = this.a.ee.getItemKey(this.a.i(), e.targetRow);
                    if (f != null && f.equals(a)) {
                        b = c[d];
                        break;
                    }
                }
            }
        }
        return b;
    };
    SelectionManager.prototype.a0 = function () {
        var a = this.r();
        var b = new Dictionary$2(PrimaryKeyValue.$, Number_$type, 0);
        for (var c = 0; c < a.count; c++) {
            var d = a.item(c);
            var e = -1;
            if (this.g.d(d)) {
                e = this.g.item(d);
            }
            if (e == -1) {
                e = this.a.ee.indexOfVisibleItemByKey(this.a.i(), d, this.a.ll(), this.a.lp());
            }
            if (this.a.ag.contains(d)) {
                var f = this.v(d);
                if (f >= 0) {
                    var g = this.a.ee.getRowKey(this.a.i(), f);
                    if (!b.containsKey(g)) {
                        b.addItem(g, f);
                    }
                    if (!this.n(g)) {
                        this.ap(g, f, true);
                    }
                }
            }
            if (!b.containsKey(d)) {
                b.addItem(d, e);
            }
            if (!this.n(d)) {
                this.ap(d, e, true);
            }
        }
        var h = this.g.o;
        var i = this.g.p;
        var j = new List$1(PrimaryKeyValue.$, 0);
        var k = new List$1(Number_$type, 0);
        for (var l = 0; l < h.count; l++) {
            if (i._inner[l]) {
                continue;
            }
            var m = h._inner[l];
            if (!b.containsKey(m)) {
                j.add(m);
                k.add(this.g.q._inner[l]);
            }
        }
        for (var n = 0; n < k.count; n++) {
            this.aw(j._inner[n], k._inner[n], false);
        }
        for (var o = 0; o < this.a.ad.ae.count; o++) {
            var p = this.a.ee.getItemKey(this.a.i(), this.a.ad.ae._inner[o]);
            if (p != null && !b.containsKey(p)) {
                var q = -1;
                if (this.g.d(p)) {
                    q = this.g.item(p);
                }
                if (q == -1) {
                    q = this.a.ee.fastGetItemIndexForKey(this.a.i(), p, this.a.ll(), this.a.lp());
                }
                this.aw(p, q, false);
            }
        }
    };
    SelectionManager.prototype.az = function () {
        var a = this.a.ds.am;
        var b = new Dictionary$2(PrimaryKeyValue.$, IList$1_$type.specialize(Number_$type), 0);
        var _loop_1 = function (c) {
            var d = a.item(c).primaryKey;
            if (d == null) {
                return "continue";
            }
            if (a.item(c).b == null) {
                return "continue";
            }
            var e = a.item(c).b.g6;
            var f = -1;
            if (this_1.l(d, e)) {
                f = this_1.f.item(d).item(e);
            }
            if (f == -1) {
                var g = this_1.a.ll();
                var h = this_1.a.lp();
                if (g != -1 && h != -1) {
                    f = this_1.a.ee.indexOfVisibleItemByKey(this_1.a.i(), d, g, h);
                }
            }
            if (this_1.a.ag.contains(d)) {
                var i = this_1.v(d);
                if (i >= 0) {
                    var j = this_1.a.ee.getRowKey(this_1.a.i(), i);
                    if (!b.containsKey(j)) {
                        b.addItem(j, ((function () {
                            var $ret = new List$1(Number_$type, 0);
                            $ret.add(e);
                            return $ret;
                        })()));
                    }
                    else if (!b.item(j).contains(e)) {
                        b.item(j).add(e);
                    }
                    if (!this_1.l(j, e)) {
                        this_1.am(j, i, e);
                    }
                }
            }
            if (!b.containsKey(d)) {
                b.addItem(d, ((function () {
                    var $ret = new List$1(Number_$type, 0);
                    $ret.add(e);
                    return $ret;
                })()));
            }
            else if (!b.item(d).contains(e)) {
                b.item(d).add(e);
            }
            if (!this_1.l(d, e)) {
                this_1.am(d, f, e);
            }
        };
        var this_1 = this;
        for (var c = 0; c < a.count; c++) {
            _loop_1(c);
        }
        var k = this.f.o;
        var l = this.f.p;
        var m = new List$1(PrimaryKeyValue.$, 0);
        var n = new List$1(Number_$type, 0);
        var o = new List$1(Number_$type, 0);
        for (var p = 0; p < k.count; p++) {
            if (l._inner[p]) {
                continue;
            }
            var q = k._inner[p];
            for (var r = 0; r < this.f.item(q).o.count; r++) {
                if (this.f.item(q).p._inner[r]) {
                    continue;
                }
                var s = this.f.item(q).o._inner[r];
                var t = this.f.item(q).q._inner[r];
                if (!b.containsKey(q) || !b.item(q).contains(s)) {
                    m.add(q);
                    n.add(s);
                    o.add(t);
                }
            }
        }
        for (var u = 0; u < m.count; u++) {
            this.at(m._inner[u], o._inner[u], n._inner[u]);
        }
    };
    SelectionManager.prototype.ay = function () {
        var a = this.a.dp.ae;
        this.t.clear();
        this.t = this.s;
        this.s = new List$1(CellRange.$, 0);
        for (var b = 0; b < a.count; b++) {
            this.s.add(a.item(b).a());
        }
        var c = this.a.ee.getStickyRows();
        if (c != null) {
            for (var d = 0; d < c.length; d++) {
                var e = this.a.ee.getRowType(c[d]);
                if (e == 3) {
                    for (var f = 0; f < this.a.model.bx.count; f++) {
                        var g = this.a.model.bx._inner[f];
                        var h = this.a.model.br._inner[g].n;
                        this.x(c[d], h);
                    }
                }
            }
        }
        var i = this.a.ll();
        var j = this.a.lp();
        for (var k = i; k <= j; k++) {
            for (var l = 0; l < this.a.model.bx.count; l++) {
                var m = this.a.model.bx._inner[l];
                var n = this.a.model.br._inner[m].n;
                this.x(k, n);
            }
        }
    };
    SelectionManager.prototype.x = function (a, b) {
        var c = false;
        var d = false;
        for (var e = 0; e < this.t.count; e++) {
            var f = this.t._inner[e];
            if (f.b(a, b)) {
                c = true;
            }
        }
        for (var g = 0; g < this.s.count; g++) {
            var h = this.s._inner[g];
            if (h.b(a, b)) {
                d = true;
            }
        }
        if (c && !d) {
            var i = this.a.fb.j(b, this.a.model);
            this.a.cp.ac(this.a, a, i);
        }
        else if (!c && d) {
            var j = this.a.fb.j(b, this.a.model);
            this.a.cp.ab(this.a, a, j);
        }
    };
    SelectionManager.prototype.r = function () {
        return this.a.ah.ae;
    };
    SelectionManager.prototype.ad = function () {
        this.ac();
        this.ab();
    };
    SelectionManager.prototype.ah = function (a) {
        for (var b = 0; b < this.g.o.count; b++) {
            if (this.g.p._inner[b]) {
                continue;
            }
            var c = this.g.o._inner[b];
            var d = this.g.q._inner[b];
            if (d >= a) {
                this.g.item(c, d + 1);
            }
        }
        for (var e = 0; e < this.f.o.count; e++) {
            if (this.f.p._inner[e]) {
                continue;
            }
            var f = this.f.o._inner[e];
            var g = this.f.q._inner[e];
            for (var h = 0; h < g.o.count; h++) {
                if (this.f.item(f).p._inner[h]) {
                    continue;
                }
                var i = g.o._inner[h];
                var j = this.f.item(f).item(i);
                if (j >= a) {
                    this.f.item(f).item(i, j + 1);
                }
            }
        }
    };
    SelectionManager.prototype.ai = function (a) {
        var b = new List$1(PrimaryKeyValue.$, 0);
        var c = new List$1(Number_$type, 0);
        for (var d = 0; d < this.g.o.count; d++) {
            if (this.g.p._inner[d]) {
                continue;
            }
            var e = this.g.o._inner[d];
            var f = this.g.q._inner[d];
            if (f == a) {
                b.add(e);
                c.add(f);
            }
            if (f > a) {
                this.g.item(e, f - 1);
            }
        }
        for (var g = 0; g < b.count; g++) {
            this.aw(b._inner[g], c._inner[g], true);
        }
        for (var h = 0; h < this.f.o.count; h++) {
            if (this.f.p._inner[h]) {
                continue;
            }
            var i = this.f.o._inner[h];
            var j = this.f.q._inner[h];
            for (var k = 0; k < j.o.count; k++) {
                if (this.f.item(i).p._inner[k]) {
                    continue;
                }
                var l = j.o._inner[k];
                var m = this.f.item(i).item(l);
                if (m == a) {
                    this.f.item(i).item(l, -1);
                }
                if (m > a) {
                    this.f.item(i).item(l, m - 1);
                }
            }
        }
    };
    SelectionManager.prototype.ag = function (a, b) {
        var c = this.a.ll();
        var d = this.a.lp();
        var e = new List$1(Number_$type, 0);
        for (var f = 0; f < this.s.count; f++) {
            var g = this.s._inner[f];
            if (g.l > d || g.j < c) {
                continue;
            }
            if (a < g.k) {
                this.w(e, g.k - 1);
            }
            if (a <= g.i) {
                this.w(e, g.i);
            }
        }
        for (var h = 0; h < e.count; h++) {
            if (e._inner[h] >= 0 && e._inner[h] <= this.a.actualColumns.count) {
                this.a.cp.af(this.a, c, d, e._inner[h], true);
            }
        }
    };
    SelectionManager.prototype.ae = function (a, b) {
        var c = this.a.ll();
        var d = this.a.lp();
        var e = new List$1(Number_$type, 0);
        for (var f = 0; f < this.s.count; f++) {
            var g = this.s._inner[f];
            if (g.l > d || g.j < c) {
                continue;
            }
            if (a < g.k) {
                this.w(e, g.k);
            }
            if (a <= g.i) {
                this.w(e, g.i + 1);
            }
        }
        for (var h = 0; h < e.count; h++) {
            if (e._inner[h] >= 0 && e._inner[h] <= this.a.actualColumns.count) {
                this.a.cp.af(this.a, c, d, e._inner[h], true);
            }
        }
    };
    SelectionManager.prototype.af = function (a, b, c) {
        var d = this.a.ll();
        var e = this.a.lp();
        var f = new List$1(Number_$type, 0);
        for (var g = 0; g < this.s.count; g++) {
            var h = this.s._inner[g];
            if (h.l > e || h.j < d) {
                continue;
            }
            if (h.c(a) && !h.c(b)) {
                this.w(f, b);
                if (b > h.i) {
                    this.w(f, h.i);
                }
                else if (b < h.k) {
                    this.w(f, h.k);
                }
            }
            else if (!h.c(a) && h.c(b)) {
                this.w(f, b);
                if (a > h.i) {
                    this.w(f, h.i + 1);
                }
                else if (a < h.k) {
                    this.w(f, h.k - 1);
                }
            }
            else if (!h.c(a) && !h.c(b)) {
                if (a < h.k && b > h.i) {
                    this.w(f, h.k - 1);
                    this.w(f, h.i);
                }
                if (a > h.i && b < h.k) {
                    this.w(f, h.k);
                    this.w(f, h.i + 1);
                }
            }
        }
        for (var i = 0; i < f.count; i++) {
            this.a.cp.af(this.a, d, e, f._inner[i], true);
        }
    };
    SelectionManager.prototype.w = function (a, b) {
        if (b < 0 || b >= this.a.actualColumns.count) {
            return;
        }
        if (!a.contains(b)) {
            a.add(b);
        }
    };
    SelectionManager.prototype.aj = function (a) {
        var b = new List$1(PrimaryKeyValue.$, 0);
        var c = new List$1(Number_$type, 0);
        for (var d = 0; d < this.g.o.count; d++) {
            if (this.g.p._inner[d]) {
                continue;
            }
            var e = this.g.o._inner[d];
            var f = this.g.q._inner[d];
            if (f == a) {
                b.add(e);
                c.add(f);
            }
        }
        for (var g = 0; g < b.count; g++) {
            this.aw(b._inner[g], c._inner[g], true);
        }
    };
    SelectionManager.prototype.aa = function () {
        this.j = true;
    };
    SelectionManager.prototype.y = function () {
        this.d.u();
        this.e.u();
        for (var a = 0; a < this.a.actualColumns.count; a++) {
            this.d.s(this.a.actualColumns._inner[a].g6, a);
            this.e.s(a, this.a.actualColumns._inner[a].g6);
        }
    };
    SelectionManager.prototype.ac = function () {
        var a = new List$1(Number_$type, 0);
        var b = new HashSet$1(Number_$type, 0);
        for (var c = 0; c < this.g.o.count; c++) {
            if (this.g.p._inner[c]) {
                continue;
            }
            var d = this.g.o._inner[c];
            a.add(this.g.item(d));
            var e = this.a.ee.indexOfVisibleItemByKey(this.a.i(), d, this.a.ll(), this.a.lp());
            b.add_1(e);
            this.g.item(d, -1);
        }
        for (var f = 0; f < a.count; f++) {
            if (!b.contains(a._inner[f])) {
                this.a.cp.ap(this.a, a._inner[f]);
            }
        }
    };
    SelectionManager.prototype.ab = function () {
        var a = new FastIterationDictionary$2(PrimaryKeyValue.$, Number_$type, 0);
        var b = new FastIterationDictionary$2(PrimaryKeyValue.$, Number_$type, 0);
        var c = new List$1(Number_$type, 0);
        for (var d = 0; d < this.f.q.count; d++) {
            var e = this.f.o._inner[d];
            var f = this.a.ee.indexOfVisibleItemByKey(this.a.i(), e, this.a.ll(), this.a.lp());
            var g = this.f.q._inner[d];
            for (var h = 0; h < g.q.count; h++) {
                var i = g.o._inner[h];
                if (!a.d(e)) {
                    a.s(e, this.f.item(e).item(i));
                    b.s(e, f);
                }
                c.add(i);
                this.f.item(e).item(i, -1);
            }
        }
        for (var j = 0; j < a.q.count; j++) {
            var k = a.o._inner[j];
            var l = a.q._inner[j];
            var m = b.q._inner[j];
            if (l > -1 && l < this.a.ee.getRowCount()) {
                var n = this.a.actualDataSource.getItemAtIndex(l);
                var o = typeCast(DataSourceSpecialRow.$, n);
                if (o != null && o.rowType == 3) {
                    var p = this.a.ee.getItemKey(this.a.i(), o.targetRow);
                    if (p.equals(k)) {
                        continue;
                    }
                }
            }
            if (!b.q.contains(l)) {
                this.a.cp.ae(this.a, l, this.d.item(c._inner[j]), c._inner[j]);
            }
        }
    };
    SelectionManager.prototype.q = function (a) {
        return this.a.dy == 2 || this.a.dy == 5;
    };
    SelectionManager.prototype.z = function (a, b, c, d) {
        var _this = this;
        if (d === void 0) {
            d = false;
        }
        if (!a.k.ag) {
            return;
        }
        b = this.q(this.a.dy) ? b : false;
        if (!b || this.u == -1) {
            if (c || d) {
                this.as(a);
            }
            else {
                this.ar(a);
            }
            this.c = null;
            if (this.p(a)) {
                this.u = a.k.w;
            }
            else {
                this.u = -1;
            }
        }
        else {
            var e = ((function () {
                var $ret = new RowRange();
                $ret.f = Math.min(_this.u, a.k.w);
                $ret.d = Math.max(_this.u, a.k.w);
                return $ret;
            })());
            this.a.qh();
            if (this.c != null) {
                for (var f = this.c.f; f <= this.c.d; f++) {
                    if (!e.b(f)) {
                        var g = this.a.ee.getRowKey(this.a.i(), f);
                        if (g != null && this.g.d(g)) {
                            this.aw(g, f, false);
                        }
                    }
                }
            }
            for (var h = e.f; h <= e.d; h++) {
                var i = this.a.ee.getRowKey(this.a.i(), h);
                if (i != null && !this.g.d(i)) {
                    this.ap(i, h, false);
                }
            }
            this.a.qy();
            this.c = e;
        }
    };
    SelectionManager.prototype.ak = function () {
        if (this.a.actualDataSource == null) {
            return;
        }
        this.a.qh();
        var a = this.a.ee.getRowCount();
        for (var b = 0; b < a; b++) {
            var c = this.a.actualDataSource.getItemAtIndex(b);
            if (typeCast(DataSourceSpecialRow.$, c) !== null) {
                continue;
            }
            var d = this.a.ee.getRowKey(this.a.i(), b);
            if (d != null && !this.g.d(d)) {
                this.ap(d, b, false);
            }
        }
        this.a.qy();
    };
    SelectionManager.$t = markType(SelectionManager, 'SelectionManager');
    return SelectionManager;
}(Base));
export { SelectionManager };
/**
 * @hidden
 */
var SortManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SortManager, _super);
    function SortManager(a) {
        var _this = _super.call(this) || this;
        _this.c = null;
        _this.e = false;
        _this.c = a;
        return _this;
    }
    SortManager.prototype.d = function (a) {
        if (null == a) {
            return false;
        }
        var b = a.h4;
        var c = this.c.b5;
        var d = this.a(b, c);
        var e = null == d ? 0 : d.c == 0 ? 1 : 2;
        var f = (this.c.d5 == 3 || this.c.d5 == 2);
        var g = this.b(e, f);
        this.f(a, g);
        return true;
    };
    SortManager.prototype.f = function (a, b) {
        if (null == a) {
            return false;
        }
        var c = a.h4;
        var d = this.c.b5;
        var e = this.a(c, d);
        return this.g(c, b, e);
    };
    SortManager.prototype.g = function (a, b, c) {
        if (this.e) {
            return false;
        }
        this.e = true;
        try {
            var d = this.c.b5;
            var e = d.j(c);
            var f = (this.c.d5 == 1 || this.c.d5 == 3);
            if (null != c) {
                d.h(c);
            }
            if (false == f) {
                d.m();
            }
            switch (b) {
                case 0: break;
                case 2:
                case 1:
                    {
                        var g = b == 1 ? 0 : 1;
                        var h = new ColumnSortDescription(2, a, g);
                        if (f && e >= 0) {
                            d.i.insert(e, h);
                        }
                        else {
                            d.g(h);
                        }
                    }
                    break;
            }
            return true;
        }
        finally {
            this.e = false;
        }
    };
    SortManager.prototype.h = function () {
        var a = this.c.b5;
        var b = a.i.count;
        if (b > 1) {
            for (var c = b - 1; c > 0; c--) {
                a.i.removeAt(c);
            }
        }
    };
    SortManager.prototype.a = function (a, b) {
        if (null == b || b.i.count < 1) {
            return null;
        }
        for (var c = 0; c < b.i.count; c++) {
            var d = b.i.item(c);
            if (d.f == a) {
                return d;
            }
        }
        return null;
    };
    SortManager.prototype.b = function (a, b) {
        if (b) {
            switch (a) {
                case 0: return 1;
                case 1: return 2;
                case 2: return 0;
            }
        }
        else {
            switch (a) {
                case 0:
                case 2: return 1;
                default: return 2;
            }
        }
        return 0;
    };
    SortManager.$t = markType(SortManager, 'SortManager');
    return SortManager;
}(Base));
export { SortManager };
/**
 * @hidden
 */
export var IDataAdapter_$type = /*@__PURE__*/ new Type(null, 'IDataAdapter');
/**
 * @hidden
 */
var DataAdapter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataAdapter, _super);
    function DataAdapter(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.h = new Dictionary$2(Base.$, Number_$type, 0);
        _this.i = new List$1(PrimaryKeyValue.$, 0);
        _this.g = null;
        _this.b = null;
        _this.d = null;
        _this.propertyChanged = null;
        _this.j = 0;
        _this.k = 0;
        _this.g = a;
        return _this;
    }
    Object.defineProperty(DataAdapter.prototype, "c", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (this.b != b) {
                this.n("DataSource", b, this.b);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataAdapter.prototype, "e", {
        get: function () {
            return this.d;
        },
        set: function (a) {
            var b = this.d;
            this.d = a;
            if (this.d != b) {
                this.n("EditableDataSource", b, this.d);
            }
        },
        enumerable: true,
        configurable: true
    });
    DataAdapter.prototype.setDataSource = function (a) {
        this.c = a;
        this.e = typeCast(IEditableDataSource_$type, this.c);
    };
    DataAdapter.prototype.getItemForKey = function (a) {
        var b = this.indexOfKey(a);
        if (b == -1) {
            if (a.value != null && a.value.length == 1) {
                return a.value[0];
            }
            return null;
        }
        return this.c.getItemAtIndex(b);
    };
    DataAdapter.prototype.getItemKey = function (a, item_) {
        var b = (item_ != null && item_.$$isSpecialRow !== undefined);
        if (a == null) {
            if (item_ == null) {
                return null;
            }
            return PrimaryKeyValue.createIdentityKey(item_);
        }
        if (b) {
            var c = item_;
            if (this.c.isSectionContentVisible || !this.c.isSectionHeaderNormalRow || c.rowType != 1) {
                return PrimaryKeyValue.createIdentityKey(item_);
            }
            else if (c.rowType == 1) {
                var d = c.getSectionKeys();
                for (var e = 0; e < d.length; e++) {
                    for (var f = 0; f < a.length; f++) {
                        if (a[f] != d[e]) {
                            return PrimaryKeyValue.createIdentityKey(item_);
                        }
                    }
                }
            }
        }
        var g = new Array(a.length);
        for (var h = 0; h < a.length; h++) {
            g[h] = this.c.getItemProperty(item_, a[h]);
        }
        return new PrimaryKeyValue(a, g);
    };
    DataAdapter.prototype.getRowKey = function (a, b) {
        if (this.c == null) {
            return null;
        }
        if (b < 0 || b > this.c.actualCount - 1) {
            return null;
        }
        var c = this.c.getItemAtIndex(b);
        if (c == null) {
            return null;
        }
        return this.getItemKey(a, c);
    };
    DataAdapter.prototype.n = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.o(a, b, c);
    };
    DataAdapter.prototype.o = function (a, b, c) {
        switch (a) {
            case "DataSource":
                this.a = null;
                this.h.clear();
                if (this.c != null) {
                    if (this.a == null) {
                        this.a = new Array(1);
                        this.a[0] = new DefaultSectionInformation(0, this.b.actualCount, null, null, null);
                    }
                    for (var d = 0; d < this.a.length; d++) {
                        if (this.a[d].groupKeyValues != null) {
                            this.h.addItem(this.a[d].groupKeyValues, d);
                        }
                    }
                    for (var e = 0; e < this.i.count; e++) {
                        this.b.pinRow(this.i._inner[e].value);
                    }
                    this.i.clear();
                }
                break;
        }
    };
    DataAdapter.prototype.getRowCount = function () {
        return this.l(0);
    };
    DataAdapter.prototype.m = function (a, b) {
        if (this.b == null) {
            return -1;
        }
        if (this.b.actualPrimaryKey != null && this.b.isKeyIndexLookupSupported) {
            return this.indexOfKey(a);
        }
        if (this.b.isItemIndexLookupSupported) {
            return this.b.indexOfItem(b);
        }
        return -1;
    };
    DataAdapter.prototype.indexOfKey = function (a) {
        if (this.b == null) {
            return -1;
        }
        if (this.b.actualPrimaryKey != null && this.b.isKeyIndexLookupSupported) {
            return this.b.indexOfKey(a.value);
        }
        return -1;
    };
    DataAdapter.prototype.fastGetItemIndexForKey = function (a, b, c, d) {
        var e = this.indexOfVisibleItemByKey(a, b, c, d);
        if (e >= 0) {
            return e;
        }
        return this.indexOfKey(b);
    };
    DataAdapter.prototype.indexOfVisibleItemByKey = function (a, b, c, d) {
        if (this.b == null) {
            return -1;
        }
        for (var e = c; e <= d; e++) {
            if (e > this.b.actualCount - 1) {
                break;
            }
            var f = this.b.getItemAtIndex(e);
            if (f == null) {
                continue;
            }
            var g = this.getItemKey(a, f);
            if (g == null) {
                continue;
            }
            if (g.value != null && g.value.length == 1 && g.value[0] != null && getInstanceType(g.value[0]) == DataSourceSpecialRow.$ && b.value != null && b.value.length == 1 && b.value[0] != null && getInstanceType(b.value[0]) == DataSourceSpecialRow.$) {
                var h = typeCast(DataSourceSpecialRow.$, g.value[0]);
                var i = typeCast(DataSourceSpecialRow.$, b.value[0]);
                if (h.rowType == i.rowType) {
                    if (h.rowType == 3 && h.targetRow == i.targetRow) {
                        return e;
                    }
                }
            }
            if (g.equals(b)) {
                return e;
            }
        }
        return -1;
    };
    DataAdapter.prototype.l = function (a) {
        if (this.b == null) {
            return 0;
        }
        return this.b.actualCount;
    };
    DataAdapter.prototype.getSectionCount = function () {
        if (this.a == null) {
            return 0;
        }
        return this.a.length;
    };
    DataAdapter.prototype.f = function (a) {
        return a;
    };
    DataAdapter.prototype.getDataRow = function (a) {
        if (a == null) {
            return -1;
        }
        a = this.f(a);
        if (this.a == null || this.a.length < 1) {
            if (this.b.actualCount > a.w) {
                return a.w;
            }
        }
        else {
            var b = this.a[a.x].startIndex;
            var c = b + a.w;
            if (c < 0 || c >= this.b.actualCount) {
                return -1;
            }
            return c;
        }
        return -1;
    };
    DataAdapter.prototype.resolveValue = function (a, b) {
        if (a < 0 || a > this.b.actualCount - 1) {
            return null;
        }
        if (b != null && b.length == 1 && b.charAt(0) == '.') {
            return this.b.getItemAtIndex(a);
        }
        return this.b.getItemPropertyAtIndex(a, b);
    };
    DataAdapter.prototype.resolveValueForPath = function (a, b) {
        var c = null;
        if (b.a0 == -400) {
            var d = this.b.getRowType(b.w);
            var e = this.b.getMainValuePath(d);
            c = e;
        }
        else {
            var f = a.a1(b);
            c = f.h4;
        }
        return this.resolveValue(b.w, c);
    };
    DataAdapter.prototype.resolveRow = function (a) {
        if (a < 0 || a > this.b.actualCount - 1) {
            return null;
        }
        return this.b.getItemAtIndex(a);
    };
    DataAdapter.prototype.resolveValueForDataRow = function (a) {
        if (a < 0 || a > this.b.actualCount - 1) {
            return null;
        }
        return this.b.getItemAtIndex(a);
    };
    DataAdapter.prototype.resolveValueForRow = function (a) {
        a = this.f(a);
        if (a == null) {
            return null;
        }
        var b = this.getDataRow(a);
        if (b < 0 || b > this.b.actualCount - 1) {
            return null;
        }
        return this.b.getItemAtIndex(b);
    };
    DataAdapter.prototype.getSectionForRow = function (a) {
        if (this.a == null || this.a.length < 2) {
            return 0;
        }
        for (var b = 0; b < this.a.length; b++) {
            if (b < this.a.length - 1) {
                if (a > this.a[b + 1].startIndex) {
                    continue;
                }
            }
            return b;
        }
        return this.a.length - 1;
    };
    DataAdapter.prototype.getRowPathForRow = function (a) {
        var b = this.getSectionForRow(a);
        return new RowPath(b, a - this.a[b].startIndex);
    };
    Object.defineProperty(DataAdapter.prototype, "firstVisibleIndexRequested", {
        get: function () {
            return this.j = 0;
        },
        set: function (a) {
            this.j = a;
            if (this.b != null) {
                this.b.firstVisibleIndexRequested = this.j;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataAdapter.prototype, "lastVisibleIndexRequested", {
        get: function () {
            return this.k = 0;
        },
        set: function (a) {
            this.k = a;
            if (this.b != null) {
                this.b.lastVisibleIndexRequested = this.k;
            }
        },
        enumerable: true,
        configurable: true
    });
    DataAdapter.prototype.isPlaceholderValue = function (a) {
        if (this.b == null) {
            return false;
        }
        var b = this.getDataRow(a);
        if (b < 0 || b > this.b.actualCount - 1) {
            return false;
        }
        return this.b.isPlaceholderItem(b);
    };
    DataAdapter.prototype.isPlaceholderItem = function (a) {
        if (this.b == null) {
            return false;
        }
        return this.b.isPlaceholderItem(a);
    };
    DataAdapter.prototype.getRowType = function (a) {
        if (this.b == null) {
            return 0;
        }
        if (a < 0 || a >= this.getRowCount()) {
            return 0;
        }
        return this.b.getRowType(a);
    };
    DataAdapter.prototype.getStickyRows = function () {
        if (this.b == null) {
            return null;
        }
        return this.b.getStickyRows();
    };
    DataAdapter.prototype.getStickyRowsInRange = function (a, b) {
        if (this.b == null) {
            return null;
        }
        return this.b.getStickyRowsInRange(a, b);
    };
    DataAdapter.prototype.getStickRowPriority = function (a) {
        if (this.b == null) {
            return -1;
        }
        return this.b.getStickyRowPriority(a);
    };
    DataAdapter.prototype.isExclusivelySticky = function (a) {
        if (this.b == null) {
            return false;
        }
        return this.b.isExclusivelySticky(a);
    };
    DataAdapter.prototype.isRowSpanning = function (a) {
        if (this.b == null) {
            return false;
        }
        return this.b.isRowSpanning(a);
    };
    DataAdapter.prototype.pinRow = function (a) {
        if (this.b == null) {
            this.i.add(a);
            return;
        }
        this.b.pinRow(a.value);
    };
    DataAdapter.prototype.unpinRow = function (a) {
        if (this.b == null) {
            for (var b = 0; b < this.i.count; b++) {
                if (this.i._inner[b].equals(a)) {
                    this.i.remove(this.i._inner[b]);
                    break;
                }
            }
            return;
        }
        this.b.unpinRow(a.value);
    };
    DataAdapter.prototype.clearPinnedRows = function () {
        if (this.b == null) {
            return;
        }
        this.b.clearPinnedRows();
    };
    DataAdapter.prototype.isRowPinned = function (a) {
        if (this.b == null) {
            return false;
        }
        return this.b.isRowPinned(a);
    };
    DataAdapter.prototype.getRowIndent = function (a) {
        if (this.b == null) {
            return 0;
        }
        return this.b.getRowLevel(a);
    };
    DataAdapter.prototype.getRootSummaryRowCount = function () {
        if (this.b == null) {
            return 0;
        }
        return this.b.getRootSummaryRowCount();
    };
    DataAdapter.prototype.isEditedValue = function (a, b) {
        if (this.e == null || a == null) {
            return false;
        }
        var c = this.getItemKey(this.b.actualPrimaryKey, a);
        return this.e.hasEdit(c.value, b) || this.e.hasAdd(c.value);
    };
    DataAdapter.prototype.isDeletedRow = function (a) {
        if (this.e == null || a == null) {
            return false;
        }
        var b = this.getItemKey(this.b.actualPrimaryKey, a);
        return this.e.hasDelete(b.value);
    };
    DataAdapter.prototype.getPendingEditID = function (a, b) {
        if (this.e == null || a == null) {
            return -1;
        }
        var c = this.getItemKey(this.b.actualPrimaryKey, a);
        return this.e.getTransactionID(c.value, b);
    };
    DataAdapter.prototype.getError = function (a) {
        if (this.e == null || a == -1) {
            return null;
        }
        return this.e.getTransactionErrorByID(a);
    };
    DataAdapter.$t = markType(DataAdapter, 'DataAdapter', Base.$, [INotifyPropertyChanged_$type, IDataAdapter_$type]);
    return DataAdapter;
}(Base));
export { DataAdapter };
/**
 * @hidden
 */
var ColumnMovingSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnMovingSeparator, _super);
    function ColumnMovingSeparator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.el = truncate(DeviceUtils.g(2));
        return _this;
    }
    ColumnMovingSeparator.prototype.cm = function (a, b, c) {
        return "columnMovingSeparator";
    };
    ColumnMovingSeparator.prototype.l = function (a) {
        return new VerticalSeparatorCellModel();
    };
    ColumnMovingSeparator.prototype.eb = function () {
        return GridStyleRepository.ay;
    };
    Object.defineProperty(ColumnMovingSeparator.prototype, "em", {
        get: function () {
            return this.el;
        },
        set: function (a) {
            var b = this.el;
            this.el = a;
            if (this.el != b) {
                this.c2("SeparatorWidth", 6, b, this.el);
            }
        },
        enumerable: true,
        configurable: true
    });
    ColumnMovingSeparator.prototype.cz = function (a, b) {
        this.c8();
    };
    ColumnMovingSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.v5 != null) {
                this.d0 = this.grid.v5;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    ColumnMovingSeparator.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "ColumnMovingSeparatorBackground":
                this.c8();
                break;
        }
    };
    ColumnMovingSeparator.$t = markType(ColumnMovingSeparator, 'ColumnMovingSeparator', DefinitionBase.$);
    return ColumnMovingSeparator;
}(DefinitionBase));
export { ColumnMovingSeparator };
/**
 * @hidden
 */
var ComboBoxColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ComboBoxColumn, _super);
    function ComboBoxColumn() {
        var _this = _super.call(this) || this;
        _this.j3 = null;
        _this.fc = 4;
        return _this;
    }
    Object.defineProperty(ComboBoxColumn.prototype, "j4", {
        get: function () {
            return this.j3;
        },
        set: function (a) {
            var b = this.j3;
            this.j3 = a;
            if (this.j3 != b) {
                this.c2("ActualDataSource", 10, b, this.j3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboBoxColumn.prototype, "j5", {
        get: function () {
            return this.g8;
        },
        set: function (a) {
            this.g8 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboBoxColumn.prototype, "j9", {
        get: function () {
            return this.h0;
        },
        set: function (a) {
            this.h0 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboBoxColumn.prototype, "j2", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            this.em = a;
        },
        enumerable: true,
        configurable: true
    });
    ComboBoxColumn.prototype.l = function (a) {
        return new TextCellModel();
    };
    ComboBoxColumn.prototype.cm = function (a, b, c) {
        return "combobox";
    };
    ComboBoxColumn.prototype.cz = function (a, b) {
        _super.prototype.cz.call(this, a, b);
        if (this.j4 == null && this.j5 != null) {
            if (b != null) {
                this.j4 = b.externalGrid.createLocalDataSource(this.j5);
            }
        }
    };
    ComboBoxColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        e.ky = this.j8(c);
    };
    ComboBoxColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
    };
    ComboBoxColumn.prototype.c3 = function (a, b, c, d) {
        _super.prototype.c3.call(this, a, b, c, d);
        switch (a) {
            case "EditorItemsSourceInternal":
                if (typeCast(IDataSource_$type, this.j5) !== null) {
                    this.j4 = this.j5;
                }
                else if (this.grid != null) {
                    this.j4 = this.grid.externalGrid.createLocalDataSource(this.j5);
                }
                break;
            case "ActualDataSource":
                if (c != null) {
                    var e = c;
                    e.schemaChanged = delegateRemove(e.schemaChanged, runOn(this, this.ka));
                }
                if (this.j4 != null) {
                    var f = this.j4;
                    f.schemaChanged = delegateCombine(f.schemaChanged, runOn(this, this.ka));
                }
                this.kb();
                break;
            case "EditorTextFieldInternal":
            case "EditorValueFieldInternal":
                this.kb();
                break;
        }
    };
    ComboBoxColumn.prototype.ka = function (a, b) {
        this.kb();
    };
    ComboBoxColumn.prototype.kb = function () {
        if (this.j4 != null) {
            if (this.j2 != null) {
                this.j4.primaryKey = this.j2;
            }
            else if (this.j9 != null) {
                this.j4.primaryKey = [this.j9];
            }
            else {
                var a = this.j4.actualSchema;
                if (a != null && a.propertyNames.length > 0) {
                    this.j4.primaryKey = [a.propertyNames[0]];
                }
            }
        }
    };
    ComboBoxColumn.prototype.j7 = function (a) {
        if (typeof a === 'string') {
            return a;
        }
        return null;
    };
    ComboBoxColumn.prototype.j8 = function (a) {
        var b = null;
        if (this.j4 != null && this.j9 != null) {
            var c = this.j4.indexOfKey([a]);
            if (c > -1) {
                var d = this.j4.getItemPropertyAtIndex(c, this.j9);
                if (d != null) {
                    b = this.j7(d);
                }
            }
        }
        if (b == null && a != null) {
            b = this.j7(a);
        }
        return b;
    };
    ComboBoxColumn.$t = markType(ComboBoxColumn, 'ComboBoxColumn', Column.$);
    return ComboBoxColumn;
}(Column));
export { ComboBoxColumn };
/**
 * @hidden
 */
var DateTimeColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DateTimeColumn, _super);
    function DateTimeColumn() {
        var _this = _super.call(this) || this;
        _this.j5 = new DateTimeColumnValueFormatter();
        _this.j6 = 0;
        _this.kd = null;
        _this.j2 = null;
        _this.ka = null;
        return _this;
    }
    Object.defineProperty(DateTimeColumn.prototype, "j7", {
        get: function () {
            return this.j6;
        },
        set: function (a) {
            var b = this.j6;
            this.j6 = a;
            if (this.j6 != b) {
                this.c2("DateTimeFormat", 4, enumGetBox(DateTimeFormats_$type, b), enumGetBox(DateTimeFormats_$type, this.j6));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "ki", {
        get: function () {
            return this.kd;
        },
        set: function (a) {
            var b = this.kd;
            this.kd = a;
            if (this.kd != b) {
                this.c2("FormatString", 8, b, this.kd);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "j4", {
        get: function () {
            return this.j2;
        },
        set: function (a) {
            var b = this.j2;
            this.j2 = a;
            if (this.j2 != b) {
                this.c2("FormatSpecifiers", 9, b, this.j2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "kc", {
        get: function () {
            return this.ka;
        },
        set: function (a) {
            var b = this.ka;
            this.ka = a;
            if (this.ka != b) {
                this.c2("FormatOverride", 9, b, this.ka);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "j8", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            this.fc = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "kb", {
        get: function () {
            return this.g8;
        },
        set: function (a) {
            this.g8 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "kf", {
        get: function () {
            return this.h0;
        },
        set: function (a) {
            this.h0 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "j3", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            this.em = a;
        },
        enumerable: true,
        configurable: true
    });
    DateTimeColumn.prototype.c3 = function (a, b, c, d) {
        _super.prototype.c3.call(this, a, b, c, d);
        switch (a) {
            case "DateTimeFormat":
                this.j5.k();
                break;
        }
    };
    DateTimeColumn.prototype.l = function (a) {
        return new DateTimeCellModel();
    };
    DateTimeColumn.prototype.cm = function (a, b, c) {
        return "datetime";
    };
    DateTimeColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        e.k6 = this.j9(c);
        e.k0 = this.j5;
        this.j5.j(e);
    };
    DateTimeColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        var e = a;
        e.k2 = this.j7;
        e.ln = this.ki;
        e.kx = this.j4;
        e.lg = this.kc;
    };
    DateTimeColumn.prototype.j9 = function (a) {
        if (a == null) {
            return dateMinValue();
        }
        if (typeCast(Date_$type, a) !== null) {
            return a;
        }
        return dateMinValue();
    };
    DateTimeColumn.$t = markType(DateTimeColumn, 'DateTimeColumn', Column.$);
    return DateTimeColumn;
}(Column));
export { DateTimeColumn };
/**
 * @hidden
 */
export var IExternalDefinitionBase_$type = /*@__PURE__*/ new Type(null, 'IExternalDefinitionBase');
/**
 * @hidden
 */
var DataBindingEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataBindingEventArgs, _super);
    function DataBindingEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._resolvedValue = null;
        _this._rowObject = null;
        _this._cellInfo = null;
        return _this;
    }
    Object.defineProperty(DataBindingEventArgs.prototype, "resolvedValue", {
        get: function () {
            return this._resolvedValue;
        },
        set: function (a) {
            this._resolvedValue = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataBindingEventArgs.prototype, "rowObject", {
        get: function () {
            return this._rowObject;
        },
        set: function (a) {
            this._rowObject = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataBindingEventArgs.prototype, "cellInfo", {
        get: function () {
            return this._cellInfo;
        },
        set: function (a) {
            this._cellInfo = a;
        },
        enumerable: true,
        configurable: true
    });
    DataBindingEventArgs.$t = markType(DataBindingEventArgs, 'DataBindingEventArgs', EventArgs.$);
    return DataBindingEventArgs;
}(EventArgs));
export { DataBindingEventArgs };
/**
 * @hidden
 */
var Header = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Header, _super);
    function Header() {
        var _this = _super.call(this) || this;
        _this.e8 = null;
        _this.e7 = null;
        _this.em = 3;
        _this.el = 3;
        _this.eq = truncate(DeviceUtils.g(12));
        _this.es = truncate(DeviceUtils.g(0));
        _this.er = truncate(DeviceUtils.g(12));
        _this.ep = truncate(DeviceUtils.g(0));
        _this.e9 = _this.fa();
        return _this;
    }
    Header.prototype.eg = function () {
        return GridStyleRepository.bj;
    };
    Header.prototype.eb = function () {
        return GridStyleRepository.bh;
    };
    Header.prototype.fa = function () {
        return GridStyleRepository.bl;
    };
    Header.prototype.af = function () {
        return GridStyleRepository.h;
    };
    Header.prototype.cz = function (a, b) {
        this.c8();
        this.df();
        this.dg();
        this.e5();
        this.e6();
    };
    Header.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.wa != null) {
                this.d0 = this.grid.wa;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    Header.prototype.df = function () {
        if (this.ek == null) {
            if (this.grid != null && this.grid.we != null) {
                this.d6 = this.grid.we;
                return;
            }
            this.d6 = this.eg();
        }
        else {
            this.d6 = this.ek;
        }
    };
    Header.prototype.dg = function () {
        if (this.textStyle == null) {
            if (this.grid != null && this.grid.fw != null) {
                this.ad = this.grid.fw;
                return;
            }
            this.ad = this.af();
        }
        else {
            this.ad = this.textStyle;
        }
    };
    Header.prototype.e5 = function () {
        if (this.fb == null) {
            if (this.grid != null && this.grid.wd != null) {
                this.e9 = this.grid.wd;
                return;
            }
            this.e9 = this.fa();
        }
        else {
            this.e9 = this.fb;
        }
    };
    Header.prototype.e6 = function () {
        if (this.eo == 3) {
            if (this.grid != null) {
                this.en = this.grid.e7;
                return;
            }
            this.en = 0;
        }
        else {
            this.en = this.eo;
        }
    };
    Header.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "HeaderBackground":
                this.c8();
                break;
            case "HeaderTextColor":
                this.df();
                break;
            case "HeaderTextStyle":
                this.dg();
                break;
            case "HeaderSortIndicatorColor":
                this.e5();
                break;
            case "HeaderSortIndicatorStyle":
                this.e6();
                break;
        }
    };
    Object.defineProperty(Header.prototype, "fb", {
        get: function () {
            return this.e8;
        },
        set: function (a) {
            var b = this.e8;
            this.e8 = a;
            if (this.e8 != b) {
                this.c2("SortIndicatorColor", 10, b, this.e8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "e9", {
        get: function () {
            return this.e7;
        },
        set: function (a) {
            var b = this.e7;
            this.e7 = a;
            if (this.e7 != b) {
                this.c2("ActualSortIndicatorColor", 2, b, this.e7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "eo", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            var b = this.em;
            this.em = a;
            if (this.em != b) {
                this.c2("SortIndicatorStyle", 11, enumGetBox(SortIndicatorStyle_$type, b), enumGetBox(SortIndicatorStyle_$type, this.em));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "en", {
        get: function () {
            return this.el;
        },
        set: function (a) {
            var b = this.el;
            this.el = a;
            if (this.el != b) {
                this.c2("ActualSortIndicatorStyle", 11, enumGetBox(SortIndicatorStyle_$type, b), enumGetBox(SortIndicatorStyle_$type, this.el));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "eu", {
        get: function () {
            return this.eq;
        },
        set: function (a) {
            var b = this.eq;
            this.eq = a;
            if (this.eq != b) {
                this.c2("PaddingLeft", 6, b, this.eq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "ew", {
        get: function () {
            return this.es;
        },
        set: function (a) {
            var b = this.es;
            this.es = a;
            if (this.es != b) {
                this.c2("PaddingTop", 6, b, this.es);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "ev", {
        get: function () {
            return this.er;
        },
        set: function (a) {
            var b = this.er;
            this.er = a;
            if (this.er != b) {
                this.c2("PaddingRight", 6, b, this.er);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "et", {
        get: function () {
            return this.ep;
        },
        set: function (a) {
            var b = this.ep;
            this.ep = a;
            if (this.ep != b) {
                this.c2("PaddingBottom", 6, b, this.ep);
            }
        },
        enumerable: true,
        configurable: true
    });
    Header.prototype.ak = function (a) {
        if (_super.prototype.ak.call(this, a)) {
            return true;
        }
        if (stringStartsWith(a, "Actual")) {
            return false;
        }
        switch (a) {
            case "PaddingBottom":
                this.c2("PaddingBottom", 0, this.et, this.et);
                return true;
            case "PaddingLeft":
                this.c2("PaddingLeft", 0, this.eu, this.eu);
                return true;
            case "PaddingRight":
                this.c2("PaddingRight", 0, this.ev, this.ev);
                return true;
            case "PaddingTop":
                this.c2("PaddingTop", 0, this.ew, this.ew);
                return true;
            case "SortIndicatorColor":
                this.c2("ActualSortIndicatorColor", 2, this.e9, this.e9);
                return true;
        }
        return false;
    };
    Header.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        a.fp = this.eu;
        a.ft = this.ew;
        a.fr = this.ev;
        a.fn = this.et;
        a.kr = this.e9;
    };
    Header.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = b.a1(a.k);
        if (e != null) {
            if (a.k.g && e.f9()) {
                var f = e.fm;
                var g = f.o;
                var h = g.count;
                var i = f.p;
                var j = f.q;
                for (var k = 0; k < h; k++) {
                    if (i._inner[k]) {
                        continue;
                    }
                    a.jv(g._inner[k], j._inner[k]);
                }
            }
        }
    };
    Header.$t = markType(Header, 'Header', DefinitionBase.$);
    return Header;
}(DefinitionBase));
export { Header };
/**
 * @hidden
 */
var ColumnResizingSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnResizingSeparator, _super);
    function ColumnResizingSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColumnResizingSeparator.prototype.cm = function (a, b, c) {
        return "columnResizingSeparator";
    };
    ColumnResizingSeparator.prototype.l = function (a) {
        return new VerticalSeparatorCellModel();
    };
    ColumnResizingSeparator.prototype.eb = function () {
        return GridStyleRepository.a5;
    };
    ColumnResizingSeparator.prototype.cz = function (a, b) {
        this.c8();
    };
    ColumnResizingSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.v7 != null) {
                this.d0 = this.grid.v7;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    ColumnResizingSeparator.prototype.el = function (a, b) {
        switch (b.propertyName) {
            case "ColumnResizingSeparatorBackground":
                this.c8();
                break;
        }
    };
    ColumnResizingSeparator.$t = markType(ColumnResizingSeparator, 'ColumnResizingSeparator', DefinitionBase.$);
    return ColumnResizingSeparator;
}(DefinitionBase));
export { ColumnResizingSeparator };
/**
 * @hidden
 */
var HeaderSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(HeaderSeparator, _super);
    function HeaderSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderSeparator.prototype.cm = function (a, b, c) {
        return "headerSeparator";
    };
    HeaderSeparator.prototype.l = function (a) {
        return new VerticalSeparatorCellModel();
    };
    HeaderSeparator.prototype.eb = function () {
        return GridStyleRepository.bi;
    };
    HeaderSeparator.prototype.el = function () {
        return truncate(DeviceUtils.g(1));
    };
    HeaderSeparator.prototype.cz = function (a, b) {
        this.c8();
        this.em();
    };
    HeaderSeparator.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "HeaderSeparatorBackground":
                this.c8();
                break;
        }
    };
    HeaderSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.wc != null) {
                this.d0 = this.grid.wc;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    HeaderSeparator.prototype.em = function () {
        if (this.grid != null) {
            this.d1 = ((function () {
                var $ret = new Brush();
                $ret.color = Color.u(0, 0, 0, 0);
                return $ret;
            })());
            var a = this.grid.k9(this.grid.lx);
            this.be = a;
            this.bf = a;
        }
    };
    HeaderSeparator.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
    };
    HeaderSeparator.$t = markType(HeaderSeparator, 'HeaderSeparator', DefinitionBase.$);
    return HeaderSeparator;
}(DefinitionBase));
export { HeaderSeparator };
/**
 * @hidden
 */
var ImageColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ImageColumn, _super);
    function ImageColumn() {
        var _this = _super.call(this) || this;
        _this.j6 = 0;
        _this.j4 = 0;
        _this.j7 = 0;
        _this.h = _this.i();
        _this.c = _this.d();
        return _this;
    }
    Object.defineProperty(ImageColumn.prototype, "j7", {
        get: function () {
            return this.j6;
        },
        set: function (a) {
            var b = this.j6;
            this.j6 = a;
            if (this.j6 != b) {
                this.c2("ImageStretchOption", 4, enumGetBox(ImageStretchOptions_$type, b), enumGetBox(ImageStretchOptions_$type, this.j6));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageColumn.prototype, "j5", {
        get: function () {
            return this.j4;
        },
        set: function (a) {
            var b = this.j4;
            this.j4 = a;
            if (this.j4 != b) {
                this.c2("ImageResourceType", 11, enumGetBox(ImageResourceType_$type, b), enumGetBox(ImageResourceType_$type, this.j4));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageColumn.prototype, "j3", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            this.fc = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageColumn.prototype, "j8", {
        get: function () {
            return this.g8;
        },
        set: function (a) {
            this.g8 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageColumn.prototype, "j9", {
        get: function () {
            return this.h0;
        },
        set: function (a) {
            this.h0 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageColumn.prototype, "j2", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            this.em = a;
        },
        enumerable: true,
        configurable: true
    });
    ImageColumn.prototype.i = function () {
        if (this.j != 4) {
            return this.j;
        }
        return 3;
    };
    ImageColumn.prototype.ep = function () {
        if (this.c == 3) {
            return 1;
        }
        return _super.prototype.ep.call(this);
    };
    ImageColumn.prototype.eq = function () {
        if (this.h == 3) {
            return 1;
        }
        return _super.prototype.eq.call(this);
    };
    ImageColumn.prototype.d = function () {
        if (this.e != 4) {
            return this.e;
        }
        return 3;
    };
    ImageColumn.prototype.l = function (a) {
        return new ImageCellModel();
    };
    ImageColumn.prototype.cm = function (a, b, c) {
        return "image";
    };
    ImageColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        if (c != null) {
            e.ir = c.toString();
            e.kz = this.j7;
            e.kx = this.j5;
            e.k4 = this.ka(c);
        }
    };
    ImageColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
    };
    ImageColumn.prototype.ka = function (a) {
        if (a == null) {
            return "";
        }
        if (typeof a === 'string') {
            return a;
        }
        return a.toString();
    };
    ImageColumn.$t = markType(ImageColumn, 'ImageColumn', Column.$);
    return ImageColumn;
}(Column));
export { ImageColumn };
/**
 * @hidden
 */
var NumericColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(NumericColumn, _super);
    function NumericColumn() {
        var _this = _super.call(this) || this;
        _this.kj = null;
        _this.kl = null;
        _this.kk = null;
        _this.km = "";
        _this.j9 = 10;
        _this.ka = 0;
        _this.kb = -1;
        _this.j6 = false;
        _this.ki = null;
        _this.j2 = null;
        _this.kf = null;
        _this.c = _this.d();
        return _this;
    }
    NumericColumn.prototype.d = function () {
        if (this.e != 4) {
            return this.e;
        }
        return 2;
    };
    Object.defineProperty(NumericColumn.prototype, "kv", {
        get: function () {
            return this.kj;
        },
        set: function (a) {
            var b = this.kj;
            this.kj = a;
            if (this.kj != b) {
                this.c2("NegativePrefix", 8, b, this.kj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "kz", {
        get: function () {
            return this.kl;
        },
        set: function (a) {
            var b = this.kl;
            this.kl = a;
            if (this.kl != b) {
                this.c2("PositivePrefix", 8, b, this.kl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "kx", {
        get: function () {
            return this.kk;
        },
        set: function (a) {
            var b = this.kk;
            this.kk = a;
            if (this.kk != b) {
                this.c2("NegativeSuffix", 8, b, this.kk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "k1", {
        get: function () {
            return this.km;
        },
        set: function (a) {
            var b = this.km;
            this.km = a;
            if (this.km != b) {
                this.c2("PositiveSuffix", 8, b, this.km);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "kc", {
        get: function () {
            return this.j9;
        },
        set: function (a) {
            var b = this.j9;
            this.j9 = a;
            if (this.j9 != b) {
                this.c2("MaxFractionDigits", 6, b, this.j9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "kd", {
        get: function () {
            return this.ka;
        },
        set: function (a) {
            var b = this.ka;
            this.ka = a;
            if (this.ka != b) {
                this.c2("MinFractionDigits", 6, b, this.ka);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "ke", {
        get: function () {
            return this.kb;
        },
        set: function (a) {
            var b = this.kb;
            this.kb = a;
            if (this.kb != b) {
                this.c2("MinIntegerDigits", 6, b, this.kb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "j7", {
        get: function () {
            return this.j6;
        },
        set: function (a) {
            var b = this.j6;
            this.j6 = a;
            if (this.j6 != b) {
                this.c2("ShowGroupingSeparator", 5, b, this.j6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "kq", {
        get: function () {
            return this.ki;
        },
        set: function (a) {
            var b = this.ki;
            this.ki = a;
            if (this.ki != b) {
                this.c2("FormatString", 8, b, this.ki);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "j4", {
        get: function () {
            return this.j2;
        },
        set: function (a) {
            var b = this.j2;
            this.j2 = a;
            if (this.j2 != b) {
                this.c2("FormatSpecifiers", 9, b, this.j2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "kh", {
        get: function () {
            return this.kf;
        },
        set: function (a) {
            var b = this.kf;
            this.kf = a;
            if (this.kf != b) {
                this.c2("FormatOverride", 9, b, this.kf);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "j5", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            this.fc = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "kg", {
        get: function () {
            return this.g8;
        },
        set: function (a) {
            this.g8 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "kn", {
        get: function () {
            return this.h0;
        },
        set: function (a) {
            this.h0 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "j3", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            this.em = a;
        },
        enumerable: true,
        configurable: true
    });
    NumericColumn.prototype.l = function (a) {
        return new NumericCellModel();
    };
    NumericColumn.prototype.cm = function (a, b, c) {
        return "numeric";
    };
    NumericColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        {
            e.k1 = false;
            e.k5 = this.j8(c);
        }
    };
    NumericColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        var e = a;
        e.lf = this.kd;
        e.ld = this.kc;
        e.lh = this.ke;
        e.ma = this.kz;
        e.l5 = this.kv;
        e.mc = this.k1;
        e.l7 = this.kx;
        e.lz = this.kq;
        e.kx = this.j4;
        e.lr = this.kh;
        e.k3 = this.j7;
    };
    NumericColumn.prototype.j8 = function (a) {
        if (a == null) {
            return NaN;
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'number') {
            return a;
        }
        if (typeof a === 'number') {
            return a;
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'string') {
            var b_1;
            if (((function () { var c = tryParseNumber(a, b_1); b_1 = c.p1; return c.ret; })())) {
                return b_1;
            }
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        return NaN;
    };
    NumericColumn.$t = markType(NumericColumn, 'NumericColumn', Column.$);
    return NumericColumn;
}(Column));
export { NumericColumn };
/**
 * @hidden
 */
var PinnedAreaSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PinnedAreaSeparator, _super);
    function PinnedAreaSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PinnedAreaSeparator.prototype.cm = function (a, b, c) {
        return "pinnedAreaSeparator";
    };
    PinnedAreaSeparator.prototype.l = function (a) {
        return ((function () {
            var $ret = new VerticalSeparatorCellModel();
            $ret.kx = false;
            return $ret;
        })());
    };
    PinnedAreaSeparator.prototype.eb = function () {
        return GridStyleRepository.a3;
    };
    PinnedAreaSeparator.prototype.cz = function (a, b) {
        this.c8();
    };
    PinnedAreaSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    PinnedAreaSeparator.prototype.c1 = function (a, b) {
    };
    PinnedAreaSeparator.$t = markType(PinnedAreaSeparator, 'PinnedAreaSeparator', DefinitionBase.$);
    return PinnedAreaSeparator;
}(DefinitionBase));
export { PinnedAreaSeparator };
/**
 * @hidden
 */
var SectionFooter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SectionFooter, _super);
    function SectionFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionFooter.prototype.l = function (a) {
        return new TextCellModel();
    };
    SectionFooter.prototype.cm = function (a, b, c) {
        return "sectionFooter";
    };
    SectionFooter.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
    };
    SectionFooter.prototype.cw = function (a, b, c, d) {
        this.d0 = GridStyleRepository.a7;
        _super.prototype.cw.call(this, a, b, c, d);
    };
    SectionFooter.$t = markType(SectionFooter, 'SectionFooter', DefinitionBase.$);
    return SectionFooter;
}(DefinitionBase));
export { SectionFooter };
/**
 * @hidden
 */
var SectionHeader = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SectionHeader, _super);
    function SectionHeader() {
        var _this = _super.call(this) || this;
        _this.fc = null;
        _this.fb = null;
        _this.et = truncate(DeviceUtils.g(12));
        _this.ev = truncate(DeviceUtils.g(1));
        _this.eu = truncate(DeviceUtils.g(1));
        _this.es = truncate(DeviceUtils.g(1));
        _this.ep = false;
        _this.em = 4;
        _this.sectionHeaderPropertyUpdating = null;
        _this.er = new Dictionary$2(String_$type, ComboBoxColumn.$, 0);
        _this.fd = _this.ee();
        return _this;
    }
    Object.defineProperty(SectionHeader.prototype, "fe", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            var b = this.fc;
            this.fc = a;
            if (this.fc != b) {
                this.c2("SelectedBackground", 10, b, this.fc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "fd", {
        get: function () {
            return this.fb;
        },
        set: function (a) {
            var b = this.fb;
            this.fb = a;
            if (this.fb != b) {
                this.c2("ActualSelectedBackground", 2, b, this.fb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "ex", {
        get: function () {
            return this.et;
        },
        set: function (a) {
            var b = this.et;
            this.et = a;
            if (this.et != b) {
                this.c2("PaddingLeft", 6, b, this.et);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "ez", {
        get: function () {
            return this.ev;
        },
        set: function (a) {
            var b = this.ev;
            this.ev = a;
            if (this.ev != b) {
                this.c2("PaddingTop", 6, b, this.ev);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "ey", {
        get: function () {
            return this.eu;
        },
        set: function (a) {
            var b = this.eu;
            this.eu = a;
            if (this.eu != b) {
                this.c2("PaddingRight", 6, b, this.eu);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "ew", {
        get: function () {
            return this.es;
        },
        set: function (a) {
            var b = this.es;
            this.es = a;
            if (this.es != b) {
                this.c2("PaddingBottom", 6, b, this.es);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "eq", {
        get: function () {
            return this.ep;
        },
        set: function (a) {
            var b = this.ep;
            this.ep = a;
            if (this.ep != b) {
                this.c2("IsCollapsable", 5, b, this.ep);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "en", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            var b = this.em;
            this.em = a;
            if (this.em != b) {
                this.c2("SummaryDisplayMode", 4, enumGetBox(GroupSummaryDisplayMode_$type, b), enumGetBox(GroupSummaryDisplayMode_$type, this.em));
            }
        },
        enumerable: true,
        configurable: true
    });
    SectionHeader.prototype.cm = function (a, b, c) {
        return "sectionHeader";
    };
    SectionHeader.prototype.l = function (a) {
        return new SectionHeaderCellModel();
    };
    SectionHeader.prototype.eb = function () {
        return GridStyleRepository.a8;
    };
    SectionHeader.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = new List$1(GroupData.$, 0);
        var f = new List$1(SummaryData.$, 0);
        var g = stringEmpty();
        var h = stringEmpty();
        var i = typeCast(FastIterationDictionary$2.$.specialize(String_$type, Base.$), c);
        if (i != null) {
            var j = b.actualDataSource.actualSchema;
            var k = 0;
            for (var l = 0; l < i.o.count; l++) {
                var m = i.o._inner[l];
                var n = i.q._inner[l];
                var o = null;
                for (var p = 0; p < b.a8.i.count; p++) {
                    if (b.a8.i.item(p).f == m) {
                        o = b.a8.i.item(p);
                        break;
                    }
                }
                if (!o.o) {
                    b.ty(o);
                }
                if (k > 0) {
                    g += ", ";
                }
                e.add(this.el(m, n, o, o.m));
                g += e._inner[k].b;
                k++;
            }
            if (this.en == 0 && b.b8.i.count > 0) {
                var q = typeCast(DataSourceSpecialRow.$, d);
                if (q != null && q.summaryResults != null) {
                    for (var r = 0; r < q.summaryResults.length; r++) {
                        if (q.summaryResults[r] != null) {
                            var s = q.summaryResults[r].summaryIndex;
                            var t = b.b8.i.item(s);
                            if (r > 0) {
                                h += ", ";
                            }
                            f.add(this.u(t, q.summaryResults[r]));
                            h += f._inner[r].c;
                        }
                    }
                }
            }
        }
        var u = typeCast(SectionHeaderCellModel.$, a);
        if (u != null) {
            u.ky = e.toArray();
            u.kz = f.toArray();
            u.lc = g;
            u.la = h;
            u.k1 = this.en;
            if (b.e5.p(u)) {
                u.b8 = 1;
            }
            else {
                u.b8 = 0;
            }
            if (b.aj.m(u)) {
                u.by = 1;
            }
            else {
                u.by = 0;
            }
            u.ar = this.eq;
            u.az = b.actualDataSource.getIsRowExpandedAtIndex(a.k.w);
            u.e6 = b.ee.getRowIndent(a.k.w);
        }
    };
    SectionHeader.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        a.kq = this.fd;
        a.fp = this.ex;
        a.ft = this.ez;
        a.fr = this.ey;
        a.fn = this.ew;
    };
    SectionHeader.prototype.cz = function (a, b) {
        this.fa();
        this.c8();
        this.df();
        this.dg();
        this.e9();
        if (a != null) {
            a.actualColumnsChanged = delegateRemove(a.actualColumnsChanged, runOn(this, this.e8));
        }
        if (b != null) {
            b.actualColumnsChanged = delegateCombine(b.actualColumnsChanged, runOn(this, this.e8));
        }
    };
    SectionHeader.prototype.e8 = function (a, b) {
        this.er.clear();
        for (var c = 0; c < b.columns.count; c++) {
            var d = typeCast(ComboBoxColumn.$, b.columns._inner[c]);
            if (d != null && !this.er.containsKey(d.h4)) {
                this.er.addItem(d.h4, d);
            }
        }
    };
    SectionHeader.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "SectionHeaderSelectedBackground":
                this.fa();
                break;
            case "SectionHeaderBackground":
                this.c8();
                break;
            case "SectionHeaderTextColor":
                this.df();
                break;
            case "SectionHeaderTextStyle":
                this.dg();
                break;
            case "IsGroupCollapsable":
                this.e9();
                break;
        }
    };
    SectionHeader.prototype.fa = function () {
        if (this.fe == null) {
            if (this.grid != null && this.grid.wo != null) {
                this.fd = this.grid.wo;
            }
            else {
                this.fd = this.ee();
            }
        }
        else {
            this.fd = this.fe;
        }
    };
    SectionHeader.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.wn != null) {
                this.d0 = this.grid.wn;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    SectionHeader.prototype.df = function () {
        if (this.ek == null) {
            if (this.grid != null && this.grid.wp != null) {
                this.d6 = this.grid.wp;
                return;
            }
            this.d6 = this.eg();
        }
        else {
            this.d6 = this.ek;
        }
    };
    SectionHeader.prototype.dg = function () {
        if (this.textStyle == null) {
            if (this.grid != null && this.grid.fx != null) {
                this.ad = this.grid.fx;
                return;
            }
            this.ad = this.af();
        }
        else {
            this.ad = this.textStyle;
        }
    };
    SectionHeader.prototype.e9 = function () {
        if (this.grid != null) {
            this.eq = this.grid.h3;
        }
    };
    SectionHeader.prototype.c3 = function (a, b, c, d) {
        _super.prototype.c3.call(this, a, b, c, d);
        switch (a) {
            case "SelectedBackground":
                this.fa();
                break;
        }
        if (this.sectionHeaderPropertyUpdating != null) {
            this.sectionHeaderPropertyUpdating(this, a, b, c, d);
        }
    };
    SectionHeader.prototype.el = function (a, b, c, d) {
        var e = b != null ? b.toString() : stringEmpty();
        var f = a + ": " + e;
        var g = stringEmpty();
        if (c != null) {
            if (c.v == null) {
                g = a + ": ";
            }
            else if (c.v != stringEmpty()) {
                g = c.v + ": ";
            }
            if (b != null) {
                switch (d) {
                    case 10:
                        if (c.q != null) {
                            var override_ = c.q;
                            var val_ = typeGetValue(b);
                            e = (override_.format(val_));
                        }
                        else {
                            e = (typeGetValue(b)).toString();
                        }
                        break;
                    case 8:
                        if (c.q != null) {
                            var override_ = c.q;
                            var val_ = b;
                            e = (override_.format(val_));
                        }
                        else {
                            var h = (b.toLocaleDateString());
                            var i = (b.toLocaleTimeString());
                            e = h + " " + i;
                        }
                        break;
                    case 5:
                        if (c.q != null) {
                            var override_ = c.q;
                            var val_ = b;
                            e = (override_.format(val_));
                        }
                        else {
                            e = b.toString();
                        }
                        break;
                    case 1:
                        if (c.q != null) {
                            var override_ = c.q;
                            var val_ = typeGetValue(b);
                            e = (override_.format(val_));
                        }
                        else {
                            e = (typeGetValue(b)).toString();
                        }
                        break;
                    case 3:
                        if (c.q != null) {
                            var override_ = c.q;
                            var val_ = typeGetValue(b);
                            e = (override_.format(val_));
                        }
                        else {
                            e = typeGetValue(b).toString();
                        }
                        break;
                    case 4:
                        if (c.q != null) {
                            var override_ = c.q;
                            var val_ = typeGetValue(b);
                            e = (override_.format(val_));
                        }
                        else {
                            e = typeGetValue(b).toString();
                        }
                        break;
                    case 7:
                        if (c.q != null) {
                            var override_ = c.q;
                            var val_ = b;
                            e = (override_.format(val_));
                        }
                        else {
                            e = b.toString();
                        }
                        break;
                    case 0:
                    case 6:
                    case 2:
                    case 11:
                        e = b.toString();
                        break;
                }
                if (this.er.containsKey(c.f)) {
                    var j = this.er.item(c.f);
                    var k = j.j8(b);
                    if (k != null) {
                        e = k;
                    }
                }
            }
            if (c.l != null) {
                e = c.l.i(b);
            }
            f = g + e;
            if (c.k != null) {
                f = c.k.i(b);
            }
            f = c.w(b, e, f);
        }
        return ((function () {
            var $ret = new GroupData();
            $ret.c = a;
            $ret.a = b;
            $ret.b = f;
            return $ret;
        })());
    };
    SectionHeader.$t = markType(SectionHeader, 'SectionHeader', DefinitionBase.$);
    return SectionHeader;
}(DefinitionBase));
export { SectionHeader };
/**
 * @hidden
 */
var RowSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RowSeparator, _super);
    function RowSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RowSeparator.prototype.cm = function (a, b, c) {
        return "rowSeparator";
    };
    RowSeparator.prototype.cz = function (a, b) {
        this.c8();
    };
    RowSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.wj != null) {
                this.d0 = this.grid.wj;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    RowSeparator.prototype.dc = function () {
        if (this.ei == null) {
            if (this.grid != null && this.grid.wl != null) {
                this.d4 = this.grid.wl;
                return;
            }
            this.d4 = this.ed();
        }
        else {
            this.d4 = this.ei;
        }
    };
    RowSeparator.prototype.de = function () {
        if (this.ej == null) {
            if (this.grid != null && this.grid.wm != null) {
                this.d5 = this.grid.wm;
                return;
            }
            this.d5 = this.ef();
        }
        else {
            this.d5 = this.ej;
        }
    };
    RowSeparator.prototype.db = function () {
        if (this.eh == null) {
            if (this.grid != null && this.grid.wk != null) {
                this.d3 = this.grid.wk;
                return;
            }
            this.d3 = this.ec();
        }
        else {
            this.d3 = this.eh;
        }
    };
    RowSeparator.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "RowSeparatorBackground":
                this.c8();
                break;
            case "RowSeparatorLastStickyRowBackground":
                this.db();
                break;
            case "RowSeparatorPinnedRowBackground":
                this.dc();
                break;
            case "RowSeparatorStickyRowBackground":
                this.de();
                break;
        }
    };
    RowSeparator.prototype.l = function (a) {
        return new RowSeparatorModel();
    };
    RowSeparator.prototype.eb = function () {
        return GridStyleRepository.bk;
    };
    RowSeparator.prototype.ef = function () {
        return GridStyleRepository.bc;
    };
    RowSeparator.prototype.ec = function () {
        return GridStyleRepository.a2;
    };
    RowSeparator.prototype.ed = function () {
        return this.eb();
    };
    RowSeparator.prototype.av = function () {
        return 1;
    };
    RowSeparator.$t = markType(RowSeparator, 'RowSeparator', DefinitionBase.$);
    return RowSeparator;
}(DefinitionBase));
export { RowSeparator };
/**
 * @hidden
 */
var HeaderRowSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(HeaderRowSeparator, _super);
    function HeaderRowSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderRowSeparator.prototype.cm = function (a, b, c) {
        return "headerRowSeparator";
    };
    HeaderRowSeparator.prototype.l = function (a) {
        return new RowSeparatorModel();
    };
    HeaderRowSeparator.prototype.eb = function () {
        return GridStyleRepository.a0;
    };
    HeaderRowSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.wb != null) {
                this.d0 = this.grid.wb;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    HeaderRowSeparator.prototype.cz = function (a, b) {
        this.c8();
    };
    HeaderRowSeparator.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "HeaderRowSeparatorBackground":
                this.c8();
                break;
        }
    };
    HeaderRowSeparator.$t = markType(HeaderRowSeparator, 'HeaderRowSeparator', DefinitionBase.$);
    return HeaderRowSeparator;
}(DefinitionBase));
export { HeaderRowSeparator };
/**
 * @hidden
 */
var SummaryRow = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryRow, _super);
    function SummaryRow() {
        var _this = _super.call(this) || this;
        _this.fd = null;
        _this.fb = null;
        _this.fe = null;
        _this.fc = null;
        _this.em = null;
        _this.el = null;
        _this.er = truncate(DeviceUtils.g(12));
        _this.et = truncate(DeviceUtils.g(0));
        _this.es = truncate(DeviceUtils.g(12));
        _this.eq = truncate(DeviceUtils.g(0));
        _this.ff = _this.ee();
        _this.en = _this.eo();
        _this.fg = _this.fh();
        return _this;
    }
    Object.defineProperty(SummaryRow.prototype, "fi", {
        get: function () {
            return this.fd;
        },
        set: function (a) {
            var b = this.fd;
            this.fd = a;
            if (this.fd != b) {
                this.c2("SelectedBackground", 10, b, this.fd);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "ff", {
        get: function () {
            return this.fb;
        },
        set: function (a) {
            var b = this.fb;
            this.fb = a;
            if (this.fb != b) {
                this.c2("ActualSelectedBackground", 2, b, this.fb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "fj", {
        get: function () {
            return this.fe;
        },
        set: function (a) {
            var b = this.fe;
            this.fe = a;
            if (this.fe != b) {
                this.c2("SummaryLabelTextColor", 10, b, this.fe);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "fg", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            var b = this.fc;
            this.fc = a;
            if (this.fc != b) {
                this.c2("ActualSummaryLabelTextColor", 2, b, this.fc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "summaryNameTextStyle", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            var b = this.em;
            this.em = a;
            if (this.em != b) {
                this.c2("SummaryNameFontInfo", 10, b, this.em);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "en", {
        get: function () {
            return this.el;
        },
        set: function (a) {
            var b = this.el;
            this.el = a;
            if (this.el != b) {
                this.c2("ActualSummaryLabelFontInfo", 3, b, this.el);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "ev", {
        get: function () {
            return this.er;
        },
        set: function (a) {
            var b = this.er;
            this.er = a;
            if (this.er != b) {
                this.c2("PaddingLeft", 6, b, this.er);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "ex", {
        get: function () {
            return this.et;
        },
        set: function (a) {
            var b = this.et;
            this.et = a;
            if (this.et != b) {
                this.c2("PaddingTop", 6, b, this.et);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "ew", {
        get: function () {
            return this.es;
        },
        set: function (a) {
            var b = this.es;
            this.es = a;
            if (this.es != b) {
                this.c2("PaddingRight", 6, b, this.es);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "eu", {
        get: function () {
            return this.eq;
        },
        set: function (a) {
            var b = this.eq;
            this.eq = a;
            if (this.eq != b) {
                this.c2("PaddingBottom", 6, b, this.eq);
            }
        },
        enumerable: true,
        configurable: true
    });
    SummaryRow.prototype.cm = function (a, b, c) {
        return "summary";
    };
    SummaryRow.prototype.l = function (a) {
        return new SummaryCellModel();
    };
    SummaryRow.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = typeCast(DataSourceSpecialRow.$, d);
        var f = stringEmpty();
        var g = stringEmpty();
        var h = b.a1(a.k);
        if (h != null) {
            var i = e.getSummaryResults(h.h4);
            if (i.length > 0 && b.b8.i.count > 0) {
                var j = b.b8.i.item(i[0].summaryIndex);
                if (j.j != null) {
                    var k = this.u(j, i[0]);
                    f = j.ac != null ? j.ac : j.j.displayName;
                    g = k.d;
                }
            }
        }
        var l = typeCast(SummaryCellModel.$, a);
        if (l != null) {
            l.k4 = f;
            l.k6 = g;
            l.e6 = b.ee.getRowIndent(a.k.w);
            if (b.e5.p(l)) {
                l.b8 = 1;
            }
            else {
                l.b8 = 0;
            }
            if (b.aj.m(l)) {
                l.by = 1;
            }
            else {
                l.by = 0;
            }
        }
    };
    SummaryRow.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        var e = typeCast(SummaryCellModel.$, a);
        e.kq = this.ff;
        e.kh = this.d0;
        e.lb = this.fg;
        e.kx = this.en;
        e.fp = this.ev;
        e.ft = this.ex;
        e.fr = this.ew;
        e.fn = this.eu;
    };
    SummaryRow.prototype.cz = function (a, b) {
        this.e8();
        this.e9();
        this.c8();
        this.df();
        this.dg();
        this.fa();
    };
    SummaryRow.prototype.fh = function () {
        return GridStyleRepository.bd;
    };
    SummaryRow.prototype.eg = function () {
        return GridStyleRepository.be;
    };
    SummaryRow.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "SummaryRootSelectedBackground":
            case "SummarySectionSelectedBackground":
                this.e8();
                break;
            case "SummaryRootBackground":
            case "SummarySectionBackground":
                this.c8();
                break;
            case "SummaryRootValueTextColor":
            case "SummarySectionValueTextColor":
                this.df();
                break;
            case "SummaryRootLabelTextColor":
            case "SummarySectionLabelTextColor":
                this.e9();
                break;
            case "SummaryRootLabelTextStyle":
            case "SummarySectionLabelTextStyle":
                this.fa();
                break;
            case "SummaryRootValueTextStyle":
            case "SummarySectionValueTextStyle":
                this.dg();
                break;
        }
    };
    SummaryRow.prototype.e8 = function () {
        if (this.fi == null) {
            this.ff = this.ee();
        }
        else {
            this.ff = this.fi;
        }
    };
    SummaryRow.prototype.e9 = function () {
    };
    SummaryRow.prototype.dg = function () {
    };
    SummaryRow.prototype.fa = function () {
    };
    SummaryRow.prototype.c3 = function (a, b, c, d) {
        _super.prototype.c3.call(this, a, b, c, d);
        switch (a) {
            case "SelectedBackground":
                this.e8();
                break;
            case "SummaryLabelTextColor":
                this.e9();
                break;
            case "SummaryNameFontInfo":
                this.fa();
                break;
        }
    };
    SummaryRow.prototype.af = function () {
        return GridStyleRepository.j;
    };
    SummaryRow.prototype.eo = function () {
        return GridStyleRepository.i;
    };
    SummaryRow.$t = markType(SummaryRow, 'SummaryRow', DefinitionBase.$);
    return SummaryRow;
}(DefinitionBase));
export { SummaryRow };
/**
 * @hidden
 */
var SummaryRowRoot = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryRowRoot, _super);
    function SummaryRowRoot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SummaryRowRoot.prototype.cm = function (a, b, c) {
        return "summaryRowRoot";
    };
    SummaryRowRoot.prototype.eb = function () {
        return GridStyleRepository.a6;
    };
    SummaryRowRoot.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.wr != null) {
                this.d0 = this.grid.wr;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    SummaryRowRoot.prototype.e8 = function () {
        if (this.fi == null) {
            if (this.grid != null && this.grid.wt != null) {
                this.ff = this.grid.wt;
            }
            else {
                this.ff = this.ee();
            }
        }
        else {
            this.ff = this.fi;
        }
    };
    SummaryRowRoot.prototype.e9 = function () {
        if (this.fj == null) {
            if (this.grid != null && this.grid.ws != null) {
                this.fg = this.grid.ws;
            }
            else {
                this.fg = this.fh();
            }
        }
        else {
            this.fg = this.fj;
        }
    };
    SummaryRowRoot.prototype.df = function () {
        if (this.ek == null) {
            if (this.grid != null && this.grid.wu != null) {
                this.d6 = this.grid.wu;
            }
            else {
                this.d6 = this.eg();
            }
        }
        else {
            this.d6 = this.ek;
        }
    };
    SummaryRowRoot.prototype.fa = function () {
        if (this.summaryNameTextStyle == null) {
            if (this.grid != null && this.grid.fy != null) {
                this.en = this.grid.fy;
            }
            else {
                this.en = this.eo();
            }
        }
        else {
            this.en = this.summaryNameTextStyle;
        }
    };
    SummaryRowRoot.$t = markType(SummaryRowRoot, 'SummaryRowRoot', SummaryRow.$);
    return SummaryRowRoot;
}(SummaryRow));
export { SummaryRowRoot };
/**
 * @hidden
 */
var SummaryRowSection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryRowSection, _super);
    function SummaryRowSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SummaryRowSection.prototype.cm = function (a, b, c) {
        return "summaryRowSection";
    };
    SummaryRowSection.prototype.eb = function () {
        return GridStyleRepository.a9;
    };
    SummaryRowSection.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.wv != null) {
                this.d0 = this.grid.wv;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    SummaryRowSection.prototype.e8 = function () {
        if (this.fi == null) {
            if (this.grid != null && this.grid.wx != null) {
                this.ff = this.grid.wx;
            }
            else {
                this.ff = this.ee();
            }
        }
        else {
            this.ff = this.fi;
        }
    };
    SummaryRowSection.prototype.e9 = function () {
        if (this.fj == null) {
            if (this.grid != null && this.grid.ww != null) {
                this.fg = this.grid.ww;
            }
            else {
                this.fg = this.fh();
            }
        }
        else {
            this.fg = this.fj;
        }
    };
    SummaryRowSection.prototype.df = function () {
        if (this.ek == null) {
            if (this.grid != null && this.grid.wy != null) {
                this.d6 = this.grid.wy;
            }
            else {
                this.d6 = this.eg();
            }
        }
        else {
            this.d6 = this.ek;
        }
    };
    SummaryRowSection.prototype.fa = function () {
        if (this.summaryNameTextStyle == null) {
            if (this.grid != null && this.grid.f0 != null) {
                this.en = this.grid.f0;
            }
            else {
                this.en = this.eo();
            }
        }
        else {
            this.en = this.summaryNameTextStyle;
        }
    };
    SummaryRowSection.$t = markType(SummaryRowSection, 'SummaryRowSection', SummaryRow.$);
    return SummaryRowSection;
}(SummaryRow));
export { SummaryRowSection };
/**
 * @hidden
 */
var TemplateColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateColumn, _super);
    function TemplateColumn() {
        var _this = _super.call(this) || this;
        _this.cellUpdating = null;
        _this.ge = false;
        return _this;
    }
    TemplateColumn.prototype.l = function (a) {
        return ((function () {
            var $ret = new TemplateCellModel();
            $ret.a0 = false;
            return $ret;
        })());
    };
    TemplateColumn.prototype.cm = function (a, b, c) {
        var d = "template-" + this.g6;
        return d;
    };
    TemplateColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        e.ky = c;
    };
    TemplateColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
    };
    TemplateColumn.prototype.j3 = function (a, b) {
        if (this.cellUpdating != null) {
            this.cellUpdating(this, ((function () {
                var $ret = new TemplateCellUpdatingEventArgs();
                $ret.cellInfo = a;
                $ret.content = b;
                return $ret;
            })()));
        }
    };
    TemplateColumn.prototype.c3 = function (a, b, c, d) {
        switch (a) {
            case "IsEditable":
                this.ge = false;
                break;
        }
        _super.prototype.c3.call(this, a, b, c, d);
    };
    TemplateColumn.$t = markType(TemplateColumn, 'TemplateColumn', Column.$);
    return TemplateColumn;
}(Column));
export { TemplateColumn };
/**
 * @hidden
 */
var TemplateCellUpdatingEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateCellUpdatingEventArgs, _super);
    function TemplateCellUpdatingEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._cellInfo = null;
        _this._content = null;
        return _this;
    }
    Object.defineProperty(TemplateCellUpdatingEventArgs.prototype, "cellInfo", {
        get: function () {
            return this._cellInfo;
        },
        set: function (a) {
            this._cellInfo = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TemplateCellUpdatingEventArgs.prototype, "content", {
        get: function () {
            return this._content;
        },
        set: function (a) {
            this._content = a;
        },
        enumerable: true,
        configurable: true
    });
    TemplateCellUpdatingEventArgs.$t = markType(TemplateCellUpdatingEventArgs, 'TemplateCellUpdatingEventArgs', EventArgs.$);
    return TemplateCellUpdatingEventArgs;
}(EventArgs));
export { TemplateCellUpdatingEventArgs };
/**
 * @hidden
 */
var TextColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextColumn, _super);
    function TextColumn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.j5 = null;
        return _this;
    }
    Object.defineProperty(TextColumn.prototype, "j8", {
        get: function () {
            return this.j5;
        },
        set: function (a) {
            var b = this.j5;
            this.j5 = a;
            if (this.j5 != b) {
                this.c2("FormatString", 8, b, this.j5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextColumn.prototype, "j3", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            this.fc = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextColumn.prototype, "j4", {
        get: function () {
            return this.g8;
        },
        set: function (a) {
            this.g8 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextColumn.prototype, "j6", {
        get: function () {
            return this.h0;
        },
        set: function (a) {
            this.h0 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextColumn.prototype, "j2", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            this.em = a;
        },
        enumerable: true,
        configurable: true
    });
    TextColumn.prototype.l = function (a) {
        return new TextCellModel();
    };
    TextColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        if (c != null) {
            e.ky = this.j7(c);
        }
        else {
            e.ky = null;
        }
    };
    TextColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        var e = a;
    };
    TextColumn.prototype.j7 = function (a) {
        if (typeof a === 'string') {
            return a;
        }
        return null;
    };
    TextColumn.prototype.cm = function (a, b, c) {
        return "text";
    };
    TextColumn.$t = markType(TextColumn, 'TextColumn', Column.$);
    return TextColumn;
}(Column));
export { TextColumn };
/**
 * @hidden
 */
var TextHeader = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextHeader, _super);
    function TextHeader() {
        var _this = _super.call(this) || this;
        _this.c = 0;
        _this.h = 1;
        return _this;
    }
    TextHeader.prototype.l = function (a) {
        var b = new TextHeaderCellModel();
        return b;
    };
    TextHeader.prototype.cm = function (a, b, c) {
        return "textHeader";
    };
    TextHeader.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        var e = a;
        var f = b.a1(a.k);
        e.k1 = f.ex;
        e.lj = f.jq;
        e.k3 = f.e1;
    };
    TextHeader.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        var f = b.a1(a.k);
        e.ky = f.hl;
        e.ir = e.ky;
        e.m = f.e6;
        e.k7 = f.f5;
        e.k5 = this.en;
    };
    TextHeader.$t = markType(TextHeader, 'TextHeader', Header.$);
    return TextHeader;
}(Header));
export { TextHeader };
/**
 * @hidden
 */
var GridEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridEffect, _super);
    function GridEffect() {
        var _this = _super.call(this) || this;
        _this.s = 0;
        _this.u = 0;
        _this.br = "";
        _this.af = false;
        _this.ac = false;
        _this.onFinished = null;
        _this.onCanceled = null;
        _this.a3 = 0;
        _this.a1 = 0;
        _this.h = null;
        _this.a7 = -1;
        _this.a8 = -1;
        _this.a2 = 300;
        _this.j = null;
        _this.a4 = 0;
        _this.c = null;
        _this.a = null;
        _this.a6 = -1;
        _this.ad = false;
        _this.ab = false;
        _this.bk = -1;
        _this.bm = null;
        _this.bn = null;
        _this.w = null;
        _this.p = null;
        _this.aa = false;
        _this.n = null;
        _this.ae = false;
        _this.ay = null;
        _this.az = 1;
        _this.a5 = -1;
        _this.b = null;
        _this.ax = new Dictionary$2(CellPath.$, Number_$type, 0);
        return _this;
    }
    GridEffect.prototype.bu = function () {
        if (this.onFinished != null) {
            this.onFinished(this);
        }
    };
    GridEffect.prototype.bt = function (a) {
        if (this.onCanceled != null) {
            this.onCanceled(this, a);
        }
    };
    Object.defineProperty(GridEffect.prototype, "t", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            this.s = a;
        },
        enumerable: true,
        configurable: true
    });
    GridEffect.prototype.am = function (a) {
        if (a == null) {
            return false;
        }
        if (a.s != this.s) {
            return false;
        }
        if (!this.af) {
            return true;
        }
        if (a.u != this.u) {
            return false;
        }
        if (a.br != this.br) {
            return false;
        }
        return true;
    };
    Object.defineProperty(GridEffect.prototype, "v", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            this.u = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bs", {
        get: function () {
            return this.br;
        },
        set: function (a) {
            this.br = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "as", {
        get: function () {
            return this.af;
        },
        set: function (a) {
            this.af = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "ap", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            this.ac = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "ba", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            this.a3 = a;
            this.a1 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "i", {
        get: function () {
            return this.h;
        },
        set: function (a) {
            this.h = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bi", {
        get: function () {
            return this.a7;
        },
        set: function (a) {
            this.a7 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bj", {
        get: function () {
            return this.a8;
        },
        set: function (a) {
            this.a8 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "a9", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            this.a2 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            this.j = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bg", {
        get: function () {
            return this.a4;
        },
        set: function (a) {
            this.a4 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "g", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "e", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            this.a = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bh", {
        get: function () {
            return this.a6;
        },
        set: function (a) {
            this.a6 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "aq", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            this.ad = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "ao", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            this.ab = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bl", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            this.bk = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bo", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            this.bm = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bq", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            this.bn = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "x", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            this.w = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "q", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            this.p = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "al", {
        get: function () {
            return this.aa;
        },
        set: function (a) {
            this.aa = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "o", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            this.n = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "ar", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            this.ae = a;
        },
        enumerable: true,
        configurable: true
    });
    GridEffect.prototype.bx = function (a) {
        this.ba = a.l;
        this.bg = a.m;
        this.bi = a.n;
        this.bj = a.o;
        this.aq = a.e;
        this.q = this.r(a.c);
    };
    GridEffect.prototype.r = function (a) {
        switch (a) {
            case 0: return null;
            case 1: return EasingFunctions.cubicEase;
            case 3: return EasingFunctions.circleEase;
            case 2: return EasingFunctions.exponentialEase;
        }
        return null;
    };
    GridEffect.prototype.au = function (a, b, c, d) {
        if (this.ar && this.an(d)) {
            return false;
        }
        var e = this.a0(d);
        var f = 1;
        if (this.a3 > 0) {
            f = e / this.a3;
        }
        var g = false;
        if (this.w == null) {
            return true;
        }
        if (f >= 1) {
            f = 1;
            g = true;
        }
        if (this.p != null) {
            f = this.p(f);
        }
        var h = this.bp(this.bm, b, a, a.o);
        this.w(f, h, this.bn, a, b);
        return g;
    };
    GridEffect.prototype.av = function (a, b, c, d) {
        if (this.ar && this.an(d)) {
            return false;
        }
        var e = this.a0(d);
        var f = 1;
        if (this.a3 > 0) {
            f = e / this.a3;
        }
        var g = false;
        if (this.w == null) {
            return true;
        }
        if (f >= 1) {
            f = 1;
            g = true;
        }
        if (this.p != null) {
            f = this.p(f);
        }
        var h = this.bp(this.bm, b, a, a);
        this.w(f, h, this.bn, a, b);
        return g;
    };
    GridEffect.prototype.a0 = function (a) {
        var b = (a - this.bk);
        if (this.a4 > 0) {
            if (b < this.a4) {
                b = 0;
            }
            else {
                b -= this.a4;
            }
        }
        return b;
    };
    GridEffect.prototype.an = function (a) {
        var b = (a - this.bk);
        if (this.a4 > 0) {
            if (b < this.a4) {
                return true;
            }
        }
        return false;
    };
    GridEffect.prototype.bz = function (a, b, c, d) {
        var e = this.bb(b, a);
        if (this.f == null) {
            return;
        }
        var f = this.bb(b, this.f);
        var g = f / this.a6;
        if (g > 5) {
            g = 5;
        }
        if (g == this.az) {
            return;
        }
        var h = g / this.az;
        this.az = g;
        var i = truncate(Math.round(this.a1 * h));
        if (i <= 0) {
            var j = 0;
            j += 1;
        }
        {
            this.a1 = i;
        }
    };
    GridEffect.prototype.at = function (a, b, c, d) {
        var e = false;
        this.bz(a.k, b, c, d);
        if (this.ar && this.an(d)) {
            return false;
        }
        var f = this.a0(d);
        var g = this.bf(b, c, a.k, d);
        var h = this.bc(b, c, a.k, d);
        if (h < 300) {
            var i = 0;
            i += 1;
        }
        var j = f - g;
        if (j < 0) {
            j = 0;
        }
        var k = 1;
        if (h > 0) {
            k = j / h;
        }
        if (k >= 1) {
            k = 1;
            e = true;
        }
        if (this.p != null) {
            k = this.p(k);
        }
        var l = this.bp(this.bm, b, a, a.k);
        this.w(k, l, this.bn, a, b);
        return e;
    };
    GridEffect.prototype.by = function (a, b, c) {
        if (this.ay == null) {
            this.ay = new Dictionary$2(Base.$, Base.$, 0);
        }
        this.ay.item(c, a);
    };
    GridEffect.prototype.bp = function (a, b, c, d) {
        if (this.al) {
            if (this.ay == null) {
                this.ay = new Dictionary$2(Base.$, Base.$, 0);
            }
            if (this.ay.containsKey(d)) {
                return this.ay.item(d);
            }
            var e = this.o(c, b);
            this.ay.item(d, e);
            return e;
        }
        else {
            return this.bm;
        }
    };
    GridEffect.prototype.aw = function (a, b, c, d) {
        if (this.ar && this.an(d)) {
            return false;
        }
        var e = this.a0(d);
        var f = 1;
        if (this.a3 > 0) {
            f = e / this.a3;
        }
        var g = false;
        if (this.w == null) {
            return true;
        }
        if (f >= 1) {
            f = 1;
            g = true;
        }
        if (this.p != null) {
            f = this.p(f);
        }
        this.w(f, this.bm, this.bn, a, b);
        return g;
    };
    GridEffect.prototype.ag = function (a, b) {
        return false;
    };
    GridEffect.prototype.ah = function (a, b) {
        return false;
    };
    GridEffect.prototype.ai = function (a, b) {
        return false;
    };
    GridEffect.prototype.aj = function (a, b) {
        return false;
    };
    GridEffect.prototype.bv = function (a) {
    };
    GridEffect.prototype.bw = function (a) {
    };
    Object.defineProperty(GridEffect.prototype, "f", {
        get: function () {
            return this.b;
        },
        enumerable: true,
        configurable: true
    });
    GridEffect.prototype.bf = function (a, b, c, d) {
        if (c == null) {
            return 0;
        }
        var e = this.bb(a, c);
        var f = this.bd(a, b, c, d);
        var g = this.a3;
        if (this.ad) {
            g = truncate(((f / this.a6) * g));
        }
        var h = this.a7;
        if (h == -1) {
            h = truncate((g / f));
            if ((g - truncate((f * h))) < this.a2) {
                h = truncate(((g - this.a2) / f));
            }
            if (h < 0) {
                h = 0;
            }
        }
        var i = h * e;
        if (this.h != null) {
            i = this.h(this.c, this.a6, c);
        }
        var j = this.a1;
        if (i < (j * -1)) {
            i = (j * -1);
        }
        if (i > (j)) {
            i = j - this.a2;
        }
        if (this.ad && this.a0(d) > i && c != null && !this.ax.containsKey(c)) {
            this.ax.addItem(c, f);
        }
        return i;
    };
    GridEffect.prototype.bd = function (a, b, c, d) {
        if (this.f == null || !this.ad) {
            return this.a6;
        }
        if (this.ax.containsKey(c)) {
            return this.ax.item(c);
        }
        var e = this.bb(a, this.f);
        return e;
    };
    GridEffect.prototype.bb = function (a, b) {
        if (b == null) {
            return 0;
        }
        var c = this.be(a, b);
        if (this.a6 == -1) {
            this.a6 = this.be(a, this.a) + 1;
        }
        if (this.ab) {
            c = ((this.a6 - 1) - c);
        }
        var d = c;
        if (d > this.a6 && d > this.a5) {
            this.a5 = d;
            this.b = b;
        }
        return d;
    };
    GridEffect.prototype.be = function (a, b) {
        return 0;
    };
    GridEffect.prototype.bc = function (a, b, c, d) {
        var e = this.a1;
        if (this.j != null) {
            if (this.a6 == -1) {
                this.a6 = this.be(a, this.a) + 1;
            }
            e = this.j(this.c, this.a6, c);
        }
        else {
            if (this.a8 == -1) {
                if (this.ad) {
                    var f = this.bd(a, b, c, d);
                    e = this.a3;
                    e = truncate(((f / this.a6) * e));
                    e = e - this.bf(a, b, c, d);
                }
                else {
                    if (this.ab) {
                        e = this.a3 - this.bf(a, b, this.d(a), d);
                    }
                    else {
                        e = this.a3 - this.bf(a, b, this.a, d);
                    }
                }
            }
            else {
                e = this.a8;
            }
        }
        return e;
    };
    GridEffect.prototype.d = function (a) {
        return this.c;
    };
    GridEffect.prototype.y = function (a, b) {
        if (b.x == a.x) {
            if (b.w <= a.w) {
                a = a.aa();
                a.w += 1;
            }
        }
        return a;
    };
    GridEffect.prototype.z = function (a, b) {
        if (b.x == a.x) {
            if (b.w < a.w) {
                a = a.aa();
                a.w -= 1;
            }
        }
        return a;
    };
    GridEffect.prototype.ak = function (a, b, c) {
        var d = this.a0(c);
        return d >= this.a1;
    };
    GridEffect.$t = markType(GridEffect, 'GridEffect');
    return GridEffect;
}(Base));
export { GridEffect };
/**
 * @hidden
 */
var ColumnEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnEffect, _super);
    function ColumnEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b0 = 0;
        return _this;
    }
    ColumnEffect.prototype.ah = function (a, b) {
        if (this.b0 == a.o) {
            return true;
        }
        return false;
    };
    ColumnEffect.$t = markType(ColumnEffect, 'ColumnEffect', GridEffect.$);
    return ColumnEffect;
}(GridEffect));
export { ColumnEffect };
/**
 * @hidden
 */
var SpacerEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SpacerEffect, _super);
    function SpacerEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b0 = 0;
        return _this;
    }
    SpacerEffect.prototype.aj = function (a, b) {
        return a.o == this.b0;
    };
    SpacerEffect.$t = markType(SpacerEffect, 'SpacerEffect', GridEffect.$);
    return SpacerEffect;
}(GridEffect));
export { SpacerEffect };
/**
 * @hidden
 */
var ColumnCellsEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnCellsEffect, _super);
    function ColumnCellsEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b2 = 0;
        _this.b1 = 0;
        _this.b0 = 0;
        return _this;
    }
    ColumnCellsEffect.prototype.ag = function (a, b) {
        if (this.b2 == -300) {
            if (a.at) {
                return true;
            }
        }
        if (this.b2 == -400) {
            if (a.a0 == -400) {
                return true;
            }
        }
        if (this.b1 >= 0) {
            if (this.b1 == a.a0 && this.b0 == a.b) {
                return true;
            }
        }
        else {
            var c = b.g(this.b2);
            if (c == null) {
                return false;
            }
            if (a.a0 == c.m && c.c == a.b) {
                return true;
            }
        }
        return false;
    };
    ColumnCellsEffect.prototype.d = function (a) {
        if (a.ci > 0) {
            var b = this.g;
            var c = new CellPath(0, b.b, b.a0, -100, -100);
            return c;
        }
        else {
            return this.g;
        }
    };
    ColumnCellsEffect.prototype.be = function (a, b) {
        var c = this.g;
        var d = this.e;
        var e = b;
        if (e == null) {
            return 0;
        }
        if (e.g) {
            return 0;
        }
        var f = 0;
        if (a.ci > 0) {
            f++;
        }
        if (c == null) {
            return 0;
        }
        if (e.aw && e.i) {
            if (d == null) {
                return 0;
            }
            return (d.w - c.w) + f - e.o;
        }
        if (e.x == c.x) {
            return (e.w - c.w) + f;
        }
        var g = f;
        var h = c.x;
        if (e.x > c.x) {
            while (h <= e.x) {
                if (h == c.x) {
                    g += (a.bv._inner[h].m - 1) - c.w;
                    if (a.bv._inner[h].d > 0) {
                        g++;
                    }
                }
                else if (h == e.x) {
                    if (a.bv._inner[h].g > 0) {
                        g++;
                    }
                    g += (e.w + 1);
                }
                else {
                    if (a.bv._inner[h].g > 0) {
                        g++;
                    }
                    g += a.bv._inner[h].m;
                    if (a.bv._inner[h].d > 0) {
                        g++;
                    }
                }
                h++;
            }
        }
        else if (e.x < c.x) {
            while (h >= e.x) {
                if (h == c.x) {
                    g -= c.w;
                    if (a.bv._inner[h].d > 0) {
                        g++;
                    }
                }
                else if (h == e.x) {
                    if (a.bv._inner[h].d > 0) {
                        g--;
                    }
                    g -= (a.bv._inner[h].m - e.w);
                }
                else {
                    if (a.bv._inner[h].g > 0) {
                        g--;
                    }
                    g -= a.bv._inner[h].m;
                    if (a.bv._inner[h].d > 0) {
                        g--;
                    }
                }
                h--;
            }
        }
        return g;
    };
    ColumnCellsEffect.$t = markType(ColumnCellsEffect, 'ColumnCellsEffect', GridEffect.$);
    return ColumnCellsEffect;
}(GridEffect));
export { ColumnCellsEffect };
/**
 * @hidden
 */
var CellEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellEffect, _super);
    function CellEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b4 = 0;
        _this.b3 = 0;
        _this.b1 = 0;
        _this.b0 = null;
        _this.b2 = false;
        return _this;
    }
    CellEffect.prototype.ag = function (a, b) {
        if (this.b0.w == a.w) {
            if (this.b4 == -400) {
                if (a.a0 == -400) {
                    return true;
                }
            }
            if (this.b3 >= 0) {
                if (this.b3 == a.a0 && this.b1 == a.b) {
                    return true;
                }
            }
            else {
                var c = b.g(this.b4);
                if (c == null) {
                    return false;
                }
                if (a.a0 == c.m && c.c == a.b) {
                    return true;
                }
            }
        }
        return false;
    };
    CellEffect.prototype.bv = function (a) {
        this.b0 = this.y(this.b0, a);
    };
    CellEffect.prototype.bw = function (a) {
        this.b0 = this.z(this.b0, a);
    };
    CellEffect.$t = markType(CellEffect, 'CellEffect', GridEffect.$);
    return CellEffect;
}(GridEffect));
export { CellEffect };
/**
 * @hidden
 */
var CellPositionEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellPositionEffect, _super);
    function CellPositionEffect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CellPositionEffect.prototype.ag = function (a, b) {
        return this.b0.equals(a);
    };
    CellPositionEffect.prototype.bv = function (a) {
        this.b0 = this.y(this.b0, a);
    };
    CellPositionEffect.prototype.bw = function (a) {
        this.b0 = this.z(this.b0, a);
    };
    CellPositionEffect.$t = markType(CellPositionEffect, 'CellPositionEffect', CellEffect.$);
    return CellPositionEffect;
}(CellEffect));
export { CellPositionEffect };
/**
 * @hidden
 */
var RowEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RowEffect, _super);
    function RowEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b0 = null;
        return _this;
    }
    RowEffect.prototype.ai = function (a, b) {
        if (this.b0.equals(a)) {
            return true;
        }
        return false;
    };
    RowEffect.prototype.bv = function (a) {
        this.b0 = this.y(this.b0, a);
    };
    RowEffect.prototype.bw = function (a) {
        this.b0 = this.z(this.b0, a);
    };
    RowEffect.$t = markType(RowEffect, 'RowEffect', GridEffect.$);
    return RowEffect;
}(GridEffect));
export { RowEffect };
/**
 * @hidden
 */
var RowCellsEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RowCellsEffect, _super);
    function RowCellsEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b0 = null;
        return _this;
    }
    RowCellsEffect.prototype.ag = function (a, b) {
        if (this.b0.x == a.x && this.b0.w == a.w && this.b0.b == a.b) {
            return true;
        }
        return false;
    };
    RowCellsEffect.prototype.bv = function (a) {
        this.b0 = this.y(this.b0, a);
    };
    RowCellsEffect.prototype.bw = function (a) {
        this.b0 = this.z(this.b0, a);
    };
    RowCellsEffect.prototype.be = function (a, b) {
        if (this.g == null || b.av) {
            return 0;
        }
        if (b.at) {
            return this.be(a, this.e);
        }
        var c = a.br._inner[this.g.a0].n;
        var d = a.br._inner[b.a0].n;
        if (b.d == 0) {
            d = a.br._inner[b.a0].n - a.co;
        }
        else if (b.d == 2) {
            d = a.br._inner[b.a0].n - (a.co + a.cr);
        }
        return d - c;
    };
    RowCellsEffect.$t = markType(RowCellsEffect, 'RowCellsEffect', GridEffect.$);
    return RowCellsEffect;
}(GridEffect));
export { RowCellsEffect };
/**
 * @hidden
 */
var GridEffectManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridEffectManager, _super);
    function GridEffectManager(a, b) {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.k = new List$1(ColumnEffect.$, 0);
        _this.j = new List$1(ColumnCellsEffect.$, 0);
        _this.m = new List$1(RowEffect.$, 0);
        _this.l = new List$1(RowCellsEffect.$, 0);
        _this.i = new List$1(CellEffect.$, 0);
        _this.n = new List$1(SpacerEffect.$, 0);
        _this.q = -30;
        _this.o = -1;
        _this.a = null;
        _this.b = a;
        _this.a = b;
        return _this;
    }
    Object.defineProperty(GridEffectManager.prototype, "c", {
        get: function () {
            return this.b;
        },
        enumerable: true,
        configurable: true
    });
    GridEffectManager.prototype.ae = function (a) {
        for (var b = 0; b < this.l.count; b++) {
            this.l._inner[b].bv(a);
        }
        for (var c = 0; c < this.m.count; c++) {
            this.m._inner[c].bv(a);
        }
        for (var d = 0; d < this.i.count; d++) {
            this.i._inner[d].bv(a);
        }
    };
    GridEffectManager.prototype.af = function (a) {
        for (var b = this.l.count - 1; b >= 0; b--) {
            if (a.equals(this.l._inner[b].b0)) {
                this.aj(this.l._inner[b].b0, false, this.l._inner[b]);
            }
            else {
                this.l._inner[b].bw(a);
            }
        }
        for (var c = this.m.count - 1; c >= 0; c--) {
            if (a.equals(this.m._inner[c].b0)) {
                this.ak(this.m._inner[c].b0, false, this.m._inner[c]);
            }
            else {
                this.m._inner[c].bw(a);
            }
        }
        for (var d = this.i.count - 1; d >= 0; d--) {
            if (a.equals(this.i._inner[d].b0)) {
                this.ag(this.i._inner[d].b0, false, this.i._inner[d]);
            }
            else {
                this.i._inner[d].bw(a);
            }
        }
    };
    GridEffectManager.prototype.ad = function () {
        var _this = this;
        var a = this.k.count > 0;
        this.a.i2 = true;
        this.an(false);
        if (a) {
            var b = this.a.model.absoluteWidth;
            this.a.fb.q(this.a, this.a.model, truncate(this.a.j7));
            this.d();
            if (b != this.a.model.absoluteWidth) {
                this.a.externalGrid.onContentSizeChanged();
            }
        }
        this.a.i2 = false;
        if (this.a.renderingEngine != null) {
            this.a.renderingEngine.invalidateVisibility(function () { return _this.a.fh.l(_this.a); });
            this.a.renderingEngine.refresh(this.a.model, true);
        }
    };
    GridEffectManager.prototype.d = function () {
        var a = this.k.count > 0;
        var b = this.p();
        var c = this.a.model;
        var d = this.a.dj;
        this.f(b, c, d);
        return a;
    };
    GridEffectManager.prototype.ac = function () {
        var a = this.p();
        var b = this.a.model;
        var c = this.a.dj;
        this.g(a, b, c);
    };
    GridEffectManager.prototype.ab = function () {
        var a = this.p();
        var b = this.a.model;
        var c = this.a.dj;
        this.e(a, b, c);
    };
    GridEffectManager.prototype.an = function (a) {
        var b = this.p();
        if ((b - this.q < 15) && !a) {
            this.b.requestFrame(this.o);
            return;
        }
        var c = this.a.model;
        var d = this.a.dj;
        var e = true;
        if (!this.f(b, c, d)) {
            e = false;
        }
        if (!this.h(b, c, d)) {
            e = false;
        }
        if (!this.g(b, c, d)) {
            e = false;
        }
        if (!this.e(b, c, d)) {
            e = false;
        }
        if (e && this.k.count == 0 && this.j.count == 0 && this.i.count == 0 && this.m.count == 0 && this.l.count == 0 && this.n.count == 0) {
            this.am();
        }
        else {
            this.b.requestFrame(this.o);
        }
    };
    GridEffectManager.prototype.p = function () {
        var a = dateNow();
        return a.getTime();
    };
    GridEffectManager.prototype.am = function () {
        this.b.teardownTicking(this.o);
        this.o = -1;
    };
    GridEffectManager.prototype.aa = function () {
        if (this.o == -1) {
            this.o = this.b.setupTicking(runOn(this, this.ad));
            this.b.requestFrame(this.o);
        }
    };
    GridEffectManager.prototype.u = function (a, b) {
        b.b0 = a.o;
        b.bl = this.p();
        this.ai(a.o, true, b);
        this.k.add(b);
        this.aa();
    };
    GridEffectManager.prototype.ai = function (a, b, c) {
        for (var d = this.k.count - 1; d >= 0; d--) {
            if (this.k._inner[d].b0 == a && this.k._inner[d].am(c)) {
                if (b) {
                    this.k._inner[d].bt(c);
                }
                this.k.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.z = function (a, b) {
        b.b0 = a.o;
        b.bl = this.p();
        this.al(a, true, b);
        this.n.add(b);
        this.aa();
    };
    GridEffectManager.prototype.al = function (a, b, c) {
        for (var d = this.n.count - 1; d >= 0; d--) {
            if (this.n._inner[d].b0 == a.o && this.n._inner[d].am(c)) {
                if (b) {
                    this.n._inner[d].bt(c);
                }
                this.n.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.t = function (a, b) {
        b.b2 = a.o;
        b.bl = this.p();
        this.ah(a.o, true, b);
        this.j.add(b);
        this.aa();
    };
    GridEffectManager.prototype.x = function (a) {
        a.b2 = -300;
        a.bl = this.p();
        this.ah(-300, true, a);
        this.j.add(a);
        this.aa();
    };
    GridEffectManager.prototype.y = function (a) {
        a.b2 = -400;
        a.bl = this.p();
        this.ah(-400, true, a);
        this.j.add(a);
        this.aa();
    };
    GridEffectManager.prototype.ah = function (a, b, c) {
        for (var d = this.j.count - 1; d >= 0; d--) {
            if (this.j._inner[d].b2 == a && this.j._inner[d].am(c)) {
                if (b) {
                    this.j._inner[d].bt(c);
                }
                this.j.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.w = function (a, b) {
        b.b0 = a;
        b.bl = this.p();
        this.ak(a, true, b);
        this.m.add(b);
        this.aa();
    };
    GridEffectManager.prototype.ak = function (a, b, c) {
        for (var d = this.m.count - 1; d >= 0; d--) {
            if (this.m._inner[d].b0.equals(a) && this.m._inner[d].am(c)) {
                if (b) {
                    this.m._inner[d].bt(c);
                }
                this.m.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.v = function (a, b) {
        b.b0 = a;
        b.bl = this.p();
        this.aj(a, true, b);
        this.l.add(b);
        this.aa();
    };
    GridEffectManager.prototype.aj = function (a, b, c) {
        for (var d = this.l.count - 1; d >= 0; d--) {
            if (this.l._inner[d].b0.equals(a) && this.l._inner[d].am(c)) {
                if (b) {
                    this.l._inner[d].bt(c);
                }
                this.l.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.r = function (a, b, c) {
        b.b4 = c;
        b.b0 = a;
        b.bl = this.p();
        b.b2 = true;
        this.ag(a, true, b);
        this.i.add(b);
        this.aa();
    };
    GridEffectManager.prototype.s = function (a, b) {
        b.b0 = a;
        b.bl = this.p();
        b.b2 = false;
        this.ag(a, true, b);
        this.i.add(b);
        this.aa();
    };
    GridEffectManager.prototype.ag = function (a, b, c) {
        for (var d = this.i.count - 1; d >= 0; d--) {
            if (this.i._inner[d].b0.equals(a) && this.i._inner[d].am(c)) {
                if (b) {
                    this.i._inner[d].bt(c);
                }
                this.i.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.f = function (a, b, c) {
        var d = true;
        var e;
        var f;
        var g = new List$1(ColumnEffect.$, 0);
        for (var h = 0; h < this.k.count; h++) {
            if (b.g(this.k._inner[h].b0) == null) {
                this.ai(this.k._inner[h].b0, false, this.k._inner[h]);
            }
        }
        for (var i = 0; i < b.br.count; i++) {
            e = b.br._inner[i];
            for (var j = 0; j < this.k.count; j++) {
                f = this.k._inner[j];
                if (f.ah(e, b)) {
                    if (!f.au(e, b, c, a)) {
                        d = false;
                    }
                    else {
                        g.add(f);
                    }
                }
            }
        }
        for (var k = 0; k < g.count; k++) {
            this.ai(g._inner[k].b0, false, g._inner[k]);
            g._inner[k].bu();
        }
        return d;
    };
    GridEffectManager.prototype.h = function (a, b, c) {
        var d = true;
        var e = b.bw;
        var f = new List$1(GridColumnSpacer.$, 0);
        var g = new List$1(SpacerEffect.$, 0);
        for (var h = 0; h < e.count; h++) {
            var i = e._inner[h];
            for (var j = 0; j < i.count; j++) {
                var k = i._inner[j];
                for (var l = 0; l < this.n.count; l++) {
                    if (this.n._inner[l].aj(k, b)) {
                        if (!this.n._inner[l].av(k, b, c, a)) {
                            d = false;
                        }
                        else {
                            f.add(k);
                            g.add(this.n._inner[l]);
                        }
                    }
                }
            }
        }
        for (var m = 0; m < f.count; m++) {
            this.al(f._inner[m], false, g._inner[m]);
            g._inner[m].bu();
        }
        return d;
    };
    GridEffectManager.prototype.g = function (a, b, c) {
        var d = true;
        var e = new CellPath(1, 0, 0, 0);
        var f;
        for (var g = 0; g < this.m.count; g++) {
            f = this.m._inner[g];
            e.b = f.b0.b;
            e.w = f.b0.w;
            e.x = f.b0.x;
            if (!f.aw(b.bv._inner[e.x], b, c, a)) {
                d = false;
            }
        }
        return d;
    };
    GridEffectManager.prototype.e = function (a, b, c) {
        var d = true;
        if (this.j.count == 0 && this.l.count == 0 && this.i.count == 0) {
            return true;
        }
        for (var e = 0; e < this.j.count; e++) {
            this.j._inner[e].b1 = -1;
            var f = b.g(this.j._inner[e].b2);
            if (f != null) {
                this.j._inner[e].b1 = f.m;
                this.j._inner[e].b0 = f.c;
            }
            this.j._inner[e].ap = true;
        }
        for (var g = 0; g < this.l.count; g++) {
            this.l._inner[g].ap = true;
        }
        for (var h = 0; h < this.i.count; h++) {
            this.i._inner[h].b3 = -1;
            if (this.i._inner[h].b2) {
                var i = b.g(this.i._inner[h].b4);
                if (i != null) {
                    this.i._inner[h].b3 = i.m;
                    this.i._inner[h].b1 = i.c;
                }
            }
            this.i._inner[h].ap = true;
        }
        for (var j = 0; j < b.bu.count; j++) {
            var k = b.bu._inner[j];
            for (var l = 0; l < k.o.count; l++) {
                if (k.p._inner[l]) {
                    continue;
                }
                var m = k.o._inner[l];
                for (var n = 0; n < this.j.count; n++) {
                    var o = this.j._inner[n];
                    if (o.ag(m, b)) {
                        if (!o.at(k.q._inner[l], b, c, a)) {
                            o.ap = false;
                        }
                    }
                }
                for (var p = 0; p < this.l.count; p++) {
                    var q = this.l._inner[p];
                    if (q.ag(m, b)) {
                        if (!q.at(k.q._inner[l], b, c, a)) {
                            q.ap = false;
                        }
                    }
                }
                for (var r = 0; r < this.i.count; r++) {
                    var s = this.i._inner[r];
                    if (s.ag(m, b)) {
                        if (!s.at(k.q._inner[l], b, c, a)) {
                            s.ap = false;
                        }
                    }
                }
            }
        }
        var t = new List$1(ColumnCellsEffect.$, 0);
        for (var u = 0; u < this.j.count; u++) {
            if (this.j._inner[u].ak(b, c, a) && this.j._inner[u].ap) {
                t.add(this.j._inner[u]);
            }
            else {
                d = false;
            }
        }
        var v = new List$1(RowCellsEffect.$, 0);
        for (var w = 0; w < this.l.count; w++) {
            if (this.l._inner[w].ak(b, c, a) && this.l._inner[w].ap) {
                v.add(this.l._inner[w]);
            }
            else {
                d = false;
            }
        }
        var x = new List$1(CellEffect.$, 0);
        for (var y = 0; y < this.i.count; y++) {
            if (this.i._inner[y].ak(b, c, a) && this.i._inner[y].ap) {
                x.add(this.i._inner[y]);
            }
            else {
                d = false;
            }
        }
        for (var z = 0; z < t.count; z++) {
            this.ah(t._inner[z].b2, false, t._inner[z]);
            t._inner[z].bu();
        }
        for (var aa = 0; aa < v.count; aa++) {
            this.aj(v._inner[aa].b0, false, v._inner[aa]);
            v._inner[aa].bu();
        }
        for (var ab = 0; ab < x.count; ab++) {
            this.ag(x._inner[ab].b0, false, x._inner[ab]);
            x._inner[ab].bu();
        }
        return d;
    };
    GridEffectManager.$t = markType(GridEffectManager, 'GridEffectManager');
    return GridEffectManager;
}(Base));
export { GridEffectManager };
/**
 * @hidden
 */
var GridLayerController = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridLayerController, _super);
    function GridLayerController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.e = new RecyclingManager();
        return _this;
    }
    GridLayerController.prototype.a = function (a, b) {
        var c = b.bu;
        var d = c.count;
        for (var e = 0; e < d; e++) {
            var f = c._inner[e].b(a);
            if (f != undefined) {
                return f;
            }
        }
        return null;
    };
    GridLayerController.prototype.b = function (a, b, c, d, e, f, g, h) {
        var i = this.a(a, c);
        if (i == null) {
            var j = null;
            var k = null;
            var l = false;
            var m = -1;
            if (a.ag) {
                m = b.ee.getDataRow(a);
                k = b.ee.resolveValueForPath(b, a);
                if (k == null && b.ee.isPlaceholderValue(a)) {
                    l = true;
                }
            }
            var n = b.n2(a, b, k, m);
            j = this.e.a(n);
            if (j == null) {
                j = b.ao(a, n);
            }
            else {
                j.jt();
            }
            var o = a;
            if (j.k != null) {
                o = j.k;
            }
            if (c.bh.d(o)) {
                c.bh.item(o).remove(j);
                if (c.bh.item(o).count == 0) {
                    c.bh.f(o);
                }
            }
            d.s(a, j);
            j.q = d;
            j.k = a;
            j.v = e;
            j.ej = m;
            j.a6 = f;
            j.a7 = g;
            j.a2 = h;
            j.x = a.d;
            j.a1 = b.cc.j && b.cc.d.k1 == j;
            var p = false;
            var q = false;
            var r = 0;
            var s = j.k.a0;
            var t = (s >= 0 && c.br._inner[s].n == 0) || a.av;
            if (t) {
                r = b.ee.getRowIndent(j.k.w);
                var u = b.ee.getRowType(j.k.w);
                if (u == 1 && b.h3) {
                    if (b.i8) {
                        if (a.a0 == -401 || (a.a0 == -400 && c.cf == 0)) {
                            p = b.h3;
                            q = b.actualDataSource.getIsRowExpandedAtIndex(j.k.w);
                        }
                    }
                    else {
                        p = b.h3;
                        q = b.actualDataSource.getIsRowExpandedAtIndex(j.k.w);
                    }
                }
            }
            j.ar = p;
            j.az = q;
            j.e6 = r;
            b.sv(j, k, b.ee.resolveRow(m));
            if (l) {
                j.cb = 1;
            }
            return j;
        }
        else {
            this.g(a, c, d);
            i.v = e;
            var v = i.k.a6;
            i.k = a;
            i.a6 = f;
            i.a7 = g;
            i.a2 = h;
            i.x = a.d;
            i.a1 = b.cc.j && b.cc.d.k1 == i;
            if (a.a6 != v && a.w >= 0 && a.a0 >= 0) {
                i.a9 = b.e5.p(i);
                i.b8 = i.a9 ? 1 : 0;
                i.b3 = b.ea.c(a.w) ? 1 : 0;
            }
            var w = false;
            var x = false;
            var y = 0;
            var z = i.k.a0;
            var aa = (z >= 0 && c.br._inner[z].n == 0) || a.av;
            if (aa) {
                y = b.ee.getRowIndent(i.k.w);
                var ab = b.ee.getRowType(i.k.w);
                if (ab == 1 && b.h3) {
                    if (b.i8) {
                        if (a.a0 == -401 || (a.a0 == -400 && c.cf == 0)) {
                            w = b.h3;
                            x = b.actualDataSource.getIsRowExpandedAtIndex(i.k.w);
                        }
                    }
                    else {
                        w = b.h3;
                        x = b.actualDataSource.getIsRowExpandedAtIndex(i.k.w);
                    }
                }
            }
            i.ar = w;
            i.az = x;
            i.e6 = y;
            return i;
        }
    };
    GridLayerController.prototype.d = function (a, b) {
        for (var c = 0; c < b.bu.count; c++) {
            if (b.bu._inner[c].d(a)) {
                return b.bu._inner[c];
            }
        }
        return null;
    };
    GridLayerController.prototype.g = function (a, b, c) {
        var d = this.d(a, b);
        if (d == null || d == c) {
            return;
        }
        var e = d.item(a);
        d.f(a);
        c.s(a, e);
        e.q = c;
    };
    GridLayerController.prototype.f = function (a, b, c) {
        if (c == null) {
            c = this.d(a, b);
        }
        if (c == null) {
            return;
        }
        var d = c.item(a);
        c.f(a);
        var e = null;
        if (b.bh.d(a)) {
            e = b.bh.item(a);
            if (e.count == 1) {
                var f = a.aa();
                b.bh.f(a);
                b.bh.s(f, e);
            }
        }
        else {
            e = new List$1(CellModel.$, 0);
            b.bh.s(a, e);
        }
        e.add(d);
    };
    GridLayerController.prototype.i = function (a, b) {
        var c = this.d(a, b);
        if (c == null) {
            return;
        }
        var d = this.c(a, b);
        this.f(a, b, c);
        this.e.c(d);
    };
    GridLayerController.prototype.j = function (a, b, c) {
        if (b == null) {
            return;
        }
        var d = b.item(a);
        this.f(a, c, b);
        this.e.c(d);
    };
    GridLayerController.prototype.c = function (a, b) {
        for (var c = 0; c < b.bu.count; c++) {
            if (b.bu._inner[c].d(a)) {
                return b.bu._inner[c].item(a);
            }
        }
        return null;
    };
    GridLayerController.prototype.h = function (a, b, c, d, e, f) {
        if (a.k.h) {
            a.cc = c + a.b4 + (a.b5 * b.br._inner[a.k.a0].k);
        }
        else {
            a.cc = c + a.b4 + (a.b5 * a.gg);
        }
        a.cd = d + a.b9 + (a.ca * a.e0);
        a.f3 = truncate(Math.round(a.cc));
        a.f5 = truncate(Math.round(a.cd));
        a.gg = truncate(e);
        a.e0 = truncate(f);
    };
    GridLayerController.$t = markType(GridLayerController, 'GridLayerController');
    return GridLayerController;
}(Base));
export { GridLayerController };
/**
 * @hidden
 */
var VisibilityEngine = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(VisibilityEngine, _super);
    function VisibilityEngine() {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.c = null;
        _this.f = false;
        _this.j = 0;
        _this.e = false;
        return _this;
    }
    Object.defineProperty(VisibilityEngine.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            this.j = a;
        },
        enumerable: true,
        configurable: true
    });
    VisibilityEngine.prototype.v = function () {
        this.e = true;
    };
    VisibilityEngine.prototype.l = function (a) {
        var b = false;
        if (this.e) {
            this.e = false;
            b = true;
        }
        this.m(a, a.model, a.fb, b);
    };
    VisibilityEngine.prototype.m = function (a, b, c, d) {
        a.q2();
        var e = b.actualVisibleRegion;
        if (e.isEmpty) {
            return;
        }
        if (e.width == 0 || e.height == 0) {
            return;
        }
        if (b.br.count == 0) {
            return;
        }
        if (a.ee == null) {
            return;
        }
        var f = this.a(a, b, c, e);
        for (var g = 0; g < b.bx.count; g++) {
            var h = b.bx._inner[g];
            var i = c.k(h, a, b);
            b.br._inner[h].l = i;
        }
        b.cp = 0;
        b.cv = 0;
        b.b7 = 0;
        b.bf = f.b;
        b.be = f.a;
        b.cn = f.k;
        b.cq = f.m;
        b.co = f.l;
        b.cr = f.n;
        a.td();
        this.d = f.b;
        this.c = f.a;
        var j = a.dj;
        a.i2 = true;
        this.u(a, b, f, j);
        if (b.bx.count == 0) {
            return;
        }
        this.n(a, b, f, j);
        f.j += b.ch;
        if (this.c.w == -1) {
            return;
        }
        this.h(a, b, b.actualVisibleRegion, f, false);
        this.o(a, b, f, j);
        a.de.ab();
        a.i2 = false;
    };
    VisibilityEngine.prototype.a = function (a, b, c, d) {
        var e;
        e = new CalculationParameters();
        e.j = d.top;
        e.g = d.bottom;
        e.h = d.left;
        e.i = d.right;
        if (this.k > 0) {
            var f = this.k * a.k8;
            e.j = Math.max(e.j - f, 0);
            e.g = Math.min(e.g + f, b.absoluteHeight);
            e.h = Math.max(e.h - f, 0);
            e.i = Math.min(e.i + f, b.absoluteWidth);
        }
        e.o = a.inset;
        e.d = Math.max(e.h, a.inset.c);
        e.f = Math.min(e.i, b.absoluteWidth - a.inset.d);
        e.e = e.f - e.d;
        e.b = c.b(e.j + b.cl + b.cm, b);
        e.a = c.b(e.g, b);
        e.k = 0;
        e.m = 0;
        b.bx.clear();
        var g = b.cf + truncate(a.inset.c);
        var h = g;
        var i = 0;
        var j = 0;
        var k = b.cg;
        for (var l = 0; l < b.br.count; l++) {
            var m = b.br._inner[l];
            var n = b.bw._inner[l];
            var o = b.br._inner[l].d == 0;
            if (o) {
                g += truncate(Math.round(n.ad(-1)));
                if (m.a != 6) {
                    g += (m.k) + a.model.cc - truncate(Math.round(m.f(b)));
                }
            }
            if (m.a == 3) {
                continue;
            }
            if (b.br._inner[l].d == 1) {
                b.bx.insert(i, l);
                i++;
            }
            else if (b.br._inner[l].d == 2) {
                b.bx.insert(b.bx.count, l);
                j++;
                if (m.a == 6) {
                    k -= m.k;
                }
            }
            else {
                if (g >= e.d + b.cf && h <= e.f - k) {
                    b.bx.insert(b.bx.count - j, l);
                }
                else if (b.br._inner[l].a == 2 || b.br._inner[l].a == 1 || b.br._inner[l].a == 6) {
                    b.bx.insert(b.bx.count - j, l);
                }
                else if (g < e.d + b.cf) {
                    e.l++;
                }
                else if (h > e.f - b.cg) {
                    e.n++;
                }
            }
            if (o) {
                h = g;
                g += truncate(Math.round(n.af(-1)));
            }
        }
        if (b.bx.count > 0) {
            e.k = b.bx._inner[0];
            e.m = b.bx._inner[b.bx.count - 1];
        }
        return e;
    };
    VisibilityEngine.prototype.u = function (a, b, c, d) {
        var e = this.d.x;
        var f = this.c.x;
        var g = this.d.w;
        var h = this.c.w;
        var i = 0;
        var j = 0;
        var k = 0;
        var l = false;
        var m = false;
        var n = false;
        var o = false;
        var p = false;
        var q = false;
        var r = a.k7 == 0;
        var s = a.l3 == 0;
        var t = null;
        var u = a.ee.getStickyRows();
        if (u != null) {
            for (var v = 0; v < u.length; v++) {
                if (t == null) {
                    t = new HashSet$1(Number_$type, 0);
                }
                t.add_1(u[v]);
            }
        }
        for (var w = 0; w < b.bu.count; w++) {
            var x = b.bu._inner[w];
            x.g = true;
            for (var y = 0; y < x.o.count; y++) {
                if (x.p._inner[y]) {
                    continue;
                }
                var z = x.o._inner[y];
                m = false;
                l = false;
                i = z.x;
                j = z.w;
                k = z.a0;
                m = z.at || z.j || z.av || z.al || z.an || z.ak || z.am;
                p = z.aq || z.al || z.an;
                o = z.g;
                n = t != null && t.contains(j);
                q = z.d != 0;
                if ((j == -1000 && k == -1000) || (j == -1001 && k == -1001)) {
                    continue;
                }
                if (b.bx.count == 0) {
                    l = true;
                }
                if (z.at && s) {
                    l = true;
                }
                if (z.g && r) {
                    l = true;
                }
                if (z.aq && (a.dragger == null || !a.dragger.isDragActive)) {
                    l = true;
                }
                if ((z.al || z.ak) && b.cf == 0) {
                    l = true;
                }
                if ((z.an || z.am) && b.cg == 0) {
                    l = true;
                }
                if (z.ao && b.b7 == 0) {
                    l = true;
                }
                if (!m && !b.bx.contains(k)) {
                    l = true;
                }
                else if (!o && (i < e || i > f)) {
                    l = true;
                }
                else {
                    if (!n && !p && !z.al && !z.an && !z.ak && !z.am) {
                        if (i == e && j < g) {
                            l = true;
                        }
                        if (i == f && j > h) {
                            l = true;
                        }
                    }
                }
                if (!a.i8 && (z.a0 == -401 || z.a0 == -402)) {
                    l = true;
                }
                if (!l) {
                    var aa = a.ee.getRowType(j);
                    var ab = a.ee.isRowSpanning(aa) && a.d3 != 1;
                    if (!z.at && !z.aq && !z.al && !z.an && !z.ak && !z.am) {
                        if (b.bn && (aa == 1 || aa == 2)) {
                            l = true;
                        }
                        else if ((ab && !m) || (m && !ab)) {
                            l = true;
                        }
                        else if ((z.au && aa != 5) || (z.ar && aa != 4) || (!z.au && aa == 5) || (!z.ar && aa == 4)) {
                            l = true;
                        }
                    }
                    else if ((aa == 4 && !z.as) || (aa != 4 && z.as)) {
                        l = true;
                    }
                }
                if (l) {
                    a.dj.j(z, x, b);
                }
            }
            x.g = false;
        }
        b.bn = false;
    };
    VisibilityEngine.prototype.t = function (a, b, c) {
        var d = c.b;
        var e = c.a;
        var f = e.x;
        var g = new CellPath(1, 0, 0, 0);
        for (var h = d.x; h <= f; h++) {
            this.q(h, a, b, c, g);
        }
    };
    VisibilityEngine.prototype.q = function (a, b, c, d, e) {
        var f = d.b;
        var g = d.a;
        var h = c.bv;
        var i = b.dj;
        var j = g.x;
        var k = d.d;
        var l = d.f;
        var m = d.e;
        var n = h._inner[a];
        var o = a == j ? g.w : n.m - 1;
        if (o == -201) {
            o = n.m - 1;
        }
        var p = 0;
        if (f.x == a) {
            p = f.w == -200 ? 0 : f.w;
        }
        if (p == -201) {
            var q = new CellPath(1, 0, a, -200);
            this.ab(q, c, k, n.i + n.l() - n.d, m, a, false, b);
            e.x = a;
            e.w = -201;
            e.a0 = 0;
            return;
        }
        if (n.g > 0) {
            this.s(a, b, c, d, e, f, n, p);
        }
        if (n.d > 0) {
            this.r(a, b, c, d, e, i, j, n);
        }
        e.x = a;
    };
    VisibilityEngine.prototype.i = function (a, b, c) {
        var d = this.a(a, b, a.fb, c);
        return this.h(a, b, c, d, true);
    };
    VisibilityEngine.prototype.h = function (a, b, c, d, e) {
        var f = d.a;
        var g = d.b;
        var h = d.a.x;
        var i = d.b.x;
        var j = new CellPath(1, 0, 0, 0);
        var k = b.bv._inner[0];
        var l = a.ee.getStickyRowsInRange(g.w, f.w);
        var m = -1;
        var n = -1;
        var o = -1;
        var p = -1;
        var q = false;
        var r = a.l3;
        var s = a.d3 == 3;
        var t = new Dictionary$2(Number_$type, PinnedRowInfo.$, 0);
        var u = new List$1(PinnedRowInfo.$, 0);
        b.cu = 0;
        if (l != null && ((a.a8.i.count > 0 && a.h5) || a.a8.i.count == 0)) {
            var v = c.top + b.ci;
            var w = c.bottom;
            var _loop_2 = function (x) {
                var y = l[x];
                var z = a.ee.getRowType(y);
                var aa = y * k.k() + k.i;
                var ab = new PinnedRowInfo();
                ab.b = b;
                ab.a = z;
                ab.k = k.e(y);
                ab.i = k.j(y);
                ab.n = a.ee.getStickRowPriority(y);
                ab.m = y;
                ab.l = aa;
                ab.e = (x == l.length - 1) || l[x + 1] != y + 1;
                ab.f = z == 5 && (x == l.length - 1);
                t.addItem(y, ab);
                if (x == 0) {
                    if (ab.a != 4) {
                        if (ab.l <= v) {
                            ab.l += (v - ab.l);
                            p = x;
                        }
                        else if (ab.j > c.bottom) {
                            ab.l += (c.bottom - ab.j);
                            q = true;
                        }
                    }
                    else {
                        ab.l += (c.bottom - ab.j);
                        ab.h = true;
                        q = true;
                        b.b7++;
                    }
                    return "continue";
                }
                var ac = l[x - 1];
                var ad = a.ee.getStickRowPriority(ac);
                var ae = a.ee.getStickRowPriority(y);
                var af = t.item(ac);
                var ag = a.ee.isExclusivelySticky(y);
                var ah = x - 1 == p;
                af.f = (z != 5 && af.a == 5) || (z == 5 && x == l.length - 1);
                var ai = ((function () {
                    var $ret = new PushRowSettings();
                    $ret.a = l;
                    $ret.d = t;
                    $ret.c = true;
                    $ret.b = ag;
                    return $ret;
                })());
                if (ab.a != 4) {
                    if (ab.l <= af.j && ah) {
                        p = x;
                        var aj = this_2.b(x - 1, x, x, ai);
                        if (!aj.b) {
                            ab.l = aj.a.j;
                        }
                    }
                    if (ab.a == 2) {
                        var ak = a.ee.getRootSummaryRowCount();
                        var al = c.bottom - ak * k.k();
                        if (ab.j > al) {
                            ab.l -= ab.j - al;
                            ab.h = true;
                            q = true;
                            ai.c = false;
                            var am = this_2.b(x - 1, x, x, ai);
                            if (!am.b) {
                                ab.l = am.a.j;
                            }
                        }
                    }
                    else if (s && ab.a == 5) {
                        var an = a.ee.getRootSummaryRowCount();
                        var ao = c.bottom - an * k.k();
                        if (ab.j > ao) {
                            ab.l -= ab.j - ao;
                            ab.h = true;
                            q = true;
                            ai.c = false;
                            var ap = this_2.b(x - 1, x, x, ai);
                            if (!ap.b) {
                                ab.l = ap.a.j;
                            }
                        }
                    }
                }
                if (z == 4) {
                    ab.l += (c.bottom - ab.j);
                    ab.h = true;
                    b.b7++;
                    q = true;
                    this_2.y(a, x - 1, x, 4, l, t);
                }
            };
            var this_2 = this;
            for (var x = 0; x < l.length; x++) {
                _loop_2(x);
            }
            for (var aq = 0; aq < l.length; aq++) {
                for (var ar = aq + 1; ar < l.length; ar++) {
                    var as = t.item(l[aq]);
                    var at = t.item(l[ar]);
                    if (at.l < as.j) {
                        at.g = true;
                        at.d = Math.round(at.j) <= Math.round(as.j);
                    }
                    else {
                        break;
                    }
                }
            }
            for (var au = 0; au <= p; au++) {
                var av = l[au];
                var aw = t.item(av).l;
                var ax = t.item(av).j;
                var ay = t.item(av).k;
                var az = t.item(av).g;
                var a0 = t.item(av).d;
                m = av;
                var a1 = false;
                var a2 = false;
                var a3 = false;
                if (t.item(av).a == 3) {
                    a1 = true;
                    a2 = true;
                }
                if (t.item(av).a == 3 && t.item(av).e) {
                    a3 = true;
                }
                u.add(t.item(av));
                if (!e) {
                    this.p(a, b, d, j, a.dj, av, aw, ay, true, a1, a2, a3, az, a0);
                }
            }
            if (q) {
                var a4 = 0;
                for (var a5 = 0; a5 < l.length; a5++) {
                    var a6 = l[a5];
                    if (!t.item(a6).h) {
                        continue;
                    }
                    if (o == -1) {
                        o = a6;
                    }
                    var a7 = t.item(a6).l;
                    var a8 = t.item(a6).j;
                    var a9 = t.item(a6).k;
                    var ba = t.item(a6).g;
                    var bb = t.item(a6).d;
                    n = a6;
                    var bc = t.item(a6).a == 3 && t.item(a6).e;
                    var bd = t.item(a6).a == 3;
                    if (!e) {
                        j.i = true;
                        j.o = (b.cp - 1) - a4;
                        this.p(a, b, d, j, a.dj, a6, a7, a9, true, bd, bd, bc, ba, bb);
                        j.i = false;
                        j.o = -1;
                    }
                    a4++;
                }
            }
        }
        for (var be = Math.max(m + 1, g.w); be <= f.w; be++) {
            if (o != -1 && n != -1) {
                if (be >= o && be <= n) {
                    continue;
                }
            }
            var bf = k.f(be);
            bf += k.i;
            var bg = k.e(be);
            var bh = false;
            var bi = false;
            var bj = false;
            var bk = a.ee.getRowType(be);
            if (bk == 3) {
                bj = true;
                bi = true;
            }
            if (bk == 0 && a.ee.isRowPinned(be)) {
                bi = true;
            }
            if (bk == 3) {
                if (t.containsKey(be) && t.item(be).e) {
                    bh = true;
                }
            }
            if (!e) {
                this.p(a, b, d, j, a.dj, be, bf, bg, false, bi, bj, bh, false, false);
            }
        }
        return u;
    };
    VisibilityEngine.prototype.y = function (a, b, c, d, e, f) {
        if (b < 0) {
            return;
        }
        var g = e[b];
        var h = e[c];
        if (f.item(g).a == d) {
            if (f.item(g).j > f.item(h).l) {
                f.item(g).l -= f.item(g).j - f.item(h).l;
                f.item(g).h = true;
                this.y(a, b - 1, b, d, e, f);
            }
        }
    };
    VisibilityEngine.prototype.b = function (a, b, c, d) {
        var _this = this;
        var e = d.a[a];
        var f = d.a[b];
        var g = d.a[c];
        var h = d.d;
        var i = h.item(e).n;
        var j = h.item(f).n;
        var k = h.item(g).n;
        var l = true;
        if (f == 12) {
            var m = 0;
        }
        d.e++;
        if (h.item(f).l < h.item(e).j) {
            if (j > i || (j == i && d.b)) {
                var n = h.item(f).l - h.item(e).j;
                var o_2 = this.g(n, a, c, d);
                var p = null;
                while (o_2 && a > 0) {
                    a = a - 1;
                    p = this.b(a, c, c, d);
                    o_2 = p.b;
                }
                if (p == null) {
                    p = ((function () {
                        var $ret = new PushRowResult();
                        $ret.b = o_2;
                        $ret.a = h.item(d.a[a]);
                        return $ret;
                    })());
                }
                return p;
            }
            else if (j == i && !d.b) {
                return ((function () {
                    var $ret = new PushRowResult();
                    $ret.b = false;
                    $ret.a = h.item(e);
                    return $ret;
                })());
            }
            else if (j < i) {
                if (k >= i) {
                    if (!l) {
                        var q_1 = h.item(f).l - h.item(e).j;
                        return ((function () {
                            var $ret = new PushRowResult();
                            $ret.b = _this.g(q_1, a, c, d);
                            $ret.a = h.item(e);
                            return $ret;
                        })());
                    }
                    else {
                        if (h.item(g).l < h.item(e).j) {
                            var r_1 = h.item(g).l - h.item(e).j;
                            return ((function () {
                                var $ret = new PushRowResult();
                                $ret.b = _this.g(r_1, a, c, d);
                                $ret.a = h.item(e);
                                return $ret;
                            })());
                        }
                    }
                    return ((function () {
                        var $ret = new PushRowResult();
                        $ret.b = true;
                        $ret.a = h.item(e);
                        return $ret;
                    })());
                }
                return ((function () {
                    var $ret = new PushRowResult();
                    $ret.b = false;
                    $ret.a = h.item(e);
                    return $ret;
                })());
            }
        }
        return ((function () {
            var $ret = new PushRowResult();
            $ret.b = true;
            $ret.a = h.item(e);
            return $ret;
        })());
    };
    VisibilityEngine.prototype.g = function (a, b, c, d) {
        var e = d.a[b];
        d.d.item(e).l += a;
        d.d.item(e).h = !d.c;
        if (b > 0) {
            var f = this.b(b - 1, b, c, d);
            if (!d.b || !d.c) {
                if (!f.b) {
                    var g = d.a[b - 1];
                    d.d.item(e).l = d.d.item(g).j;
                    return false;
                }
            }
        }
        return true;
    };
    VisibilityEngine.prototype.p = function (a, b, c, d, e, f, g, h, i, j, k, l, m, n) {
        d.w = f;
        d.d = 0;
        d.ap = m;
        d.af = n;
        var o = b.br;
        var p = c.d;
        var q = c.f;
        var r = c.e;
        var s = a.l3;
        var t = a.ee.getRowType(f);
        d.ar = t == 4;
        d.au = t == 5;
        var u = false;
        if (t != 0) {
            u = a.ee.isRowSpanning(t) && a.d3 != 1;
        }
        if (u) {
            var v = a.i8 ? b.cf : 0;
            var w = a.i8 ? b.cg : 0;
            var x = p;
            var y = r;
            if (v > 0) {
                d.a0 = -401;
                y = b.cf;
                this.z(x, y, g, h, d.aa(), b, p, q, a, i, j, k, l, t);
            }
            d.a0 = -400;
            x = p + v;
            y = r - v - w;
            this.z(x, y, g, h, d.aa(), b, p, q, a, i, j, k, l, t);
            if (w > 0) {
                d.a0 = -402;
                x = q - b.cg;
                y = b.cg;
                this.z(x, y, g, h, d.aa(), b, p, q, a, i, j, k, l, t);
            }
        }
        else {
            for (var z = 0; z < b.bx.count; z++) {
                var aa = b.bx._inner[z];
                var ab = o._inner[aa];
                d.a0 = ab.m;
                d.a6 = ab.n;
                d.d = ab.d;
                var ac = d.aa();
                this.z(c.o.c + ab.l, ab.k, g, h, ac, b, p, q, a, i, j, k, l, t);
            }
        }
        var ad = t != 4 && t != 2 && (t != 5 || a.d3 != 3);
        if (ad && i) {
            b.cv = truncate(Math.round((g + h + a.l4) - c.j));
        }
        var ae = t == 4 || (t == 5 && a.d3 == 3);
        if (ae && i && g < c.g) {
            b.cu += truncate(h) + a.l4;
        }
        if (s > 0) {
            if (ad && i) {
                b.cv = truncate(Math.round((g + h + a.l4 + s) - c.j));
            }
            if (ae && i && g < c.g) {
                b.cu += s;
            }
            d.d = 0;
            d.a0 = -300;
            d.as = t == 4;
            this.ad(c, d.aa(), b, p, r, g + h + a.l4, s, a, i, j, k, l, t);
        }
    };
    VisibilityEngine.prototype.r = function (a, b, c, d, e, f, g, h) {
        var i = d.d;
        var j = d.f;
        var k = d.e;
        e.x = a;
        e.w = -201;
        e.a0 = 0;
        var l = new CellPath(1, e.a0, e.x, e.w);
        var m = h.i + h.l() - h.d;
        var n = m;
        if (a == g) {
            n = d.g - h.d;
            if (n < (h.i + h.g)) {
                n = (h.i + h.g);
            }
            this.ac(l, c, i, Math.min(m, n), k, a, false, true, b);
        }
        else {
            this.ab(l, c, i, Math.min(m, n), k, a, false, b);
        }
    };
    VisibilityEngine.prototype.s = function (a, b, c, d, e, f, g, h) {
        var i = d.d;
        var j = d.f;
        var k = d.e;
        e.x = a;
        e.w = -200;
        e.a0 = 0;
        var l = new CellPath(1, e.a0, e.x, e.w);
        if (a == f.x) {
            if (h == g.m - 1) {
                var m = g.j(h);
                var n = g.f(h) + g.i;
                var o = (n + m) - g.g;
                this.ac(l, c, i, Math.min(o, d.j), k, a, true, true, b);
            }
            else {
                this.ac(l, c, i, Math.max(g.i, d.j - b.inset.e), k, a, true, true, b);
            }
        }
        else {
            this.ab(l, c, i, g.i, k, a, true, b);
        }
    };
    VisibilityEngine.prototype.n = function (a, b, c, d) {
        var e = b.br;
        var f = a.inset;
        var g = f.e;
        if (b.ci > 0) {
            var h = Math.max(c.j, g);
            b.bj = this.f;
            if (this.f) {
                h = g;
            }
            for (var i = 0; i < b.bx.count; i++) {
                var j = b.bx._inner[i];
                var k = e._inner[j];
                var l = new CellPath(1, k.m, -100, -100);
                l.d = k.d;
                this.aa(l, b, h, c.d, c.f, a);
                if (a.h6) {
                    var m = new CellPath(1, k.m, -100, -101);
                    m.d = k.d;
                    var n = a.k9(a.lx);
                    var o = a.lx + n * 2;
                    var p = c.o.c + b.br._inner[l.a0].l + b.br._inner[l.a0].k - a.lx - n;
                    this.ae(m, b, h, p, o, b.cl, c.d, c.f, a);
                }
            }
            if (b.cm > 0) {
                var q = new CellPath(1, -300, -100, -100);
                this.ad(c, q, b, c.d, c.e, 0, b.cm, a, false, false, false, false, 0);
            }
        }
        if (a.bv == 0 && a.dragger != null && a.dragger.isDragActive && a.dragger.dragType == 1) {
            var r = new CellPath(1, -400, 0, -102);
            this.ae(r, b, Math.max(c.j, g), a.l0, a.lc, b.by, c.h, c.i, a);
        }
        if (a.bh != 1 && a.dragger != null && a.dragger.isDragActive && a.dragger.dragType == 2) {
            var s = new CellPath(1, -400, 0, -102);
            this.ae(s, b, c.j, a.l0, a.la, b.by, c.h, c.i, a);
        }
    };
    VisibilityEngine.prototype.o = function (a, b, c, d) {
        if (b.cd > -1) {
            b.b4 = c.d + a.fb.k(b.cd, a, b) - a.lz;
        }
        else {
            b.b4 = b.cf;
        }
        if (b.ce > -1) {
            var e = b.br._inner[b.ce].l - a.lz;
            if (c.i >= b.absoluteWidth) {
                b.b5 = e + a.inset.c;
            }
            else {
                b.b5 = e - (b.absoluteWidth - c.i - a.inset.c - a.inset.d);
            }
        }
        var f = Math.max(c.j - b.ci, a.inset.e);
        var g = c.j;
        var h = b.b7 * (a.k8 + a.l3 + a.l4);
        var i = c.g - h;
        var j = Math.min(b.absoluteHeight - h, c.g - h);
        var k = Math.max(0, j - g);
        var l = new CellPath(1, 0, 0, 0);
        if (b.cf > 0) {
            l.a0 = -500;
            if (b.ci > 0) {
                l.w = -100;
                this.ae(l.aa(), b, f, b.b4, a.lz, b.ci, c.d, c.i, a);
            }
            l.w = -103;
            this.ae(l.aa(), b, g, b.b4, a.lz, k, c.d, c.i, a);
            if (b.b7 > 0) {
                l.w = -104;
                this.ae(l.aa(), b, i, b.b4, a.lz, h, c.d, c.i, a);
            }
        }
        if (b.cg > 0) {
            l.a0 = -501;
            if (b.ci > 0) {
                l.w = -100;
                this.ae(l.aa(), b, f, b.b5, a.lz, b.ci, c.d, c.i, a);
            }
            l.w = -103;
            this.ae(l.aa(), b, g, b.b5, a.lz, k, c.d, c.i, a);
            if (b.b7 > 0) {
                l.w = -104;
                this.ae(l.aa(), b, i, b.b5, a.lz, h, c.d, c.i, a);
            }
        }
    };
    VisibilityEngine.prototype.w = function (a, b, c, d, e, f, g, h, i) {
        this.x(a, b, c, d, e, f, g, h, i, false, false, false);
    };
    VisibilityEngine.prototype.x = function (a, b, c, d, e, f, g, h, i, j, k, l) {
        var m = a.dj.b(c, a, b, d, e, j, k, l);
        a.dj.h(m, b, f, g, h, i);
        if (a.cc.j) {
            if (a.cc.a == null && a.cc.p == m.k.w && a.cc.o == m.k.a0) {
                a.cc.z(m);
            }
        }
        else {
            if (a.as != null && a.as.a0 == m.k.a0 && a.as.w == m.k.w) {
                a.cc.y(m);
            }
            if (a.ar != null && a.ar.a0 == m.k.a0 && a.ar.w == m.k.w) {
                a.jb(m);
            }
        }
    };
    VisibilityEngine.prototype.z = function (a, b, c, d, e, f, g, h, i, j, k, l, m, n) {
        var o = f.al;
        var p = e.d;
        var q = e.d != 0;
        var r = i.fb;
        var s = 1;
        if (n == 1) {
            s = 2;
        }
        if (n == 2) {
            s = 3;
        }
        if (e.a0 == -400 || e.a0 == -401 || e.a0 == -402) {
            if (n == 1 || n == 2) {
                if (!e.af) {
                    o = j && !e.ap ? f.a3 : f.a6;
                }
                else {
                    o = f.al;
                }
            }
        }
        else {
            if (f.br._inner[e.a0].a == 1 || f.br._inner[e.a0].a == 2 || f.br._inner[e.a0].a == 3) {
                if (j) {
                    o = n != 4 ? f.a1 : f.a9;
                }
                else {
                    o = q ? f.as : f.a7;
                }
            }
            else if (f.br._inner[e.a0].a == 6) {
                q = e.d != 0 || i.columns._inner[e.a0].fj != 0;
                if (j) {
                    o = n != 4 ? f.a2 : f.bc;
                }
                else {
                    o = q ? f.av : f.ba;
                }
            }
            else {
                if (j) {
                    o = n != 4 ? (q ? f.aq : f.a0) : (q ? f.ap : f.az);
                }
                else {
                    o = q ? f.an : f.al;
                }
            }
        }
        if (p == 1) {
            var t = f.br._inner[e.a0].l;
            a = g + t;
        }
        else if (p == 2) {
            var u = f.br._inner[e.a0].l;
            if (h >= f.absoluteWidth) {
                a = u + i.inset.c;
            }
            else {
                a = u - (f.absoluteWidth - h - i.inset.c - i.inset.d);
            }
        }
        this.x(i, f, e, o, s, a, c, b, d, k, l, m);
    };
    VisibilityEngine.prototype.aa = function (a, b, c, d, e, f) {
        var g = a.d == 0 ? b.az : b.ap;
        if (b.br._inner[a.a0].a == 1 || b.br._inner[a.a0].a == 2 || b.br._inner[a.a0].a == 3) {
            g = a.d == 0 ? b.a9 : b.au;
        }
        if (b.br._inner[a.a0].a == 6) {
            g = a.d == 0 && f.columns._inner[a.a0].fj == 0 ? b.bc : b.ax;
        }
        var h = b.br._inner[a.a0].l + f.inset.c;
        var i = b.br._inner[a.a0].k;
        if (a.d == 1) {
            h = d + b.br._inner[a.a0].l;
        }
        else if (a.d == 2) {
            var j = b.br._inner[a.a0].l;
            if (e >= b.absoluteWidth) {
                h = j + f.inset.c;
            }
            else {
                h = j - (b.absoluteWidth - e - f.inset.c - f.inset.d);
            }
        }
        this.w(f, b, a, g, 0, h, c, i, b.cl);
    };
    VisibilityEngine.prototype.ae = function (a, b, c, d, e, f, g, h, i) {
        var j = b.bd;
        if (a.h) {
            j = a.d == 0 ? b.ay : b.ao;
            if (b.br._inner[a.a0].a == 1 || b.br._inner[a.a0].a == 2 || b.br._inner[a.a0].a == 3) {
                j = a.d == 0 ? b.a8 : b.at;
            }
            if (b.br._inner[a.a0].a == 6) {
                j = a.d == 0 && i.columns._inner[a.a0].fj == 0 ? b.bb : b.aw;
            }
            if (a.d == 1) {
                d += g - i.inset.c;
            }
            else if (a.d == 2) {
                if (h < b.absoluteWidth) {
                    d -= b.absoluteWidth - h - i.inset.d;
                }
            }
        }
        if (!i.i8) {
            if ((a.al || a.an) && a.w != -104) {
                j = b.ar;
            }
        }
        this.w(i, b, a, j, 5, d, c, e, f);
    };
    VisibilityEngine.prototype.ab = function (a, b, c, d, e, f, g, h) {
        this.ac(a, b, c, d, e, f, g, false, h);
    };
    VisibilityEngine.prototype.ac = function (a, b, c, d, e, f, g, h, i) {
        var j = g ? b.bv._inner[f].g : b.bv._inner[f].d;
        var k = 3;
        var l = b.a6;
        if (g) {
            k = 2;
        }
        if (h) {
            l = b.a6;
        }
        this.w(i, b, a, l, k, c, d, e, j);
    };
    VisibilityEngine.prototype.ad = function (a, b, c, d, e, f, g, h, i, j, k, l, m) {
        var n = 0;
        var o = c.al;
        if (i) {
            if (m == 1 || m == 2) {
                o = !b.ap ? c.a3 : c.a6;
            }
            else if (m == 4) {
                o = c.a5;
            }
            else {
                o = c.aq;
            }
        }
        else {
            if (m == 1 || m == 2) {
                o = c.a6;
            }
        }
        if (b.g) {
            var p = h.inset;
            var q = p.e;
            var r = Math.max(a.j, q);
            n = r + c.cl;
            if (this.f) {
                n = a.o.e + c.cl;
            }
            o = c.ay;
        }
        else {
            var s = c.bv._inner[b.x];
            n = f;
        }
        this.x(h, c, b, o, 4, d, n, e, g, j, k, l);
    };
    VisibilityEngine.$t = markType(VisibilityEngine, 'VisibilityEngine');
    return VisibilityEngine;
}(Base));
export { VisibilityEngine };
/**
 * @hidden
 */
var PinnedRowInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PinnedRowInfo, _super);
    function PinnedRowInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.m = 0;
        _this.o = null;
        _this.l = 0;
        _this.k = 0;
        _this.i = 0;
        _this.e = false;
        _this.c = false;
        _this.a = 0;
        _this.f = false;
        _this.n = 0;
        _this.g = false;
        _this.d = false;
        _this.b = null;
        return _this;
    }
    Object.defineProperty(PinnedRowInfo.prototype, "j", {
        get: function () {
            return this.l + this.i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PinnedRowInfo.prototype, "h", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (this.c != b) {
                if (this.b != null) {
                    this.b.cp = Math.min(0, this.c ? this.b.cp + 1 : this.b.cp - 1);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    PinnedRowInfo.prototype.toString = function () {
        return EnumUtil.getName(DataSourceRowType_$type, this.a) + "(" + this.n + ") " + this.j;
    };
    PinnedRowInfo.$t = markType(PinnedRowInfo, 'PinnedRowInfo');
    return PinnedRowInfo;
}(Base));
export { PinnedRowInfo };
/**
 * @hidden
 */
var PushRowSettings = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PushRowSettings, _super);
    function PushRowSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.d = null;
        _this.b = false;
        _this.c = false;
        _this.e = 0;
        return _this;
    }
    PushRowSettings.$t = markType(PushRowSettings, 'PushRowSettings');
    return PushRowSettings;
}(Base));
export { PushRowSettings };
/**
 * @hidden
 */
var PushRowResult = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PushRowResult, _super);
    function PushRowResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b = false;
        _this.a = null;
        return _this;
    }
    PushRowResult.$t = markType(PushRowResult, 'PushRowResult');
    return PushRowResult;
}(Base));
export { PushRowResult };
/**
 * @hidden
 */
export var ICellRenderingEngine_$type = /*@__PURE__*/ new Type(null, 'ICellRenderingEngine');
/**
 * @hidden
 */
var SpatialEngine = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SpatialEngine, _super);
    function SpatialEngine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.f = new List$1(ColumnInfo.$, 0);
        _this.c = new Dictionary$2(Number_$type, ColumnInfo.$, 0);
        _this.d = new List$1(Number_$type, 0);
        _this.e = new List$1(Number_$type, 0);
        _this.a = new GridColumnSpacerCollection();
        return _this;
    }
    SpatialEngine.prototype.r = function (a, b, c) {
        b.absoluteHeight = 0;
        b.absoluteWidth = 0;
        b.absoluteHeight = truncate(a.inset.e);
        b.ch = truncate(a.inset.e);
        b.bv.clear();
        this.c.clear();
        for (var d = 0; d < a.model.br.count; d++) {
            this.c.addItem(a.model.br._inner[d].o, a.model.br._inner[d]);
        }
        b.c1();
        b.cf = 0;
        b.cg = 0;
        b.cd = -1;
        b.ce = -1;
        a.model.cc = a.ld;
        if (a.ee == null) {
            return;
        }
        var e = a.ee.getSectionCount();
        e = Math.max(1, e);
        a.model.cm = a.k7 > 0 ? a.l3 : 0;
        a.model.ci = a.k7 + a.model.cm;
        a.model.cl = a.k7;
        a.model.absoluteHeight += a.model.ci;
        a.model.ch += a.model.ci;
        a.model.b0 = a.inset.c;
        a.model.b1 = a.inset.d;
        a.model.b2 = a.inset.e;
        a.model.bz = a.inset.b;
        for (var f = 0; f < e; f++) {
            var g = new SectionInfo();
            g.h = f;
            g.i = b.absoluteHeight;
            g.m = a.ee.getRowCount();
            g.g = a.l7;
            g.d = a.l5;
            g.o = a.l3;
            g.p = a.l4;
            g.n = a.k8;
            g.q = g.m * g.n;
            a.model.absoluteHeight += g.l();
            a.model.bv.add(g);
        }
        var h = a.defaultColumnWidth;
        var i = 0;
        var j = a.defaultColumnWidth;
        var k = a.j8;
        this.f.clear();
        this.d.clear();
        this.e.clear();
        for (i = 0; i < a.actualColumns.count; i++) {
            var l = new ColumnInfo();
            if (this.c.containsKey(a.actualColumns._inner[i].g6)) {
                l = this.c.item(a.actualColumns._inner[i].g6);
            }
            l.m = i;
            var m = a.actualColumns._inner[i];
            l.p = m.h4;
            l.o = m.g6;
            if (m.e8 == 3) {
                l.h = -1;
            }
            if (m.e8 == 5) {
                l.h = 0;
            }
            l.a = m.e8;
            var n = null;
            h = m.width;
            if (n == null) {
                n = (h == null) ? j : h;
            }
            var o = 0;
            if (!isNaN_(k)) {
                o = k;
            }
            if (!isNaN_(n.e) && n.e > 0) {
                o = Math.max(o, n.e);
            }
            if (!isNaN_(m.gq)) {
                o = m.gq;
            }
            l.b = n;
            l.i = o;
            l.d = m.fk;
            l.n = i;
            if (l.d == 1) {
                this.d.add(i);
            }
            if (l.d == 2) {
                this.e.add(i);
            }
            if (m.e8 != 2 && m.e8 != 3) {
                if (m.fk == 0) {
                    if (b.cd == -1) {
                        b.cd = i;
                    }
                }
                if (b.ce == -1 && m.fk == 2) {
                    b.ce = i;
                }
            }
            a.model.cy(l);
        }
        this.s(b);
        this.c.clear();
        a.model.cf = 0;
        a.model.cg = 0;
        this.q(a, b, c);
        a.de.ac();
        a.model.absoluteHeight += truncate(a.inset.b);
    };
    SpatialEngine.prototype.s = function (a) {
        if (this.d.count > 0 || this.e.count > 0) {
            for (var b = 0; b < a.br.count; b++) {
                a.br._inner[b].n = this.m(a.br._inner[b].d, b, a);
            }
        }
    };
    SpatialEngine.prototype.q = function (a, b, c) {
        var e_18, _a;
        b.absoluteWidth = 0;
        b.cj = 0;
        b.cf = 0;
        b.cg = 0;
        var d = a.model.cc;
        var e = a.model.cc;
        var f = 0;
        var g = new List$1(ColumnInfo.$, 0);
        var h = b.bw;
        try {
            for (var _b = tslib_1.__values(fromEnum(b.br)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var i = _c.value;
                if (i.b.c) {
                    f += i.b.f * this.g(i);
                    g.add(i);
                }
                else {
                    i.k = truncate((Math.max(DeviceUtils.g(i.b.f), i.i)));
                    if (i.a != 3) {
                        if (i.a == 6) {
                            e += i.k + a.model.cc;
                        }
                        else {
                            e += i.k + a.model.cc - truncate(Math.round(i.f(b)));
                        }
                        b.cj += i.k + a.model.cc;
                        if (i.d == 1) {
                            b.cf += i.k + b.cc - truncate(Math.round(i.f(b)));
                        }
                        if (i.d == 2) {
                            b.cg += i.k + b.cc - truncate(Math.round(i.f(b)));
                        }
                    }
                    if (i.a == 6) {
                        d += i.k + a.model.cc;
                    }
                    else {
                        d += i.k + a.model.cc - truncate(Math.round(i.f(b)));
                    }
                }
            }
        }
        catch (e_18_1) {
            e_18 = { error: e_18_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_18)
                    throw e_18.error;
            }
        }
        b.cf = Math.max(0, b.cf - b.cc);
        if (f > 0) {
            var j = e;
            e = SpatialEngine.p(a, b, c, d, e, f, g);
        }
        a.model.absoluteWidth = e;
        a.model.absoluteWidth += truncate((a.inset.c + a.inset.d));
        a.model.cj += truncate((a.inset.c + a.inset.d));
    };
    SpatialEngine.prototype.g = function (a) {
        if (a.a == 6) {
            return 1;
        }
        if (a.a == 3) {
            return 0;
        }
        var b = 1 - Math.max(0, Math.min(1, Math.abs(a.h)));
        return b;
    };
    SpatialEngine.p = function (a, b, c, d, e, f, g) {
        var e_19, _a, e_20, _b;
        c -= d;
        c -= truncate((a.inset.c + a.inset.d));
        c -= (g.count * a.model.cc);
        c -= a.model.cs + a.model.ct;
        var h = 0;
        var i = (c) / f;
        if (i < 0) {
            i = 0;
        }
        if (c < 0) {
            c = 0;
        }
        var j = false;
        var k = new HashSet$1(ColumnInfo.$, 0);
        while (f > 0 && !j) {
            j = true;
            try {
                for (var _c = (e_19 = void 0, tslib_1.__values(fromEnum(g))), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var l = _d.value;
                    if (k.contains(l)) {
                        continue;
                    }
                    if (l.i > i * l.b.f) {
                        j = false;
                        if (l.a != 3) {
                            f--;
                        }
                        k.add_1(l);
                        l.k = truncate(l.i);
                        if (l.a != 6) {
                            if (l.a != 3) {
                                e += (l.k) + a.model.cc - truncate(Math.round(l.f(b)));
                                b.cj += l.k + a.model.cc;
                            }
                            if (l.a == 6) {
                                var m = (l.k) + a.model.cc;
                                d += m;
                                c -= m;
                            }
                            else {
                                var n = (l.k) + a.model.cc - truncate(Math.round(l.f(b)));
                                d += n;
                                c -= n;
                            }
                        }
                        else {
                            e += l.k;
                            b.cj += l.k + a.model.cc;
                        }
                    }
                }
            }
            catch (e_19_1) {
                e_19 = { error: e_19_1 };
            }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return))
                        _a.call(_c);
                }
                finally {
                    if (e_19)
                        throw e_19.error;
                }
            }
            i = (c) / f;
        }
        if (c < 0) {
            c = 0;
        }
        var o = 0;
        try {
            for (var _e = tslib_1.__values(fromEnum(g)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var p = _f.value;
                if (k.contains(p)) {
                    if (p.a != 3) {
                        if (p.d == 1) {
                            a.model.cf += p.k + a.model.cc;
                        }
                        if (p.d == 2) {
                            a.model.cg += p.k + a.model.cc;
                        }
                    }
                    continue;
                }
                var q = Math.max(p.i, i * p.b.f);
                var r = o + q;
                o += q;
                if (Math.round(r) >= r) {
                    p.k = truncate(Math.ceil(q));
                }
                else {
                    p.k = truncate(Math.floor(q));
                }
                e += a.model.cc;
                d += a.model.cc;
                h += a.model.cc;
                o += a.model.cc;
                b.cj += a.model.cc;
                if (p.a != 3) {
                    if (p.a == 6) {
                        e += p.k;
                    }
                    else {
                        e += p.k - truncate(Math.round(p.f(b)));
                    }
                    if (p.d == 1) {
                        a.model.cf += p.k + a.model.cc;
                    }
                    if (p.d == 2) {
                        a.model.cg += p.k + a.model.cc;
                    }
                    b.cj += p.k;
                }
                if (p.a == 6) {
                    d += p.k;
                    h += p.k;
                }
                else {
                    d += p.k - truncate(Math.round(p.f(b)));
                    h += p.k - truncate(Math.round(p.f(b)));
                }
            }
        }
        catch (e_20_1) {
            e_20 = { error: e_20_1 };
        }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return))
                    _b.call(_e);
            }
            finally {
                if (e_20)
                    throw e_20.error;
            }
        }
        a.model.cf = Math.max(0, a.model.cf - a.model.cc);
        if (h < c) {
            var s = (c - h - a.model.cc);
            g._inner[g.count - 1].k += s;
            e += s;
            d += s;
            b.cj += s;
        }
        if (h > c) {
            var t = (c - h - a.model.cc);
            g._inner[g.count - 1].k += t;
            e += t;
            d += t;
            b.cj += t;
        }
        return e;
    };
    SpatialEngine.prototype.k = function (a, b, c) {
        return this.l(a, c, false);
    };
    SpatialEngine.prototype.l = function (a, b, c) {
        var d = 0;
        if (b.br._inner[a].d == 1) {
            d += this.h(a, b.br._inner[a].o, 1, b);
        }
        if (b.br._inner[a].d == 0) {
            d += this.h(b.br.count, b.br._inner[a].o, 1, b);
            d += this.h(a, b.br._inner[a].o, 0, b);
        }
        if (b.br._inner[a].d == 2) {
            d += this.h(b.br.count, b.br._inner[a].o, 1, b);
            d += this.h(b.br.count, b.br._inner[a].o, 0, b);
            d += this.h(a, b.br._inner[a].o, 2, b);
        }
        d += truncate(Math.round(b.bw._inner[a].ad(b.br._inner[a].o)));
        if (!c) {
            d = truncate((d + Math.round(b.br._inner[a].e(b))));
        }
        return d;
    };
    SpatialEngine.prototype.h = function (a, b, c, d) {
        var e = 0;
        for (var f = 0; f < a; f++) {
            if (d.br._inner[f].d == c) {
                e += truncate(Math.round(d.bw._inner[f].ad(b)));
                if (d.br._inner[f].a != 6) {
                    e += (d.br._inner[f].k) + d.cc - truncate(Math.round(d.br._inner[f].f(d)));
                }
                e += truncate(Math.round(d.bw._inner[f].af(b)));
            }
        }
        return e;
    };
    SpatialEngine.prototype.m = function (a, b, c) {
        var d = b;
        if (a == 0) {
            var e = 0;
            for (var f = 0; f < b; f++) {
                if (c.br._inner[f].d == 0) {
                    e++;
                }
            }
            d = this.d.count + e;
        }
        if (a == 1) {
            var g = 0;
            for (var h = 0; h < this.d.count; h++) {
                if (this.d._inner[h] < b) {
                    g++;
                }
            }
            d = g;
        }
        if (a == 2) {
            var i = 0;
            for (var j = 0; j < this.e.count; j++) {
                if (this.e._inner[j] > b) {
                    i++;
                }
            }
            d = c.br.count - 1 - i;
        }
        return d;
    };
    SpatialEngine.prototype.j = function (a, b) {
        for (var c = 0; c < b.br.count; c++) {
            if (b.br._inner[c].n == a) {
                return c;
            }
        }
        return -1;
    };
    SpatialEngine.prototype.n = function (a, b, c) {
        var d = c.br._inner[a].o;
        var e = truncate(b.inset.c) + c.cf + c.cc;
        var f = c.bw;
        var g = c.br;
        for (var h = 0; h < a; h++) {
            if (g._inner[h].d != 0) {
                continue;
            }
            e += truncate(Math.round(f._inner[h].ad(d)));
            if (g._inner[h].a != 6) {
                e += (g._inner[h].k) + b.model.cc - truncate(Math.round(g._inner[h].f(c)));
            }
            e += truncate(Math.round(f._inner[h].af(d)));
        }
        e += truncate(Math.round(f._inner[a].ad(d)));
        return (e);
    };
    SpatialEngine.prototype.o = function (a, b, c) {
        var d = 0;
        var e = 0;
        var f = truncate(b.inset.c);
        e += f;
        var g = c.bw;
        var h = c.br;
        var i = h.count;
        for (var j = 0; j < i; j++) {
            var k = h._inner[j];
            e += truncate(Math.round(g._inner[d].ad(-1)));
            if (k.a != 6) {
                e += (k.k) + b.model.cc - truncate(Math.round(k.f(c)));
            }
            if (a <= e) {
                return d;
            }
            e += truncate(Math.round(g._inner[d].af(-1)));
            d++;
        }
        var l = c.br.count - 1;
        if (d > l) {
            d = l;
        }
        return d;
    };
    SpatialEngine.prototype.b = function (a, b) {
        var c = b.bv.count;
        for (var d = 0; d < c; d++) {
            var e = b.bv._inner[d];
            var f = e.i;
            var g = f + e.l();
            if (a <= g) {
                if (a < f) {
                    a = f;
                }
                return e.a(a);
            }
        }
        return new RowPath(b.bv.count - 1, b.bv._inner[b.bv.count - 1].m - 1);
    };
    SpatialEngine.prototype.v = function (a, b, c, d) {
        this.ab(a, b, d, false);
        for (var e = b + 1; e < d.br.count; e++) {
            this.aa(e, d, false, b);
        }
    };
    SpatialEngine.prototype.t = function (a, b, c) {
        for (var d = c.br.count - 1; d >= a; d--) {
            this.aa(d, c, true, a);
        }
    };
    SpatialEngine.prototype.x = function (a, b) {
        for (var c = 0; c < b.bu.count; c++) {
            var d = new List$1(CellModel.$, 0);
            var e = b.bu._inner[c];
            for (var f = 0; f < e.o.count; f++) {
                if (e.p._inner[f]) {
                    continue;
                }
                var g = e.o._inner[f];
                if (g.x > a.x || (g.x == a.x && g.w >= a.w)) {
                    d.add(e.q._inner[f]);
                }
            }
            e.g = true;
            for (var h = 0; h < d.count; h++) {
                var i = d._inner[h];
                e.f(i.k);
                i.k.w = i.k.w + 1;
            }
            for (var j = 0; j < d.count; j++) {
                var k = d._inner[j];
                e.s(k.k, k);
            }
            e.g = false;
        }
    };
    SpatialEngine.prototype.y = function (a, b, c) {
        for (var d = 0; d < c.bu.count; d++) {
            var e = new List$1(CellModel.$, 0);
            var f = c.bu._inner[d];
            var g = new List$1(CellPath.$, 0);
            for (var h = 0; h < f.o.count; h++) {
                if (f.p._inner[h]) {
                    continue;
                }
                var i = f.o._inner[h];
                if (i.x > b.x || (i.x == b.x && i.w > b.w)) {
                    e.add(f.q._inner[h]);
                }
                if (i.x == b.x && i.w == b.w) {
                    g.add(i);
                }
            }
            f.g = true;
            for (var j = 0; j < g.count; j++) {
                var k = g._inner[j];
                a.j(k, f, c);
            }
            for (var l = 0; l < e.count; l++) {
                var m = e._inner[l];
                f.f(m.k);
                m.k.w = m.k.w - 1;
            }
            for (var n = 0; n < e.count; n++) {
                var o = e._inner[n];
                f.s(o.k, o);
            }
            f.g = false;
        }
    };
    SpatialEngine.prototype.aa = function (a, b, c, d) {
        for (var e = 0; e < b.bu.count; e++) {
            var f = new List$1(CellModel.$, 0);
            var g = b.bu._inner[e];
            for (var h = 0; h < g.o.count; h++) {
                if (g.p._inner[h]) {
                    continue;
                }
                var i = g.o._inner[h];
                if (i.a0 == a && (i.ag || i.aj)) {
                    f.add(g.q._inner[h]);
                }
            }
            g.g = true;
            for (var j = 0; j < f.count; j++) {
                var k = f._inner[j];
                g.f(k.k);
                if (c) {
                    k.k.a0 = k.k.a0 + 1;
                }
                else {
                    k.k.a0 = k.k.a0 - 1;
                }
                g.s(k.k, k);
            }
            g.g = false;
        }
        var l = b.bw;
        if (c) {
            if (a == l.count - 1) {
                l.add(new GridColumnSpacerCollection());
            }
            for (var m = l._inner[a].count - 1; m >= 0; m--) {
                if (a != d || l._inner[a]._inner[m].d) {
                    l._inner[a + 1].add(l._inner[a]._inner[m]);
                    l._inner[a].removeAt(m);
                }
            }
        }
        else {
            for (var n = l._inner[a].count - 1; n >= 0; n--) {
                l._inner[a - 1].add(l._inner[a]._inner[n]);
                l._inner[a].removeAt(n);
            }
        }
    };
    SpatialEngine.prototype.ab = function (a, b, c, d) {
        for (var e = 0; e < c.bu.count; e++) {
            var f = new List$1(CellModel.$, 0);
            var g = c.bu._inner[e];
            for (var h = 0; h < g.o.count; h++) {
                if (g.p._inner[h]) {
                    continue;
                }
                var i = g.o._inner[h];
                if (i.a0 == b && (i.ag || i.aj)) {
                    f.add(g.q._inner[h]);
                }
            }
            g.g = true;
            for (var j = 0; j < f.count; j++) {
                var k = f._inner[j];
                if (d) {
                    g.f(k.k);
                    k.k.a0 = -800;
                    g.s(k.k, k);
                }
                else {
                    a.j(k.k, g, c);
                }
            }
            g.g = false;
        }
        var l = c.bw;
        if (b < l.count) {
            for (var m = l._inner[b].count - 1; m >= 0; m--) {
                this.a.add(l._inner[b]._inner[m]);
                l._inner[b].removeAt(m);
            }
        }
    };
    SpatialEngine.prototype.z = function (a, b) {
        for (var c = 0; c < b.bu.count; c++) {
            var d = new List$1(CellModel.$, 0);
            var e = b.bu._inner[c];
            for (var f = 0; f < e.o.count; f++) {
                if (e.p._inner[f]) {
                    continue;
                }
                var g = e.o._inner[f];
                if (g.a0 == -800 && (g.ag || g.aj)) {
                    d.add(e.q._inner[f]);
                }
            }
            e.g = true;
            for (var h = 0; h < d.count; h++) {
                var i = d._inner[h];
                e.f(i.k);
                i.k.a0 = a;
                e.s(i.k, i);
            }
            e.g = false;
        }
    };
    SpatialEngine.prototype.w = function (a, b) {
        for (var c = 0; c < b.br.count; c++) {
            this.ab(a, c, b, false);
        }
    };
    SpatialEngine.prototype.u = function (a, b, c, d, e) {
        this.ab(a, c, b, true);
        for (var f = c + 1; f < b.br.count; f++) {
            this.aa(f, b, false, c);
        }
        for (var g = b.br.count - 1; g >= d; g--) {
            this.aa(g, b, true, d);
        }
        this.z(d, b);
        var h = b.bw;
        for (var i = this.a.count - 1; i >= 0; i--) {
            h._inner[c].add(this.a._inner[i]);
            this.a.removeAt(i);
        }
    };
    SpatialEngine.prototype.i = function (a, b) {
        if (b == null) {
            return 0;
        }
        var c = 0;
        for (var d = 0; d < b.x; d++) {
            c += a.bv._inner[d].m;
        }
        c += b.w;
        return c;
    };
    SpatialEngine.$t = markType(SpatialEngine, 'SpatialEngine');
    return SpatialEngine;
}(Base));
export { SpatialEngine };
/**
 * @hidden
 */
var ColumnExchanger = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnExchanger, _super);
    function ColumnExchanger(a) {
        var _rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _rest[_i - 1] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this.c = null;
        _this.a = null;
        _this.b = 0;
        a = (a == void 0) ? 0 : a;
        switch (a) {
            case 0: break;
            case 1:
                {
                    var c = _rest[0];
                    var d = _rest[1];
                    _this.a = c;
                    _this.b = d;
                }
                break;
        }
        return _this;
    }
    ColumnExchanger.$t = markType(ColumnExchanger, 'ColumnExchanger');
    return ColumnExchanger;
}(Base));
export { ColumnExchanger };
/**
 * @hidden
 */
var ColumnExchangersCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnExchangersCollection, _super);
    function ColumnExchangersCollection() {
        return _super.call(this, ColumnExchanger.$, 0) || this;
    }
    ColumnExchangersCollection.$t = markType(ColumnExchangersCollection, 'ColumnExchangersCollection', ObservableCollection$1.$.specialize(ColumnExchanger.$));
    return ColumnExchangersCollection;
}(ObservableCollection$1));
export { ColumnExchangersCollection };
/**
 * @hidden
 */
var ResponsiveEngine = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ResponsiveEngine, _super);
    function ResponsiveEngine(a) {
        var _this = _super.call(this) || this;
        _this.c = null;
        _this.l = 500;
        _this.m = 200;
        _this.k = dateMinValue();
        _this.h = false;
        _this.i = false;
        _this.j = null;
        _this.a = null;
        _this.f = null;
        _this.b = null;
        _this.d = null;
        _this.a = a;
        _this.g = new ResponsiveStatesCollection();
        _this.j = new List$1(Number_$type, 0);
        _this.h = true;
        _this.d = null;
        return _this;
    }
    Object.defineProperty(ResponsiveEngine.prototype, "g", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            this.f = a;
        },
        enumerable: true,
        configurable: true
    });
    ResponsiveEngine.prototype.x = function (a) {
        if (this.b == a) {
            return;
        }
        this.d = a;
        if (this.h) {
        }
        else {
            this.w();
        }
    };
    ResponsiveEngine.prototype.y = function (a, b) {
        this.k = dateNow();
        if (this.h) {
            this.q();
            this.h = false;
        }
        else {
            this.w();
        }
    };
    ResponsiveEngine.prototype.w = function () {
        var _this = this;
        if (this.i) {
            return;
        }
        var a = this.n();
        this.i = true;
        this.a.delayedExecutionManager.executeIn(function () {
            if (!_this.i) {
                return;
            }
            _this.i = false;
            if (_this.n() < 1) {
                _this.q();
            }
            else {
                _this.w();
            }
        }, a);
    };
    ResponsiveEngine.prototype.q = function () {
        if (this.b != null) {
            return;
        }
        var a = null;
        if (this.g.count > 0) {
            a = this.e(this.a.j7);
        }
        if (a == this.c) {
            return;
        }
        if (this.c != null && a != null) {
            this.c.q();
            this.c = null;
        }
        if (a != null) {
            if (this.d != null) {
                this.d = null;
            }
            this.b = a;
            this.c = a;
            this.c.l = 0;
            this.c.p();
            this.t(this.c);
            this.c.o();
        }
    };
    ResponsiveEngine.prototype.t = function (a) {
        var _this = this;
        if (a.c.count == a.l) {
            this.b = null;
            var b = this.e(this.a.j7);
            {
                if (b != this.c) {
                    this.w();
                }
            }
            return;
        }
        if (this.h) {
            this.u(a);
            this.c.l = this.c.l + 1;
            this.t(a);
        }
        else {
            this.a.delayedExecutionManager.executeIn(function () {
                var c = _this.a.cp;
                c.animationCompleted = delegateCombine(c.animationCompleted, runOn(_this, _this.p));
                var d = _this.a.cp;
                d.animationCanceled = delegateCombine(d.animationCanceled, runOn(_this, _this.o));
                _this.a.cp.ar();
                _this.u(a);
                _this.j = _this.a.cp.m();
                if (_this.j.count == 0) {
                    _this.r(-1);
                }
            }, a.c._inner[0].i);
        }
    };
    ResponsiveEngine.prototype.u = function (a) {
        var b = a.c._inner[a.l];
        this.v(b.e);
        this.s(b.b);
    };
    ResponsiveEngine.prototype.o = function (a, b) {
        this.r(b.a);
    };
    ResponsiveEngine.prototype.p = function (a, b) {
        this.r(b.a);
    };
    ResponsiveEngine.prototype.r = function (a) {
        if (this.j.contains(a)) {
            this.j.remove(a);
        }
        if (this.j.count == 0) {
            var b = this.a.cp;
            b.animationCompleted = delegateRemove(b.animationCompleted, runOn(this, this.p));
            var c = this.a.cp;
            c.animationCanceled = delegateRemove(c.animationCanceled, runOn(this, this.o));
            this.c.l = this.c.l + 1;
            this.t(this.c);
        }
    };
    ResponsiveEngine.prototype.v = function (a) {
        for (var b = 0; b < a.count; b++) {
            var c = a._inner[b];
            var d = null;
            for (var e = 0; e < this.a.actualColumns.count; e++) {
                if (this.a.actualColumns._inner[e].il == c.c) {
                    d = this.a.actualColumns._inner[e];
                    break;
                }
            }
            if (d == null) {
                for (var f = 0; f < this.a.actualColumns.count; f++) {
                    if (this.a.actualColumns._inner[f].h4 == c.c) {
                        d = this.a.actualColumns._inner[f];
                        break;
                    }
                }
            }
            if (d == null) {
                continue;
            }
            var g = d.externalObject;
            this.a.propertySetter.setProperty(g, c.d, c.b);
        }
    };
    ResponsiveEngine.prototype.s = function (a) {
        for (var b = 0; b < a.count; b++) {
            var c = a._inner[b];
            if (c.a == null) {
                continue;
            }
            if (c.b >= this.a.actualColumns.count) {
                continue;
            }
            var d = this.a.actualColumns._inner[c.b];
            this.a.qz(c.a, d);
        }
    };
    ResponsiveEngine.prototype.e = function (a) {
        if (this.d != null) {
            return this.d;
        }
        for (var b = 0; b < this.g.count; b++) {
            var c = this.g._inner[b];
            if (a >= c.k && a <= c.j && !c.i) {
                return c;
            }
        }
        return null;
    };
    ResponsiveEngine.prototype.n = function () {
        var a = timeSpanFromMilliseconds(this.m);
        var b = timeSpanFromMilliseconds(this.l);
        if (+(this.k) != +(dateMinValue())) {
            a = +(dateNow()) - +(this.k);
        }
        var c = truncate(timeSpanTotalMilliseconds(a));
        var d = (this.m - c);
        if (d < 1) {
            d = 0;
        }
        return d;
    };
    ResponsiveEngine.$t = markType(ResponsiveEngine, 'ResponsiveEngine');
    return ResponsiveEngine;
}(Base));
export { ResponsiveEngine };
/**
 * @hidden
 */
var ResponsivePhase = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ResponsivePhase, _super);
    function ResponsivePhase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.j = null;
        _this.k = null;
        _this.i = 0;
        _this.d = new ColumnPropertySettersCollection();
        _this.a = new ColumnExchangersCollection();
        return _this;
    }
    Object.defineProperty(ResponsivePhase.prototype, "e", {
        get: function () {
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResponsivePhase.prototype, "b", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    ResponsivePhase.prototype.g = function (a) {
        this.e.add(a);
        return this;
    };
    ResponsivePhase.prototype.c = function () {
        var a = new ColumnPropertySetter(0);
        this.e.add(a);
        return a;
    };
    ResponsivePhase.prototype.f = function (a) {
        this.b.add(a);
        return this;
    };
    ResponsivePhase.prototype.h = function () {
        var a = new ColumnExchanger(0);
        this.b.add(a);
        return this;
    };
    ResponsivePhase.$t = markType(ResponsivePhase, 'ResponsivePhase');
    return ResponsivePhase;
}(Base));
export { ResponsivePhase };
/**
 * @hidden
 */
var ResponsivePhasesCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ResponsivePhasesCollection, _super);
    function ResponsivePhasesCollection() {
        return _super.call(this, ResponsivePhase.$, 0) || this;
    }
    ResponsivePhasesCollection.$t = markType(ResponsivePhasesCollection, 'ResponsivePhasesCollection', ObservableCollection$1.$.specialize(ResponsivePhase.$));
    return ResponsivePhasesCollection;
}(ObservableCollection$1));
export { ResponsivePhasesCollection };
/**
 * @hidden
 */
var ResponsiveState = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ResponsiveState, _super);
    function ResponsiveState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.m = null;
        _this.n = null;
        _this.k = 0;
        _this.j = 0;
        _this.stateEntering = null;
        _this.stateEntered = null;
        _this.stateExited = null;
        _this.h = false;
        _this.l = 0;
        _this.b = new ResponsivePhasesCollection();
        return _this;
    }
    Object.defineProperty(ResponsiveState.prototype, "i", {
        get: function () {
            return this.h;
        },
        set: function (a) {
            this.h = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResponsiveState.prototype, "c", {
        get: function () {
            return this.b;
        },
        enumerable: true,
        configurable: true
    });
    ResponsiveState.prototype.d = function (a) {
        this.c.add(a);
        return this;
    };
    ResponsiveState.prototype.a = function () {
        var a = new ResponsivePhase();
        this.c.add(a);
        return a;
    };
    ResponsiveState.prototype.p = function () {
        if (this.stateEntering != null) {
            this.stateEntering(this, new ResponsiveStateEnteringEventArgs());
        }
    };
    ResponsiveState.prototype.o = function () {
        if (this.stateEntered != null) {
            this.stateEntered(this, new ResponsiveStateEnteredEventArgs());
        }
    };
    ResponsiveState.prototype.q = function () {
        if (this.stateExited != null) {
            this.stateExited(this, new ResponsiveStateExitedEventArgs());
        }
    };
    ResponsiveState.$t = markType(ResponsiveState, 'ResponsiveState');
    return ResponsiveState;
}(Base));
export { ResponsiveState };
/**
 * @hidden
 */
var ResponsiveStatesCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ResponsiveStatesCollection, _super);
    function ResponsiveStatesCollection() {
        return _super.call(this, ResponsiveState.$, 0) || this;
    }
    ResponsiveStatesCollection.$t = markType(ResponsiveStatesCollection, 'ResponsiveStatesCollection', ObservableCollection$1.$.specialize(ResponsiveState.$));
    return ResponsiveStatesCollection;
}(ObservableCollection$1));
export { ResponsiveStatesCollection };
/**
 * @hidden
 */
var GridLayer = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridLayer, _super);
    function GridLayer(a) {
        var _this = _super.call(this, CellPath.$, CellModel.$, 0) || this;
        _this.v = null;
        _this.v = a;
        return _this;
    }
    GridLayer.$t = markType(GridLayer, 'GridLayer', FastIterationDictionary$2.$.specialize(CellPath.$, CellModel.$));
    return GridLayer;
}(FastIterationDictionary$2));
export { GridLayer };
/**
 * @hidden
 */
var ColumnInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnInfo, _super);
    function ColumnInfo() {
        var _this = _super.call(this) || this;
        _this.m = 0;
        _this.n = 0;
        _this.b = null;
        _this.i = 0;
        _this.k = 0;
        _this.l = 0;
        _this.p = null;
        _this.o = 0;
        _this.c = 0;
        _this.g = 0;
        _this.j = 0;
        _this.h = 0;
        _this.a = 0;
        _this.d = 0;
        _this.g = 0;
        _this.h = 0;
        _this.j = 0;
        _this.i = 0;
        return _this;
    }
    ColumnInfo.prototype.e = function (a) {
        var b = this.h;
        if (this.a != 6) {
            if (b > 0 && b < 1) {
                b = 0;
            }
            if (b >= 1) {
                b = b - 1;
            }
        }
        return this.g + b * (this.k + a.cc);
    };
    ColumnInfo.prototype.f = function (a) {
        var b = Math.abs(this.g + this.h * (this.k + a.cc));
        if (b < (-1 * (this.k + a.cc))) {
            b = (-1 * (this.k + a.cc));
        }
        if (b > (this.k + a.cc)) {
            b = (this.k + a.cc);
        }
        return b;
    };
    ColumnInfo.$t = markType(ColumnInfo, 'ColumnInfo');
    return ColumnInfo;
}(Base));
export { ColumnInfo };
/**
 * @hidden
 */
var SectionInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SectionInfo, _super);
    function SectionInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.h = 0;
        _this.m = 0;
        _this.q = 0;
        _this.o = 0;
        _this.g = 0;
        _this.d = 0;
        _this.n = 0;
        _this.p = 0;
        _this.i = 0;
        _this.b = null;
        _this.c = null;
        return _this;
    }
    SectionInfo.prototype.l = function () {
        return this.q + this.g + this.d + ((this.o + this.p) * this.m);
    };
    SectionInfo.prototype.e = function (a) {
        if (a == -200) {
            return this.g;
        }
        if (a == -201) {
            return this.d;
        }
        if (this.b == null) {
            return this.n;
        }
        else {
            return this.b._inner[a];
        }
    };
    SectionInfo.prototype.f = function (a) {
        if (this.c == null) {
            if (a == -200) {
                return 0;
            }
            else if (a == -201) {
                return this.l() - this.g;
            }
            return (a * this.k()) + this.g;
        }
        else {
            if (a == -200) {
                return 0;
            }
            else if (a == -201) {
                return this.l() - this.d;
            }
            return this.c._inner[a];
        }
    };
    SectionInfo.prototype.k = function () {
        return this.n + this.p + this.o;
    };
    SectionInfo.prototype.j = function (a) {
        if (this.c == null) {
            return this.n + this.p + this.o;
        }
        else {
            return this.b._inner[a] + this.o + this.p;
        }
    };
    SectionInfo.prototype.a = function (a) {
        a -= this.i;
        if (a < this.g) {
            return new RowPath(this.h, -200);
        }
        else if (a > this.l() - this.d) {
            return new RowPath(this.h, -201);
        }
        a -= this.g;
        if (this.b == null) {
            var b = this.k();
            var c = truncate((a / b));
            if (c >= this.m) {
                c = this.m - 1;
            }
            return new RowPath(this.h, c);
        }
        else {
            for (var d = 0; d < this.m; d++) {
                var e = this.c._inner[d];
                var f = this.j(d);
                if (a >= e && a <= e + f) {
                    return new RowPath(this.h, d);
                }
            }
        }
        return null;
    };
    SectionInfo.$t = markType(SectionInfo, 'SectionInfo');
    return SectionInfo;
}(Base));
export { SectionInfo };
/**
 * @hidden
 */
var VisualModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(VisualModel, _super);
    function VisualModel() {
        var _this = _super.call(this) || this;
        _this._actualVisibleRegion = null;
        _this._absoluteWidth = 0;
        _this._absoluteHeight = 0;
        _this.ci = 0;
        _this.cl = 0;
        _this.cm = 0;
        _this.ch = 0;
        _this.cf = 0;
        _this.cg = 0;
        _this.cc = 0;
        _this.cs = 0;
        _this.ct = 0;
        _this.b4 = 0;
        _this.b5 = 0;
        _this.cd = 0;
        _this.ce = 0;
        _this.cj = 0;
        _this.cp = 0;
        _this.b7 = 0;
        _this.b0 = 0;
        _this.b1 = 0;
        _this.b2 = 0;
        _this.bz = 0;
        _this.ae = null;
        _this.p = null;
        _this.i = null;
        _this.k = null;
        _this.ah = null;
        _this.s = null;
        _this.o = null;
        _this.j = null;
        _this.ag = null;
        _this.r = null;
        _this.q = null;
        _this.af = null;
        _this.w = null;
        _this.v = null;
        _this.l = null;
        _this.aj = null;
        _this.u = null;
        _this.t = null;
        _this.ai = null;
        _this.m = null;
        _this.x = null;
        _this.n = null;
        _this.y = null;
        _this.z = null;
        _this.aa = null;
        _this.ab = null;
        _this.ac = null;
        _this.ad = null;
        _this.ak = null;
        _this.c = null;
        _this.bg = null;
        _this.bv = null;
        _this.br = null;
        _this.bl = false;
        _this.bn = false;
        _this.bk = false;
        _this.bq = new List$1(GridColumnSpacerCollection.$, 0);
        _this.bo = null;
        _this.bf = null;
        _this.be = null;
        _this.cx = -1;
        _this.f = null;
        _this.bp = null;
        _this.bx = null;
        _this.cn = 0;
        _this.cq = 0;
        _this.co = 0;
        _this.cr = 0;
        _this.bj = false;
        _this.cv = 0;
        _this.cw = 0;
        _this.cu = 0;
        _this.actualVisibleRegion = Rect.empty;
        _this.ae = new GridLayer("SubContentLayer");
        _this.i = new GridLayer("ContentLayer");
        _this.ah = new GridLayer("SuperContentLayer");
        _this.j = new GridLayer("DecoratorLayer");
        _this.x = new GridLayer("PinnedRowsLayer");
        _this.y = new GridLayer("PinnedRowsSubLayer");
        _this.z = new GridLayer("PinnedRowsSuperLayer");
        _this.aa = new GridLayer("PinnedSectionLayer");
        _this.ab = new GridLayer("PinnedSectionSubLayer");
        _this.ac = new GridLayer("PinnedSectionSuperLayer");
        _this.ad = new GridLayer("SectionLayer");
        _this.ag = new GridLayer("SubHeaderLayer");
        _this.w = new GridLayer("HeaderLayer");
        _this.v = new GridLayer("HeaderDecoratorLayer");
        _this.aj = new GridLayer("SuperHeaderLayer");
        _this.ak = new GridLayer("VerticalSeparatorLayer");
        _this.af = new GridLayer("SubHeaderDecoratorLayer");
        _this.ai = new GridLayer("SuperHeaderDecoratorLayer");
        _this.k = new GridLayer("FixedContentLayer");
        _this.m = new GridLayer("FixedHeaderLayer");
        _this.n = new GridLayer("FixedPinnedRowsLayer");
        _this.o = new GridLayer("FixedSeparatorLayer");
        _this.p = new GridLayer("FixedSubContentLayer");
        _this.r = new GridLayer("FixedSubHeaderLayer");
        _this.s = new GridLayer("FixedSuperContentLayer");
        _this.u = new GridLayer("FixedSuperHeaderLayer");
        _this.q = new GridLayer("FixedSubHeaderDecoratorLayer");
        _this.u = new GridLayer("FixedSuperHeaderLayer");
        _this.t = new GridLayer("FixedSuperHeaderDecoratorLayer");
        _this.l = new GridLayer("FixedHeaderDecoratorLayer");
        _this.bg = new FastIterationDictionary$2(CellPath.$, List$1.$.specialize(CellModel.$), 0);
        _this.c2();
        _this.bv = new List$1(SectionInfo.$, 0);
        _this.br = new List$1(ColumnInfo.$, 0);
        _this.bo = new Dictionary$2(Number_$type, Number_$type, 0);
        _this.bx = new List$1(Number_$type, 0);
        return _this;
    }
    Object.defineProperty(VisualModel.prototype, "actualVisibleRegion", {
        get: function () {
            return this._actualVisibleRegion;
        },
        set: function (a) {
            this._actualVisibleRegion = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "absoluteWidth", {
        get: function () {
            return this._absoluteWidth;
        },
        set: function (a) {
            this._absoluteWidth = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "absoluteHeight", {
        get: function () {
            return this._absoluteHeight;
        },
        set: function (a) {
            this._absoluteHeight = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "b8", {
        get: function () {
            return truncate(this.actualVisibleRegion.top);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "b3", {
        get: function () {
            return truncate(this.actualVisibleRegion.left);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "b6", {
        get: function () {
            return truncate(this.actualVisibleRegion.right);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "by", {
        get: function () {
            return truncate(this.actualVisibleRegion.height);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "b9", {
        get: function () {
            return truncate(this.actualVisibleRegion.width);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a7", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            this.ae = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "as", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            this.p = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "al", {
        get: function () {
            return this.i;
        },
        set: function (a) {
            this.i = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "an", {
        get: function () {
            return this.k;
        },
        set: function (a) {
            this.k = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ba", {
        get: function () {
            return this.ah;
        },
        set: function (a) {
            this.ah = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "av", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            this.s = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ar", {
        get: function () {
            return this.o;
        },
        set: function (a) {
            this.o = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "am", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            this.j = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a9", {
        get: function () {
            return this.ag;
        },
        set: function (a) {
            this.ag = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "au", {
        get: function () {
            return this.r;
        },
        set: function (a) {
            this.r = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "at", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            this.q = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a8", {
        get: function () {
            return this.af;
        },
        set: function (a) {
            this.af = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "az", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            this.w = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ay", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            this.v = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ao", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            this.l = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "bc", {
        get: function () {
            return this.aj;
        },
        set: function (a) {
            this.aj = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ax", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            this.u = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "aw", {
        get: function () {
            return this.t;
        },
        set: function (a) {
            this.t = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "bb", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            this.ai = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ap", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            this.m = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a0", {
        get: function () {
            return this.x;
        },
        set: function (a) {
            this.x = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "aq", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            this.n = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a1", {
        get: function () {
            return this.y;
        },
        set: function (a) {
            this.y = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a2", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            this.z = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a3", {
        get: function () {
            return this.aa;
        },
        set: function (a) {
            this.aa = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a4", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            this.ab = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a5", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            this.ac = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a6", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            this.ad = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "bd", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            this.ak = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    VisualModel.prototype.e = function (a, b) {
        a += this.actualVisibleRegion.left;
        b += this.actualVisibleRegion.top;
        var c = this.bu;
        var d = c.count;
        for (var e = d - 1; e >= 0; e--) {
            if (c._inner[e] == this.al) {
                break;
            }
            var f = c._inner[e].q;
            var g = c._inner[e].q.count;
            var h = c._inner[e].p;
            for (var i = 0; i < g; i++) {
                if (h._inner[i]) {
                    continue;
                }
                var j = f._inner[i];
                if (a >= j.cc && a <= j.cc + j.gg && b >= j.cd && b <= j.cd + j.e0) {
                    this.c = j;
                    return j;
                }
            }
        }
        if (this.c != null) {
            var k = this.c;
            if (a >= k.cc && a <= k.cc + k.gg && b >= k.cd && b <= k.cd + k.e0) {
                this.c = k;
                return k;
            }
        }
        c = this.bu;
        d = c.count;
        for (var l = d - 1; l >= 0; l--) {
            var m = c._inner[l].q;
            var n = c._inner[l].q.count;
            var o = c._inner[l].p;
            for (var p = 0; p < n; p++) {
                if (o._inner[p]) {
                    continue;
                }
                var q = m._inner[p];
                if (a >= q.cc && a <= q.cc + q.gg && b >= q.cd && b <= q.cd + q.e0) {
                    this.c = q;
                    return q;
                }
            }
        }
        return null;
    };
    Object.defineProperty(VisualModel.prototype, "bh", {
        get: function () {
            return this.bg;
        },
        set: function (a) {
            this.bg = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "bw", {
        get: function () {
            while (this.bq.count < this.br.count) {
                this.bq.add(new GridColumnSpacerCollection());
            }
            return this.bq;
        },
        set: function (a) {
            this.bq = a;
        },
        enumerable: true,
        configurable: true
    });
    VisualModel.prototype.bm = function () {
        if (this.bf != null && this.be != null && this.bf.w >= 0 && this.be.w >= 0) {
            return true;
        }
        return false;
    };
    VisualModel.prototype.g = function (a) {
        if (a == this.cx) {
            return this.f;
        }
        var b = null;
        if (this.bo.containsKey(a)) {
            b = this.br._inner[this.bo.item(a)];
        }
        this.cx = a;
        this.f = b;
        return b;
    };
    VisualModel.prototype.cy = function (a) {
        this.br.add(a);
        this.bo.addItem(a.o, this.br.count - 1);
    };
    VisualModel.prototype.c2 = function () {
        this.bp = new List$1(GridLayer.$, 0);
        this.bp.add(this.a7);
        this.bp.add(this.al);
        this.bp.add(this.ba);
        this.bp.add(this.am);
        this.bp.add(this.a1);
        this.bp.add(this.a0);
        this.bp.add(this.a2);
        this.bp.add(this.as);
        this.bp.add(this.an);
        this.bp.add(this.av);
        this.bp.add(this.aq);
        this.bp.add(this.ar);
        this.bp.add(this.a6);
        this.bp.add(this.a4);
        this.bp.add(this.a3);
        this.bp.add(this.a5);
        this.bp.add(this.a9);
        this.bp.add(this.a8);
        this.bp.add(this.az);
        this.bp.add(this.ay);
        this.bp.add(this.bc);
        this.bp.add(this.bb);
        this.bp.add(this.au);
        this.bp.add(this.at);
        this.bp.add(this.ap);
        this.bp.add(this.ao);
        this.bp.add(this.ax);
        this.bp.add(this.aw);
        this.bp.add(this.bd);
    };
    Object.defineProperty(VisualModel.prototype, "bu", {
        get: function () {
            return this.bp;
        },
        enumerable: true,
        configurable: true
    });
    VisualModel.prototype.bi = function () {
        for (var a = 0; a < this.bp.count; a++) {
            for (var b = 0; b < this.bp._inner[a].o.count; b++) {
                if (this.bp._inner[a].p._inner[b]) {
                    continue;
                }
                var c = this.bp._inner[a].o._inner[b];
                var d = this.bp._inner[a].q._inner[b];
                if (c != d.k) {
                    return false;
                }
            }
        }
        return true;
    };
    VisualModel.prototype.c1 = function () {
        this.f = null;
        this.cx = -1;
        this.br.clear();
        this.bo.clear();
    };
    VisualModel.prototype.c0 = function () {
        this.c1();
        this.bv.clear();
        this.a7.u();
        this.al.u();
        this.ba.u();
        this.am.u();
        this.a1.u();
        this.a0.u();
        this.a2.u();
        this.as.u();
        this.an.u();
        this.av.u();
        this.aq.u();
        this.ar.u();
        this.a6.u();
        this.a4.u();
        this.a3.u();
        this.a5.u();
        this.a9.u();
        this.a8.u();
        this.az.u();
        this.ay.u();
        this.bc.u();
        this.bb.u();
        this.au.u();
        this.at.u();
        this.ap.u();
        this.ao.u();
        this.ax.u();
        this.aw.u();
        this.bd.u();
    };
    VisualModel.prototype.b = function () {
        var a = new VisualModelExport();
        a.ae = new RectData(this.actualVisibleRegion.x, this.actualVisibleRegion.y, this.actualVisibleRegion.width, this.actualVisibleRegion.height);
        a.ah = this.absoluteWidth;
        a.ag = this.absoluteHeight;
        a.au = this.cl;
        a.an = this.ci;
        a.am = this.ch;
        a.ak = this.cf;
        a.al = this.cg;
        a.ai = this.cc;
        a.aq = this.cs;
        a.ar = this.ct;
        a.as = this.b8;
        a.ap = this.b3;
        a.ao = this.by;
        a.at = this.b9;
        a.x = this.a(this.a7);
        a.a = this.a(this.al);
        a.aa = this.a(this.ba);
        a.b = this.a(this.am);
        a.r = this.a(this.a1);
        a.q = this.a(this.a0);
        a.s = this.a(this.a2);
        a.h = this.a(this.as);
        a.c = this.a(this.an);
        a.k = this.a(this.av);
        a.f = this.a(this.aq);
        a.g = this.a(this.ar);
        a.w = this.a(this.a6);
        a.u = this.a(this.a4);
        a.t = this.a(this.a3);
        a.v = this.a(this.a5);
        a.z = this.a(this.a9);
        a.y = this.a(this.a8);
        a.o = this.a(this.az);
        a.n = this.a(this.ay);
        a.ac = this.a(this.bc);
        a.ab = this.a(this.bb);
        a.j = this.a(this.au);
        a.i = this.a(this.at);
        a.e = this.a(this.ap);
        a.d = this.a(this.ao);
        a.m = this.a(this.ax);
        a.l = this.a(this.aw);
        a.ad = this.a(this.bd);
        a.ax();
        return a;
    };
    VisualModel.prototype.a = function (a) {
        var e_21, _a;
        var b = new GridLayerExport(a.v);
        var c = a == this.az;
        try {
            for (var _b = tslib_1.__values(fromEnum(a.n)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var d = _c.value;
                var e = d.b(null);
                if (this.bj && c) {
                    e.s += this.b8;
                }
                b.e(e);
            }
        }
        catch (e_21_1) {
            e_21 = { error: e_21_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_21)
                    throw e_21.error;
            }
        }
        return b;
    };
    VisualModel.prototype.h = function (a, b, c, d, e) {
        var f = new GridColumnSpacer();
        f.i = c;
        f.j = c;
        f.f = d;
        f.n = b.o;
        f.d = e;
        this.bw._inner[a].add(f);
        return f;
    };
    VisualModel.prototype.cz = function (a) {
        var b = this.bw;
        for (var c = 0; c < b.count; c++) {
            var d = b._inner[c];
            for (var e = d.count - 1; e >= 0; e--) {
                if (d._inner[e].o == a.o) {
                    d.removeAt(e);
                }
            }
        }
    };
    VisualModel.prototype.bt = function (a) {
        var b = new List$1(GridColumnSpacer.$, 0);
        var c = this.bw;
        for (var d = 0; d < c.count; d++) {
            var e = c._inner[d];
            for (var f = e.count - 1; f >= 0; f--) {
                if (e._inner[f].n == a.o) {
                    b.add(e._inner[f]);
                }
            }
        }
        return b;
    };
    VisualModel.prototype.bs = function (a) {
        var b = new List$1(CellModel.$, 0);
        for (var c = 0; c < this.bu.count; c++) {
            var d = new List$1(CellModel.$, 0);
            var e = this.bu._inner[c];
            for (var f = 0; f < e.o.count; f++) {
                if (e.p._inner[f]) {
                    continue;
                }
                var g = e.q._inner[f];
                if (g.k.a0 == a.m && g.k.b == a.c) {
                    b.add(g);
                }
            }
        }
        return b;
    };
    VisualModel.prototype.d = function (a, b) {
        for (var c = 0; c < this.bu.count; c++) {
            var d = this.bu._inner[c];
            for (var e = 0; e < d.o.count; e++) {
                if (d.p._inner[e]) {
                    continue;
                }
                var f = d.q._inner[e];
                if (f.k.a0 == a && f.k.w == b) {
                    return f;
                }
            }
        }
        return null;
    };
    VisualModel.prototype.ck = function () {
        var a = 0;
        for (var b = 0; b < this.bv.count; b++) {
            a += this.bv._inner[b].m;
        }
        return a;
    };
    VisualModel.$t = markType(VisualModel, 'VisualModel');
    return VisualModel;
}(Base));
export { VisualModel };
//# sourceMappingURL=IExternalGrid_combined.js.map
